// // // import { useState } from "react";
// // // import {
// // //   Heading1,
// // //   AlignLeft,
// // //   AlertTriangle,
// // //   List as ListIcon,
// // //   Images,
// // //   Image as ImageIcon,
// // //   Code2,
// // //   Terminal,
// // //   CheckCircle2,
// // //   Plus,
// // //   Trash2,
// // //   ChevronUp,
// // //   ChevronDown,
// // //   ChevronDown as Caret,
// // //   Copy,
// // //   Check,
// // //   GripVertical,
// // //   KeyRound,
// // //   RefreshCw,
// // //   Info,
// // //   XCircle,
// // //   ImageOff,
// // //   ChevronLeft,
// // //   ChevronRight,
// // //   Columns2,
// // //   AlignCenter,
// // //   AlignRight,
// // //   AlignJustify,
// // // } from "lucide-react";
// // // import { useMutation } from "react-query";
// // // import { postDocument } from "../../../Services/Document";
// // // import { toast } from "react-toastify";

// // // const CALLOUT_STYLE = {
// // //   info: { bg: "#E6F1FB", border: "#185FA5", text: "#0C447C", icon: Info },
// // //   warning: {
// // //     bg: "#FAEEDA",
// // //     border: "#BA7517",
// // //     text: "#633806",
// // //     icon: AlertTriangle,
// // //   },
// // //   success: {
// // //     bg: "#EAF3DE",
// // //     border: "#3B6D11",
// // //     text: "#27500A",
// // //     icon: CheckCircle2,
// // //   },
// // //   error: { bg: "#FCEBEB", border: "#A32D2D", text: "#501313", icon: XCircle },
// // // };

// // // const BLOCK_TYPES = {
// // //   heading: { label: "Heading", ramp: "blue", icon: Heading1 },
// // //   paragraph: { label: "Paragraph", ramp: "gray", icon: AlignLeft },
// // //   callout: { label: "Callout", ramp: "amber", icon: AlertTriangle },
// // //   list: { label: "List", ramp: "green", icon: ListIcon },
// // //   slider: { label: "Image slider", ramp: "purple", icon: Images },
// // //   image: { label: "Image", ramp: "pink", icon: ImageIcon },
// // //   columns: { label: "Two columns", ramp: "blue", icon: Columns2 },
// // //   request_payload: { label: "Request payload", ramp: "teal", icon: Code2 },
// // //   code: { label: "Code sample", ramp: "gray", icon: Terminal },
// // //   success_response: {
// // //     label: "Success response",
// // //     ramp: "green",
// // //     icon: CheckCircle2,
// // //   },
// // // };

// // // const RAMP = {
// // //   blue: { 50: "#E6F1FB", 200: "#85B7EB", 600: "#185FA5", 800: "#0C447C" },
// // //   gray: { 50: "#F1EFE8", 200: "#B4B2A9", 600: "#5F5E5A", 800: "#444441" },
// // //   amber: { 50: "#FAEEDA", 200: "#EF9F27", 600: "#854F0B", 800: "#633806" },
// // //   green: { 50: "#EAF3DE", 200: "#97C459", 600: "#3B6D11", 800: "#27500A" },
// // //   purple: { 50: "#EEEDFE", 200: "#AFA9EC", 600: "#534AB7", 800: "#3C3489" },
// // //   pink: { 50: "#FBEAF0", 200: "#ED93B1", 600: "#993556", 800: "#72243E" },
// // //   teal: { 50: "#E1F5EE", 200: "#5DCAA5", 600: "#0F6E56", 800: "#085041" },
// // // };

// // // const ALIGN_OPTIONS = [
// // //   { value: "left", label: "Left", icon: AlignLeft },
// // //   { value: "center", label: "Center", icon: AlignCenter },
// // //   { value: "right", label: "Right", icon: AlignRight },
// // //   { value: "justify", label: "Justify", icon: AlignJustify },
// // // ];

// // // const OBJECT_FIT_OPTIONS = ["cover", "contain", "fill", "none", "scale-down"];

// // // let uid = 1;
// // // const nextId = () => `blk-${uid++}`;
// // // const genKey = (prefix) =>
// // //   `${prefix}_${Math.random().toString(36).slice(2, 8)}`;

// // // const emptyImageValue = (prefix) => ({
// // //   image_key: genKey(prefix),
// // //   url: "",
// // //   caption: "",
// // //   alt: "",
// // //   width: "100%",
// // //   height: "220px",
// // //   objectFit: "cover",
// // // });

// // // const emptyColumnContent = () => ({
// // //   heading: "",
// // //   text: "",
// // //   align: "left",
// // //   image: {
// // //     url: "",
// // //     alt: "",
// // //     width: "100%",
// // //     height: "160px",
// // //     objectFit: "cover",
// // //   },
// // // });

// // // const emptyBlockFor = (type) => {
// // //   const id = nextId();
// // //   switch (type) {
// // //     case "heading":
// // //       return { id, type: "heading", level: "h2", text: "", align: "left" };
// // //     case "paragraph":
// // //       return { id, type: "paragraph", text: "", align: "left" };
// // //     case "callout":
// // //       return { id, type: "callout", style: "info", text: "", align: "left" };
// // //     case "list":
// // //       return { id, type: "list", style: "bullet", items: [""], align: "left" };
// // //     case "slider":
// // //       return { id, type: "slider", images: [emptyImageValue("slider_step")] };
// // //     case "image":
// // //       return {
// // //         id,
// // //         type: "image",
// // //         image_key: genKey("image"),
// // //         url: "",
// // //         caption: "",
// // //         align: "center",
// // //         width: "100%",
// // //         height: "auto",
// // //         objectFit: "cover",
// // //       };
// // //     case "columns":
// // //       return {
// // //         id,
// // //         type: "columns",
// // //         gap: 20,
// // //         left: emptyColumnContent(),
// // //         right: emptyColumnContent(),
// // //       };
// // //     case "request_payload":
// // //       return { id, type: "request_payload", data: "{\n  \n}" };
// // //     case "code":
// // //       return { id, type: "code", language: "python", code: "" };
// // //     case "success_response":
// // //       return { id, type: "success_response", data: "{\n  \n}" };
// // //     default:
// // //       return { id, type: "paragraph", text: "", align: "left" };
// // //   }
// // // };

// // // const initialBlocks = [];

// // // const initialValues = {
// // //   category: "",
// // //   title: "",
// // //   doc_type: "",
// // //   overview: "",
// // //   api_method: "",
// // //   api_endpoint: "",
// // //   content_blocks: initialBlocks,
// // // };

// // // function useFormikLike(initial) {
// // //   const [values, setValues] = useState(initial);
// // //   const setField = (path, val) => {
// // //     setValues((prev) => {
// // //       const next = structuredClone(prev);
// // //       const keys = path.split(".");
// // //       let cur = next;
// // //       for (let i = 0; i < keys.length - 1; i++) cur = cur[keys[i]];
// // //       cur[keys[keys.length - 1]] = val;
// // //       return next;
// // //     });
// // //   };
// // //   return { values, setValues, setField };
// // // }

// // // function Field({ label, children, hint }) {
// // //   return (
// // //     <label style={{ display: "block", marginBottom: 14 }}>
// // //       <span
// // //         style={{
// // //           display: "block",
// // //           fontSize: 12,
// // //           fontWeight: 600,
// // //           color: "#5F5E5A",
// // //           letterSpacing: "0.02em",
// // //           textTransform: "uppercase",
// // //           marginBottom: 6,
// // //         }}
// // //       >
// // //         {label}
// // //       </span>
// // //       {children}
// // //       {hint && (
// // //         <span
// // //           style={{
// // //             display: "block",
// // //             fontSize: 12,
// // //             color: "#9A988E",
// // //             marginTop: 4,
// // //           }}
// // //         >
// // //           {hint}
// // //         </span>
// // //       )}
// // //     </label>
// // //   );
// // // }

// // // const inputStyle = {
// // //   width: "100%",
// // //   boxSizing: "border-box",
// // //   padding: "9px 11px",
// // //   borderRadius: 8,
// // //   border: "1px solid #DEDCD1",
// // //   fontSize: 14,
// // //   fontFamily: "'IBM Plex Sans', sans-serif",
// // //   color: "#20201C",
// // //   background: "#FFFFFF",
// // //   outline: "none",
// // // };
// // // const monoStyle = {
// // //   ...inputStyle,
// // //   fontFamily: "'IBM Plex Mono', monospace",
// // //   fontSize: 13,
// // // };
// // // const selectStyle = { ...inputStyle, cursor: "pointer" };
// // // const textareaStyle = {
// // //   ...inputStyle,
// // //   resize: "vertical",
// // //   minHeight: 70,
// // //   lineHeight: 1.5,
// // // };

// // // function IconBtn({ onClick, title, children, danger, active }) {
// // //   return (
// // //     <button
// // //       onClick={onClick}
// // //       title={title}
// // //       style={{
// // //         display: "inline-flex",
// // //         alignItems: "center",
// // //         justifyContent: "center",
// // //         width: 28,
// // //         height: 28,
// // //         borderRadius: 6,
// // //         border: active ? "1px solid #1B2340" : "1px solid #E4E2D8",
// // //         background: active ? "#1B2340" : "#fff",
// // //         color: active ? "#fff" : danger ? "#993C1D" : "#5F5E5A",
// // //         cursor: "pointer",
// // //       }}
// // //     >
// // //       {children}
// // //     </button>
// // //   );
// // // }

// // // function AlignPicker({ value, onChange }) {
// // //   return (
// // //     <Field label="Text align">
// // //       <div style={{ display: "flex", gap: 6 }}>
// // //         {ALIGN_OPTIONS.map((opt) => {
// // //           const Icon = opt.icon;
// // //           return (
// // //             <IconBtn
// // //               key={opt.value}
// // //               title={opt.label}
// // //               active={value === opt.value}
// // //               onClick={() => onChange(opt.value)}
// // //             >
// // //               <Icon size={14} />
// // //             </IconBtn>
// // //           );
// // //         })}
// // //       </div>
// // //     </Field>
// // //   );
// // // }

// // // function ImageDimensionFields({ width, height, objectFit, onChange }) {
// // //   return (
// // //     <div
// // //       style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}
// // //     >
// // //       <Field label="Width" hint="px, % or auto">
// // //         <input
// // //           style={inputStyle}
// // //           value={width}
// // //           onChange={(e) => onChange({ width: e.target.value })}
// // //           placeholder="100%"
// // //         />
// // //       </Field>
// // //       <Field label="Height" hint="px or auto">
// // //         <input
// // //           style={inputStyle}
// // //           value={height}
// // //           onChange={(e) => onChange({ height: e.target.value })}
// // //           placeholder="220px"
// // //         />
// // //       </Field>
// // //       <Field label="Fit">
// // //         <select
// // //           style={selectStyle}
// // //           value={objectFit}
// // //           onChange={(e) => onChange({ objectFit: e.target.value })}
// // //         >
// // //           {OBJECT_FIT_OPTIONS.map((f) => (
// // //             <option key={f} value={f}>
// // //               {f}
// // //             </option>
// // //           ))}
// // //         </select>
// // //       </Field>
// // //     </div>
// // //   );
// // // }

// // // function JsonField({ label, value, onChange }) {
// // //   const [error, setError] = useState(null);
// // //   return (
// // //     <Field label={label} hint={error ? null : "Valid JSON object"}>
// // //       <textarea
// // //         style={{ ...monoStyle, minHeight: 120 }}
// // //         value={value}
// // //         onChange={(e) => {
// // //           onChange(e.target.value);
// // //           try {
// // //             JSON.parse(e.target.value);
// // //             setError(null);
// // //           } catch {
// // //             setError("Not valid JSON yet");
// // //           }
// // //         }}
// // //       />
// // //       {error && (
// // //         <span
// // //           style={{
// // //             display: "block",
// // //             fontSize: 12,
// // //             color: "#993C1D",
// // //             marginTop: 4,
// // //           }}
// // //         >
// // //           {error}
// // //         </span>
// // //       )}
// // //     </Field>
// // //   );
// // // }

// // // function BlockCard({ block, index, total, onChange, onRemove, onMove }) {
// // //   const [open, setOpen] = useState(true);
// // //   const meta = BLOCK_TYPES[block.type];
// // //   const Icon = meta.icon;
// // //   const c = RAMP[meta.ramp];
// // //   const patch = (field, val) => onChange({ ...block, [field]: val });

// // //   return (
// // //     <div
// // //       style={{
// // //         border: "1px solid #E4E2D8",
// // //         borderRadius: 12,
// // //         background: "#FFFFFF",
// // //         marginBottom: 12,
// // //         overflow: "hidden",
// // //       }}
// // //     >
// // //       <div
// // //         style={{
// // //           display: "flex",
// // //           alignItems: "center",
// // //           gap: 10,
// // //           padding: "10px 12px",
// // //           background: c[50],
// // //           cursor: "pointer",
// // //           userSelect: "none",
// // //         }}
// // //         onClick={() => setOpen((o) => !o)}
// // //       >
// // //         <GripVertical size={15} color={c[600]} style={{ flexShrink: 0 }} />
// // //         <span
// // //           style={{
// // //             fontSize: 12,
// // //             fontFamily: "'IBM Plex Mono', monospace",
// // //             color: c[600],
// // //             fontWeight: 600,
// // //           }}
// // //         >
// // //           {String(index + 1).padStart(2, "0")}
// // //         </span>
// // //         <Icon size={15} color={c[800]} style={{ flexShrink: 0 }} />
// // //         <span style={{ fontSize: 13, fontWeight: 600, color: c[800] }}>
// // //           {meta.label}
// // //         </span>
// // //         <span
// // //           style={{
// // //             fontSize: 12,
// // //             color: c[600],
// // //             marginLeft: 2,
// // //             overflow: "hidden",
// // //             textOverflow: "ellipsis",
// // //             whiteSpace: "nowrap",
// // //             flex: 1,
// // //           }}
// // //         >
// // //           {blockPreview(block)}
// // //         </span>
// // //         <div
// // //           style={{ display: "flex", gap: 4 }}
// // //           onClick={(e) => e.stopPropagation()}
// // //         >
// // //           <IconBtn
// // //             title="Move up"
// // //             onClick={() => index > 0 && onMove(index, index - 1)}
// // //           >
// // //             <ChevronUp size={14} />
// // //           </IconBtn>
// // //           <IconBtn
// // //             title="Move down"
// // //             onClick={() => index < total - 1 && onMove(index, index + 1)}
// // //           >
// // //             <ChevronDown size={14} />
// // //           </IconBtn>
// // //           <IconBtn title="Delete block" danger onClick={() => onRemove(index)}>
// // //             <Trash2 size={14} />
// // //           </IconBtn>
// // //           <Caret
// // //             size={16}
// // //             color={c[600]}
// // //             style={{
// // //               transform: open ? "rotate(180deg)" : "none",
// // //               transition: "transform 0.15s",
// // //               marginLeft: 2,
// // //             }}
// // //           />
// // //         </div>
// // //       </div>

// // //       {open && (
// // //         <div style={{ padding: 16 }}>
// // //           <BlockFields block={block} patch={patch} onChange={onChange} />
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // }

// // // function blockPreview(b) {
// // //   if (b.type === "heading" || b.type === "paragraph" || b.type === "callout")
// // //     return b.text || "Empty";
// // //   if (b.type === "list")
// // //     return `${b.items.length} item${b.items.length === 1 ? "" : "s"}`;
// // //   if (b.type === "slider")
// // //     return `${b.images.length} image${b.images.length === 1 ? "" : "s"}`;
// // //   if (b.type === "image") return b.image_key || "unkeyed";
// // //   if (b.type === "columns")
// // //     return `${b.left?.heading || "Left"} / ${b.right?.heading || "Right"}`;
// // //   if (b.type === "code") return b.language;
// // //   if (b.type === "request_payload" || b.type === "success_response")
// // //     return "JSON data";
// // //   return "";
// // // }

// // // function ColumnEditor({ label, value, onChange }) {
// // //   const patch = (field, val) => onChange({ ...value, [field]: val });
// // //   const patchImage = (fields) =>
// // //     onChange({ ...value, image: { ...value.image, ...fields } });
// // //   return (
// // //     <div
// // //       style={{
// // //         border: "1px solid #EDEBE0",
// // //         borderRadius: 9,
// // //         padding: 12,
// // //         flex: 1,
// // //         minWidth: 0,
// // //       }}
// // //     >
// // //       <div
// // //         style={{
// // //           fontSize: 12,
// // //           fontWeight: 600,
// // //           color: "#8A8878",
// // //           marginBottom: 8,
// // //         }}
// // //       >
// // //         {label}
// // //       </div>
// // //       <Field label="Heading">
// // //         <input
// // //           style={inputStyle}
// // //           value={value.heading}
// // //           onChange={(e) => patch("heading", e.target.value)}
// // //           placeholder="Column heading"
// // //         />
// // //       </Field>
// // //       <Field label="Text">
// // //         <textarea
// // //           style={textareaStyle}
// // //           value={value.text}
// // //           onChange={(e) => patch("text", e.target.value)}
// // //           placeholder="Column copy..."
// // //         />
// // //       </Field>
// // //       <AlignPicker value={value.align} onChange={(v) => patch("align", v)} />
// // //       <Field label="Image URL (optional)">
// // //         <input
// // //           style={inputStyle}
// // //           value={value.image.url}
// // //           onChange={(e) => patchImage({ url: e.target.value })}
// // //           placeholder="https://..."
// // //         />
// // //       </Field>
// // //       {value.image.url && (
// // //         <>
// // //           <Field label="Alt text">
// // //             <input
// // //               style={inputStyle}
// // //               value={value.image.alt}
// // //               onChange={(e) => patchImage({ alt: e.target.value })}
// // //               placeholder="Accessible description"
// // //             />
// // //           </Field>
// // //           <ImageDimensionFields
// // //             width={value.image.width}
// // //             height={value.image.height}
// // //             objectFit={value.image.objectFit}
// // //             onChange={patchImage}
// // //           />
// // //         </>
// // //       )}
// // //     </div>
// // //   );
// // // }

// // // function BlockFields({ block, patch }) {
// // //   switch (block.type) {
// // //     case "heading":
// // //       return (
// // //         <>
// // //           <Field label="Level">
// // //             <select
// // //               style={selectStyle}
// // //               value={block.level}
// // //               onChange={(e) => patch("level", e.target.value)}
// // //             >
// // //               {["h1", "h2", "h3", "h4"].map((l) => (
// // //                 <option key={l} value={l}>
// // //                   {l.toUpperCase()}
// // //                 </option>
// // //               ))}
// // //             </select>
// // //           </Field>
// // //           <Field label="Heading text">
// // //             <input
// // //               style={inputStyle}
// // //               value={block.text}
// // //               onChange={(e) => patch("text", e.target.value)}
// // //               placeholder="Section heading"
// // //             />
// // //           </Field>
// // //           <AlignPicker
// // //             value={block.align || "left"}
// // //             onChange={(v) => patch("align", v)}
// // //           />
// // //         </>
// // //       );
// // //     case "paragraph":
// // //       return (
// // //         <>
// // //           <Field label="Paragraph text">
// // //             <textarea
// // //               style={textareaStyle}
// // //               value={block.text}
// // //               onChange={(e) => patch("text", e.target.value)}
// // //               placeholder="Write the paragraph copy..."
// // //             />
// // //           </Field>
// // //           <AlignPicker
// // //             value={block.align || "left"}
// // //             onChange={(v) => patch("align", v)}
// // //           />
// // //         </>
// // //       );
// // //     case "callout":
// // //       return (
// // //         <>
// // //           <Field label="Style">
// // //             <select
// // //               style={selectStyle}
// // //               value={block.style}
// // //               onChange={(e) => patch("style", e.target.value)}
// // //             >
// // //               {["info", "warning", "success", "error"].map((s) => (
// // //                 <option key={s} value={s}>
// // //                   {s}
// // //                 </option>
// // //               ))}
// // //             </select>
// // //           </Field>
// // //           <Field label="Callout text">
// // //             <textarea
// // //               style={textareaStyle}
// // //               value={block.text}
// // //               onChange={(e) => patch("text", e.target.value)}
// // //               placeholder="Warning or note copy..."
// // //             />
// // //           </Field>
// // //           <AlignPicker
// // //             value={block.align || "left"}
// // //             onChange={(v) => patch("align", v)}
// // //           />
// // //         </>
// // //       );
// // //     case "list":
// // //       return (
// // //         <>
// // //           <Field label="Style">
// // //             <select
// // //               style={selectStyle}
// // //               value={block.style}
// // //               onChange={(e) => patch("style", e.target.value)}
// // //             >
// // //               <option value="bullet">Bullet</option>
// // //               <option value="number">Numbered</option>
// // //             </select>
// // //           </Field>
// // //           <Field label="Items">
// // //             {block.items.map((item, i) => (
// // //               <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
// // //                 <input
// // //                   style={inputStyle}
// // //                   value={item}
// // //                   onChange={(e) => {
// // //                     const items = [...block.items];
// // //                     items[i] = e.target.value;
// // //                     patch("items", items);
// // //                   }}
// // //                   placeholder={`Item ${i + 1}`}
// // //                 />
// // //                 <IconBtn
// // //                   title="Remove item"
// // //                   danger
// // //                   onClick={() =>
// // //                     patch(
// // //                       "items",
// // //                       block.items.filter((_, idx) => idx !== i),
// // //                     )
// // //                   }
// // //                 >
// // //                   <Trash2 size={13} />
// // //                 </IconBtn>
// // //               </div>
// // //             ))}
// // //             <button
// // //               onClick={() => patch("items", [...block.items, ""])}
// // //               style={{
// // //                 display: "inline-flex",
// // //                 alignItems: "center",
// // //                 gap: 6,
// // //                 marginTop: 2,
// // //                 fontSize: 13,
// // //                 padding: "6px 10px",
// // //                 borderRadius: 7,
// // //                 border: "1px dashed #C7C4B6",
// // //                 background: "transparent",
// // //                 color: "#5F5E5A",
// // //                 cursor: "pointer",
// // //               }}
// // //             >
// // //               <Plus size={13} /> Add item
// // //             </button>
// // //           </Field>
// // //           <AlignPicker
// // //             value={block.align || "left"}
// // //             onChange={(v) => patch("align", v)}
// // //           />
// // //         </>
// // //       );
// // //     case "slider":
// // //       return (
// // //         <>
// // //           {block.images.map((img, i) => (
// // //             <div
// // //               key={i}
// // //               style={{
// // //                 border: "1px solid #EDEBE0",
// // //                 borderRadius: 9,
// // //                 padding: 12,
// // //                 marginBottom: 10,
// // //               }}
// // //             >
// // //               <div
// // //                 style={{
// // //                   display: "flex",
// // //                   justifyContent: "space-between",
// // //                   alignItems: "center",
// // //                   marginBottom: 8,
// // //                 }}
// // //               >
// // //                 <span
// // //                   style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
// // //                 >
// // //                   Slide {i + 1}
// // //                 </span>
// // //                 <IconBtn
// // //                   title="Remove slide"
// // //                   danger
// // //                   onClick={() =>
// // //                     patch(
// // //                       "images",
// // //                       block.images.filter((_, idx) => idx !== i),
// // //                     )
// // //                   }
// // //                 >
// // //                   <Trash2 size={13} />
// // //                 </IconBtn>
// // //               </div>
// // //               <ImageKeyField
// // //                 value={img.image_key}
// // //                 onChange={(v) => {
// // //                   const images = [...block.images];
// // //                   images[i] = { ...images[i], image_key: v };
// // //                   patch("images", images);
// // //                 }}
// // //                 prefix="slide"
// // //               />
// // //               <Field label="Image URL">
// // //                 <input
// // //                   style={inputStyle}
// // //                   value={img.url}
// // //                   onChange={(e) => {
// // //                     const images = [...block.images];
// // //                     images[i] = { ...images[i], url: e.target.value };
// // //                     patch("images", images);
// // //                   }}
// // //                   placeholder="https://..."
// // //                 />
// // //               </Field>
// // //               <Field label="Caption">
// // //                 <input
// // //                   style={inputStyle}
// // //                   value={img.caption}
// // //                   onChange={(e) => {
// // //                     const images = [...block.images];
// // //                     images[i] = { ...images[i], caption: e.target.value };
// // //                     patch("images", images);
// // //                   }}
// // //                   placeholder="What this slide shows"
// // //                 />
// // //               </Field>
// // //               <Field label="Alt text">
// // //                 <input
// // //                   style={inputStyle}
// // //                   value={img.alt}
// // //                   onChange={(e) => {
// // //                     const images = [...block.images];
// // //                     images[i] = { ...images[i], alt: e.target.value };
// // //                     patch("images", images);
// // //                   }}
// // //                   placeholder="Accessible description"
// // //                 />
// // //               </Field>
// // //               <ImageDimensionFields
// // //                 width={img.width || "100%"}
// // //                 height={img.height || "220px"}
// // //                 objectFit={img.objectFit || "cover"}
// // //                 onChange={(fields) => {
// // //                   const images = [...block.images];
// // //                   images[i] = { ...images[i], ...fields };
// // //                   patch("images", images);
// // //                 }}
// // //               />
// // //             </div>
// // //           ))}
// // //           <button
// // //             onClick={() =>
// // //               patch("images", [...block.images, emptyImageValue("slider_step")])
// // //             }
// // //             style={{
// // //               display: "inline-flex",
// // //               alignItems: "center",
// // //               gap: 6,
// // //               fontSize: 13,
// // //               padding: "6px 10px",
// // //               borderRadius: 7,
// // //               border: "1px dashed #C7C4B6",
// // //               background: "transparent",
// // //               color: "#5F5E5A",
// // //               cursor: "pointer",
// // //             }}
// // //           >
// // //             <Plus size={13} /> Add slide
// // //           </button>
// // //         </>
// // //       );
// // //     case "image":
// // //       return (
// // //         <>
// // //           <ImageKeyField
// // //             value={block.image_key}
// // //             onChange={(v) => patch("image_key", v)}
// // //             prefix="image"
// // //           />
// // //           <Field label="Image URL">
// // //             <input
// // //               style={inputStyle}
// // //               value={block.url}
// // //               onChange={(e) => patch("url", e.target.value)}
// // //               placeholder="https://..."
// // //             />
// // //           </Field>
// // //           <Field label="Caption">
// // //             <input
// // //               style={inputStyle}
// // //               value={block.caption}
// // //               onChange={(e) => patch("caption", e.target.value)}
// // //               placeholder="Figure caption"
// // //             />
// // //           </Field>
// // //           <Field
// // //             label="Container align"
// // //             hint="Position of the image within the document width"
// // //           >
// // //             <div style={{ display: "flex", gap: 6 }}>
// // //               {[
// // //                 { value: "left", label: "Left", icon: AlignLeft },
// // //                 { value: "center", label: "Center", icon: AlignCenter },
// // //                 { value: "right", label: "Right", icon: AlignRight },
// // //               ].map((opt) => {
// // //                 const Ic = opt.icon;
// // //                 return (
// // //                   <IconBtn
// // //                     key={opt.value}
// // //                     title={opt.label}
// // //                     active={block.align === opt.value}
// // //                     onClick={() => patch("align", opt.value)}
// // //                   >
// // //                     <Ic size={14} />
// // //                   </IconBtn>
// // //                 );
// // //               })}
// // //             </div>
// // //           </Field>
// // //           <ImageDimensionFields
// // //             width={block.width || "100%"}
// // //             height={block.height || "auto"}
// // //             objectFit={block.objectFit || "cover"}
// // //             onChange={(fields) =>
// // //               Object.entries(fields).forEach(([k, v]) => patch(k, v))
// // //             }
// // //           />
// // //         </>
// // //       );
// // //     case "columns":
// // //       return (
// // //         <>
// // //           <Field label="Gap between columns" hint="in pixels">
// // //             <input
// // //               type="number"
// // //               style={{ ...inputStyle, width: 120 }}
// // //               value={block.gap}
// // //               onChange={(e) => patch("gap", Number(e.target.value) || 0)}
// // //             />
// // //           </Field>
// // //           <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
// // //             <ColumnEditor
// // //               label="Left column"
// // //               value={block.left}
// // //               onChange={(v) => patch("left", v)}
// // //             />
// // //             <ColumnEditor
// // //               label="Right column"
// // //               value={block.right}
// // //               onChange={(v) => patch("right", v)}
// // //             />
// // //           </div>
// // //         </>
// // //       );
// // //     case "code":
// // //       return (
// // //         <>
// // //           <Field label="Language">
// // //             <input
// // //               style={inputStyle}
// // //               value={block.language}
// // //               onChange={(e) => patch("language", e.target.value)}
// // //               placeholder="python"
// // //             />
// // //           </Field>
// // //           <Field label="Code">
// // //             <textarea
// // //               style={{ ...monoStyle, minHeight: 140 }}
// // //               value={block.code}
// // //               onChange={(e) => patch("code", e.target.value)}
// // //               placeholder="Paste the code sample..."
// // //             />
// // //           </Field>
// // //         </>
// // //       );
// // //     case "request_payload":
// // //     case "success_response":
// // //       return (
// // //         <JsonField
// // //           label="JSON data"
// // //           value={block.data}
// // //           onChange={(v) => patch("data", v)}
// // //         />
// // //       );
// // //     default:
// // //       return null;
// // //   }
// // // }

// // // function ImageKeyField({ value, onChange, prefix }) {
// // //   return (
// // //     <Field
// // //       label="Image key"
// // //       hint="Used to reference this image elsewhere in the document"
// // //     >
// // //       <div style={{ display: "flex", gap: 6 }}>
// // //         <div style={{ position: "relative", flex: 1 }}>
// // //           <KeyRound
// // //             size={13}
// // //             color="#9A988E"
// // //             style={{ position: "absolute", left: 10, top: 12 }}
// // //           />
// // //           <input
// // //             style={{ ...monoStyle, paddingLeft: 30 }}
// // //             value={value}
// // //             onChange={(e) => onChange(e.target.value)}
// // //             placeholder="unique_image_key"
// // //           />
// // //         </div>
// // //         <IconBtn
// // //           title="Generate a new key"
// // //           onClick={() => onChange(genKey(prefix))}
// // //         >
// // //           <RefreshCw size={13} />
// // //         </IconBtn>
// // //       </div>
// // //     </Field>
// // //   );
// // // }

// // // function PreviewImg({ src, alt, style }) {
// // //   const [broken, setBroken] = useState(false);
// // //   if (!src || broken) {
// // //     return (
// // //       <div
// // //         style={{
// // //           display: "flex",
// // //           flexDirection: "column",
// // //           alignItems: "center",
// // //           justifyContent: "center",
// // //           gap: 6,
// // //           background: "#F1EFE8",
// // //           border: "1px dashed #C7C4B6",
// // //           borderRadius: 8,
// // //           color: "#8A8878",
// // //           fontSize: 12,
// // //           minHeight: 110,
// // //           ...style,
// // //         }}
// // //       >
// // //         <ImageOff size={18} />
// // //         <span>{alt || "Image"}</span>
// // //       </div>
// // //     );
// // //   }
// // //   return (
// // //     <img
// // //       src={src}
// // //       alt={alt}
// // //       onError={() => setBroken(true)}
// // //       style={{ display: "block", borderRadius: 8, ...style }}
// // //     />
// // //   );
// // // }

// // // function SliderPreview({ images }) {
// // //   const [i, setI] = useState(0);
// // //   if (!images.length) return null;
// // //   const img = images[Math.min(i, images.length - 1)];
// // //   return (
// // //     <div
// // //       style={{
// // //         border: "1px solid #E4E2D8",
// // //         borderRadius: 10,
// // //         overflow: "hidden",
// // //         background: "#FAF9F4",
// // //       }}
// // //     >
// // //       <PreviewImg
// // //         src={img.url}
// // //         alt={img.alt}
// // //         style={{
// // //           width: img.width || "100%",
// // //           height: img.height || "220px",
// // //           objectFit: img.objectFit || "cover",
// // //           borderRadius: 0,
// // //         }}
// // //       />
// // //       <div
// // //         style={{
// // //           padding: "10px 14px",
// // //           display: "flex",
// // //           alignItems: "center",
// // //           gap: 10,
// // //         }}
// // //       >
// // //         <button
// // //           onClick={() => setI((v) => (v - 1 + images.length) % images.length)}
// // //           style={{
// // //             border: "1px solid #E4E2D8",
// // //             background: "#fff",
// // //             borderRadius: 6,
// // //             width: 26,
// // //             height: 26,
// // //             display: "flex",
// // //             alignItems: "center",
// // //             justifyContent: "center",
// // //             cursor: "pointer",
// // //             flexShrink: 0,
// // //           }}
// // //         >
// // //           <ChevronLeft size={14} />
// // //         </button>
// // //         <div style={{ flex: 1 }}>
// // //           <div style={{ fontSize: 13, color: "#20201C", lineHeight: 1.5 }}>
// // //             {img.caption || "No caption"}
// // //           </div>
// // //           <div style={{ fontSize: 11, color: "#9A988E", marginTop: 2 }}>
// // //             {i + 1} of {images.length}
// // //           </div>
// // //         </div>
// // //         <button
// // //           onClick={() => setI((v) => (v + 1) % images.length)}
// // //           style={{
// // //             border: "1px solid #E4E2D8",
// // //             background: "#fff",
// // //             borderRadius: 6,
// // //             width: 26,
// // //             height: 26,
// // //             display: "flex",
// // //             alignItems: "center",
// // //             justifyContent: "center",
// // //             cursor: "pointer",
// // //             flexShrink: 0,
// // //           }}
// // //         >
// // //           <ChevronRight size={14} />
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // function ColumnContent({ value }) {
// // //   const align = value.align || "left";
// // //   const justify =
// // //     align === "center"
// // //       ? "center"
// // //       : align === "right"
// // //         ? "flex-end"
// // //         : "flex-start";
// // //   return (
// // //     <div
// // //       style={{
// // //         flex: 1,
// // //         minWidth: 0,
// // //         textAlign: align,
// // //         display: "flex",
// // //         flexDirection: "column",
// // //         alignItems: justify,
// // //       }}
// // //     >
// // //       {value.heading && (
// // //         <div
// // //           style={{
// // //             fontSize: 15,
// // //             fontWeight: 600,
// // //             color: "#1B2340",
// // //             marginBottom: 6,
// // //           }}
// // //         >
// // //           {value.heading}
// // //         </div>
// // //       )}
// // //       {value.image?.url && (
// // //         <PreviewImg
// // //           src={value.image.url}
// // //           alt={value.image.alt}
// // //           style={{
// // //             width: value.image.width || "100%",
// // //             height: value.image.height || "160px",
// // //             objectFit: value.image.objectFit || "cover",
// // //             marginBottom: 8,
// // //           }}
// // //         />
// // //       )}
// // //       {value.text && (
// // //         <p
// // //           style={{
// // //             fontSize: 13.5,
// // //             lineHeight: 1.7,
// // //             color: "#3A3A34",
// // //             margin: 0,
// // //           }}
// // //         >
// // //           {value.text}
// // //         </p>
// // //       )}
// // //     </div>
// // //   );
// // // }

// // // function RenderedBlock({ block }) {
// // //   switch (block.type) {
// // //     case "heading": {
// // //       const sizes = { h1: 24, h2: 20, h3: 17, h4: 15 };
// // //       return (
// // //         <div
// // //           style={{
// // //             fontSize: sizes[block.level] || 18,
// // //             fontWeight: 600,
// // //             color: "#1B2340",
// // //             margin: "4px 0",
// // //             textAlign: block.align || "left",
// // //           }}
// // //         >
// // //           {block.text || (
// // //             <span style={{ color: "#C7C4B6" }}>Empty heading</span>
// // //           )}
// // //         </div>
// // //       );
// // //     }
// // //     case "paragraph":
// // //       return (
// // //         <p
// // //           style={{
// // //             fontSize: 14,
// // //             lineHeight: 1.7,
// // //             color: "#3A3A34",
// // //             margin: "4px 0",
// // //             textAlign: block.align || "left",
// // //           }}
// // //         >
// // //           {block.text || (
// // //             <span style={{ color: "#C7C4B6" }}>Empty paragraph</span>
// // //           )}
// // //         </p>
// // //       );
// // //     case "callout": {
// // //       const s = CALLOUT_STYLE[block.style] || CALLOUT_STYLE.info;
// // //       const Icon = s.icon;
// // //       return (
// // //         <div
// // //           style={{
// // //             display: "flex",
// // //             gap: 10,
// // //             background: s.bg,
// // //             borderLeft: `3px solid ${s.border}`,
// // //             borderRadius: 6,
// // //             padding: "10px 12px",
// // //             textAlign: block.align || "left",
// // //           }}
// // //         >
// // //           <Icon
// // //             size={16}
// // //             color={s.text}
// // //             style={{ flexShrink: 0, marginTop: 1 }}
// // //           />
// // //           <span
// // //             style={{ fontSize: 13.5, color: s.text, lineHeight: 1.6, flex: 1 }}
// // //           >
// // //             {block.text || "Empty callout"}
// // //           </span>
// // //         </div>
// // //       );
// // //     }
// // //     case "list": {
// // //       const Tag = block.style === "number" ? "ol" : "ul";
// // //       return (
// // //         <Tag
// // //           style={{
// // //             margin: "4px 0",
// // //             paddingLeft: 20,
// // //             textAlign: block.align || "left",
// // //           }}
// // //         >
// // //           {block.items.map((it, i) => (
// // //             <li
// // //               key={i}
// // //               style={{ fontSize: 14, color: "#3A3A34", lineHeight: 1.7 }}
// // //             >
// // //               {it || <span style={{ color: "#C7C4B6" }}>Empty item</span>}
// // //             </li>
// // //           ))}
// // //         </Tag>
// // //       );
// // //     }
// // //     case "slider":
// // //       return <SliderPreview images={block.images} />;
// // //     case "image": {
// // //       const align = block.align || "center";
// // //       const marginLeft = align === "left" ? 0 : "auto";
// // //       const marginRight = align === "right" ? 0 : "auto";
// // //       return (
// // //         <div style={{ textAlign: align }}>
// // //           <PreviewImg
// // //             src={block.url}
// // //             alt={block.alt}
// // //             style={{
// // //               width: block.width || "100%",
// // //               height: block.height || "auto",
// // //               objectFit: block.objectFit || "cover",
// // //               maxWidth: "100%",
// // //               marginLeft,
// // //               marginRight,
// // //             }}
// // //           />
// // //           {block.caption && (
// // //             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
// // //               {block.caption}
// // //             </div>
// // //           )}
// // //         </div>
// // //       );
// // //     }
// // //     case "columns":
// // //       return (
// // //         <div
// // //           style={{ display: "flex", gap: block.gap ?? 20, flexWrap: "wrap" }}
// // //         >
// // //           <ColumnContent value={block.left} />
// // //           <ColumnContent value={block.right} />
// // //         </div>
// // //       );
// // //     case "code":
// // //       return (
// // //         <div
// // //           style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
// // //         >
// // //           <div
// // //             style={{
// // //               padding: "6px 12px",
// // //               fontSize: 11,
// // //               color: "#9BA6C7",
// // //               fontFamily: "'IBM Plex Mono', monospace",
// // //               borderBottom: "1px solid #2A335C",
// // //             }}
// // //           >
// // //             {block.language || "code"}
// // //           </div>
// // //           <pre
// // //             style={{
// // //               margin: 0,
// // //               padding: 12,
// // //               fontSize: 12.5,
// // //               color: "#E6EAF5",
// // //               fontFamily: "'IBM Plex Mono', monospace",
// // //               overflow: "auto",
// // //             }}
// // //           >
// // //             {block.code || "// empty"}
// // //           </pre>
// // //         </div>
// // //       );
// // //     case "request_payload":
// // //     case "success_response": {
// // //       const isSuccess = block.type === "success_response";
// // //       let pretty = block.data;
// // //       try {
// // //         pretty = JSON.stringify(JSON.parse(block.data), null, 2);
// // //       } catch {
// // //         /* keep raw */
// // //       }
// // //       return (
// // //         <div
// // //           style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
// // //         >
// // //           <div
// // //             style={{
// // //               display: "flex",
// // //               alignItems: "center",
// // //               justifyContent: "space-between",
// // //               padding: "6px 12px",
// // //               borderBottom: "1px solid #2A335C",
// // //             }}
// // //           >
// // //             <span
// // //               style={{
// // //                 fontSize: 11,
// // //                 color: "#9BA6C7",
// // //                 fontFamily: "'IBM Plex Mono', monospace",
// // //               }}
// // //             >
// // //               {isSuccess ? "response" : "request payload"}
// // //             </span>
// // //             {isSuccess && (
// // //               <span
// // //                 style={{
// // //                   fontSize: 10,
// // //                   fontWeight: 600,
// // //                   color: "#27500A",
// // //                   background: "#C0DD97",
// // //                   borderRadius: 4,
// // //                   padding: "2px 6px",
// // //                 }}
// // //               >
// // //                 201 success
// // //               </span>
// // //             )}
// // //           </div>
// // //           <pre
// // //             style={{
// // //               margin: 0,
// // //               padding: 12,
// // //               fontSize: 12.5,
// // //               color: "#E6EAF5",
// // //               fontFamily: "'IBM Plex Mono', monospace",
// // //               overflow: "auto",
// // //             }}
// // //           >
// // //             {pretty}
// // //           </pre>
// // //         </div>
// // //       );
// // //     }
// // //     default:
// // //       return null;
// // //   }
// // // }

// // // function DocumentPreview({ values }) {
// // //   return (
// // //     <div
// // //       style={{
// // //         background: "#fff",
// // //         borderRadius: 12,
// // //         border: "1px solid #E4E2D8",
// // //         padding: "20px 22px",
// // //       }}
// // //     >
// // //       <div
// // //         style={{
// // //           fontSize: 11,
// // //           fontWeight: 600,
// // //           color: "#8A8878",
// // //           textTransform: "uppercase",
// // //           letterSpacing: "0.04em",
// // //           marginBottom: 6,
// // //         }}
// // //       >
// // //         {values.category} · {values.doc_type}
// // //       </div>
// // //       <div
// // //         style={{
// // //           fontSize: 22,
// // //           fontWeight: 700,
// // //           color: "#1B2340",
// // //           fontFamily: "'Space Grotesk', sans-serif",
// // //           marginBottom: 8,
// // //         }}
// // //       >
// // //         {values.title || "Untitled workflow doc"}
// // //       </div>
// // //       <p
// // //         style={{
// // //           fontSize: 14,
// // //           color: "#5F5E5A",
// // //           lineHeight: 1.7,
// // //           marginBottom: 18,
// // //         }}
// // //       >
// // //         {values.overview}
// // //       </p>
// // //       <div
// // //         style={{
// // //           display: "flex",
// // //           gap: 8,
// // //           alignItems: "center",
// // //           marginBottom: 20,
// // //           fontFamily: "'IBM Plex Mono', monospace",
// // //           fontSize: 12.5,
// // //         }}
// // //       >
// // //         <span
// // //           style={{
// // //             background: "#1B2340",
// // //             color: "#fff",
// // //             borderRadius: 5,
// // //             padding: "3px 8px",
// // //             fontWeight: 600,
// // //           }}
// // //         >
// // //           {values.api_method}
// // //         </span>
// // //         <span style={{ color: "#5F5E5A", wordBreak: "break-all" }}>
// // //           {values.api_endpoint}
// // //         </span>
// // //       </div>
// // //       <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
// // //         {values.content_blocks.map((b) => (
// // //           <RenderedBlock key={b.id} block={b} />
// // //         ))}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // function toExportBlock(b) {
// // //   const { id, ...rest } = b;
// // //   if (b.type === "request_payload" || b.type === "success_response") {
// // //     let parsed;
// // //     try {
// // //       parsed = JSON.parse(b.data);
// // //     } catch {
// // //       parsed = b.data;
// // //     }
// // //     return { type: b.type, data: parsed };
// // //   }
// // //   return rest;
// // // }

// // // export default function HrmsBlockEditor() {
// // //   const { values, setField } = useFormikLike(initialValues);
// // //   const [copied, setCopied] = useState(false);
// // //   const [showPreview, setShowPreview] = useState(true);
// // //   const [previewTab, setPreviewTab] = useState("rendered");
// // //   const [addType, setAddType] = useState("paragraph");

// // //   const { mutate: AddDocuments } = useMutation(postDocument, {
// // //     onSuccess: (res) => {
// // //       if (res?.data?.response_code == 200) {
// // //         toast.success(res?.data?.message);
// // //       } else {
// // //         toast.warn(res?.data?.message);
// // //       }
// // //     },
// // //   });

// // //   const blocks = values.content_blocks;

// // //   const updateBlock = (idx, updated) => {
// // //     const next = [...blocks];
// // //     next[idx] = updated;
// // //     setField("content_blocks", next);
// // //   };
// // //   const removeBlock = (idx) =>
// // //     setField(
// // //       "content_blocks",
// // //       blocks.filter((_, i) => i !== idx),
// // //     );
// // //   const moveBlock = (from, to) => {
// // //     const next = [...blocks];
// // //     const [item] = next.splice(from, 1);
// // //     next.splice(to, 0, item);
// // //     setField("content_blocks", next);
// // //   };
// // //   const addBlock = () =>
// // //     setField("content_blocks", [...blocks, emptyBlockFor(addType)]);

// // //   const exportJson = {
// // //     category: values.category,
// // //     title: values.title,
// // //     doc_type: values.doc_type,
// // //     overview: values.overview,
// // //     api_method: values.api_method,
// // //     api_endpoint: values.api_endpoint,
// // //     content_blocks: blocks.map(toExportBlock),
// // //   };

// // //   const jsonString = JSON.stringify(exportJson, null, 2);

// // //   const copyJson = async () => {
// // //     try {
// // //       await navigator.clipboard.writeText(jsonString);
// // //       setCopied(true);
// // //       setTimeout(() => setCopied(false), 1500);
// // //     } catch {
// // //       setCopied(false);
// // //     }
// // //   };
// // //   const saveDocument = async () => {
// // //     AddDocuments(exportJson);
// // //   };

// // //   return (
// // //     <div
// // //       style={{
// // //         fontFamily: "'IBM Plex Sans', sans-serif",
// // //         background: "#F3F2EC",
// // //         padding: 24,
// // //         minHeight: "100vh",
// // //         boxSizing: "border-box",
// // //       }}
// // //     >
// // //       <style>{`
// // //         @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&family=Space+Grotesk:wght@600;700&display=swap');
// // //         input:focus, textarea:focus, select:focus { border-color: #185FA5 !important; box-shadow: 0 0 0 3px rgba(24,95,165,0.12); }
// // //       `}</style>

// // //       <div style={{ maxWidth: 1180, margin: "0 auto" }}>
// // //         <div
// // //           style={{
// // //             display: "flex",
// // //             alignItems: "baseline",
// // //             justifyContent: "space-between",
// // //             marginBottom: 20,
// // //             flexWrap: "wrap",
// // //             gap: 10,
// // //           }}
// // //         >
// // //           <div>
// // //             <div
// // //               style={{
// // //                 fontSize: 12,
// // //                 fontFamily: "'IBM Plex Mono', monospace",
// // //                 color: "#8A8878",
// // //                 letterSpacing: "0.06em",
// // //                 textTransform: "uppercase",
// // //                 marginBottom: 4,
// // //               }}
// // //             >
// // //               HRMS content block editor
// // //             </div>
// // //             <h1
// // //               style={{
// // //                 fontFamily: "'Space Grotesk', sans-serif",
// // //                 fontSize: 26,
// // //                 fontWeight: 700,
// // //                 color: "#1B2340",
// // //                 margin: 0,
// // //               }}
// // //             >
// // //               {values.title || "Untitled workflow doc"}
// // //             </h1>
// // //           </div>
// // //           <div style={{ display: "flex", gap: 8 }}>
// // //             <button
// // //               onClick={() => setShowPreview((s) => !s)}
// // //               style={{
// // //                 fontSize: 13,
// // //                 padding: "8px 14px",
// // //                 borderRadius: 8,
// // //                 border: "1px solid #DEDCD1",
// // //                 background: "#fff",
// // //                 color: "#20201C",
// // //                 cursor: "pointer",
// // //               }}
// // //             >
// // //               {showPreview ? "Hide JSON" : "Show JSON"}
// // //             </button>
// // //             <button
// // //               onClick={copyJson}
// // //               style={{
// // //                 display: "inline-flex",
// // //                 alignItems: "center",
// // //                 gap: 6,
// // //                 fontSize: 13,
// // //                 padding: "8px 14px",
// // //                 borderRadius: 8,
// // //                 border: "none",
// // //                 background: "#1B2340",
// // //                 color: "#fff",
// // //                 cursor: "pointer",
// // //               }}
// // //             >
// // //               {copied ? <Check size={14} /> : <Copy size={14} />}{" "}
// // //               {copied ? "Copied" : "Copy JSON"}
// // //             </button>
// // //             <button
// // //               onClick={saveDocument}
// // //               style={{
// // //                 display: "inline-flex",
// // //                 alignItems: "center",
// // //                 gap: 6,
// // //                 fontSize: 13,
// // //                 padding: "8px 14px",
// // //                 borderRadius: 8,
// // //                 border: "none",
// // //                 background: "#1B2340",
// // //                 color: "#fff",
// // //                 cursor: "pointer",
// // //               }}
// // //             >
// // //               Save Document
// // //             </button>
// // //           </div>
// // //         </div>

// // //         <div
// // //           style={{
// // //             display: "grid",
// // //             gridTemplateColumns: showPreview ? "1fr 1fr" : "1fr",
// // //             gap: 20,
// // //             alignItems: "start",
// // //           }}
// // //         >
// // //           <div>
// // //             {/* Document meta card */}
// // //             <div
// // //               style={{
// // //                 background: "#fff",
// // //                 border: "1px solid #E4E2D8",
// // //                 borderRadius: 12,
// // //                 padding: 18,
// // //                 marginBottom: 20,
// // //               }}
// // //             >
// // //               <div
// // //                 style={{
// // //                   fontSize: 13,
// // //                   fontWeight: 600,
// // //                   color: "#1B2340",
// // //                   marginBottom: 12,
// // //                 }}
// // //               >
// // //                 Document details
// // //               </div>
// // //               <div
// // //                 style={{
// // //                   display: "grid",
// // //                   gridTemplateColumns: "1fr 1fr",
// // //                   gap: 12,
// // //                 }}
// // //               >
// // //                 <Field label="Category">
// // //                   <input
// // //                     style={inputStyle}
// // //                     value={values.category}
// // //                     onChange={(e) => setField("category", e.target.value)}
// // //                   />
// // //                 </Field>
// // //                 <Field label="Doc type">
// // //                   <input
// // //                     style={inputStyle}
// // //                     value={values.doc_type}
// // //                     onChange={(e) => setField("doc_type", e.target.value)}
// // //                   />
// // //                 </Field>
// // //               </div>
// // //               <Field label="Title">
// // //                 <input
// // //                   style={inputStyle}
// // //                   value={values.title}
// // //                   onChange={(e) => setField("title", e.target.value)}
// // //                 />
// // //               </Field>
// // //               <Field label="Overview">
// // //                 <textarea
// // //                   style={textareaStyle}
// // //                   value={values.overview}
// // //                   onChange={(e) => setField("overview", e.target.value)}
// // //                 />
// // //               </Field>
// // //               <div
// // //                 style={{
// // //                   display: "grid",
// // //                   gridTemplateColumns: "120px 1fr",
// // //                   gap: 12,
// // //                 }}
// // //               >
// // //                 <Field label="API method">
// // //                   <select
// // //                     style={selectStyle}
// // //                     value={values.api_method}
// // //                     onChange={(e) => setField("api_method", e.target.value)}
// // //                   >
// // //                     {["GET", "POST", "PUT", "PATCH", "DELETE"].map((m) => (
// // //                       <option key={m} value={m}>
// // //                         {m}
// // //                       </option>
// // //                     ))}
// // //                   </select>
// // //                 </Field>
// // //                 <Field label="API endpoint">
// // //                   <input
// // //                     style={monoStyle}
// // //                     value={values.api_endpoint}
// // //                     onChange={(e) => setField("api_endpoint", e.target.value)}
// // //                   />
// // //                 </Field>
// // //               </div>
// // //             </div>

// // //             {/* Blocks */}
// // //             <div
// // //               style={{
// // //                 fontSize: 13,
// // //                 fontWeight: 600,
// // //                 color: "#1B2340",
// // //                 marginBottom: 10,
// // //               }}
// // //             >
// // //               Content blocks ({blocks.length})
// // //             </div>
// // //             {blocks.map((b, i) => (
// // //               <BlockCard
// // //                 key={b.id}
// // //                 block={b}
// // //                 index={i}
// // //                 total={blocks.length}
// // //                 onChange={(updated) => updateBlock(i, updated)}
// // //                 onRemove={removeBlock}
// // //                 onMove={moveBlock}
// // //               />
// // //             ))}

// // //             <div
// // //               style={{
// // //                 display: "flex",
// // //                 gap: 8,
// // //                 marginTop: 14,
// // //                 background: "#fff",
// // //                 border: "1px dashed #C7C4B6",
// // //                 borderRadius: 12,
// // //                 padding: 14,
// // //                 alignItems: "center",
// // //               }}
// // //             >
// // //               <select
// // //                 style={{ ...selectStyle, width: "auto", flex: 1 }}
// // //                 value={addType}
// // //                 onChange={(e) => setAddType(e.target.value)}
// // //               >
// // //                 {Object.entries(BLOCK_TYPES).map(([k, v]) => (
// // //                   <option key={k} value={k}>
// // //                     {v.label}
// // //                   </option>
// // //                 ))}
// // //               </select>
// // //               <button
// // //                 onClick={addBlock}
// // //                 style={{
// // //                   display: "inline-flex",
// // //                   alignItems: "center",
// // //                   gap: 6,
// // //                   fontSize: 13,
// // //                   fontWeight: 600,
// // //                   padding: "9px 16px",
// // //                   borderRadius: 8,
// // //                   border: "none",
// // //                   background: "#1B2340",
// // //                   color: "#fff",
// // //                   cursor: "pointer",
// // //                 }}
// // //               >
// // //                 <Plus size={14} /> Add block
// // //               </button>
// // //             </div>
// // //           </div>

// // //           {showPreview && (
// // //             <div style={{ position: "sticky", top: 20 }}>
// // //               <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
// // //                 {[
// // //                   ["rendered", "Preview"],
// // //                   ["json", "JSON"],
// // //                 ].map(([key, label]) => (
// // //                   <button
// // //                     key={key}
// // //                     onClick={() => setPreviewTab(key)}
// // //                     style={{
// // //                       fontSize: 12.5,
// // //                       fontWeight: 600,
// // //                       padding: "6px 12px",
// // //                       borderRadius: 7,
// // //                       cursor: "pointer",
// // //                       border:
// // //                         previewTab === key
// // //                           ? "1px solid #1B2340"
// // //                           : "1px solid #DEDCD1",
// // //                       background: previewTab === key ? "#1B2340" : "#fff",
// // //                       color: previewTab === key ? "#fff" : "#5F5E5A",
// // //                     }}
// // //                   >
// // //                     {label}
// // //                   </button>
// // //                 ))}
// // //                 <span
// // //                   style={{
// // //                     fontSize: 11.5,
// // //                     color: "#9A988E",
// // //                     alignSelf: "center",
// // //                     marginLeft: 4,
// // //                   }}
// // //                 >
// // //                   {previewTab === "rendered"
// // //                     ? "How this data will display"
// // //                     : "Data admin will submit"}
// // //                 </span>
// // //               </div>

// // //               {previewTab === "rendered" ? (
// // //                 <div style={{ maxHeight: "80vh", overflow: "auto" }}>
// // //                   <DocumentPreview values={values} />
// // //                 </div>
// // //               ) : (
// // //                 <div
// // //                   style={{
// // //                     background: "#1B2340",
// // //                     borderRadius: 12,
// // //                     overflow: "hidden",
// // //                     border: "1px solid #1B2340",
// // //                   }}
// // //                 >
// // //                   <div
// // //                     style={{
// // //                       padding: "10px 14px",
// // //                       fontSize: 12,
// // //                       color: "#9BA6C7",
// // //                       fontFamily: "'IBM Plex Mono', monospace",
// // //                       borderBottom: "1px solid #2A335C",
// // //                     }}
// // //                   >
// // //                     output.json
// // //                   </div>
// // //                   <pre
// // //                     style={{
// // //                       margin: 0,
// // //                       padding: 16,
// // //                       fontSize: 12.5,
// // //                       lineHeight: 1.6,
// // //                       color: "#E6EAF5",
// // //                       fontFamily: "'IBM Plex Mono', monospace",
// // //                       overflow: "auto",
// // //                       maxHeight: "80vh",
// // //                     }}
// // //                   >
// // //                     {jsonString}
// // //                   </pre>
// // //                 </div>
// // //               )}
// // //             </div>
// // //           )}
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // import { useEffect, useState } from "react";
// // import {
// //   Heading1,
// //   AlignLeft,
// //   AlertTriangle,
// //   List as ListIcon,
// //   Images,
// //   Image as ImageIcon,
// //   Code2,
// //   Terminal,
// //   CheckCircle2,
// //   Plus,
// //   Trash2,
// //   ChevronUp,
// //   ChevronDown,
// //   ChevronDown as Caret,
// //   Copy,
// //   Check,
// //   GripVertical,
// //   KeyRound,
// //   RefreshCw,
// //   Info,
// //   XCircle,
// //   ImageOff,
// //   ChevronLeft,
// //   ChevronRight,
// //   Columns2,
// //   AlignCenter,
// //   AlignRight,
// //   AlignJustify,
// //   Video,
// //   Music2,
// //   Paperclip,
// //   Sparkles,
// //   MousePointerClick,
// //   Tags,
// //   ListOrdered,
// //   ThumbsUp,
// //   ThumbsDown,
// //   Table2,
// //   SeparatorHorizontal,
// //   FileText,
// //   FileArchive,
// //   FileSpreadsheet,
// //   File as FileGeneric,
// //   Download,
// // } from "lucide-react";
// // import { useMutation, useQuery, useQueryClient } from "react-query";
// // import {
// //   getDocument,
// //   patchDocument,
// //   postDocument,
// // } from "../../../Services/Document";
// // import { toast } from "react-toastify";
// // import { useLocation, useNavigate, useParams } from "react-router-dom";
// // import axios from "axios";
// // import { baseUrl } from "../../../Config/baseUrl";

// // const CALLOUT_STYLE = {
// //   info: { bg: "#E6F1FB", border: "#185FA5", text: "#0C447C", icon: Info },
// //   warning: {
// //     bg: "#FAEEDA",
// //     border: "#BA7517",
// //     text: "#633806",
// //     icon: AlertTriangle,
// //   },
// //   success: {
// //     bg: "#EAF3DE",
// //     border: "#3B6D11",
// //     text: "#27500A",
// //     icon: CheckCircle2,
// //   },
// //   error: { bg: "#FCEBEB", border: "#A32D2D", text: "#501313", icon: XCircle },
// // };

// // const BLOCK_TYPES = {
// //   heading: { label: "Heading", ramp: "blue", icon: Heading1 },
// //   paragraph: { label: "Paragraph", ramp: "gray", icon: AlignLeft },
// //   callout: { label: "Callout", ramp: "amber", icon: AlertTriangle },
// //   list: { label: "List", ramp: "green", icon: ListIcon },
// //   slider: { label: "Image slider", ramp: "purple", icon: Images },
// //   image: { label: "Image", ramp: "pink", icon: ImageIcon },
// //   columns: { label: "Multi-column", ramp: "blue", icon: Columns2 },
// //   request_payload: { label: "Request payload", ramp: "teal", icon: Code2 },
// //   code: { label: "Code sample", ramp: "gray", icon: Terminal },
// //   success_response: {
// //     label: "Success response",
// //     ramp: "green",
// //     icon: CheckCircle2,
// //   },
// //   video: { label: "Video embed", ramp: "blue", icon: Video },
// //   audio: { label: "Audio player / voice note", ramp: "purple", icon: Music2 },
// //   file: { label: "File attachment", ramp: "teal", icon: Paperclip },
// //   lottie: {
// //     label: "Lottie / interactive animation",
// //     ramp: "pink",
// //     icon: Sparkles,
// //   },
// //   button: {
// //     label: "Button / action link",
// //     ramp: "green",
// //     icon: MousePointerClick,
// //   },
// //   badges: { label: "Badge / tag cloud", ramp: "amber", icon: Tags },
// //   stepper: { label: "Step-by-step guide", ramp: "blue", icon: ListOrdered },
// //   feedback: { label: "Feedback widget", ramp: "green", icon: ThumbsUp },
// //   table: { label: "Table", ramp: "gray", icon: Table2 },
// //   divider: {
// //     label: "Divider / spacer",
// //     ramp: "gray",
// //     icon: SeparatorHorizontal,
// //   },
// // };

// // const RAMP = {
// //   blue: { 50: "#E6F1FB", 200: "#85B7EB", 600: "#185FA5", 800: "#0C447C" },
// //   gray: { 50: "#F1EFE8", 200: "#B4B2A9", 600: "#5F5E5A", 800: "#444441" },
// //   amber: { 50: "#FAEEDA", 200: "#EF9F27", 600: "#854F0B", 800: "#633806" },
// //   green: { 50: "#EAF3DE", 200: "#97C459", 600: "#3B6D11", 800: "#27500A" },
// //   purple: { 50: "#EEEDFE", 200: "#AFA9EC", 600: "#534AB7", 800: "#3C3489" },
// //   pink: { 50: "#FBEAF0", 200: "#ED93B1", 600: "#993556", 800: "#72243E" },
// //   teal: { 50: "#E1F5EE", 200: "#5DCAA5", 600: "#0F6E56", 800: "#085041" },
// // };

// // const ALIGN_OPTIONS = [
// //   { value: "left", label: "Left", icon: AlignLeft },
// //   { value: "center", label: "Center", icon: AlignCenter },
// //   { value: "right", label: "Right", icon: AlignRight },
// //   { value: "justify", label: "Justify", icon: AlignJustify },
// // ];

// // const OBJECT_FIT_OPTIONS = ["cover", "contain", "fill", "none", "scale-down"];

// // let uid = 1;
// // const nextId = () => `blk-${uid++}`;
// // const genKey = (prefix) =>
// //   `${prefix}_${Math.random().toString(36).slice(2, 8)}`;

// // const emptyImageValue = (prefix) => ({
// //   image_key: genKey(prefix),
// //   url: "",
// //   caption: "",
// //   alt: "",
// //   width: "100%",
// //   height: "220px",
// //   objectFit: "cover",
// // });

// // const emptyColumn = () => ({
// //   id: genKey("column"),
// //   blocks: [],
// // });

// // const emptyBlockFor = (type) => {
// //   const id = nextId();
// //   switch (type) {
// //     case "heading":
// //       return { id, type: "heading", level: "h2", text: "", align: "left" };
// //     case "paragraph":
// //       return { id, type: "paragraph", text: "", align: "left" };
// //     case "callout":
// //       return { id, type: "callout", style: "info", text: "", align: "left" };
// //     case "list":
// //       return { id, type: "list", style: "bullet", items: [""], align: "left" };
// //     case "slider":
// //       return { id, type: "slider", images: [emptyImageValue("slider_step")] };
// //     case "image":
// //       return {
// //         id,
// //         type: "image",
// //         image_key: genKey("image"),
// //         url: "",
// //         caption: "",
// //         align: "center",
// //         width: "100%",
// //         height: "auto",
// //         objectFit: "cover",
// //       };
// //     case "columns":
// //       return {
// //         id,
// //         type: "columns",
// //         gap: 20,
// //         columns: [emptyColumn(), emptyColumn()],
// //       };
// //     case "request_payload":
// //       return { id, type: "request_payload", data: "{\n  \n}" };
// //     case "code":
// //       return { id, type: "code", language: "python", code: "" };
// //     case "success_response":
// //       return { id, type: "success_response", data: "{\n  \n}" };
// //     case "video":
// //       return {
// //         id,
// //         type: "video",
// //         provider: "youtube",
// //         url: "",
// //         caption: "",
// //         aspectRatio: "16:9",
// //       };
// //     case "audio":
// //       return {
// //         id,
// //         type: "audio",
// //         url: "",
// //         title: "",
// //         subtitle: "",
// //         duration: "",
// //       };
// //     case "file":
// //       return {
// //         id,
// //         type: "file",
// //         url: "",
// //         filename: "",
// //         filetype: "PDF",
// //         filesize: "",
// //       };
// //     case "lottie":
// //       return {
// //         id,
// //         type: "lottie",
// //         url: "",
// //         caption: "",
// //         width: "100%",
// //         height: "280px",
// //         loop: true,
// //         autoplay: true,
// //       };
// //     case "button":
// //       return {
// //         id,
// //         type: "button",
// //         label: "",
// //         url: "",
// //         style: "primary",
// //         align: "left",
// //         newTab: true,
// //       };
// //     case "badges":
// //       return {
// //         id,
// //         type: "badges",
// //         tags: [{ id: genKey("tag"), label: "New", tone: "blue" }],
// //       };
// //     case "stepper":
// //       return {
// //         id,
// //         type: "stepper",
// //         steps: [{ id: genKey("step"), title: "", text: "" }],
// //       };
// //     case "feedback":
// //       return { id, type: "feedback", prompt: "Was this helpful?" };
// //     case "table":
// //       return {
// //         id,
// //         type: "table",
// //         columns: ["Column 1", "Column 2"],
// //         rows: [["", ""]],
// //       };
// //     case "divider":
// //       return { id, type: "divider", style: "solid", spacing: 24 };
// //     default:
// //       return { id, type: "paragraph", text: "", align: "left" };
// //   }
// // };

// // const initialBlocks = [];

// // const initialValues = {
// //   page_title: "",
// //   category: "",
// //   title: "",
// //   doc_type: "",
// //   overview: "",
// //   api_method: "",
// //   api_endpoint: "",
// //   content_blocks: initialBlocks,
// // };

// // function useFormikLike(initial) {
// //   const [values, setValues] = useState(initial);
// //   const setField = (path, val) => {
// //     setValues((prev) => {
// //       const next = structuredClone(prev);
// //       const keys = path.split(".");
// //       let cur = next;
// //       for (let i = 0; i < keys.length - 1; i++) cur = cur[keys[i]];
// //       cur[keys[keys.length - 1]] = val;
// //       return next;
// //     });
// //   };
// //   return { values, setValues, setField };
// // }

// // function Field({ label, children, hint }) {
// //   return (
// //     <label style={{ display: "block", marginBottom: 14 }}>
// //       <span
// //         style={{
// //           display: "block",
// //           fontSize: 12,
// //           fontWeight: 600,
// //           color: "#5F5E5A",
// //           letterSpacing: "0.02em",
// //           textTransform: "uppercase",
// //           marginBottom: 6,
// //         }}
// //       >
// //         {label}
// //       </span>
// //       {children}
// //       {hint && (
// //         <span
// //           style={{
// //             display: "block",
// //             fontSize: 12,
// //             color: "#9A988E",
// //             marginTop: 4,
// //           }}
// //         >
// //           {hint}
// //         </span>
// //       )}
// //     </label>
// //   );
// // }

// // const inputStyle = {
// //   width: "100%",
// //   boxSizing: "border-box",
// //   padding: "9px 11px",
// //   borderRadius: 8,
// //   border: "1px solid #DEDCD1",
// //   fontSize: 14,
// //   fontFamily: "'IBM Plex Sans', sans-serif",
// //   color: "#20201C",
// //   background: "#FFFFFF",
// //   outline: "none",
// // };
// // const monoStyle = {
// //   ...inputStyle,
// //   fontFamily: "'IBM Plex Mono', monospace",
// //   fontSize: 13,
// // };
// // const selectStyle = { ...inputStyle, cursor: "pointer" };
// // const textareaStyle = {
// //   ...inputStyle,
// //   resize: "vertical",
// //   minHeight: 70,
// //   lineHeight: 1.5,
// // };

// // function IconBtn({ onClick, title, children, danger, active }) {
// //   return (
// //     <button
// //       onClick={onClick}
// //       title={title}
// //       style={{
// //         display: "inline-flex",
// //         alignItems: "center",
// //         justifyContent: "center",
// //         width: 28,
// //         height: 28,
// //         borderRadius: 6,
// //         border: active ? "1px solid #1B2340" : "1px solid #E4E2D8",
// //         background: active ? "#1B2340" : "#fff",
// //         color: active ? "#fff" : danger ? "#993C1D" : "#5F5E5A",
// //         cursor: "pointer",
// //       }}
// //     >
// //       {children}
// //     </button>
// //   );
// // }

// // function AlignPicker({ value, onChange }) {
// //   return (
// //     <Field label="Text align">
// //       <div style={{ display: "flex", gap: 6 }}>
// //         {ALIGN_OPTIONS.map((opt) => {
// //           const Icon = opt.icon;
// //           return (
// //             <IconBtn
// //               key={opt.value}
// //               title={opt.label}
// //               active={value === opt.value}
// //               onClick={() => onChange(opt.value)}
// //             >
// //               <Icon size={14} />
// //             </IconBtn>
// //           );
// //         })}
// //       </div>
// //     </Field>
// //   );
// // }

// // function ImageDimensionFields({ width, height, objectFit, onChange }) {
// //   return (
// //     <div
// //       style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}
// //     >
// //       <Field label="Width" hint="px, % or auto">
// //         <input
// //           style={inputStyle}
// //           value={width}
// //           onChange={(e) => onChange({ width: e.target.value })}
// //           placeholder="100%"
// //         />
// //       </Field>
// //       <Field label="Height" hint="px or auto">
// //         <input
// //           style={inputStyle}
// //           value={height}
// //           onChange={(e) => onChange({ height: e.target.value })}
// //           placeholder="220px"
// //         />
// //       </Field>
// //       <Field label="Fit">
// //         <select
// //           style={selectStyle}
// //           value={objectFit}
// //           onChange={(e) => onChange({ objectFit: e.target.value })}
// //         >
// //           {OBJECT_FIT_OPTIONS.map((f) => (
// //             <option key={f} value={f}>
// //               {f}
// //             </option>
// //           ))}
// //         </select>
// //       </Field>
// //     </div>
// //   );
// // }

// // function JsonField({ label, value, onChange }) {
// //   const [error, setError] = useState(null);
// //   return (
// //     <Field label={label} hint={error ? null : "Valid JSON object"}>
// //       <textarea
// //         style={{ ...monoStyle, minHeight: 120 }}
// //         value={value}
// //         onChange={(e) => {
// //           onChange(e.target.value);
// //           try {
// //             JSON.parse(e.target.value);
// //             setError(null);
// //           } catch {
// //             setError("Not valid JSON yet");
// //           }
// //         }}
// //       />
// //       {error && (
// //         <span
// //           style={{
// //             display: "block",
// //             fontSize: 12,
// //             color: "#993C1D",
// //             marginTop: 4,
// //           }}
// //         >
// //           {error}
// //         </span>
// //       )}
// //     </Field>
// //   );
// // }

// // function BlockCard({
// //   block,
// //   index,
// //   total,
// //   onChange,
// //   onRemove,
// //   onMove,
// //   compact,
// // }) {
// //   const [open, setOpen] = useState(true);
// //   const meta = BLOCK_TYPES[block.type];
// //   const Icon = meta.icon;
// //   const c = RAMP[meta.ramp];
// //   const patch = (field, val) => onChange({ ...block, [field]: val });

// //   return (
// //     <div
// //       style={{
// //         border: "1px solid #E4E2D8",
// //         borderRadius: 12,
// //         background: "#FFFFFF",
// //         marginBottom: 12,
// //         overflow: "hidden",
// //       }}
// //     >
// //       <div
// //         style={{
// //           display: "flex",
// //           alignItems: "center",
// //           gap: 10,
// //           padding: "10px 12px",
// //           background: c[50],
// //           cursor: "pointer",
// //           userSelect: "none",
// //         }}
// //         onClick={() => setOpen((o) => !o)}
// //       >
// //         <GripVertical size={15} color={c[600]} style={{ flexShrink: 0 }} />
// //         <span
// //           style={{
// //             fontSize: 12,
// //             fontFamily: "'IBM Plex Mono', monospace",
// //             color: c[600],
// //             fontWeight: 600,
// //           }}
// //         >
// //           {String(index + 1).padStart(2, "0")}
// //         </span>
// //         <Icon size={15} color={c[800]} style={{ flexShrink: 0 }} />
// //         <span style={{ fontSize: 13, fontWeight: 600, color: c[800] }}>
// //           {meta.label}
// //         </span>
// //         <span
// //           style={{
// //             fontSize: 12,
// //             color: c[600],
// //             marginLeft: 2,
// //             overflow: "hidden",
// //             textOverflow: "ellipsis",
// //             whiteSpace: "nowrap",
// //             flex: 1,
// //             minWidth: 0, // ⬅ isko add karna zaroori hai, warna ellipsis kaam nahi karega lambe text pe
// //           }}
// //         >
// //           {blockPreview(block)}
// //         </span>
// //         <div
// //           style={{ display: "flex", gap: 4 }}
// //           onClick={(e) => e.stopPropagation()}
// //         >
// //           <IconBtn
// //             title="Move up"
// //             onClick={() => index > 0 && onMove(index, index - 1)}
// //           >
// //             <ChevronUp size={14} />
// //           </IconBtn>
// //           <IconBtn
// //             title="Move down"
// //             onClick={() => index < total - 1 && onMove(index, index + 1)}
// //           >
// //             <ChevronDown size={14} />
// //           </IconBtn>
// //           <IconBtn title="Delete block" danger onClick={() => onRemove(index)}>
// //             <Trash2 size={14} />
// //           </IconBtn>
// //           <Caret
// //             size={16}
// //             color={c[600]}
// //             style={{
// //               transform: open ? "rotate(180deg)" : "none",
// //               transition: "transform 0.15s",
// //               marginLeft: 2,
// //             }}
// //           />
// //         </div>
// //       </div>

// //       {open && (
// //         <div style={{ padding: 16 }}>
// //           <BlockFields block={block} patch={patch} onChange={onChange} />
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// // function blockPreview(b) {
// //   if (b.type === "heading" || b.type === "paragraph" || b.type === "callout")
// //     return b.text || "Empty";
// //   if (b.type === "list")
// //     return `${b.items.length} item${b.items.length === 1 ? "" : "s"}`;
// //   if (b.type === "slider")
// //     return `${b.images.length} image${b.images.length === 1 ? "" : "s"}`;
// //   if (b.type === "image") return b.image_key || "unkeyed";
// //   if (b.type === "columns") {
// //     const total = (b.columns || []).reduce(
// //       (s, c) => s + (c.blocks?.length || 0),
// //       0,
// //     );
// //     return `${b.columns?.length || 0} columns, ${total} block${total === 1 ? "" : "s"}`;
// //   }
// //   if (b.type === "code") return b.language;
// //   if (b.type === "request_payload" || b.type === "success_response")
// //     return "JSON data";
// //   if (b.type === "video") return b.url || "No URL set";
// //   if (b.type === "audio") return b.title || b.url || "No audio set";
// //   if (b.type === "file") return b.filename || "No file set";
// //   if (b.type === "lottie") return b.caption || b.url || "No animation set";
// //   if (b.type === "button") return b.label || "No label set";
// //   if (b.type === "badges")
// //     return `${b.tags.length} tag${b.tags.length === 1 ? "" : "s"}`;
// //   if (b.type === "stepper")
// //     return `${b.steps.length} step${b.steps.length === 1 ? "" : "s"}`;
// //   if (b.type === "feedback") return b.prompt || "Feedback widget";
// //   if (b.type === "table")
// //     return `${b.rows.length} row${b.rows.length === 1 ? "" : "s"} \u00d7 ${b.columns.length} col${b.columns.length === 1 ? "" : "s"}`;
// //   if (b.type === "divider") return b.style;
// //   return "";
// // }

// // function ColumnBlockList({ blocks, onChange }) {
// //   const [addType, setAddType] = useState("paragraph");
// //   const nestedTypes = Object.entries(BLOCK_TYPES).filter(
// //     ([k]) => k !== "columns",
// //   );

// //   const updateBlock = (idx, updated) => {
// //     const next = [...blocks];
// //     next[idx] = updated;
// //     onChange(next);
// //   };
// //   const removeBlock = (idx) => onChange(blocks.filter((_, i) => i !== idx));
// //   const moveBlock = (from, to) => {
// //     const next = [...blocks];
// //     const [item] = next.splice(from, 1);
// //     next.splice(to, 0, item);
// //     onChange(next);
// //   };
// //   const addBlock = () => onChange([...blocks, emptyBlockFor(addType)]);

// //   return (
// //     <div>
// //       {blocks.map((b, i) => (
// //         <BlockCard
// //           key={b.id}
// //           block={b}
// //           index={i}
// //           total={blocks.length}
// //           onChange={(updated) => updateBlock(i, updated)}
// //           onRemove={removeBlock}
// //           onMove={moveBlock}
// //         />
// //       ))}
// //       <div
// //         style={{
// //           display: "flex",
// //           gap: 8,
// //           background: "#FAF9F4",
// //           border: "1px dashed #C7C4B6",
// //           borderRadius: 9,
// //           padding: 10,
// //           alignItems: "center",
// //         }}
// //       >
// //         <select
// //           style={{
// //             ...selectStyle,
// //             width: "auto",
// //             flex: 1,
// //             fontSize: 12.5,
// //             padding: "6px 9px",
// //           }}
// //           value={addType}
// //           onChange={(e) => setAddType(e.target.value)}
// //         >
// //           {nestedTypes.map(([k, v]) => (
// //             <option key={k} value={k}>
// //               {v.label}
// //             </option>
// //           ))}
// //         </select>
// //         <button
// //           onClick={addBlock}
// //           style={{
// //             display: "inline-flex",
// //             alignItems: "center",
// //             gap: 5,
// //             fontSize: 12,
// //             fontWeight: 600,
// //             padding: "6px 11px",
// //             borderRadius: 7,
// //             border: "none",
// //             background: "#1B2340",
// //             color: "#fff",
// //             cursor: "pointer",
// //             whiteSpace: "nowrap",
// //           }}
// //         >
// //           <Plus size={12} /> Add block
// //         </button>
// //       </div>
// //     </div>
// //   );
// // }

// // function BlockFields({ block, patch, onChange }) {
// //   switch (block.type) {
// //     case "heading":
// //       return (
// //         <>
// //           <Field label="Level">
// //             <select
// //               style={selectStyle}
// //               value={block.level}
// //               onChange={(e) => patch("level", e.target.value)}
// //             >
// //               {["h1", "h2", "h3", "h4"].map((l) => (
// //                 <option key={l} value={l}>
// //                   {l.toUpperCase()}
// //                 </option>
// //               ))}
// //             </select>
// //           </Field>
// //           <Field label="Heading text">
// //             <input
// //               style={inputStyle}
// //               value={block.text}
// //               onChange={(e) => patch("text", e.target.value)}
// //               placeholder="Section heading"
// //             />
// //           </Field>
// //           <AlignPicker
// //             value={block.align || "left"}
// //             onChange={(v) => patch("align", v)}
// //           />
// //         </>
// //       );
// //     case "paragraph":
// //       return (
// //         <>
// //           <Field label="Paragraph text">
// //             <textarea
// //               style={textareaStyle}
// //               value={block.text}
// //               onChange={(e) => patch("text", e.target.value)}
// //               placeholder="Write the paragraph copy..."
// //             />
// //           </Field>
// //           <AlignPicker
// //             value={block.align || "left"}
// //             onChange={(v) => patch("align", v)}
// //           />
// //         </>
// //       );
// //     case "callout":
// //       return (
// //         <>
// //           <Field label="Style">
// //             <select
// //               style={selectStyle}
// //               value={block.style}
// //               onChange={(e) => patch("style", e.target.value)}
// //             >
// //               {["info", "warning", "success", "error"].map((s) => (
// //                 <option key={s} value={s}>
// //                   {s}
// //                 </option>
// //               ))}
// //             </select>
// //           </Field>
// //           <Field label="Callout text">
// //             <textarea
// //               style={textareaStyle}
// //               value={block.text}
// //               onChange={(e) => patch("text", e.target.value)}
// //               placeholder="Warning or note copy..."
// //             />
// //           </Field>
// //           <AlignPicker
// //             value={block.align || "left"}
// //             onChange={(v) => patch("align", v)}
// //           />
// //         </>
// //       );
// //     case "list":
// //       return (
// //         <>
// //           <Field label="Style">
// //             <select
// //               style={selectStyle}
// //               value={block.style}
// //               onChange={(e) => patch("style", e.target.value)}
// //             >
// //               <option value="bullet">Bullet</option>
// //               <option value="number">Numbered</option>
// //             </select>
// //           </Field>
// //           <Field label="Items">
// //             {block.items.map((item, i) => (
// //               <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
// //                 <input
// //                   style={inputStyle}
// //                   value={item}
// //                   onChange={(e) => {
// //                     const items = [...block.items];
// //                     items[i] = e.target.value;
// //                     patch("items", items);
// //                   }}
// //                   placeholder={`Item ${i + 1}`}
// //                 />
// //                 <IconBtn
// //                   title="Remove item"
// //                   danger
// //                   onClick={() =>
// //                     patch(
// //                       "items",
// //                       block.items.filter((_, idx) => idx !== i),
// //                     )
// //                   }
// //                 >
// //                   <Trash2 size={13} />
// //                 </IconBtn>
// //               </div>
// //             ))}
// //             <button
// //               onClick={() => patch("items", [...block.items, ""])}
// //               style={{
// //                 display: "inline-flex",
// //                 alignItems: "center",
// //                 gap: 6,
// //                 marginTop: 2,
// //                 fontSize: 13,
// //                 padding: "6px 10px",
// //                 borderRadius: 7,
// //                 border: "1px dashed #C7C4B6",
// //                 background: "transparent",
// //                 color: "#5F5E5A",
// //                 cursor: "pointer",
// //               }}
// //             >
// //               <Plus size={13} /> Add item
// //             </button>
// //           </Field>
// //           <AlignPicker
// //             value={block.align || "left"}
// //             onChange={(v) => patch("align", v)}
// //           />
// //         </>
// //       );
// //     case "slider":
// //       return (
// //         <>
// //           {block.images.map((img, i) => (
// //             <div
// //               key={i}
// //               style={{
// //                 border: "1px solid #EDEBE0",
// //                 borderRadius: 9,
// //                 padding: 12,
// //                 marginBottom: 10,
// //               }}
// //             >
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   justifyContent: "space-between",
// //                   alignItems: "center",
// //                   marginBottom: 8,
// //                 }}
// //               >
// //                 <span
// //                   style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
// //                 >
// //                   Slide {i + 1}
// //                 </span>
// //                 <IconBtn
// //                   title="Remove slide"
// //                   danger
// //                   onClick={() =>
// //                     patch(
// //                       "images",
// //                       block.images.filter((_, idx) => idx !== i),
// //                     )
// //                   }
// //                 >
// //                   <Trash2 size={13} />
// //                 </IconBtn>
// //               </div>
// //               <ImageKeyField
// //                 value={img.image_key}
// //                 onChange={(v) => {
// //                   const images = [...block.images];
// //                   images[i] = { ...images[i], image_key: v };
// //                   patch("images", images);
// //                 }}
// //                 prefix="slide"
// //               />
// //               <Field label="Image URL">
// //                 <input
// //                   style={inputStyle}
// //                   value={img.url}
// //                   onChange={(e) => {
// //                     const images = [...block.images];
// //                     images[i] = { ...images[i], url: e.target.value };
// //                     patch("images", images);
// //                   }}
// //                   placeholder="https://..."
// //                 />
// //               </Field>
// //               <Field label="Caption">
// //                 <input
// //                   style={inputStyle}
// //                   value={img.caption}
// //                   onChange={(e) => {
// //                     const images = [...block.images];
// //                     images[i] = { ...images[i], caption: e.target.value };
// //                     patch("images", images);
// //                   }}
// //                   placeholder="What this slide shows"
// //                 />
// //               </Field>
// //               <Field label="Alt text">
// //                 <input
// //                   style={inputStyle}
// //                   value={img.alt}
// //                   onChange={(e) => {
// //                     const images = [...block.images];
// //                     images[i] = { ...images[i], alt: e.target.value };
// //                     patch("images", images);
// //                   }}
// //                   placeholder="Accessible description"
// //                 />
// //               </Field>
// //               <ImageDimensionFields
// //                 width={img.width || "100%"}
// //                 height={img.height || "220px"}
// //                 objectFit={img.objectFit || "cover"}
// //                 onChange={(fields) => {
// //                   const images = [...block.images];
// //                   images[i] = { ...images[i], ...fields };
// //                   patch("images", images);
// //                 }}
// //               />
// //             </div>
// //           ))}
// //           <button
// //             onClick={() =>
// //               patch("images", [...block.images, emptyImageValue("slider_step")])
// //             }
// //             style={{
// //               display: "inline-flex",
// //               alignItems: "center",
// //               gap: 6,
// //               fontSize: 13,
// //               padding: "6px 10px",
// //               borderRadius: 7,
// //               border: "1px dashed #C7C4B6",
// //               background: "transparent",
// //               color: "#5F5E5A",
// //               cursor: "pointer",
// //             }}
// //           >
// //             <Plus size={13} /> Add slide
// //           </button>
// //         </>
// //       );
// //     case "image":
// //       return (
// //         <>
// //           <ImageKeyField
// //             value={block.image_key}
// //             onChange={(v) => patch("image_key", v)}
// //             prefix="image"
// //           />
// //           <Field label="Orignal Image URL">
// //             <input
// //               style={inputStyle}
// //               value={block.url}
// //               onChange={(e) => patch("url", e.target.value)}
// //               placeholder="https://..."
// //             />
// //           </Field>
// //           <Field label="Genrated Image URL">
// //             <input
// //               disabled
// //               style={inputStyle}
// //               value={block.url}
// //               onChange={(e) => patch("url", e.target.value)}
// //               placeholder="https://..."
// //             />
// //           </Field>
// //           <Field label="Caption">
// //             <input
// //               style={inputStyle}
// //               value={block.caption}
// //               onChange={(e) => patch("caption", e.target.value)}
// //               placeholder="Figure caption"
// //             />
// //           </Field>
// //           <Field
// //             label="Container align"
// //             hint="Position of the image within the document width"
// //           >
// //             <div style={{ display: "flex", gap: 6 }}>
// //               {[
// //                 { value: "left", label: "Left", icon: AlignLeft },
// //                 { value: "center", label: "Center", icon: AlignCenter },
// //                 { value: "right", label: "Right", icon: AlignRight },
// //               ].map((opt) => {
// //                 const Ic = opt.icon;
// //                 return (
// //                   <IconBtn
// //                     key={opt.value}
// //                     title={opt.label}
// //                     active={block.align === opt.value}
// //                     onClick={() => patch("align", opt.value)}
// //                   >
// //                     <Ic size={14} />
// //                   </IconBtn>
// //                 );
// //               })}
// //             </div>
// //           </Field>
// //           <ImageDimensionFields
// //             width={block.width || "100%"}
// //             height={block.height || "auto"}
// //             objectFit={block.objectFit || "cover"}
// //             onChange={(fields) =>
// //               Object.entries(fields).forEach(([k, v]) => patch(k, v))
// //             }
// //           />
// //         </>
// //       );
// //     case "columns": {
// //       const columns = block.columns || [];
// //       const setColumns = (next) => patch("columns", next);
// //       const addColumn = () => setColumns([...columns, emptyColumn()]);
// //       const removeColumn = (ci) =>
// //         setColumns(columns.filter((_, i) => i !== ci));
// //       const updateColumnBlocks = (ci, newBlocks) => {
// //         setColumns(
// //           columns.map((c, i) => (i === ci ? { ...c, blocks: newBlocks } : c)),
// //         );
// //       };
// //       return (
// //         <>
// //           <div
// //             style={{
// //               display: "flex",
// //               gap: 10,
// //               marginBottom: 4,
// //               flexWrap: "wrap",
// //             }}
// //           >
// //             <Field label="Gap between columns" hint="in pixels">
// //               <input
// //                 type="number"
// //                 style={{ ...inputStyle, width: 120 }}
// //                 value={block.gap}
// //                 onChange={(e) => patch("gap", Number(e.target.value) || 0)}
// //               />
// //             </Field>
// //             <Field
// //               label="Columns"
// //               hint={`${columns.length} column${columns.length === 1 ? "" : "s"}`}
// //             >
// //               <button
// //                 onClick={addColumn}
// //                 style={{
// //                   display: "inline-flex",
// //                   alignItems: "center",
// //                   gap: 6,
// //                   fontSize: 13,
// //                   fontWeight: 600,
// //                   padding: "9px 14px",
// //                   borderRadius: 8,
// //                   border: "1px dashed #C7C4B6",
// //                   background: "transparent",
// //                   color: "#5F5E5A",
// //                   cursor: "pointer",
// //                 }}
// //               >
// //                 <Plus size={13} /> Add column
// //               </button>
// //             </Field>
// //           </div>
// //           <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
// //             {columns.map((col, ci) => (
// //               <div
// //                 key={col.id}
// //                 style={{
// //                   border: "1px solid #EDEBE0",
// //                   borderRadius: 9,
// //                   padding: 12,
// //                   flex: "1 1 240px",
// //                   minWidth: 240,
// //                 }}
// //               >
// //                 <div
// //                   style={{
// //                     display: "flex",
// //                     justifyContent: "space-between",
// //                     alignItems: "center",
// //                     marginBottom: 10,
// //                   }}
// //                 >
// //                   <span
// //                     style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
// //                   >
// //                     Column {ci + 1} · {col.blocks.length} block
// //                     {col.blocks.length === 1 ? "" : "s"}
// //                   </span>
// //                   {columns.length > 1 && (
// //                     <IconBtn
// //                       title="Remove column"
// //                       danger
// //                       onClick={() => removeColumn(ci)}
// //                     >
// //                       <Trash2 size={13} />
// //                     </IconBtn>
// //                   )}
// //                 </div>
// //                 <ColumnBlockList
// //                   blocks={col.blocks}
// //                   onChange={(nb) => updateColumnBlocks(ci, nb)}
// //                 />
// //               </div>
// //             ))}
// //           </div>
// //         </>
// //       );
// //     }
// //     case "code":
// //       return (
// //         <>
// //           <Field label="Language">
// //             <input
// //               style={inputStyle}
// //               value={block.language}
// //               onChange={(e) => patch("language", e.target.value)}
// //               placeholder="python"
// //             />
// //           </Field>
// //           <Field label="Code">
// //             <textarea
// //               style={{ ...monoStyle, minHeight: 140 }}
// //               value={block.code}
// //               onChange={(e) => patch("code", e.target.value)}
// //               placeholder="Paste the code sample..."
// //             />
// //           </Field>
// //         </>
// //       );
// //     case "request_payload":
// //     case "success_response":
// //       return (
// //         <JsonField
// //           label="JSON data"
// //           value={block.data}
// //           onChange={(v) => patch("data", v)}
// //         />
// //       );
// //     case "video":
// //       return (
// //         <>
// //           <Field label="Provider">
// //             <select
// //               style={selectStyle}
// //               value={block.provider}
// //               onChange={(e) => patch("provider", e.target.value)}
// //             >
// //               {["youtube", "vimeo", "loom", "mp4"].map((p) => (
// //                 <option key={p} value={p}>
// //                   {p === "mp4" ? "Direct MP4" : p[0].toUpperCase() + p.slice(1)}
// //                 </option>
// //               ))}
// //             </select>
// //           </Field>
// //           <Field
// //             label="Video URL"
// //             hint="Paste the share/watch link, or a direct .mp4 URL"
// //           >
// //             <input
// //               style={inputStyle}
// //               value={block.url}
// //               onChange={(e) => patch("url", e.target.value)}
// //               placeholder="https://..."
// //             />
// //           </Field>
// //           <Field label="Caption">
// //             <input
// //               style={inputStyle}
// //               value={block.caption}
// //               onChange={(e) => patch("caption", e.target.value)}
// //               placeholder="Optional caption"
// //             />
// //           </Field>
// //           <Field label="Aspect ratio">
// //             <select
// //               style={selectStyle}
// //               value={block.aspectRatio}
// //               onChange={(e) => patch("aspectRatio", e.target.value)}
// //             >
// //               {["16:9", "4:3", "1:1", "9:16"].map((r) => (
// //                 <option key={r} value={r}>
// //                   {r}
// //                 </option>
// //               ))}
// //             </select>
// //           </Field>
// //         </>
// //       );
// //     case "audio":
// //       return (
// //         <>
// //           <Field label="Audio URL">
// //             <input
// //               style={inputStyle}
// //               value={block.url}
// //               onChange={(e) => patch("url", e.target.value)}
// //               placeholder="https://.../episode.mp3"
// //             />
// //           </Field>
// //           <Field label="Title">
// //             <input
// //               style={inputStyle}
// //               value={block.title}
// //               onChange={(e) => patch("title", e.target.value)}
// //               placeholder="Episode or clip title"
// //             />
// //           </Field>
// //           <Field label="Subtitle">
// //             <input
// //               style={inputStyle}
// //               value={block.subtitle}
// //               onChange={(e) => patch("subtitle", e.target.value)}
// //               placeholder="e.g. Podcast · Voice note"
// //             />
// //           </Field>
// //           <Field label="Duration" hint="Display only, e.g. 3:45">
// //             <input
// //               style={{ ...inputStyle, width: 120 }}
// //               value={block.duration}
// //               onChange={(e) => patch("duration", e.target.value)}
// //               placeholder="3:45"
// //             />
// //           </Field>
// //         </>
// //       );
// //     case "file":
// //       return (
// //         <>
// //           <Field label="File URL">
// //             <input
// //               style={inputStyle}
// //               value={block.url}
// //               onChange={(e) => patch("url", e.target.value)}
// //               placeholder="https://.../file.pdf"
// //             />
// //           </Field>
// //           <Field label="Filename">
// //             <input
// //               style={inputStyle}
// //               value={block.filename}
// //               onChange={(e) => patch("filename", e.target.value)}
// //               placeholder="onboarding-guide.pdf"
// //             />
// //           </Field>
// //           <div
// //             style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}
// //           >
// //             <Field label="File type">
// //               <select
// //                 style={selectStyle}
// //                 value={block.filetype}
// //                 onChange={(e) => patch("filetype", e.target.value)}
// //               >
// //                 {["PDF", "ZIP", "CSV", "DOCX", "XLSX", "Other"].map((t) => (
// //                   <option key={t} value={t}>
// //                     {t}
// //                   </option>
// //                 ))}
// //               </select>
// //             </Field>
// //             <Field label="File size" hint="Display only">
// //               <input
// //                 style={inputStyle}
// //                 value={block.filesize}
// //                 onChange={(e) => patch("filesize", e.target.value)}
// //                 placeholder="2.4 MB"
// //               />
// //             </Field>
// //           </div>
// //         </>
// //       );
// //     case "lottie":
// //       return (
// //         <>
// //           <Field label="Animation URL" hint="Link to a .json or .lottie file">
// //             <input
// //               style={inputStyle}
// //               value={block.url}
// //               onChange={(e) => patch("url", e.target.value)}
// //               placeholder="https://.../animation.json"
// //             />
// //           </Field>
// //           <Field label="Caption">
// //             <input
// //               style={inputStyle}
// //               value={block.caption}
// //               onChange={(e) => patch("caption", e.target.value)}
// //               placeholder="Optional caption"
// //             />
// //           </Field>
// //           <div
// //             style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}
// //           >
// //             <Field label="Width" hint="px or %">
// //               <input
// //                 style={inputStyle}
// //                 value={block.width}
// //                 onChange={(e) => patch("width", e.target.value)}
// //                 placeholder="100%"
// //               />
// //             </Field>
// //             <Field label="Height" hint="px">
// //               <input
// //                 style={inputStyle}
// //                 value={block.height}
// //                 onChange={(e) => patch("height", e.target.value)}
// //                 placeholder="280px"
// //               />
// //             </Field>
// //           </div>
// //           <div style={{ display: "flex", gap: 16, marginTop: 4 }}>
// //             <label
// //               style={{
// //                 display: "flex",
// //                 alignItems: "center",
// //                 gap: 6,
// //                 fontSize: 13,
// //                 color: "#5F5E5A",
// //               }}
// //             >
// //               <input
// //                 type="checkbox"
// //                 checked={block.loop}
// //                 onChange={(e) => patch("loop", e.target.checked)}
// //               />
// //               Loop
// //             </label>
// //             <label
// //               style={{
// //                 display: "flex",
// //                 alignItems: "center",
// //                 gap: 6,
// //                 fontSize: 13,
// //                 color: "#5F5E5A",
// //               }}
// //             >
// //               <input
// //                 type="checkbox"
// //                 checked={block.autoplay}
// //                 onChange={(e) => patch("autoplay", e.target.checked)}
// //               />
// //               Autoplay
// //             </label>
// //           </div>
// //         </>
// //       );
// //     case "button":
// //       return (
// //         <>
// //           <Field label="Label">
// //             <input
// //               style={inputStyle}
// //               value={block.label}
// //               onChange={(e) => patch("label", e.target.value)}
// //               placeholder="Get API Key"
// //             />
// //           </Field>
// //           <Field label="Link URL">
// //             <input
// //               style={inputStyle}
// //               value={block.url}
// //               onChange={(e) => patch("url", e.target.value)}
// //               placeholder="https://..."
// //             />
// //           </Field>
// //           <Field label="Style">
// //             <select
// //               style={selectStyle}
// //               value={block.style}
// //               onChange={(e) => patch("style", e.target.value)}
// //             >
// //               <option value="primary">Primary</option>
// //               <option value="secondary">Secondary</option>
// //             </select>
// //           </Field>
// //           <Field label="Align">
// //             <div style={{ display: "flex", gap: 6 }}>
// //               {[
// //                 { value: "left", label: "Left", icon: AlignLeft },
// //                 { value: "center", label: "Center", icon: AlignCenter },
// //                 { value: "right", label: "Right", icon: AlignRight },
// //               ].map((opt) => {
// //                 const Ic = opt.icon;
// //                 return (
// //                   <IconBtn
// //                     key={opt.value}
// //                     title={opt.label}
// //                     active={(block.align || "left") === opt.value}
// //                     onClick={() => patch("align", opt.value)}
// //                   >
// //                     <Ic size={14} />
// //                   </IconBtn>
// //                 );
// //               })}
// //             </div>
// //           </Field>
// //           <label
// //             style={{
// //               display: "flex",
// //               alignItems: "center",
// //               gap: 6,
// //               fontSize: 13,
// //               color: "#5F5E5A",
// //               marginTop: 4,
// //             }}
// //           >
// //             <input
// //               type="checkbox"
// //               checked={block.newTab}
// //               onChange={(e) => patch("newTab", e.target.checked)}
// //             />
// //             Open in new tab
// //           </label>
// //         </>
// //       );
// //     case "badges":
// //       return (
// //         <Field label="Tags">
// //           {block.tags.map((tag, i) => (
// //             <div
// //               key={tag.id}
// //               style={{
// //                 display: "flex",
// //                 gap: 6,
// //                 marginBottom: 6,
// //                 alignItems: "center",
// //               }}
// //             >
// //               <input
// //                 style={inputStyle}
// //                 value={tag.label}
// //                 onChange={(e) => {
// //                   const tags = [...block.tags];
// //                   tags[i] = { ...tags[i], label: e.target.value };
// //                   patch("tags", tags);
// //                 }}
// //                 placeholder="Beta"
// //               />
// //               <select
// //                 style={{ ...selectStyle, width: 110, flexShrink: 0 }}
// //                 value={tag.tone}
// //                 onChange={(e) => {
// //                   const tags = [...block.tags];
// //                   tags[i] = { ...tags[i], tone: e.target.value };
// //                   patch("tags", tags);
// //                 }}
// //               >
// //                 {Object.keys(RAMP).map((tone) => (
// //                   <option key={tone} value={tone}>
// //                     {tone}
// //                   </option>
// //                 ))}
// //               </select>
// //               <IconBtn
// //                 title="Remove tag"
// //                 danger
// //                 onClick={() =>
// //                   patch(
// //                     "tags",
// //                     block.tags.filter((_, idx) => idx !== i),
// //                   )
// //                 }
// //               >
// //                 <Trash2 size={13} />
// //               </IconBtn>
// //             </div>
// //           ))}
// //           <button
// //             onClick={() =>
// //               patch("tags", [
// //                 ...block.tags,
// //                 { id: genKey("tag"), label: "", tone: "blue" },
// //               ])
// //             }
// //             style={{
// //               display: "inline-flex",
// //               alignItems: "center",
// //               gap: 6,
// //               marginTop: 2,
// //               fontSize: 13,
// //               padding: "6px 10px",
// //               borderRadius: 7,
// //               border: "1px dashed #C7C4B6",
// //               background: "transparent",
// //               color: "#5F5E5A",
// //               cursor: "pointer",
// //             }}
// //           >
// //             <Plus size={13} /> Add tag
// //           </button>
// //         </Field>
// //       );
// //     case "stepper":
// //       return (
// //         <>
// //           {block.steps.map((step, i) => (
// //             <div
// //               key={step.id}
// //               style={{
// //                 border: "1px solid #EDEBE0",
// //                 borderRadius: 9,
// //                 padding: 12,
// //                 marginBottom: 10,
// //               }}
// //             >
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   justifyContent: "space-between",
// //                   alignItems: "center",
// //                   marginBottom: 8,
// //                 }}
// //               >
// //                 <span
// //                   style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
// //                 >
// //                   Step {i + 1}
// //                 </span>
// //                 <IconBtn
// //                   title="Remove step"
// //                   danger
// //                   onClick={() =>
// //                     patch(
// //                       "steps",
// //                       block.steps.filter((_, idx) => idx !== i),
// //                     )
// //                   }
// //                 >
// //                   <Trash2 size={13} />
// //                 </IconBtn>
// //               </div>
// //               <Field label="Step title">
// //                 <input
// //                   style={inputStyle}
// //                   value={step.title}
// //                   onChange={(e) => {
// //                     const steps = [...block.steps];
// //                     steps[i] = { ...steps[i], title: e.target.value };
// //                     patch("steps", steps);
// //                   }}
// //                   placeholder="Install the SDK"
// //                 />
// //               </Field>
// //               <Field label="Step details">
// //                 <textarea
// //                   style={textareaStyle}
// //                   value={step.text}
// //                   onChange={(e) => {
// //                     const steps = [...block.steps];
// //                     steps[i] = { ...steps[i], text: e.target.value };
// //                     patch("steps", steps);
// //                   }}
// //                   placeholder="What the reader should do..."
// //                 />
// //               </Field>
// //             </div>
// //           ))}
// //           <button
// //             onClick={() =>
// //               patch("steps", [
// //                 ...block.steps,
// //                 { id: genKey("step"), title: "", text: "" },
// //               ])
// //             }
// //             style={{
// //               display: "inline-flex",
// //               alignItems: "center",
// //               gap: 6,
// //               fontSize: 13,
// //               padding: "6px 10px",
// //               borderRadius: 7,
// //               border: "1px dashed #C7C4B6",
// //               background: "transparent",
// //               color: "#5F5E5A",
// //               cursor: "pointer",
// //             }}
// //           >
// //             <Plus size={13} /> Add step
// //           </button>
// //         </>
// //       );
// //     case "feedback":
// //       return (
// //         <Field label="Prompt text">
// //           <input
// //             style={inputStyle}
// //             value={block.prompt}
// //             onChange={(e) => patch("prompt", e.target.value)}
// //             placeholder="Was this helpful?"
// //           />
// //         </Field>
// //       );
// //     case "table":
// //       return (
// //         <>
// //           <Field label="Columns">
// //             {block.columns.map((col, i) => (
// //               <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
// //                 <input
// //                   style={inputStyle}
// //                   value={col}
// //                   onChange={(e) => {
// //                     const columns = [...block.columns];
// //                     columns[i] = e.target.value;
// //                     onChange({ ...block, columns });
// //                   }}
// //                   placeholder={`Column ${i + 1}`}
// //                 />
// //                 <IconBtn
// //                   title="Remove column"
// //                   danger
// //                   onClick={() => {
// //                     const columns = block.columns.filter((_, idx) => idx !== i);
// //                     const rows = block.rows.map((row) =>
// //                       row.filter((_, idx) => idx !== i),
// //                     );
// //                     onChange({ ...block, columns, rows });
// //                   }}
// //                 >
// //                   <Trash2 size={13} />
// //                 </IconBtn>
// //               </div>
// //             ))}
// //             <button
// //               onClick={() => {
// //                 const columns = [
// //                   ...block.columns,
// //                   `Column ${block.columns.length + 1}`,
// //                 ];
// //                 const rows = block.rows.map((row) => [...row, ""]);
// //                 onChange({ ...block, columns, rows });
// //               }}
// //               style={{
// //                 display: "inline-flex",
// //                 alignItems: "center",
// //                 gap: 6,
// //                 fontSize: 13,
// //                 padding: "6px 10px",
// //                 borderRadius: 7,
// //                 border: "1px dashed #C7C4B6",
// //                 background: "transparent",
// //                 color: "#5F5E5A",
// //                 cursor: "pointer",
// //               }}
// //             >
// //               <Plus size={13} /> Add column
// //             </button>
// //           </Field>
// //           <Field label="Rows">
// //             {block.rows.map((row, ri) => (
// //               <div
// //                 key={ri}
// //                 style={{
// //                   display: "flex",
// //                   gap: 6,
// //                   marginBottom: 6,
// //                   alignItems: "center",
// //                 }}
// //               >
// //                 {row.map((cell, ci) => (
// //                   <input
// //                     key={ci}
// //                     style={inputStyle}
// //                     value={cell}
// //                     onChange={(e) => {
// //                       const rows = block.rows.map((r) => [...r]);
// //                       rows[ri][ci] = e.target.value;
// //                       patch("rows", rows);
// //                     }}
// //                     placeholder={block.columns[ci] || `Col ${ci + 1}`}
// //                   />
// //                 ))}
// //                 <IconBtn
// //                   title="Remove row"
// //                   danger
// //                   onClick={() =>
// //                     patch(
// //                       "rows",
// //                       block.rows.filter((_, idx) => idx !== ri),
// //                     )
// //                   }
// //                 >
// //                   <Trash2 size={13} />
// //                 </IconBtn>
// //               </div>
// //             ))}
// //             <button
// //               onClick={() =>
// //                 patch("rows", [...block.rows, block.columns.map(() => "")])
// //               }
// //               style={{
// //                 display: "inline-flex",
// //                 alignItems: "center",
// //                 gap: 6,
// //                 fontSize: 13,
// //                 padding: "6px 10px",
// //                 borderRadius: 7,
// //                 border: "1px dashed #C7C4B6",
// //                 background: "transparent",
// //                 color: "#5F5E5A",
// //                 cursor: "pointer",
// //               }}
// //             >
// //               <Plus size={13} /> Add row
// //             </button>
// //           </Field>
// //         </>
// //       );
// //     case "divider":
// //       return (
// //         <>
// //           <Field label="Style">
// //             <select
// //               style={selectStyle}
// //               value={block.style}
// //               onChange={(e) => patch("style", e.target.value)}
// //             >
// //               <option value="solid">Solid line</option>
// //               <option value="dashed">Dashed line</option>
// //               <option value="space">Blank space only</option>
// //             </select>
// //           </Field>
// //           <Field label="Spacing" hint="Vertical space in pixels">
// //             <input
// //               type="number"
// //               style={{ ...inputStyle, width: 120 }}
// //               value={block.spacing}
// //               onChange={(e) => patch("spacing", Number(e.target.value) || 0)}
// //             />
// //           </Field>
// //         </>
// //       );
// //     default:
// //       return null;
// //   }
// // }

// // function ImageKeyField({ value, onChange, prefix }) {
// //   return (
// //     <Field
// //       label="Image key"
// //       hint="Used to reference this image elsewhere in the document"
// //     >
// //       <div style={{ display: "flex", gap: 6 }}>
// //         <div style={{ position: "relative", flex: 1 }}>
// //           <KeyRound
// //             size={13}
// //             color="#9A988E"
// //             style={{ position: "absolute", left: 10, top: 12 }}
// //           />
// //           <input
// //             style={{ ...monoStyle, paddingLeft: 30 }}
// //             value={value}
// //             onChange={(e) => onChange(e.target.value)}
// //             placeholder="unique_image_key"
// //           />
// //         </div>
// //         <IconBtn
// //           title="Generate a new key"
// //           onClick={() => onChange(genKey(prefix))}
// //         >
// //           <RefreshCw size={13} />
// //         </IconBtn>
// //       </div>
// //     </Field>
// //   );
// // }

// // function PreviewImg({ src, alt, style }) {
// //   const [broken, setBroken] = useState(false);
// //   if (!src || broken) {
// //     return (
// //       <div
// //         style={{
// //           display: "flex",
// //           flexDirection: "column",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           gap: 6,
// //           background: "#F1EFE8",
// //           border: "1px dashed #C7C4B6",
// //           borderRadius: 8,
// //           color: "#8A8878",
// //           fontSize: 12,
// //           minHeight: 110,
// //           ...style,
// //         }}
// //       >
// //         <ImageOff size={18} />
// //         <span>{alt || "Image"}</span>
// //       </div>
// //     );
// //   }
// //   return (
// //     <img
// //       src={src}
// //       alt={alt}
// //       onError={() => setBroken(true)}
// //       style={{ display: "block", borderRadius: 8, ...style }}
// //     />
// //   );
// // }

// // function SliderPreview({ images }) {
// //   const [i, setI] = useState(0);
// //   if (!images.length) return null;
// //   const img = images[Math.min(i, images.length - 1)];
// //   return (
// //     <div
// //       style={{
// //         border: "1px solid #E4E2D8",
// //         borderRadius: 10,
// //         overflow: "hidden",
// //         background: "#FAF9F4",
// //       }}
// //     >
// //       <PreviewImg
// //         src={img.url}
// //         alt={img.alt}
// //         style={{
// //           width: img.width || "100%",
// //           height: img.height || "220px",
// //           objectFit: img.objectFit || "cover",
// //           borderRadius: 0,
// //         }}
// //       />
// //       <div
// //         style={{
// //           padding: "10px 14px",
// //           display: "flex",
// //           alignItems: "center",
// //           gap: 10,
// //         }}
// //       >
// //         <button
// //           onClick={() => setI((v) => (v - 1 + images.length) % images.length)}
// //           style={{
// //             border: "1px solid #E4E2D8",
// //             background: "#fff",
// //             borderRadius: 6,
// //             width: 26,
// //             height: 26,
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             cursor: "pointer",
// //             flexShrink: 0,
// //           }}
// //         >
// //           <ChevronLeft size={14} />
// //         </button>
// //         <div style={{ flex: 1 }}>
// //           <div style={{ fontSize: 13, color: "#20201C", lineHeight: 1.5 }}>
// //             {img.caption || "No caption"}
// //           </div>
// //           <div style={{ fontSize: 11, color: "#9A988E", marginTop: 2 }}>
// //             {i + 1} of {images.length}
// //           </div>
// //         </div>
// //         <button
// //           onClick={() => setI((v) => (v + 1) % images.length)}
// //           style={{
// //             border: "1px solid #E4E2D8",
// //             background: "#fff",
// //             borderRadius: 6,
// //             width: 26,
// //             height: 26,
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             cursor: "pointer",
// //             flexShrink: 0,
// //           }}
// //         >
// //           <ChevronRight size={14} />
// //         </button>
// //       </div>
// //     </div>
// //   );
// // }

// // function toEmbedUrl(provider, url) {
// //   if (!url) return "";
// //   if (provider === "mp4") return url;
// //   if (provider === "youtube") {
// //     const idMatch = url.match(/(?:youtu\.be\/|v=|embed\/)([a-zA-Z0-9_-]{6,})/);
// //     return idMatch ? `https://www.youtube.com/embed/${idMatch[1]}` : url;
// //   }
// //   if (provider === "vimeo") {
// //     const idMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
// //     return idMatch ? `https://player.vimeo.com/video/${idMatch[1]}` : url;
// //   }
// //   if (provider === "loom") {
// //     const idMatch = url.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
// //     return idMatch ? `https://www.loom.com/embed/${idMatch[1]}` : url;
// //   }
// //   return url;
// // }

// // const FILE_TYPE_ICONS = {
// //   PDF: FileText,
// //   ZIP: FileArchive,
// //   CSV: FileSpreadsheet,
// //   DOCX: FileText,
// //   XLSX: FileSpreadsheet,
// //   Other: FileGeneric,
// // };

// // function RenderedBlock({ block }) {
// //   switch (block.type) {
// //     case "heading": {
// //       const sizes = { h1: 24, h2: 20, h3: 17, h4: 15 };
// //       return (
// //         <div
// //           style={{
// //             fontSize: sizes[block.level] || 18,
// //             fontWeight: 600,
// //             color: "#1B2340",
// //             margin: "4px 0",
// //             textAlign: block.align || "left",
// //           }}
// //         >
// //           {block.text || (
// //             <span style={{ color: "#C7C4B6" }}>Empty heading</span>
// //           )}
// //         </div>
// //       );
// //     }
// //     case "paragraph":
// //       return (
// //         <p
// //           style={{
// //             fontSize: 14,
// //             lineHeight: 1.7,
// //             color: "#3A3A34",
// //             margin: "4px 0",
// //             textAlign: block.align || "left",
// //           }}
// //         >
// //           {block.text || (
// //             <span style={{ color: "#C7C4B6" }}>Empty paragraph</span>
// //           )}
// //         </p>
// //       );
// //     case "callout": {
// //       const s = CALLOUT_STYLE[block.style] || CALLOUT_STYLE.info;
// //       const Icon = s.icon;
// //       return (
// //         <div
// //           style={{
// //             display: "flex",
// //             gap: 10,
// //             background: s.bg,
// //             borderLeft: `3px solid ${s.border}`,
// //             borderRadius: 6,
// //             padding: "10px 12px",
// //             textAlign: block.align || "left",
// //           }}
// //         >
// //           <Icon
// //             size={16}
// //             color={s.text}
// //             style={{ flexShrink: 0, marginTop: 1 }}
// //           />
// //           <span
// //             style={{ fontSize: 13.5, color: s.text, lineHeight: 1.6, flex: 1 }}
// //           >
// //             {block.text || "Empty callout"}
// //           </span>
// //         </div>
// //       );
// //     }
// //     case "list": {
// //       const Tag = block.style === "number" ? "ol" : "ul";
// //       return (
// //         <Tag
// //           style={{
// //             margin: "4px 0",
// //             paddingLeft: 20,
// //             textAlign: block.align || "left",
// //           }}
// //         >
// //           {block.items.map((it, i) => (
// //             <li
// //               key={i}
// //               style={{ fontSize: 14, color: "#3A3A34", lineHeight: 1.7 }}
// //             >
// //               {it || <span style={{ color: "#C7C4B6" }}>Empty item</span>}
// //             </li>
// //           ))}
// //         </Tag>
// //       );
// //     }
// //     case "slider":
// //       return <SliderPreview images={block.images} />;
// //     case "image": {
// //       const align = block.align || "center";
// //       const marginLeft = align === "left" ? 0 : "auto";
// //       const marginRight = align === "right" ? 0 : "auto";
// //       return (
// //         <div style={{ textAlign: align }}>
// //           <PreviewImg
// //             src={block.url}
// //             alt={block.alt}
// //             style={{
// //               width: block.width || "100%",
// //               height: block.height || "auto",
// //               objectFit: block.objectFit || "cover",
// //               maxWidth: "100%",
// //               marginLeft,
// //               marginRight,
// //             }}
// //           />
// //           {block.caption && (
// //             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
// //               {block.caption}
// //             </div>
// //           )}
// //         </div>
// //       );
// //     }
// //     case "columns":
// //       return (
// //         <div
// //           style={{ display: "flex", gap: block.gap ?? 20, flexWrap: "wrap" }}
// //         >
// //           {(block.columns || []).map((col) => (
// //             <div
// //               key={col.id}
// //               style={{
// //                 flex: "1 1 200px",
// //                 minWidth: 0,
// //                 display: "flex",
// //                 flexDirection: "column",
// //                 gap: 14,
// //               }}
// //             >
// //               {col.blocks.map((b) => (
// //                 <RenderedBlock key={b.id} block={b} />
// //               ))}
// //             </div>
// //           ))}
// //         </div>
// //       );
// //     case "code":
// //       return (
// //         <div
// //           style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
// //         >
// //           <div
// //             style={{
// //               padding: "6px 12px",
// //               fontSize: 11,
// //               color: "#9BA6C7",
// //               fontFamily: "'IBM Plex Mono', monospace",
// //               borderBottom: "1px solid #2A335C",
// //             }}
// //           >
// //             {block.language || "code"}
// //           </div>
// //           <pre
// //             style={{
// //               margin: 0,
// //               padding: 12,
// //               fontSize: 12.5,
// //               color: "#E6EAF5",
// //               fontFamily: "'IBM Plex Mono', monospace",
// //               overflow: "auto",
// //             }}
// //           >
// //             {block.code || "// empty"}
// //           </pre>
// //         </div>
// //       );
// //     case "request_payload":
// //     case "success_response": {
// //       const isSuccess = block.type === "success_response";
// //       let pretty = block.data;
// //       try {
// //         pretty = JSON.stringify(JSON.parse(block.data), null, 2);
// //       } catch {
// //         /* keep raw */
// //       }
// //       return (
// //         <div
// //           style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
// //         >
// //           <div
// //             style={{
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "space-between",
// //               padding: "6px 12px",
// //               borderBottom: "1px solid #2A335C",
// //             }}
// //           >
// //             <span
// //               style={{
// //                 fontSize: 11,
// //                 color: "#9BA6C7",
// //                 fontFamily: "'IBM Plex Mono', monospace",
// //               }}
// //             >
// //               {isSuccess ? "response" : "request payload"}
// //             </span>
// //             {isSuccess && (
// //               <span
// //                 style={{
// //                   fontSize: 10,
// //                   fontWeight: 600,
// //                   color: "#27500A",
// //                   background: "#C0DD97",
// //                   borderRadius: 4,
// //                   padding: "2px 6px",
// //                 }}
// //               >
// //                 201 success
// //               </span>
// //             )}
// //           </div>
// //           <pre
// //             style={{
// //               margin: 0,
// //               padding: 12,
// //               fontSize: 12.5,
// //               color: "#E6EAF5",
// //               fontFamily: "'IBM Plex Mono', monospace",
// //               overflow: "auto",
// //             }}
// //           >
// //             {pretty}
// //           </pre>
// //         </div>
// //       );
// //     }
// //     case "video": {
// //       const ratios = {
// //         "16:9": "56.25%",
// //         "4:3": "75%",
// //         "1:1": "100%",
// //         "9:16": "177.78%",
// //       };
// //       const embedUrl = toEmbedUrl(block.provider, block.url);
// //       return (
// //         <div>
// //           <div
// //             style={{
// //               position: "relative",
// //               width: "100%",
// //               paddingTop: ratios[block.aspectRatio] || "56.25%",
// //               background: "#1B2340",
// //               borderRadius: 8,
// //               overflow: "hidden",
// //             }}
// //           >
// //             {embedUrl ? (
// //               block.provider === "mp4" ? (
// //                 <video
// //                   src={embedUrl}
// //                   controls
// //                   style={{
// //                     position: "absolute",
// //                     inset: 0,
// //                     width: "100%",
// //                     height: "100%",
// //                     objectFit: "cover",
// //                   }}
// //                 />
// //               ) : (
// //                 <iframe
// //                   src={embedUrl}
// //                   title={block.caption || "Video"}
// //                   allow="autoplay; fullscreen; picture-in-picture"
// //                   style={{
// //                     position: "absolute",
// //                     inset: 0,
// //                     width: "100%",
// //                     height: "100%",
// //                     border: 0,
// //                   }}
// //                 />
// //               )
// //             ) : (
// //               <div
// //                 style={{
// //                   position: "absolute",
// //                   inset: 0,
// //                   display: "flex",
// //                   flexDirection: "column",
// //                   alignItems: "center",
// //                   justifyContent: "center",
// //                   gap: 6,
// //                   color: "#9BA6C7",
// //                   fontSize: 12,
// //                 }}
// //               >
// //                 <Video size={20} />
// //                 <span>No video URL set</span>
// //               </div>
// //             )}
// //           </div>
// //           {block.caption && (
// //             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
// //               {block.caption}
// //             </div>
// //           )}
// //         </div>
// //       );
// //     }
// //     case "audio":
// //       return (
// //         <div
// //           style={{
// //             display: "flex",
// //             alignItems: "flex-start",
// //             gap: 12,
// //             border: "1px solid #E4E2D8",
// //             borderRadius: 10,
// //             padding: "12px 14px",
// //             background: "#FBFAF6",
// //           }}
// //         >
// //           <div
// //             style={{
// //               width: 36,
// //               height: 36,
// //               borderRadius: "50%",
// //               background: "#EEEDFE",
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               flexShrink: 0,
// //             }}
// //           >
// //             <Music2 size={16} color="#534AB7" />
// //           </div>
// //           <div style={{ flex: 1, minWidth: 0 }}>
// //             <div style={{ fontSize: 13.5, fontWeight: 600, color: "#1B2340" }}>
// //               {block.title || "Untitled audio"}
// //             </div>
// //             <div style={{ fontSize: 12, color: "#8A8878" }}>
// //               {block.subtitle}
// //               {block.subtitle && block.duration ? " · " : ""}
// //               {block.duration}
// //             </div>
// //             {block.url ? (
// //               <audio
// //                 src={block.url}
// //                 controls
// //                 style={{ width: "100%", height: 32, marginTop: 6 }}
// //               />
// //             ) : (
// //               <div style={{ fontSize: 12, color: "#C7C4B6", marginTop: 4 }}>
// //                 No audio URL set
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       );
// //     case "file": {
// //       const Icon = FILE_TYPE_ICONS[block.filetype] || FileGeneric;
// //       return (
// //         <div
// //           style={{
// //             display: "flex",
// //             alignItems: "center",
// //             gap: 12,
// //             border: "1px solid #E4E2D8",
// //             borderRadius: 10,
// //             padding: "12px 14px",
// //             background: "#FBFAF6",
// //           }}
// //         >
// //           <div
// //             style={{
// //               width: 36,
// //               height: 36,
// //               borderRadius: 8,
// //               background: "#E1F5EE",
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               flexShrink: 0,
// //             }}
// //           >
// //             <Icon size={17} color="#0F6E56" />
// //           </div>
// //           <div style={{ flex: 1, minWidth: 0 }}>
// //             <div
// //               style={{
// //                 fontSize: 13.5,
// //                 fontWeight: 600,
// //                 color: "#1B2340",
// //                 overflow: "hidden",
// //                 textOverflow: "ellipsis",
// //                 whiteSpace: "nowrap",
// //               }}
// //             >
// //               {block.filename || "Untitled file"}
// //             </div>
// //             <div style={{ fontSize: 12, color: "#8A8878" }}>
// //               {block.filetype}
// //               {block.filesize ? ` · ${block.filesize}` : ""}
// //             </div>
// //           </div>
// //           <a
// //             href={block.url || "#"}
// //             target="_blank"
// //             rel="noreferrer"
// //             style={{
// //               display: "inline-flex",
// //               alignItems: "center",
// //               gap: 6,
// //               fontSize: 12.5,
// //               fontWeight: 600,
// //               padding: "7px 12px",
// //               borderRadius: 7,
// //               background: "#1B2340",
// //               color: "#fff",
// //               textDecoration: "none",
// //               flexShrink: 0,
// //             }}
// //           >
// //             <Download size={13} /> Download
// //           </a>
// //         </div>
// //       );
// //     }
// //     case "lottie":
// //       return (
// //         <div>
// //           <div
// //             style={{
// //               width: block.width || "100%",
// //               height: block.height || "280px",
// //               borderRadius: 8,
// //               background: "#FBEAF0",
// //               border: "1px dashed #ED93B1",
// //               display: "flex",
// //               flexDirection: "column",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               gap: 6,
// //               color: "#993556",
// //             }}
// //           >
// //             <Sparkles size={20} />
// //             <span
// //               style={{ fontSize: 12, padding: "0 12px", textAlign: "center" }}
// //             >
// //               {block.url
// //                 ? "Lottie animation (plays on the live site)"
// //                 : "No animation URL set"}
// //             </span>
// //           </div>
// //           {block.caption && (
// //             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
// //               {block.caption}
// //             </div>
// //           )}
// //         </div>
// //       );
// //     case "button": {
// //       const align = block.align || "left";
// //       const justify =
// //         align === "center"
// //           ? "center"
// //           : align === "right"
// //             ? "flex-end"
// //             : "flex-start";
// //       const primary = block.style !== "secondary";
// //       return (
// //         <div style={{ display: "flex", justifyContent: justify }}>
// //           <a
// //             href={block.url || "#"}
// //             target={block.newTab ? "_blank" : undefined}
// //             rel={block.newTab ? "noreferrer" : undefined}
// //             style={{
// //               display: "inline-flex",
// //               alignItems: "center",
// //               gap: 6,
// //               fontSize: 13.5,
// //               fontWeight: 600,
// //               padding: "9px 18px",
// //               borderRadius: 8,
// //               textDecoration: "none",
// //               background: primary ? "#1B2340" : "transparent",
// //               color: primary ? "#fff" : "#1B2340",
// //               border: primary ? "none" : "1px solid #1B2340",
// //             }}
// //           >
// //             {block.label || "Button label"}
// //           </a>
// //         </div>
// //       );
// //     }
// //     case "badges":
// //       return (
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
// //           {block.tags.map((tag) => {
// //             const c = RAMP[tag.tone] || RAMP.blue;
// //             return (
// //               <span
// //                 key={tag.id}
// //                 style={{
// //                   fontSize: 12,
// //                   fontWeight: 600,
// //                   padding: "4px 10px",
// //                   borderRadius: 999,
// //                   background: c[50],
// //                   color: c[800],
// //                   border: `1px solid ${c[200]}`,
// //                 }}
// //               >
// //                 {tag.label || "Tag"}
// //               </span>
// //             );
// //           })}
// //         </div>
// //       );
// //     case "stepper":
// //       return (
// //         <div style={{ display: "flex", flexDirection: "column" }}>
// //           {block.steps.map((step, i) => (
// //             <div key={step.id} style={{ display: "flex", gap: 12 }}>
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   flexDirection: "column",
// //                   alignItems: "center",
// //                 }}
// //               >
// //                 <div
// //                   style={{
// //                     width: 24,
// //                     height: 24,
// //                     borderRadius: "50%",
// //                     background: "#1B2340",
// //                     color: "#fff",
// //                     fontSize: 11.5,
// //                     fontWeight: 700,
// //                     display: "flex",
// //                     alignItems: "center",
// //                     justifyContent: "center",
// //                     flexShrink: 0,
// //                   }}
// //                 >
// //                   {i + 1}
// //                 </div>
// //                 {i < block.steps.length - 1 && (
// //                   <div
// //                     style={{
// //                       width: 2,
// //                       flex: 1,
// //                       background: "#E4E2D8",
// //                       minHeight: 18,
// //                     }}
// //                   />
// //                 )}
// //               </div>
// //               <div style={{ paddingBottom: 16 }}>
// //                 <div
// //                   style={{ fontSize: 13.5, fontWeight: 600, color: "#1B2340" }}
// //                 >
// //                   {step.title || (
// //                     <span style={{ color: "#C7C4B6" }}>Untitled step</span>
// //                   )}
// //                 </div>
// //                 {step.text && (
// //                   <div
// //                     style={{
// //                       fontSize: 13,
// //                       color: "#5F5E5A",
// //                       lineHeight: 1.6,
// //                       marginTop: 3,
// //                     }}
// //                   >
// //                     {step.text}
// //                   </div>
// //                 )}
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       );
// //     case "feedback":
// //       return (
// //         <div
// //           style={{
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "space-between",
// //             border: "1px solid #E4E2D8",
// //             borderRadius: 10,
// //             padding: "12px 14px",
// //             background: "#FBFAF6",
// //           }}
// //         >
// //           <span style={{ fontSize: 13.5, color: "#3A3A34" }}>
// //             {block.prompt || "Was this helpful?"}
// //           </span>
// //           <div style={{ display: "flex", gap: 8 }}>
// //             <div
// //               style={{
// //                 width: 30,
// //                 height: 30,
// //                 borderRadius: 7,
// //                 border: "1px solid #E4E2D8",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //                 color: "#5F5E5A",
// //               }}
// //             >
// //               <ThumbsUp size={14} />
// //             </div>
// //             <div
// //               style={{
// //                 width: 30,
// //                 height: 30,
// //                 borderRadius: 7,
// //                 border: "1px solid #E4E2D8",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //                 color: "#5F5E5A",
// //               }}
// //             >
// //               <ThumbsDown size={14} />
// //             </div>
// //           </div>
// //         </div>
// //       );
// //     case "table":
// //       return (
// //         <div
// //           style={{
// //             overflow: "auto",
// //             border: "1px solid #E4E2D8",
// //             borderRadius: 8,
// //           }}
// //         >
// //           <table
// //             style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}
// //           >
// //             <thead>
// //               <tr>
// //                 {block.columns.map((col, i) => (
// //                   <th
// //                     key={i}
// //                     style={{
// //                       textAlign: "left",
// //                       padding: "8px 12px",
// //                       background: "#F1EFE8",
// //                       color: "#1B2340",
// //                       fontWeight: 600,
// //                       borderBottom: "1px solid #E4E2D8",
// //                       whiteSpace: "nowrap",
// //                     }}
// //                   >
// //                     {col || `Column ${i + 1}`}
// //                   </th>
// //                 ))}
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {block.rows.map((row, ri) => (
// //                 <tr key={ri}>
// //                   {row.map((cell, ci) => (
// //                     <td
// //                       key={ci}
// //                       style={{
// //                         padding: "8px 12px",
// //                         borderBottom: "1px solid #EDEBE0",
// //                         color: "#3A3A34",
// //                       }}
// //                     >
// //                       {cell}
// //                     </td>
// //                   ))}
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         </div>
// //       );
// //     case "divider":
// //       return block.style === "space" ? (
// //         <div style={{ height: block.spacing ?? 24 }} />
// //       ) : (
// //         <hr
// //           style={{
// //             border: "none",
// //             borderTop: `1px ${block.style === "dashed" ? "dashed" : "solid"} #E4E2D8`,
// //             margin: `${block.spacing ?? 24}px 0`,
// //           }}
// //         />
// //       );
// //     default:
// //       return null;
// //   }
// // }

// // function DocumentPreview({ values }) {
// //   return (
// //     <div
// //       style={{
// //         background: "#fff",
// //         borderRadius: 12,
// //         border: "1px solid #E4E2D8",
// //         padding: "20px 22px",
// //       }}
// //     >
// //       <div
// //         style={{
// //           fontSize: 11,
// //           fontWeight: 600,
// //           color: "#8A8878",
// //           textTransform: "uppercase",
// //           letterSpacing: "0.04em",
// //           marginBottom: 6,
// //         }}
// //       >
// //         {values.category} · {values.doc_type}
// //       </div>
// //       <div
// //         style={{
// //           fontSize: 22,
// //           fontWeight: 700,
// //           color: "#1B2340",
// //           fontFamily: "'Space Grotesk', sans-serif",
// //           marginBottom: 8,
// //         }}
// //       >
// //         {values.title || "Untitled workflow doc"}
// //       </div>
// //       <p
// //         style={{
// //           fontSize: 14,
// //           color: "#5F5E5A",
// //           lineHeight: 1.7,
// //           marginBottom: 18,
// //         }}
// //       >
// //         {values.overview}
// //       </p>
// //       <div
// //         style={{
// //           display: "flex",
// //           gap: 8,
// //           alignItems: "center",
// //           marginBottom: 20,
// //           fontFamily: "'IBM Plex Mono', monospace",
// //           fontSize: 12.5,
// //         }}
// //       >
// //         <span
// //           style={{
// //             background: "#1B2340",
// //             color: "#fff",
// //             borderRadius: 5,
// //             padding: "3px 8px",
// //             fontWeight: 600,
// //           }}
// //         >
// //           {values.api_method}
// //         </span>
// //         <span style={{ color: "#5F5E5A", wordBreak: "break-all" }}>
// //           {values.api_endpoint}
// //         </span>
// //       </div>
// //       <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
// //         {values.content_blocks.map((b) => (
// //           <RenderedBlock key={b.id} block={b} />
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

// // function toExportBlock(b) {
// //   const { id, ...rest } = b;
// //   if (b.type === "request_payload" || b.type === "success_response") {
// //     let parsed;
// //     try {
// //       parsed = JSON.parse(b.data);
// //     } catch {
// //       parsed = b.data;
// //     }
// //     return { type: b.type, data: parsed };
// //   }
// //   if (b.type === "columns") {
// //     return {
// //       ...rest,
// //       columns: (b.columns || []).map((col) => ({
// //         blocks: (col.blocks || []).map(toExportBlock),
// //       })),
// //     };
// //   }
// //   return rest;
// // }

// // export default function HrmsBlockEditor() {
// //   const { values, setField, setValues } = useFormikLike(initialValues);
// //   const [copied, setCopied] = useState(false);
// //   const [showPreview, setShowPreview] = useState(true);
// //   const [previewTab, setPreviewTab] = useState("rendered");
// //   const [addType, setAddType] = useState("paragraph");
// //   const { state } = useLocation();
// //   const { type } = useParams(); //add || update
// //   const [page_data, setPageData] = useState([]);

// //   const navigate = useNavigate();

// //   const client = useQueryClient();

// //   const { mutate: AddDocuments, isLoading } = useMutation(postDocument, {
// //     onSuccess: (res) => {
// //       if (res?.data?.response_code === 200) {
// //         client.refetchQueries(["get-document"]);
// //         toast.success(res?.data?.message);
// //         navigate(-1);
// //       } else {
// //         toast.warn(res?.data?.message);
// //       }
// //     },
// //   });

// //   const {
// //     data: documentResponse,

// //     isError,
// //     refetch,
// //   } = useQuery(["get-document", state], () => getDocument({ doc_id: state }), {
// //     enabled: Boolean(state),
// //   });

// //   function fromImportBlock(b) {
// //     const id = nextId();
// //     if (b.type === "request_payload" || b.type === "success_response") {
// //       const data =
// //         typeof b.data === "string"
// //           ? b.data
// //           : JSON.stringify(b.data ?? {}, null, 2);
// //       return { ...b, id, data };
// //     }
// //     if (b.type === "columns") {
// //       return {
// //         ...b,
// //         id,
// //         columns: (b.columns || []).map((col) => ({
// //           id: genKey("column"),
// //           blocks: (col.blocks || []).map(fromImportBlock),
// //         })),
// //       };
// //     }
// //     return { ...b, id };
// //   }

// //   useEffect(() => {
// //     const doc = documentResponse?.data?.data; // aapke sample response ke hisaab se
// //     if (!doc) return;
// //     setValues({
// //       page_title: doc.page_title || "",
// //       category: doc.category || "",
// //       title: doc.title || "",
// //       doc_type: doc.doc_type || "",
// //       overview: doc.overview || "",
// //       api_method: doc.api_method || "",
// //       api_endpoint: doc.api_endpoint || "",
// //       content_blocks: (doc.content_blocks || []).map(fromImportBlock),
// //     });
// //   }, [documentResponse]);

// //   const blocks = values.content_blocks;

// //   const updateBlock = (idx, updated) => {
// //     const next = [...blocks];
// //     next[idx] = updated;
// //     setField("content_blocks", next);
// //   };
// //   const removeBlock = (idx) =>
// //     setField(
// //       "content_blocks",
// //       blocks.filter((_, i) => i !== idx),
// //     );
// //   const moveBlock = (from, to) => {
// //     const next = [...blocks];
// //     const [item] = next.splice(from, 1);
// //     next.splice(to, 0, item);
// //     setField("content_blocks", next);
// //   };
// //   const addBlock = () =>
// //     setField("content_blocks", [...blocks, emptyBlockFor(addType)]);

// //   const exportJson = {
// //     page_title: values?.page_title,
// //     category: values.category,
// //     title: values.title,
// //     doc_type: values.doc_type,
// //     overview: values.overview,
// //     api_method: values.api_method,
// //     api_endpoint: values.api_endpoint,
// //     content_blocks: blocks.map(toExportBlock),
// //   };

// //   const jsonString = JSON.stringify(exportJson, null, 2);

// //   const copyJson = async () => {
// //     try {
// //       await navigator.clipboard.writeText(jsonString);
// //       setCopied(true);
// //       setTimeout(() => setCopied(false), 1500);
// //     } catch {
// //       setCopied(false);
// //     }
// //   };

// //   const isEditMode = Boolean(state);

// //   const { mutate: EditDocument, isLoading: IsUpdateLoading } = useMutation(
// //     (payload) => patchDocument({ ...payload, doc_id: state }),
// //     {
// //       onSuccess: (res) => {
// //         if (res?.data?.response_code === 200) {
// //           navigate(-1);
// //           toast.success(res?.data?.message);
// //           client.refetchQueries(["get-document"]);
// //         } else {
// //           toast.warn(res?.data?.message);
// //         }
// //       },
// //     },
// //   );
// //   const saveDocument = async () => {
// //     if (isEditMode) EditDocument(exportJson);
// //     else AddDocuments(exportJson);
// //   };

// //   const getCreer = () => {
// //     axios
// //       .get(`${baseUrl}/blog/frontend-page-id-api/`, {
// //         headers: {
// //           Authorization: `Token ${localStorage.getItem("token")}`,
// //           "Access-Control-Allow-Origin": "*",
// //         },
// //       })
// //       .then((res) => {
// //         setPageData(res.data?.data);
// //       })
// //       .catch((err) => {
// //         toast.error("Error deleting blog", err?.response?.data?.message);
// //       });
// //   };

// //   useEffect(() => {
// //     getCreer();
// //   }, []);

// //   return (
// //     <div
// //       style={{
// //         fontFamily: "'IBM Plex Sans', sans-serif",
// //         background: "#F3F2EC",
// //         padding: 24,
// //         minHeight: "100vh",

// //         boxSizing: "border-box",
// //       }}
// //     >
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&family=Space+Grotesk:wght@600;700&display=swap');
// //         input:focus, textarea:focus, select:focus { border-color: #185FA5 !important; box-shadow: 0 0 0 3px rgba(24,95,165,0.12); }
// //       `}</style>

// //       <div style={{ maxWidth: "100%", margin: "0 auto" }}>
// //         <div
// //           style={{
// //             display: "flex",
// //             alignItems: "baseline",
// //             justifyContent: "space-between",
// //             marginBottom: 20,
// //             flexWrap: "wrap",
// //             gap: 10,
// //           }}
// //         >
// //           <div>
// //             <div
// //               style={{
// //                 fontSize: 12,
// //                 fontFamily: "'IBM Plex Mono', monospace",
// //                 color: "#8A8878",
// //                 letterSpacing: "0.06em",
// //                 textTransform: "uppercase",
// //                 marginBottom: 4,
// //               }}
// //             >
// //               HRMS content block editor
// //             </div>
// //             <h1
// //               style={{
// //                 fontFamily: "'Space Grotesk', sans-serif",
// //                 fontSize: 26,
// //                 fontWeight: 700,
// //                 color: "#1B2340",
// //                 margin: 0,
// //               }}
// //             >
// //               {values.title || "Untitled workflow doc"}
// //             </h1>
// //           </div>
// //           <div style={{ display: "flex", gap: 8 }}>
// //             <button
// //               onClick={() => setShowPreview((s) => !s)}
// //               style={{
// //                 fontSize: 13,
// //                 padding: "8px 14px",
// //                 borderRadius: 8,
// //                 border: "1px solid #DEDCD1",
// //                 background: "#fff",
// //                 color: "#20201C",
// //                 cursor: "pointer",
// //               }}
// //             >
// //               {showPreview ? "Hide JSON" : "Show JSON"}
// //             </button>
// //             <button
// //               onClick={copyJson}
// //               style={{
// //                 display: "inline-flex",
// //                 alignItems: "center",
// //                 gap: 6,
// //                 fontSize: 13,
// //                 padding: "8px 14px",
// //                 borderRadius: 8,
// //                 border: "none",
// //                 background: "#1B2340",
// //                 color: "#fff",
// //                 cursor: "pointer",
// //               }}
// //             >
// //               {copied ? <Check size={14} /> : <Copy size={14} />}{" "}
// //               {copied ? "Copied" : "Copy JSON"}
// //             </button>
// //             <button
// //               disabled={isLoading || IsUpdateLoading}
// //               onClick={saveDocument}
// //               style={{
// //                 display: "inline-flex",
// //                 alignItems: "center",
// //                 gap: 6,
// //                 fontSize: 13,
// //                 padding: "8px 14px",
// //                 borderRadius: 8,
// //                 border: "none",
// //                 background: "#1B2340",
// //                 color: "#fff",
// //                 cursor: "pointer",
// //               }}
// //             >
// //               {isLoading || IsUpdateLoading
// //                 ? "Saving..."
// //                 : isEditMode
// //                   ? "Update Document"
// //                   : "Save Document"}
// //             </button>
// //           </div>
// //         </div>

// //         <div
// //           style={{
// //             display: "grid",
// //             gridTemplateColumns: showPreview ? "1fr 1fr" : "1fr",
// //             gap: 20,
// //             alignItems: "start",
// //             minWidth: 0,
// //           }}
// //         >
// //           <div style={{ minWidth: 0 }}>
// //             {/* Document meta card */}
// //             <div
// //               style={{
// //                 background: "#fff",
// //                 border: "1px solid #E4E2D8",
// //                 borderRadius: 12,
// //                 padding: 18,
// //                 marginBottom: 20,
// //               }}
// //             >
// //               <div
// //                 style={{
// //                   fontSize: 13,
// //                   fontWeight: 600,
// //                   color: "#1B2340",
// //                   marginBottom: 12,
// //                 }}
// //               >
// //                 Document details
// //               </div>

// //               <Field label="Select the page you want to view">
// //                 <select
// //                   style={selectStyle}
// //                   value={values.page_title}
// //                   onChange={(e) => setField("page_title", e.target.value)}
// //                 >
// //                   <option className="font-bold ">Select A Page</option>
// //                   {page_data?.map((i) => (
// //                     <option value={i?.id}>{i?.name}</option>
// //                   ))}
// //                 </select>
// //               </Field>
// //               <div
// //                 style={{
// //                   display: "grid",
// //                   gridTemplateColumns: "1fr 1fr",
// //                   gap: 12,
// //                 }}
// //               >
// //                 <Field label="Category">
// //                   <input
// //                     style={inputStyle}
// //                     value={values.category}
// //                     onChange={(e) => setField("category", e.target.value)}
// //                   />
// //                 </Field>
// //                 <Field label="Doc type">
// //                   <input
// //                     style={inputStyle}
// //                     value={values.doc_type}
// //                     onChange={(e) => setField("doc_type", e.target.value)}
// //                   />
// //                 </Field>
// //               </div>
// //               <Field label="Title">
// //                 <input
// //                   style={inputStyle}
// //                   value={values.title}
// //                   onChange={(e) => setField("title", e.target.value)}
// //                 />
// //               </Field>
// //               <Field label="Overview">
// //                 <textarea
// //                   style={textareaStyle}
// //                   value={values.overview}
// //                   onChange={(e) => setField("overview", e.target.value)}
// //                 />
// //               </Field>
// //               <div
// //                 style={{
// //                   display: "grid",
// //                   gridTemplateColumns: "120px 1fr",
// //                   gap: 12,
// //                 }}
// //               >
// //                 <Field label="API method">
// //                   <select
// //                     style={selectStyle}
// //                     value={values.api_method}
// //                     onChange={(e) => setField("api_method", e.target.value)}
// //                   >
// //                     {["GET", "POST", "PUT", "PATCH", "DELETE"].map((m) => (
// //                       <option key={m} value={m}>
// //                         {m}
// //                       </option>
// //                     ))}
// //                   </select>
// //                 </Field>
// //                 <Field label="API endpoint">
// //                   <input
// //                     style={monoStyle}
// //                     value={values.api_endpoint}
// //                     onChange={(e) => setField("api_endpoint", e.target.value)}
// //                   />
// //                 </Field>
// //               </div>
// //             </div>

// //             {/* Blocks */}
// //             <div
// //               style={{
// //                 fontSize: 13,
// //                 fontWeight: 600,
// //                 color: "#1B2340",
// //                 marginBottom: 10,
// //               }}
// //             >
// //               Content blocks ({blocks.length})
// //             </div>
// //             {blocks.map((b, i) => (
// //               <BlockCard
// //                 key={b.id}
// //                 block={b}
// //                 index={i}
// //                 total={blocks.length}
// //                 onChange={(updated) => updateBlock(i, updated)}
// //                 onRemove={removeBlock}
// //                 onMove={moveBlock}
// //               />
// //             ))}

// //             <div
// //               style={{
// //                 display: "flex",
// //                 gap: 8,
// //                 marginTop: 14,
// //                 background: "#fff",
// //                 border: "1px dashed #C7C4B6",
// //                 borderRadius: 12,
// //                 padding: 14,
// //                 alignItems: "center",
// //               }}
// //             >
// //               <select
// //                 style={{ ...selectStyle, width: "auto", flex: 1 }}
// //                 value={addType}
// //                 onChange={(e) => setAddType(e.target.value)}
// //               >
// //                 {Object.entries(BLOCK_TYPES).map(([k, v]) => (
// //                   <option key={k} value={k}>
// //                     {v.label}
// //                   </option>
// //                 ))}
// //               </select>
// //               <button
// //                 onClick={addBlock}
// //                 style={{
// //                   display: "inline-flex",
// //                   alignItems: "center",
// //                   gap: 6,
// //                   fontSize: 13,
// //                   fontWeight: 600,
// //                   padding: "9px 16px",
// //                   borderRadius: 8,
// //                   border: "none",
// //                   background: "#1B2340",
// //                   color: "#fff",
// //                   cursor: "pointer",
// //                 }}
// //               >
// //                 <Plus size={14} /> Add block
// //               </button>
// //             </div>
// //           </div>

// //           {showPreview && (
// //             <div style={{ position: "sticky", top: 20, minWidth: 0 }}>
// //               <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
// //                 {[
// //                   ["rendered", "Preview"],
// //                   ["json", "JSON"],
// //                 ].map(([key, label]) => (
// //                   <button
// //                     key={key}
// //                     onClick={() => setPreviewTab(key)}
// //                     style={{
// //                       fontSize: 12.5,
// //                       fontWeight: 600,
// //                       padding: "6px 12px",
// //                       borderRadius: 7,
// //                       cursor: "pointer",
// //                       border:
// //                         previewTab === key
// //                           ? "1px solid #1B2340"
// //                           : "1px solid #DEDCD1",
// //                       background: previewTab === key ? "#1B2340" : "#fff",
// //                       color: previewTab === key ? "#fff" : "#5F5E5A",
// //                     }}
// //                   >
// //                     {label}
// //                   </button>
// //                 ))}
// //                 <span
// //                   style={{
// //                     fontSize: 11.5,
// //                     color: "#9A988E",
// //                     alignSelf: "center",
// //                     marginLeft: 4,
// //                   }}
// //                 >
// //                   {previewTab === "rendered"
// //                     ? "How this data will display"
// //                     : "Data admin will submit"}
// //                 </span>
// //               </div>

// //               {previewTab === "rendered" ? (
// //                 <div style={{ maxHeight: "80vh", overflow: "auto" }}>
// //                   <DocumentPreview values={values} />
// //                 </div>
// //               ) : (
// //                 <div
// //                   style={{
// //                     background: "#1B2340",
// //                     borderRadius: 12,
// //                     overflow: "hidden",
// //                     border: "1px solid #1B2340",
// //                   }}
// //                 >
// //                   <div
// //                     style={{
// //                       padding: "10px 14px",
// //                       fontSize: 12,
// //                       color: "#9BA6C7",
// //                       fontFamily: "'IBM Plex Mono', monospace",
// //                       borderBottom: "1px solid #2A335C",
// //                     }}
// //                   >
// //                     output.json
// //                   </div>
// //                   <pre
// //                     style={{
// //                       margin: 0,
// //                       padding: 16,
// //                       fontSize: 12.5,
// //                       lineHeight: 1.6,
// //                       color: "#E6EAF5",
// //                       fontFamily: "'IBM Plex Mono', monospace",
// //                       overflow: "auto",
// //                       maxHeight: "80vh",
// //                     }}
// //                   >
// //                     {jsonString}
// //                   </pre>
// //                 </div>
// //               )}
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// import { useEffect, useState, useRef } from "react";
// import {
//   Heading1,
//   AlignLeft,
//   AlertTriangle,
//   List as ListIcon,
//   Images,
//   Image as ImageIcon,
//   Code2,
//   Terminal,
//   CheckCircle2,
//   Plus,
//   Trash2,
//   ChevronUp,
//   ChevronDown,
//   ChevronDown as Caret,
//   Copy,
//   Check,
//   GripVertical,
//   KeyRound,
//   RefreshCw,
//   Info,
//   XCircle,
//   ImageOff,
//   ChevronLeft,
//   ChevronRight,
//   Columns2,
//   AlignCenter,
//   AlignRight,
//   AlignJustify,
//   Video,
//   Music2,
//   Paperclip,
//   Sparkles,
//   MousePointerClick,
//   Tags,
//   ListOrdered,
//   ThumbsUp,
//   ThumbsDown,
//   Table2,
//   SeparatorHorizontal,
//   FileText,
//   FileArchive,
//   FileSpreadsheet,
//   File as FileGeneric,
//   Download,
//   PenSquare,
// } from "lucide-react";
// import { useMutation, useQuery, useQueryClient } from "react-query";
// import {
//   getDocument,
//   patchDocument,
//   postDocument,
// } from "../../../Services/Document";
// import { toast } from "react-toastify";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { baseUrl } from "../../../Config/baseUrl";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// const RICHTEXT_MODULES = {
//   toolbar: [
//     [{ header: [1, 2, 3, false] }],
//     ["bold", "italic", "underline", "strike"],
//     [{ color: [] }, { background: [] }],
//     [{ list: "ordered" }, { list: "bullet" }],
//     ["blockquote", "code-block", "link"],
//     ["clean"],
//   ],
// };

// const CALLOUT_STYLE = {
//   info: { bg: "#E6F1FB", border: "#185FA5", text: "#0C447C", icon: Info },
//   warning: {
//     bg: "#FAEEDA",
//     border: "#BA7517",
//     text: "#633806",
//     icon: AlertTriangle,
//   },
//   success: {
//     bg: "#EAF3DE",
//     border: "#3B6D11",
//     text: "#27500A",
//     icon: CheckCircle2,
//   },
//   error: { bg: "#FCEBEB", border: "#A32D2D", text: "#501313", icon: XCircle },
// };

// const BLOCK_TYPES = {
//   heading: { label: "Heading", ramp: "blue", icon: Heading1 },
//   paragraph: { label: "Paragraph", ramp: "gray", icon: AlignLeft },
//   callout: { label: "Callout", ramp: "amber", icon: AlertTriangle },
//   list: { label: "List", ramp: "green", icon: ListIcon },
//   slider: { label: "Image slider", ramp: "purple", icon: Images },
//   image: { label: "Image", ramp: "pink", icon: ImageIcon },
//   columns: { label: "Multi-column", ramp: "blue", icon: Columns2 },
//   request_payload: { label: "Request payload", ramp: "teal", icon: Code2 },
//   code: { label: "Code sample", ramp: "gray", icon: Terminal },
//   success_response: {
//     label: "Success response",
//     ramp: "green",
//     icon: CheckCircle2,
//   },
//   video: { label: "Video embed", ramp: "blue", icon: Video },
//   audio: { label: "Audio player / voice note", ramp: "purple", icon: Music2 },
//   file: { label: "File attachment", ramp: "teal", icon: Paperclip },
//   lottie: {
//     label: "Lottie / interactive animation",
//     ramp: "pink",
//     icon: Sparkles,
//   },
//   button: {
//     label: "Button / action link",
//     ramp: "green",
//     icon: MousePointerClick,
//   },
//   badges: { label: "Badge / tag cloud", ramp: "amber", icon: Tags },
//   stepper: { label: "Step-by-step guide", ramp: "blue", icon: ListOrdered },
//   feedback: { label: "Feedback widget", ramp: "green", icon: ThumbsUp },
//   table: { label: "Table", ramp: "gray", icon: Table2 },
//   divider: {
//     label: "Divider / spacer",
//     ramp: "gray",
//     icon: SeparatorHorizontal,
//   },
//   richtext: { label: "Rich text editor", ramp: "purple", icon: PenSquare },
// };

// const RAMP = {
//   blue: { 50: "#E6F1FB", 200: "#85B7EB", 600: "#185FA5", 800: "#0C447C" },
//   gray: { 50: "#F1EFE8", 200: "#B4B2A9", 600: "#5F5E5A", 800: "#444441" },
//   amber: { 50: "#FAEEDA", 200: "#EF9F27", 600: "#854F0B", 800: "#633806" },
//   green: { 50: "#EAF3DE", 200: "#97C459", 600: "#3B6D11", 800: "#27500A" },
//   purple: { 50: "#EEEDFE", 200: "#AFA9EC", 600: "#534AB7", 800: "#3C3489" },
//   pink: { 50: "#FBEAF0", 200: "#ED93B1", 600: "#993556", 800: "#72243E" },
//   teal: { 50: "#E1F5EE", 200: "#5DCAA5", 600: "#0F6E56", 800: "#085041" },
// };

// const ALIGN_OPTIONS = [
//   { value: "left", label: "Left", icon: AlignLeft },
//   { value: "center", label: "Center", icon: AlignCenter },
//   { value: "right", label: "Right", icon: AlignRight },
//   { value: "justify", label: "Justify", icon: AlignJustify },
// ];

// const OBJECT_FIT_OPTIONS = ["cover", "contain", "fill", "none", "scale-down"];

// let uid = 1;
// const nextId = () => `blk-${uid++}`;
// const genKey = (prefix) =>
//   `${prefix}_${Math.random().toString(36).slice(2, 8)}`;

// // ---- Media upload helpers ----------------------------------------------

// function guessExtension(mimeType) {
//   const map = {
//     "image/jpeg": "jpg",
//     "image/png": "png",
//     "image/webp": "webp",
//     "image/gif": "gif",
//     "audio/mpeg": "mp3",
//     "audio/wav": "wav",
//     "video/mp4": "mp4",
//     "application/pdf": "pdf",
//   };
//   return map[mimeType] || mimeType?.split("/")[1] || "bin";
// }

// async function urlToFile(url) {
//   const res = await fetch(url);
//   if (!res.ok) throw new Error("Could not fetch that URL");
//   const blob = await res.blob();
//   const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
//   return new File([blob], `media-${timestamp}.${guessExtension(blob.type)}`, {
//     type: blob.type,
//   });
// }

// async function uploadFileToServer(file) {
//   const formData = new FormData();
//   formData.append("title", "file");
//   formData.append("image", file);

//   const res = await axios.post(
//     `${baseUrl}/blog/upload-image-to-s3-api/`, // TODO: point this at your real upload endpoint
//     formData,
//     {
//       headers: {
//         Authorization: `Token ${localStorage.getItem("token")}`,
//       },
//     },
//   );

//   return res.data?.data?.image; // TODO: adjust to match your API's actual response shape
// }

// // -------------------------------------------------------------------------

// const emptyImageValue = (prefix) => ({
//   image_key: genKey(prefix),
//   url: "",
//   caption: "",
//   alt: "",
//   width: "100%",
//   height: "220px",
//   objectFit: "cover",
// });

// const emptyColumn = () => ({
//   id: genKey("column"),
//   blocks: [],
// });

// const emptyBlockFor = (type) => {
//   const id = nextId();
//   switch (type) {
//     case "heading":
//       return { id, type: "heading", level: "h2", text: "", align: "left" };
//     case "paragraph":
//       return { id, type: "paragraph", text: "", align: "left" };
//     case "callout":
//       return { id, type: "callout", style: "info", text: "", align: "left" };
//     case "list":
//       return { id, type: "list", style: "bullet", items: [""], align: "left" };
//     case "slider":
//       return { id, type: "slider", images: [emptyImageValue("slider_step")] };
//     case "image":
//       return {
//         id,
//         type: "image",
//         image_key: genKey("image"),
//         url: "",
//         caption: "",
//         align: "center",
//         width: "100%",
//         height: "auto",
//         objectFit: "cover",
//       };
//     case "columns":
//       return {
//         id,
//         type: "columns",
//         gap: 20,
//         columns: [emptyColumn(), emptyColumn()],
//       };
//     case "request_payload":
//       return { id, type: "request_payload", data: "{\n  \n}" };
//     case "code":
//       return { id, type: "code", language: "python", code: "" };
//     case "success_response":
//       return { id, type: "success_response", data: "{\n  \n}" };
//     case "video":
//       return {
//         id,
//         type: "video",
//         provider: "youtube",
//         url: "",
//         caption: "",
//         aspectRatio: "16:9",
//       };
//     case "audio":
//       return {
//         id,
//         type: "audio",
//         url: "",
//         title: "",
//         subtitle: "",
//         duration: "",
//       };
//     case "file":
//       return {
//         id,
//         type: "file",
//         url: "",
//         filename: "",
//         filetype: "PDF",
//         filesize: "",
//       };
//     case "lottie":
//       return {
//         id,
//         type: "lottie",
//         url: "",
//         caption: "",
//         width: "100%",
//         height: "280px",
//         loop: true,
//         autoplay: true,
//       };
//     case "button":
//       return {
//         id,
//         type: "button",
//         label: "",
//         url: "",
//         style: "primary",
//         align: "left",
//         newTab: true,
//       };
//     case "badges":
//       return {
//         id,
//         type: "badges",
//         tags: [{ id: genKey("tag"), label: "New", tone: "blue" }],
//       };
//     case "stepper":
//       return {
//         id,
//         type: "stepper",
//         steps: [{ id: genKey("step"), title: "", text: "" }],
//       };
//     case "feedback":
//       return { id, type: "feedback", prompt: "Was this helpful?" };
//     case "table":
//       return {
//         id,
//         type: "table",
//         columns: ["Column 1", "Column 2"],
//         rows: [["", ""]],
//       };
//     case "divider":
//       return { id, type: "divider", style: "solid", spacing: 24 };
//     default:
//       return { id, type: "paragraph", text: "", align: "left" };
//     case "richtext":
//       return { id, type: "richtext", html: "", align: "left" };
//   }
// };

// const initialBlocks = [];

// const initialValues = {
//   page_title: "",
//   category: "",
//   title: "",
//   doc_type: "",
//   overview: "",
//   api_method: "",
//   api_endpoint: "",
//   content_blocks: initialBlocks,
// };

// function useFormikLike(initial) {
//   const [values, setValues] = useState(initial);
//   const setField = (path, val) => {
//     setValues((prev) => {
//       const next = structuredClone(prev);
//       const keys = path.split(".");
//       let cur = next;
//       for (let i = 0; i < keys.length - 1; i++) cur = cur[keys[i]];
//       cur[keys[keys.length - 1]] = val;
//       return next;
//     });
//   };
//   return { values, setValues, setField };
// }

// function Field({ label, children, hint }) {
//   return (
//     <label style={{ display: "block", marginBottom: 14 }}>
//       <span
//         style={{
//           display: "block",
//           fontSize: 12,
//           fontWeight: 600,
//           color: "#5F5E5A",
//           letterSpacing: "0.02em",
//           textTransform: "uppercase",
//           marginBottom: 6,
//         }}
//       >
//         {label}
//       </span>
//       {children}
//       {hint && (
//         <span
//           style={{
//             display: "block",
//             fontSize: 12,
//             color: "#9A988E",
//             marginTop: 4,
//           }}
//         >
//           {hint}
//         </span>
//       )}
//     </label>
//   );
// }

// const inputStyle = {
//   width: "100%",
//   boxSizing: "border-box",
//   padding: "9px 11px",
//   borderRadius: 8,
//   border: "1px solid #DEDCD1",
//   fontSize: 14,
//   fontFamily: "'IBM Plex Sans', sans-serif",
//   color: "#20201C",
//   background: "#FFFFFF",
//   outline: "none",
// };
// const monoStyle = {
//   ...inputStyle,
//   fontFamily: "'IBM Plex Mono', monospace",
//   fontSize: 13,
// };
// const selectStyle = { ...inputStyle, cursor: "pointer" };
// const textareaStyle = {
//   ...inputStyle,
//   resize: "vertical",
//   minHeight: 70,
//   lineHeight: 1.5,
// };

// function IconBtn({ onClick, title, children, danger, active }) {
//   return (
//     <button
//       onClick={onClick}
//       title={title}
//       style={{
//         display: "inline-flex",
//         alignItems: "center",
//         justifyContent: "center",
//         width: 28,
//         height: 28,
//         borderRadius: 6,
//         border: active ? "1px solid #1B2340" : "1px solid #E4E2D8",
//         background: active ? "#1B2340" : "#fff",
//         color: active ? "#fff" : danger ? "#993C1D" : "#5F5E5A",
//         cursor: "pointer",
//       }}
//     >
//       {children}
//     </button>
//   );
// }

// function Spinner({ size = 14 }) {
//   return (
//     <span
//       style={{
//         display: "inline-block",
//         width: size,
//         height: size,
//         border: "2px solid #DEDCD1",
//         borderTopColor: "#1B2340",
//         borderRadius: "50%",
//         animation: "spSpin 0.7s linear infinite",
//         flexShrink: 0,
//       }}
//     />
//   );
// }

// function AlignPicker({ value, onChange }) {
//   return (
//     <Field label="Text align">
//       <div style={{ display: "flex", gap: 6 }}>
//         {ALIGN_OPTIONS.map((opt) => {
//           const Icon = opt.icon;
//           return (
//             <IconBtn
//               key={opt.value}
//               title={opt.label}
//               active={value === opt.value}
//               onClick={() => onChange(opt.value)}
//             >
//               <Icon size={14} />
//             </IconBtn>
//           );
//         })}
//       </div>
//     </Field>
//   );
// }

// function ImageDimensionFields({ width, height, objectFit, onChange }) {
//   return (
//     <div
//       style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}
//     >
//       <Field label="Width" hint="px, % or auto">
//         <input
//           style={inputStyle}
//           value={width}
//           onChange={(e) => onChange({ width: e.target.value })}
//           placeholder="100%"
//         />
//       </Field>
//       <Field label="Height" hint="px or auto">
//         <input
//           style={inputStyle}
//           value={height}
//           onChange={(e) => onChange({ height: e.target.value })}
//           placeholder="220px"
//         />
//       </Field>
//       <Field label="Fit">
//         <select
//           style={selectStyle}
//           value={objectFit}
//           onChange={(e) => onChange({ objectFit: e.target.value })}
//         >
//           {OBJECT_FIT_OPTIONS.map((f) => (
//             <option key={f} value={f}>
//               {f}
//             </option>
//           ))}
//         </select>
//       </Field>
//     </div>
//   );
// }

// function JsonField({ label, value, onChange }) {
//   const [error, setError] = useState(null);
//   return (
//     <Field label={label} hint={error ? null : "Valid JSON object"}>
//       <textarea
//         style={{ ...monoStyle, minHeight: 120 }}
//         value={value}
//         onChange={(e) => {
//           onChange(e.target.value);
//           try {
//             JSON.parse(e.target.value);
//             setError(null);
//           } catch {
//             setError("Not valid JSON yet");
//           }
//         }}
//       />
//       {error && (
//         <span
//           style={{
//             display: "block",
//             fontSize: 12,
//             color: "#993C1D",
//             marginTop: 4,
//           }}
//         >
//           {error}
//         </span>
//       )}
//     </Field>
//   );
// }

// // ---- Media upload field (URL fetch OR direct file upload) --------------

// function MediaUploadField({ label, value, onChange, accept = "*/*", hint }) {
//   const [mode, setMode] = useState("url");
//   const [pastedUrl, setPastedUrl] = useState("");
//   const [status, setStatus] = useState("idle"); // idle | working | error
//   const fileInputRef = useRef(null);

//   const runUpload = async (file) => {
//     setStatus("working");
//     try {
//       const uploadedUrl = await uploadFileToServer(file);
//       if (!uploadedUrl) throw new Error("No URL returned");
//       onChange(uploadedUrl);
//       setStatus("idle");
//     } catch (err) {
//       toast.error("Upload failed. Please try again.");
//       setStatus("error");
//     }
//   };

//   const handleUrlConvert = async () => {
//     if (!pastedUrl) return;
//     setStatus("working");
//     try {
//       const file = await urlToFile(pastedUrl);
//       await runUpload(file);
//     } catch {
//       toast.error("Couldn't read that URL");
//       setStatus("error");
//     }
//   };

//   const handleFilePick = (e) => {
//     const file = e.target.files?.[0];
//     if (file) runUpload(file);
//     e.target.value = ""; // allow re-picking the same file later
//   };

//   const tabBtn = (key, text) => (
//     <button
//       type="button"
//       onClick={() => setMode(key)}
//       style={{
//         fontSize: 12,
//         fontWeight: 600,
//         padding: "5px 10px",
//         borderRadius: 6,
//         cursor: "pointer",
//         border: mode === key ? "1px solid #1B2340" : "1px solid #DEDCD1",
//         background: mode === key ? "#1B2340" : "#fff",
//         color: mode === key ? "#fff" : "#5F5E5A",
//       }}
//     >
//       {text}
//     </button>
//   );

//   return (
//     <Field label={label} hint={hint}>
//       <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
//         {tabBtn("url", "Paste URL")}
//         {tabBtn("upload", "Upload file")}
//       </div>

//       {mode === "url" ? (
//         <div style={{ display: "flex", gap: 6 }}>
//           <input
//             style={inputStyle}
//             value={pastedUrl}
//             onChange={(e) => setPastedUrl(e.target.value)}
//             placeholder="https://..."
//             disabled={status === "working"}
//           />
//           <button
//             type="button"
//             onClick={handleUrlConvert}
//             disabled={status === "working" || !pastedUrl}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 12.5,
//               fontWeight: 600,
//               padding: "0 16px",
//               borderRadius: 8,
//               border: "none",
//               background: "#1B2340",
//               color: "#fff",
//               cursor: status === "working" ? "default" : "pointer",
//               opacity: status === "working" || !pastedUrl ? 0.6 : 1,
//               flexShrink: 0,
//             }}
//           >
//             {status === "working" ? <Spinner /> : "Use"}
//           </button>
//         </div>
//       ) : (
//         <div>
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept={accept}
//             onChange={handleFilePick}
//             style={{ display: "none" }}
//           />
//           <button
//             type="button"
//             onClick={() => fileInputRef.current?.click()}
//             disabled={status === "working"}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 8,
//               fontSize: 13,
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px dashed #C7C4B6",
//               background: "transparent",
//               color: "#5F5E5A",
//               cursor: status === "working" ? "default" : "pointer",
//               opacity: status === "working" ? 0.7 : 1,
//             }}
//           >
//             {status === "working" ? (
//               <>
//                 <Spinner /> Uploading…
//               </>
//             ) : (
//               <>
//                 <Paperclip size={14} /> Choose file
//               </>
//             )}
//           </button>
//         </div>
//       )}

//       <div
//         style={{
//           marginTop: 8,
//           display: "flex",
//           alignItems: "center",
//           gap: 6,
//         }}
//       >
//         <span style={{ fontSize: 11, color: "#9A988E", flexShrink: 0 }}>
//           Generated URL:
//         </span>
//         <input
//           disabled
//           style={{
//             ...inputStyle,
//             fontSize: 12,
//             color: "#5F5E5A",
//             background: "#F7F6F1",
//           }}
//           value={value || ""}
//           placeholder="Not uploaded yet"
//         />
//       </div>
//     </Field>
//   );
// }

// // -------------------------------------------------------------------------

// function BlockCard({
//   block,
//   index,
//   total,
//   onChange,
//   onRemove,
//   onMove,
//   compact,
// }) {
//   const [open, setOpen] = useState(true);
//   const meta = BLOCK_TYPES[block.type];
//   const Icon = meta.icon;
//   const c = RAMP[meta.ramp];
//   const patch = (field, val) => onChange({ ...block, [field]: val });

//   return (
//     <div
//       style={{
//         border: "1px solid #E4E2D8",
//         borderRadius: 12,
//         background: "#FFFFFF",
//         marginBottom: 12,
//         overflow: "hidden",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 10,
//           padding: "10px 12px",
//           background: c[50],
//           cursor: "pointer",
//           userSelect: "none",
//         }}
//         onClick={() => setOpen((o) => !o)}
//       >
//         <GripVertical size={15} color={c[600]} style={{ flexShrink: 0 }} />
//         <span
//           style={{
//             fontSize: 12,
//             fontFamily: "'IBM Plex Mono', monospace",
//             color: c[600],
//             fontWeight: 600,
//           }}
//         >
//           {String(index + 1).padStart(2, "0")}
//         </span>
//         <Icon size={15} color={c[800]} style={{ flexShrink: 0 }} />
//         <span style={{ fontSize: 13, fontWeight: 600, color: c[800] }}>
//           {meta.label}
//         </span>
//         <span
//           style={{
//             fontSize: 12,
//             color: c[600],
//             marginLeft: 2,
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             whiteSpace: "nowrap",
//             flex: 1,
//             minWidth: 0,
//           }}
//         >
//           {blockPreview(block)}
//         </span>
//         <div
//           style={{ display: "flex", gap: 4 }}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <IconBtn
//             title="Move up"
//             onClick={() => index > 0 && onMove(index, index - 1)}
//           >
//             <ChevronUp size={14} />
//           </IconBtn>
//           <IconBtn
//             title="Move down"
//             onClick={() => index < total - 1 && onMove(index, index + 1)}
//           >
//             <ChevronDown size={14} />
//           </IconBtn>
//           <IconBtn title="Delete block" danger onClick={() => onRemove(index)}>
//             <Trash2 size={14} />
//           </IconBtn>
//           <Caret
//             size={16}
//             color={c[600]}
//             style={{
//               transform: open ? "rotate(180deg)" : "none",
//               transition: "transform 0.15s",
//               marginLeft: 2,
//             }}
//           />
//         </div>
//       </div>

//       {open && (
//         <div style={{ padding: 16 }}>
//           <BlockFields block={block} patch={patch} onChange={onChange} />
//         </div>
//       )}
//     </div>
//   );
// }

// function blockPreview(b) {
//   if (b.type === "heading" || b.type === "paragraph" || b.type === "callout")
//     return b.text || "Empty";
//   if (b.type === "list")
//     return `${b.items.length} item${b.items.length === 1 ? "" : "s"}`;
//   if (b.type === "slider")
//     return `${b.images.length} image${b.images.length === 1 ? "" : "s"}`;
//   if (b.type === "image") return b.image_key || "unkeyed";
//   if (b.type === "columns") {
//     const total = (b.columns || []).reduce(
//       (s, c) => s + (c.blocks?.length || 0),
//       0,
//     );
//     return `${b.columns?.length || 0} columns, ${total} block${total === 1 ? "" : "s"}`;
//   }
//   if (b.type === "code") return b.language;
//   if (b.type === "request_payload" || b.type === "success_response")
//     return "JSON data";
//   if (b.type === "video") return b.url || "No URL set";
//   if (b.type === "audio") return b.title || b.url || "No audio set";
//   if (b.type === "file") return b.filename || "No file set";
//   if (b.type === "lottie") return b.caption || b.url || "No animation set";
//   if (b.type === "button") return b.label || "No label set";
//   if (b.type === "badges")
//     return `${b.tags.length} tag${b.tags.length === 1 ? "" : "s"}`;
//   if (b.type === "stepper")
//     return `${b.steps.length} step${b.steps.length === 1 ? "" : "s"}`;
//   if (b.type === "feedback") return b.prompt || "Feedback widget";
//   if (b.type === "table")
//     return `${b.rows.length} row${b.rows.length === 1 ? "" : "s"} \u00d7 ${b.columns.length} col${b.columns.length === 1 ? "" : "s"}`;
//   if (b.type === "divider") return b.style;
//   if (b.type === "richtext") {
//     const plain = (b.html || "").replace(/<[^>]+>/g, "").trim();
//     return plain || "Empty";
//   }
//   return "";
// }

// function ColumnBlockList({ blocks, onChange }) {
//   const [addType, setAddType] = useState("paragraph");
//   const nestedTypes = Object.entries(BLOCK_TYPES).filter(
//     ([k]) => k !== "columns",
//   );

//   const updateBlock = (idx, updated) => {
//     const next = [...blocks];
//     next[idx] = updated;
//     onChange(next);
//   };
//   const removeBlock = (idx) => onChange(blocks.filter((_, i) => i !== idx));
//   const moveBlock = (from, to) => {
//     const next = [...blocks];
//     const [item] = next.splice(from, 1);
//     next.splice(to, 0, item);
//     onChange(next);
//   };
//   const addBlock = () => onChange([...blocks, emptyBlockFor(addType)]);

//   return (
//     <div>
//       {blocks.map((b, i) => (
//         <BlockCard
//           key={b.id}
//           block={b}
//           index={i}
//           total={blocks.length}
//           onChange={(updated) => updateBlock(i, updated)}
//           onRemove={removeBlock}
//           onMove={moveBlock}
//         />
//       ))}
//       <div
//         style={{
//           display: "flex",
//           gap: 8,
//           background: "#FAF9F4",
//           border: "1px dashed #C7C4B6",
//           borderRadius: 9,
//           padding: 10,
//           alignItems: "center",
//         }}
//       >
//         <select
//           style={{
//             ...selectStyle,
//             width: "auto",
//             flex: 1,
//             fontSize: 12.5,
//             padding: "6px 9px",
//           }}
//           value={addType}
//           onChange={(e) => setAddType(e.target.value)}
//         >
//           {nestedTypes.map(([k, v]) => (
//             <option key={k} value={k}>
//               {v.label}
//             </option>
//           ))}
//         </select>
//         <button
//           onClick={addBlock}
//           style={{
//             display: "inline-flex",
//             alignItems: "center",
//             gap: 5,
//             fontSize: 12,
//             fontWeight: 600,
//             padding: "6px 11px",
//             borderRadius: 7,
//             border: "none",
//             background: "#1B2340",
//             color: "#fff",
//             cursor: "pointer",
//             whiteSpace: "nowrap",
//           }}
//         >
//           <Plus size={12} /> Add block
//         </button>
//       </div>
//     </div>
//   );
// }

// function BlockFields({ block, patch, onChange }) {
//   switch (block.type) {
//     case "heading":
//       return (
//         <>
//           <Field label="Level">
//             <select
//               style={selectStyle}
//               value={block.level}
//               onChange={(e) => patch("level", e.target.value)}
//             >
//               {["h1", "h2", "h3", "h4"].map((l) => (
//                 <option key={l} value={l}>
//                   {l.toUpperCase()}
//                 </option>
//               ))}
//             </select>
//           </Field>
//           <Field label="Heading text">
//             <input
//               style={inputStyle}
//               value={block.text}
//               onChange={(e) => patch("text", e.target.value)}
//               placeholder="Section heading"
//             />
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );
//     case "paragraph":
//       return (
//         <>
//           <Field label="Paragraph text">
//             <textarea
//               style={textareaStyle}
//               value={block.text}
//               onChange={(e) => patch("text", e.target.value)}
//               placeholder="Write the paragraph copy..."
//             />
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );
//     case "callout":
//       return (
//         <>
//           <Field label="Style">
//             <select
//               style={selectStyle}
//               value={block.style}
//               onChange={(e) => patch("style", e.target.value)}
//             >
//               {["info", "warning", "success", "error"].map((s) => (
//                 <option key={s} value={s}>
//                   {s}
//                 </option>
//               ))}
//             </select>
//           </Field>
//           <Field label="Callout text">
//             <textarea
//               style={textareaStyle}
//               value={block.text}
//               onChange={(e) => patch("text", e.target.value)}
//               placeholder="Warning or note copy..."
//             />
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );
//     case "list":
//       return (
//         <>
//           <Field label="Style">
//             <select
//               style={selectStyle}
//               value={block.style}
//               onChange={(e) => patch("style", e.target.value)}
//             >
//               <option value="bullet">Bullet</option>
//               <option value="number">Numbered</option>
//             </select>
//           </Field>
//           <Field label="Items">
//             {block.items.map((item, i) => (
//               <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
//                 <input
//                   style={inputStyle}
//                   value={item}
//                   onChange={(e) => {
//                     const items = [...block.items];
//                     items[i] = e.target.value;
//                     patch("items", items);
//                   }}
//                   placeholder={`Item ${i + 1}`}
//                 />
//                 <IconBtn
//                   title="Remove item"
//                   danger
//                   onClick={() =>
//                     patch(
//                       "items",
//                       block.items.filter((_, idx) => idx !== i),
//                     )
//                   }
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//             ))}
//             <button
//               onClick={() => patch("items", [...block.items, ""])}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 marginTop: 2,
//                 fontSize: 13,
//                 padding: "6px 10px",
//                 borderRadius: 7,
//                 border: "1px dashed #C7C4B6",
//                 background: "transparent",
//                 color: "#5F5E5A",
//                 cursor: "pointer",
//               }}
//             >
//               <Plus size={13} /> Add item
//             </button>
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );
//     case "slider":
//       return (
//         <>
//           {block.images.map((img, i) => (
//             <div
//               key={i}
//               style={{
//                 border: "1px solid #EDEBE0",
//                 borderRadius: 9,
//                 padding: 12,
//                 marginBottom: 10,
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   marginBottom: 8,
//                 }}
//               >
//                 <span
//                   style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
//                 >
//                   Slide {i + 1}
//                 </span>
//                 <IconBtn
//                   title="Remove slide"
//                   danger
//                   onClick={() =>
//                     patch(
//                       "images",
//                       block.images.filter((_, idx) => idx !== i),
//                     )
//                   }
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//               <ImageKeyField
//                 value={img.image_key}
//                 onChange={(v) => {
//                   const images = [...block.images];
//                   images[i] = { ...images[i], image_key: v };
//                   patch("images", images);
//                 }}
//                 prefix="slide"
//               />
//               <MediaUploadField
//                 label="Image"
//                 value={img.url}
//                 onChange={(url) => {
//                   const images = [...block.images];
//                   images[i] = { ...images[i], url };
//                   patch("images", images);
//                 }}
//                 accept="image/*"
//               />
//               <Field label="Caption">
//                 <input
//                   style={inputStyle}
//                   value={img.caption}
//                   onChange={(e) => {
//                     const images = [...block.images];
//                     images[i] = { ...images[i], caption: e.target.value };
//                     patch("images", images);
//                   }}
//                   placeholder="What this slide shows"
//                 />
//               </Field>
//               <Field label="Alt text">
//                 <input
//                   style={inputStyle}
//                   value={img.alt}
//                   onChange={(e) => {
//                     const images = [...block.images];
//                     images[i] = { ...images[i], alt: e.target.value };
//                     patch("images", images);
//                   }}
//                   placeholder="Accessible description"
//                 />
//               </Field>
//               <ImageDimensionFields
//                 width={img.width || "100%"}
//                 height={img.height || "220px"}
//                 objectFit={img.objectFit || "cover"}
//                 onChange={(fields) => {
//                   const images = [...block.images];
//                   images[i] = { ...images[i], ...fields };
//                   patch("images", images);
//                 }}
//               />
//             </div>
//           ))}
//           <button
//             onClick={() =>
//               patch("images", [...block.images, emptyImageValue("slider_step")])
//             }
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 13,
//               padding: "6px 10px",
//               borderRadius: 7,
//               border: "1px dashed #C7C4B6",
//               background: "transparent",
//               color: "#5F5E5A",
//               cursor: "pointer",
//             }}
//           >
//             <Plus size={13} /> Add slide
//           </button>
//         </>
//       );
//     case "image":
//       return (
//         <>
//           <ImageKeyField
//             value={block.image_key}
//             onChange={(v) => patch("image_key", v)}
//             prefix="image"
//           />
//           <MediaUploadField
//             label="Image"
//             value={block.url}
//             onChange={(url) => patch("url", url)}
//             accept="image/*"
//           />
//           <Field label="Caption">
//             <input
//               style={inputStyle}
//               value={block.caption}
//               onChange={(e) => patch("caption", e.target.value)}
//               placeholder="Figure caption"
//             />
//           </Field>
//           <Field
//             label="Container align"
//             hint="Position of the image within the document width"
//           >
//             <div style={{ display: "flex", gap: 6 }}>
//               {[
//                 { value: "left", label: "Left", icon: AlignLeft },
//                 { value: "center", label: "Center", icon: AlignCenter },
//                 { value: "right", label: "Right", icon: AlignRight },
//               ].map((opt) => {
//                 const Ic = opt.icon;
//                 return (
//                   <IconBtn
//                     key={opt.value}
//                     title={opt.label}
//                     active={block.align === opt.value}
//                     onClick={() => patch("align", opt.value)}
//                   >
//                     <Ic size={14} />
//                   </IconBtn>
//                 );
//               })}
//             </div>
//           </Field>
//           <ImageDimensionFields
//             width={block.width || "100%"}
//             height={block.height || "auto"}
//             objectFit={block.objectFit || "cover"}
//             onChange={(fields) =>
//               Object.entries(fields).forEach(([k, v]) => patch(k, v))
//             }
//           />
//         </>
//       );
//     case "columns": {
//       const columns = block.columns || [];
//       const setColumns = (next) => patch("columns", next);
//       const addColumn = () => setColumns([...columns, emptyColumn()]);
//       const removeColumn = (ci) =>
//         setColumns(columns.filter((_, i) => i !== ci));
//       const updateColumnBlocks = (ci, newBlocks) => {
//         setColumns(
//           columns.map((c, i) => (i === ci ? { ...c, blocks: newBlocks } : c)),
//         );
//       };
//       return (
//         <>
//           <div
//             style={{
//               display: "flex",
//               gap: 10,
//               marginBottom: 4,
//               flexWrap: "wrap",
//             }}
//           >
//             <Field label="Gap between columns" hint="in pixels">
//               <input
//                 type="number"
//                 style={{ ...inputStyle, width: 120 }}
//                 value={block.gap}
//                 onChange={(e) => patch("gap", Number(e.target.value) || 0)}
//               />
//             </Field>
//             <Field
//               label="Columns"
//               hint={`${columns.length} column${columns.length === 1 ? "" : "s"}`}
//             >
//               <button
//                 onClick={addColumn}
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 6,
//                   fontSize: 13,
//                   fontWeight: 600,
//                   padding: "9px 14px",
//                   borderRadius: 8,
//                   border: "1px dashed #C7C4B6",
//                   background: "transparent",
//                   color: "#5F5E5A",
//                   cursor: "pointer",
//                 }}
//               >
//                 <Plus size={13} /> Add column
//               </button>
//             </Field>
//           </div>
//           <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
//             {columns.map((col, ci) => (
//               <div
//                 key={col.id}
//                 style={{
//                   border: "1px solid #EDEBE0",
//                   borderRadius: 9,
//                   padding: 12,
//                   flex: "1 1 240px",
//                   minWidth: 240,
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 10,
//                   }}
//                 >
//                   <span
//                     style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
//                   >
//                     Column {ci + 1} · {col.blocks.length} block
//                     {col.blocks.length === 1 ? "" : "s"}
//                   </span>
//                   {columns.length > 1 && (
//                     <IconBtn
//                       title="Remove column"
//                       danger
//                       onClick={() => removeColumn(ci)}
//                     >
//                       <Trash2 size={13} />
//                     </IconBtn>
//                   )}
//                 </div>
//                 <ColumnBlockList
//                   blocks={col.blocks}
//                   onChange={(nb) => updateColumnBlocks(ci, nb)}
//                 />
//               </div>
//             ))}
//           </div>
//         </>
//       );
//     }
//     case "code":
//       return (
//         <>
//           <Field label="Language">
//             <input
//               style={inputStyle}
//               value={block.language}
//               onChange={(e) => patch("language", e.target.value)}
//               placeholder="python"
//             />
//           </Field>
//           <Field label="Code">
//             <textarea
//               style={{ ...monoStyle, minHeight: 140 }}
//               value={block.code}
//               onChange={(e) => patch("code", e.target.value)}
//               placeholder="Paste the code sample..."
//             />
//           </Field>
//         </>
//       );
//     case "request_payload":
//     case "success_response":
//       return (
//         <JsonField
//           label="JSON data"
//           value={block.data}
//           onChange={(v) => patch("data", v)}
//         />
//       );
//     case "video":
//       return (
//         <>
//           <Field label="Provider">
//             <select
//               style={selectStyle}
//               value={block.provider}
//               onChange={(e) => patch("provider", e.target.value)}
//             >
//               {["youtube", "vimeo", "loom", "mp4"].map((p) => (
//                 <option key={p} value={p}>
//                   {p === "mp4" ? "Direct MP4" : p[0].toUpperCase() + p.slice(1)}
//                 </option>
//               ))}
//             </select>
//           </Field>
//           {block.provider === "mp4" ? (
//             <MediaUploadField
//               label="Video file"
//               value={block.url}
//               onChange={(url) => patch("url", url)}
//               accept="video/*"
//             />
//           ) : (
//             <Field label="Video URL" hint="Paste the share/watch link">
//               <input
//                 style={inputStyle}
//                 value={block.url}
//                 onChange={(e) => patch("url", e.target.value)}
//                 placeholder="https://..."
//               />
//             </Field>
//           )}
//           <Field label="Caption">
//             <input
//               style={inputStyle}
//               value={block.caption}
//               onChange={(e) => patch("caption", e.target.value)}
//               placeholder="Optional caption"
//             />
//           </Field>
//           <Field label="Aspect ratio">
//             <select
//               style={selectStyle}
//               value={block.aspectRatio}
//               onChange={(e) => patch("aspectRatio", e.target.value)}
//             >
//               {["16:9", "4:3", "1:1", "9:16"].map((r) => (
//                 <option key={r} value={r}>
//                   {r}
//                 </option>
//               ))}
//             </select>
//           </Field>
//         </>
//       );
//     case "audio":
//       return (
//         <>
//           <MediaUploadField
//             label="Audio file"
//             value={block.url}
//             onChange={(url) => patch("url", url)}
//             accept="audio/*"
//           />
//           <Field label="Title">
//             <input
//               style={inputStyle}
//               value={block.title}
//               onChange={(e) => patch("title", e.target.value)}
//               placeholder="Episode or clip title"
//             />
//           </Field>
//           <Field label="Subtitle">
//             <input
//               style={inputStyle}
//               value={block.subtitle}
//               onChange={(e) => patch("subtitle", e.target.value)}
//               placeholder="e.g. Podcast · Voice note"
//             />
//           </Field>
//           <Field label="Duration" hint="Display only, e.g. 3:45">
//             <input
//               style={{ ...inputStyle, width: 120 }}
//               value={block.duration}
//               onChange={(e) => patch("duration", e.target.value)}
//               placeholder="3:45"
//             />
//           </Field>
//         </>
//       );
//     case "file":
//       return (
//         <>
//           <MediaUploadField
//             label="File"
//             value={block.url}
//             onChange={(url) => patch("url", url)}
//             accept="*/*"
//           />
//           <Field label="Filename">
//             <input
//               style={inputStyle}
//               value={block.filename}
//               onChange={(e) => patch("filename", e.target.value)}
//               placeholder="onboarding-guide.pdf"
//             />
//           </Field>
//           <div
//             style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}
//           >
//             <Field label="File type">
//               <select
//                 style={selectStyle}
//                 value={block.filetype}
//                 onChange={(e) => patch("filetype", e.target.value)}
//               >
//                 {["PDF", "ZIP", "CSV", "DOCX", "XLSX", "Other"].map((t) => (
//                   <option key={t} value={t}>
//                     {t}
//                   </option>
//                 ))}
//               </select>
//             </Field>
//             <Field label="File size" hint="Display only">
//               <input
//                 style={inputStyle}
//                 value={block.filesize}
//                 onChange={(e) => patch("filesize", e.target.value)}
//                 placeholder="2.4 MB"
//               />
//             </Field>
//           </div>
//         </>
//       );
//     case "lottie":
//       return (
//         <>
//           <Field label="Animation URL" hint="Link to a .json or .lottie file">
//             <input
//               style={inputStyle}
//               value={block.url}
//               onChange={(e) => patch("url", e.target.value)}
//               placeholder="https://.../animation.json"
//             />
//           </Field>
//           <Field label="Caption">
//             <input
//               style={inputStyle}
//               value={block.caption}
//               onChange={(e) => patch("caption", e.target.value)}
//               placeholder="Optional caption"
//             />
//           </Field>
//           <div
//             style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}
//           >
//             <Field label="Width" hint="px or %">
//               <input
//                 style={inputStyle}
//                 value={block.width}
//                 onChange={(e) => patch("width", e.target.value)}
//                 placeholder="100%"
//               />
//             </Field>
//             <Field label="Height" hint="px">
//               <input
//                 style={inputStyle}
//                 value={block.height}
//                 onChange={(e) => patch("height", e.target.value)}
//                 placeholder="280px"
//               />
//             </Field>
//           </div>
//           <div style={{ display: "flex", gap: 16, marginTop: 4 }}>
//             <label
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 color: "#5F5E5A",
//               }}
//             >
//               <input
//                 type="checkbox"
//                 checked={block.loop}
//                 onChange={(e) => patch("loop", e.target.checked)}
//               />
//               Loop
//             </label>
//             <label
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 color: "#5F5E5A",
//               }}
//             >
//               <input
//                 type="checkbox"
//                 checked={block.autoplay}
//                 onChange={(e) => patch("autoplay", e.target.checked)}
//               />
//               Autoplay
//             </label>
//           </div>
//         </>
//       );
//     case "button":
//       return (
//         <>
//           <Field label="Label">
//             <input
//               style={inputStyle}
//               value={block.label}
//               onChange={(e) => patch("label", e.target.value)}
//               placeholder="Get API Key"
//             />
//           </Field>
//           <Field label="Link URL">
//             <input
//               style={inputStyle}
//               value={block.url}
//               onChange={(e) => patch("url", e.target.value)}
//               placeholder="https://..."
//             />
//           </Field>
//           <Field label="Style">
//             <select
//               style={selectStyle}
//               value={block.style}
//               onChange={(e) => patch("style", e.target.value)}
//             >
//               <option value="primary">Primary</option>
//               <option value="secondary">Secondary</option>
//             </select>
//           </Field>
//           <Field label="Align">
//             <div style={{ display: "flex", gap: 6 }}>
//               {[
//                 { value: "left", label: "Left", icon: AlignLeft },
//                 { value: "center", label: "Center", icon: AlignCenter },
//                 { value: "right", label: "Right", icon: AlignRight },
//               ].map((opt) => {
//                 const Ic = opt.icon;
//                 return (
//                   <IconBtn
//                     key={opt.value}
//                     title={opt.label}
//                     active={(block.align || "left") === opt.value}
//                     onClick={() => patch("align", opt.value)}
//                   >
//                     <Ic size={14} />
//                   </IconBtn>
//                 );
//               })}
//             </div>
//           </Field>
//           <label
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 13,
//               color: "#5F5E5A",
//               marginTop: 4,
//             }}
//           >
//             <input
//               type="checkbox"
//               checked={block.newTab}
//               onChange={(e) => patch("newTab", e.target.checked)}
//             />
//             Open in new tab
//           </label>
//         </>
//       );
//     case "badges":
//       return (
//         <Field label="Tags">
//           {block.tags.map((tag, i) => (
//             <div
//               key={tag.id}
//               style={{
//                 display: "flex",
//                 gap: 6,
//                 marginBottom: 6,
//                 alignItems: "center",
//               }}
//             >
//               <input
//                 style={inputStyle}
//                 value={tag.label}
//                 onChange={(e) => {
//                   const tags = [...block.tags];
//                   tags[i] = { ...tags[i], label: e.target.value };
//                   patch("tags", tags);
//                 }}
//                 placeholder="Beta"
//               />
//               <select
//                 style={{ ...selectStyle, width: 110, flexShrink: 0 }}
//                 value={tag.tone}
//                 onChange={(e) => {
//                   const tags = [...block.tags];
//                   tags[i] = { ...tags[i], tone: e.target.value };
//                   patch("tags", tags);
//                 }}
//               >
//                 {Object.keys(RAMP).map((tone) => (
//                   <option key={tone} value={tone}>
//                     {tone}
//                   </option>
//                 ))}
//               </select>
//               <IconBtn
//                 title="Remove tag"
//                 danger
//                 onClick={() =>
//                   patch(
//                     "tags",
//                     block.tags.filter((_, idx) => idx !== i),
//                   )
//                 }
//               >
//                 <Trash2 size={13} />
//               </IconBtn>
//             </div>
//           ))}
//           <button
//             onClick={() =>
//               patch("tags", [
//                 ...block.tags,
//                 { id: genKey("tag"), label: "", tone: "blue" },
//               ])
//             }
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               marginTop: 2,
//               fontSize: 13,
//               padding: "6px 10px",
//               borderRadius: 7,
//               border: "1px dashed #C7C4B6",
//               background: "transparent",
//               color: "#5F5E5A",
//               cursor: "pointer",
//             }}
//           >
//             <Plus size={13} /> Add tag
//           </button>
//         </Field>
//       );
//     case "stepper":
//       return (
//         <>
//           {block.steps.map((step, i) => (
//             <div
//               key={step.id}
//               style={{
//                 border: "1px solid #EDEBE0",
//                 borderRadius: 9,
//                 padding: 12,
//                 marginBottom: 10,
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   marginBottom: 8,
//                 }}
//               >
//                 <span
//                   style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
//                 >
//                   Step {i + 1}
//                 </span>
//                 <IconBtn
//                   title="Remove step"
//                   danger
//                   onClick={() =>
//                     patch(
//                       "steps",
//                       block.steps.filter((_, idx) => idx !== i),
//                     )
//                   }
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//               <Field label="Step title">
//                 <input
//                   style={inputStyle}
//                   value={step.title}
//                   onChange={(e) => {
//                     const steps = [...block.steps];
//                     steps[i] = { ...steps[i], title: e.target.value };
//                     patch("steps", steps);
//                   }}
//                   placeholder="Install the SDK"
//                 />
//               </Field>
//               <Field label="Step details">
//                 <textarea
//                   style={textareaStyle}
//                   value={step.text}
//                   onChange={(e) => {
//                     const steps = [...block.steps];
//                     steps[i] = { ...steps[i], text: e.target.value };
//                     patch("steps", steps);
//                   }}
//                   placeholder="What the reader should do..."
//                 />
//               </Field>
//             </div>
//           ))}
//           <button
//             onClick={() =>
//               patch("steps", [
//                 ...block.steps,
//                 { id: genKey("step"), title: "", text: "" },
//               ])
//             }
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 13,
//               padding: "6px 10px",
//               borderRadius: 7,
//               border: "1px dashed #C7C4B6",
//               background: "transparent",
//               color: "#5F5E5A",
//               cursor: "pointer",
//             }}
//           >
//             <Plus size={13} /> Add step
//           </button>
//         </>
//       );
//     case "feedback":
//       return (
//         <Field label="Prompt text">
//           <input
//             style={inputStyle}
//             value={block.prompt}
//             onChange={(e) => patch("prompt", e.target.value)}
//             placeholder="Was this helpful?"
//           />
//         </Field>
//       );
//     case "table":
//       return (
//         <>
//           <Field label="Columns">
//             {block.columns.map((col, i) => (
//               <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
//                 <input
//                   style={inputStyle}
//                   value={col}
//                   onChange={(e) => {
//                     const columns = [...block.columns];
//                     columns[i] = e.target.value;
//                     onChange({ ...block, columns });
//                   }}
//                   placeholder={`Column ${i + 1}`}
//                 />
//                 <IconBtn
//                   title="Remove column"
//                   danger
//                   onClick={() => {
//                     const columns = block.columns.filter((_, idx) => idx !== i);
//                     const rows = block.rows.map((row) =>
//                       row.filter((_, idx) => idx !== i),
//                     );
//                     onChange({ ...block, columns, rows });
//                   }}
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//             ))}
//             <button
//               onClick={() => {
//                 const columns = [
//                   ...block.columns,
//                   `Column ${block.columns.length + 1}`,
//                 ];
//                 const rows = block.rows.map((row) => [...row, ""]);
//                 onChange({ ...block, columns, rows });
//               }}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "6px 10px",
//                 borderRadius: 7,
//                 border: "1px dashed #C7C4B6",
//                 background: "transparent",
//                 color: "#5F5E5A",
//                 cursor: "pointer",
//               }}
//             >
//               <Plus size={13} /> Add column
//             </button>
//           </Field>
//           <Field label="Rows">
//             {block.rows.map((row, ri) => (
//               <div
//                 key={ri}
//                 style={{
//                   display: "flex",
//                   gap: 6,
//                   marginBottom: 6,
//                   alignItems: "center",
//                 }}
//               >
//                 {row.map((cell, ci) => (
//                   <input
//                     key={ci}
//                     style={inputStyle}
//                     value={cell}
//                     onChange={(e) => {
//                       const rows = block.rows.map((r) => [...r]);
//                       rows[ri][ci] = e.target.value;
//                       patch("rows", rows);
//                     }}
//                     placeholder={block.columns[ci] || `Col ${ci + 1}`}
//                   />
//                 ))}
//                 <IconBtn
//                   title="Remove row"
//                   danger
//                   onClick={() =>
//                     patch(
//                       "rows",
//                       block.rows.filter((_, idx) => idx !== ri),
//                     )
//                   }
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//             ))}
//             <button
//               onClick={() =>
//                 patch("rows", [...block.rows, block.columns.map(() => "")])
//               }
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "6px 10px",
//                 borderRadius: 7,
//                 border: "1px dashed #C7C4B6",
//                 background: "transparent",
//                 color: "#5F5E5A",
//                 cursor: "pointer",
//               }}
//             >
//               <Plus size={13} /> Add row
//             </button>
//           </Field>
//         </>
//       );
//     case "divider":
//       return (
//         <>
//           <Field label="Style">
//             <select
//               style={selectStyle}
//               value={block.style}
//               onChange={(e) => patch("style", e.target.value)}
//             >
//               <option value="solid">Solid line</option>
//               <option value="dashed">Dashed line</option>
//               <option value="space">Blank space only</option>
//             </select>
//           </Field>
//           <Field label="Spacing" hint="Vertical space in pixels">
//             <input
//               type="number"
//               style={{ ...inputStyle, width: 120 }}
//               value={block.spacing}
//               onChange={(e) => patch("spacing", Number(e.target.value) || 0)}
//             />
//           </Field>
//         </>
//       );

//     case "richtext":
//       return (
//         <>
//           <Field label="Content">
//             <div
//               style={{
//                 border: "1px solid #DEDCD1",
//                 borderRadius: 8,
//                 // overflow: "hidden",
//                 background: "#fff",
//                 overflow: "visible",
//               }}
//             >
//               <ReactQuill
//                 theme="snow"
//                 value={block.html}
//                 onChange={(html) => patch("html", html)}
//                 placeholder="Write rich content..."
//                 modules={{
//                   toolbar: [
//                     [{ header: [1, 2, 3, false] }],
//                     ["bold", "italic", "underline", "strike"],

//                     // [{ color: [] }, { background: [] }],
//                     [{ list: "ordered" }, { list: "bullet" }],
//                     ["blockquote", "code-block", "link"],
//                     ["clean"],
//                   ],
//                 }}
//               />
//             </div>
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );

//     default:
//       return null;
//   }
// }

// function ImageKeyField({ value, onChange, prefix }) {
//   return (
//     <Field
//       label="Image key"
//       hint="Used to reference this image elsewhere in the document"
//     >
//       <div style={{ display: "flex", gap: 6 }}>
//         <div style={{ position: "relative", flex: 1 }}>
//           <KeyRound
//             size={13}
//             color="#9A988E"
//             style={{ position: "absolute", left: 10, top: 12 }}
//           />
//           <input
//             style={{ ...monoStyle, paddingLeft: 30 }}
//             value={value}
//             onChange={(e) => onChange(e.target.value)}
//             placeholder="unique_image_key"
//           />
//         </div>
//         <IconBtn
//           title="Generate a new key"
//           onClick={() => onChange(genKey(prefix))}
//         >
//           <RefreshCw size={13} />
//         </IconBtn>
//       </div>
//     </Field>
//   );
// }

// function PreviewImg({ src, alt, style }) {
//   const [broken, setBroken] = useState(false);
//   if (!src || broken) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           gap: 6,
//           background: "#F1EFE8",
//           border: "1px dashed #C7C4B6",
//           borderRadius: 8,
//           color: "#8A8878",
//           fontSize: 12,
//           minHeight: 110,
//           ...style,
//         }}
//       >
//         <ImageOff size={18} />
//         <span>{alt || "Image"}</span>
//       </div>
//     );
//   }
//   return (
//     <img
//       src={src}
//       alt={alt}
//       onError={() => setBroken(true)}
//       style={{ display: "block", borderRadius: 8, ...style }}
//     />
//   );
// }

// function toResponsiveSize(v) {
//   return v;
// }

// function NavButton({ side, onClick, visible }) {
//   return (
//     <button
//       onClick={onClick}
//       aria-label={side === "left" ? "Previous slide" : "Next slide"}
//       style={{
//         position: "absolute",
//         top: "50%",
//         [side]: 8,
//         transform: "translateY(-50%)",
//         border: "none",
//         background: "rgba(255,255,255,0.9)",
//         borderRadius: "50%",
//         width: 30,
//         height: 30,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         cursor: "pointer",
//         boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
//         opacity: visible ? 1 : 0,
//         transition: "opacity 150ms ease, transform 150ms ease",
//       }}
//       onMouseEnter={(e) =>
//         (e.currentTarget.style.transform = "translateY(-50%) scale(1.08)")
//       }
//       onMouseLeave={(e) =>
//         (e.currentTarget.style.transform = "translateY(-50%)")
//       }
//     >
//       {side === "left" ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
//     </button>
//   );
// }

// function SliderPreview({ images }) {
//   const [i, setI] = useState(0);
//   const [isHovering, setIsHovering] = useState(false);

//   if (!images?.length) return null;
//   const img = images[Math.min(i, images.length - 1)];
//   const hasMultiple = images.length > 1;

//   const go = (delta) =>
//     setI((v) => (v + delta + images.length) % images.length);

//   return (
//     <div
//       style={{
//         border: "1px solid #E4E2D8",
//         borderRadius: 12,
//         overflow: "hidden",
//         background: "#FAF9F4",
//         width: "100%",
//         boxSizing: "border-box",
//         boxShadow: "0 1px 2px rgba(32,32,28,0.04)",
//       }}
//     >
//       <div
//         style={{ position: "relative" }}
//         onMouseEnter={() => setIsHovering(true)}
//         onMouseLeave={() => setIsHovering(false)}
//       >
//         <PreviewImg
//           key={img.url}
//           src={img.url}
//           alt={img.alt}
//           style={{
//             width: img.width || "100%",
//             height: toResponsiveSize(img.height || "220px"),
//             objectFit: img.objectFit || "cover",
//             borderRadius: 0,
//             display: "block",
//             animation: "spFade 200ms ease",
//           }}
//         />

//         {hasMultiple && (
//           <div
//             style={{
//               position: "absolute",
//               top: 10,
//               right: 10,
//               padding: "3px 8px",
//               borderRadius: 999,
//               background: "rgba(32,32,28,0.55)",
//               backdropFilter: "blur(2px)",
//               color: "#fff",
//               fontSize: 11,
//               fontWeight: 500,
//               letterSpacing: 0.2,
//             }}
//           >
//             {i + 1} / {images.length}
//           </div>
//         )}

//         {hasMultiple && (
//           <>
//             <NavButton
//               side="left"
//               onClick={() => go(-1)}
//               visible={isHovering}
//             />
//             <NavButton
//               side="right"
//               onClick={() => go(1)}
//               visible={isHovering}
//             />
//           </>
//         )}
//       </div>

//       <div
//         style={{
//           padding: "10px 14px",
//           display: "flex",
//           alignItems: "center",
//           gap: 10,
//         }}
//       >
//         <div style={{ flex: 1, minWidth: 0 }}>
//           <div
//             style={{
//               fontSize: "clamp(12.5px, 3.2vw, 13px)",
//               color: "#20201C",
//               lineHeight: 1.5,
//               wordBreak: "break-word",
//             }}
//           >
//             {img.caption || "No caption"}
//           </div>
//         </div>

//         {hasMultiple && (
//           <div style={{ display: "flex", gap: 5, flexShrink: 0 }}>
//             {images.map((_, idx) => (
//               <button
//                 key={idx}
//                 onClick={() => setI(idx)}
//                 aria-label={`Go to slide ${idx + 1}`}
//                 style={{
//                   width: idx === i ? 16 : 6,
//                   height: 6,
//                   borderRadius: 999,
//                   border: "none",
//                   padding: 0,
//                   cursor: "pointer",
//                   background: idx === i ? "#20201C" : "#DAD8CC",
//                   transition: "all 150ms ease",
//                 }}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function toEmbedUrl(provider, url) {
//   if (!url) return "";
//   if (provider === "mp4") return url;
//   if (provider === "youtube") {
//     const idMatch = url.match(/(?:youtu\.be\/|v=|embed\/)([a-zA-Z0-9_-]{6,})/);
//     return idMatch ? `https://www.youtube.com/embed/${idMatch[1]}` : url;
//   }
//   if (provider === "vimeo") {
//     const idMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
//     return idMatch ? `https://player.vimeo.com/video/${idMatch[1]}` : url;
//   }
//   if (provider === "loom") {
//     const idMatch = url.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
//     return idMatch ? `https://www.loom.com/embed/${idMatch[1]}` : url;
//   }
//   return url;
// }

// const FILE_TYPE_ICONS = {
//   PDF: FileText,
//   ZIP: FileArchive,
//   CSV: FileSpreadsheet,
//   DOCX: FileText,
//   XLSX: FileSpreadsheet,
//   Other: FileGeneric,
// };

// function RenderedBlock({ block }) {
//   switch (block.type) {
//     case "heading": {
//       const sizes = { h1: 24, h2: 20, h3: 17, h4: 15 };
//       return (
//         <div
//           style={{
//             fontSize: sizes[block.level] || 18,
//             fontWeight: 600,
//             color: "#1B2340",
//             margin: "4px 0",
//             textAlign: block.align || "left",
//           }}
//         >
//           {block.text || (
//             <span style={{ color: "#C7C4B6" }}>Empty heading</span>
//           )}
//         </div>
//       );
//     }
//     case "paragraph":
//       return (
//         <p
//           style={{
//             fontSize: 14,
//             lineHeight: 1.7,
//             color: "#3A3A34",
//             margin: "4px 0",
//             textAlign: block.align || "left",
//           }}
//         >
//           {block.text || (
//             <span style={{ color: "#C7C4B6" }}>Empty paragraph</span>
//           )}
//         </p>
//       );
//     case "callout": {
//       const s = CALLOUT_STYLE[block.style] || CALLOUT_STYLE.info;
//       const Icon = s.icon;
//       return (
//         <div
//           style={{
//             display: "flex",
//             gap: 10,
//             background: s.bg,
//             borderLeft: `3px solid ${s.border}`,
//             borderRadius: 6,
//             padding: "10px 12px",
//             textAlign: block.align || "left",
//           }}
//         >
//           <Icon
//             size={16}
//             color={s.text}
//             style={{ flexShrink: 0, marginTop: 1 }}
//           />
//           <span
//             style={{ fontSize: 13.5, color: s.text, lineHeight: 1.6, flex: 1 }}
//           >
//             {block.text || "Empty callout"}
//           </span>
//         </div>
//       );
//     }
//     case "list": {
//       const Tag = block.style === "number" ? "ol" : "ul";
//       return (
//         <Tag
//           style={{
//             margin: "4px 0",
//             paddingLeft: 20,
//             textAlign: block.align || "left",
//           }}
//         >
//           {block.items.map((it, i) => (
//             <li
//               key={i}
//               style={{ fontSize: 14, color: "#3A3A34", lineHeight: 1.7 }}
//             >
//               {it || <span style={{ color: "#C7C4B6" }}>Empty item</span>}
//             </li>
//           ))}
//         </Tag>
//       );
//     }
//     case "slider":
//       return <SliderPreview images={block.images} />;
//     case "image": {
//       const align = block.align || "center";
//       const marginLeft = align === "left" ? 0 : "auto";
//       const marginRight = align === "right" ? 0 : "auto";
//       return (
//         <div style={{ textAlign: align }}>
//           <PreviewImg
//             src={block.url}
//             alt={block.alt}
//             style={{
//               width: block.width || "100%",
//               height: block.height || "auto",
//               objectFit: block.objectFit || "cover",
//               maxWidth: "100%",
//               marginLeft,
//               marginRight,
//             }}
//           />
//           {block.caption && (
//             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
//               {block.caption}
//             </div>
//           )}
//         </div>
//       );
//     }
//     case "columns":
//       return (
//         <div
//           style={{ display: "flex", gap: block.gap ?? 20, flexWrap: "wrap" }}
//         >
//           {(block.columns || []).map((col) => (
//             <div
//               key={col.id}
//               style={{
//                 flex: "1 1 200px",
//                 minWidth: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 14,
//               }}
//             >
//               {col.blocks.map((b) => (
//                 <RenderedBlock key={b.id} block={b} />
//               ))}
//             </div>
//           ))}
//         </div>
//       );
//     case "code":
//       return (
//         <div
//           style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
//         >
//           <div
//             style={{
//               padding: "6px 12px",
//               fontSize: 11,
//               color: "#9BA6C7",
//               fontFamily: "'IBM Plex Mono', monospace",
//               borderBottom: "1px solid #2A335C",
//             }}
//           >
//             {block.language || "code"}
//           </div>
//           <pre
//             style={{
//               margin: 0,
//               padding: 12,
//               fontSize: 12.5,
//               color: "#E6EAF5",
//               fontFamily: "'IBM Plex Mono', monospace",
//               overflow: "auto",
//             }}
//           >
//             {block.code || "// empty"}
//           </pre>
//         </div>
//       );
//     case "request_payload":
//     case "success_response": {
//       const isSuccess = block.type === "success_response";
//       let pretty = block.data;
//       try {
//         pretty = JSON.stringify(JSON.parse(block.data), null, 2);
//       } catch {
//         /* keep raw */
//       }
//       return (
//         <div
//           style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               padding: "6px 12px",
//               borderBottom: "1px solid #2A335C",
//             }}
//           >
//             <span
//               style={{
//                 fontSize: 11,
//                 color: "#9BA6C7",
//                 fontFamily: "'IBM Plex Mono', monospace",
//               }}
//             >
//               {isSuccess ? "response" : "request payload"}
//             </span>
//             {isSuccess && (
//               <span
//                 style={{
//                   fontSize: 10,
//                   fontWeight: 600,
//                   color: "#27500A",
//                   background: "#C0DD97",
//                   borderRadius: 4,
//                   padding: "2px 6px",
//                 }}
//               >
//                 201 success
//               </span>
//             )}
//           </div>
//           <pre
//             style={{
//               margin: 0,
//               padding: 12,
//               fontSize: 12.5,
//               color: "#E6EAF5",
//               fontFamily: "'IBM Plex Mono', monospace",
//               overflow: "auto",
//             }}
//           >
//             {pretty}
//           </pre>
//         </div>
//       );
//     }
//     case "video": {
//       const ratios = {
//         "16:9": "56.25%",
//         "4:3": "75%",
//         "1:1": "100%",
//         "9:16": "177.78%",
//       };
//       const embedUrl = toEmbedUrl(block.provider, block.url);
//       return (
//         <div>
//           <div
//             style={{
//               position: "relative",
//               width: "100%",
//               paddingTop: ratios[block.aspectRatio] || "56.25%",
//               background: "#1B2340",
//               borderRadius: 8,
//               overflow: "hidden",
//             }}
//           >
//             {embedUrl ? (
//               block.provider === "mp4" ? (
//                 <video
//                   src={embedUrl}
//                   controls
//                   style={{
//                     position: "absolute",
//                     inset: 0,
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "cover",
//                   }}
//                 />
//               ) : (
//                 <iframe
//                   src={embedUrl}
//                   title={block.caption || "Video"}
//                   allow="autoplay; fullscreen; picture-in-picture"
//                   style={{
//                     position: "absolute",
//                     inset: 0,
//                     width: "100%",
//                     height: "100%",
//                     border: 0,
//                   }}
//                 />
//               )
//             ) : (
//               <div
//                 style={{
//                   position: "absolute",
//                   inset: 0,
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: 6,
//                   color: "#9BA6C7",
//                   fontSize: 12,
//                 }}
//               >
//                 <Video size={20} />
//                 <span>No video URL set</span>
//               </div>
//             )}
//           </div>
//           {block.caption && (
//             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
//               {block.caption}
//             </div>
//           )}
//         </div>
//       );
//     }
//     case "audio":
//       return (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "flex-start",
//             gap: 12,
//             border: "1px solid #E4E2D8",
//             borderRadius: 10,
//             padding: "12px 14px",
//             background: "#FBFAF6",
//           }}
//         >
//           <div
//             style={{
//               width: 36,
//               height: 36,
//               borderRadius: "50%",
//               background: "#EEEDFE",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             <Music2 size={16} color="#534AB7" />
//           </div>
//           <div style={{ flex: 1, minWidth: 0 }}>
//             <div style={{ fontSize: 13.5, fontWeight: 600, color: "#1B2340" }}>
//               {block.title || "Untitled audio"}
//             </div>
//             <div style={{ fontSize: 12, color: "#8A8878" }}>
//               {block.subtitle}
//               {block.subtitle && block.duration ? " · " : ""}
//               {block.duration}
//             </div>
//             {block.url ? (
//               <audio
//                 src={block.url}
//                 controls
//                 style={{ width: "100%", height: 32, marginTop: 6 }}
//               />
//             ) : (
//               <div style={{ fontSize: 12, color: "#C7C4B6", marginTop: 4 }}>
//                 No audio URL set
//               </div>
//             )}
//           </div>
//         </div>
//       );
//     case "file": {
//       const Icon = FILE_TYPE_ICONS[block.filetype] || FileGeneric;
//       return (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 12,
//             border: "1px solid #E4E2D8",
//             borderRadius: 10,
//             padding: "12px 14px",
//             background: "#FBFAF6",
//           }}
//         >
//           <div
//             style={{
//               width: 36,
//               height: 36,
//               borderRadius: 8,
//               background: "#E1F5EE",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             <Icon size={17} color="#0F6E56" />
//           </div>
//           <div style={{ flex: 1, minWidth: 0 }}>
//             <div
//               style={{
//                 fontSize: 13.5,
//                 fontWeight: 600,
//                 color: "#1B2340",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 whiteSpace: "nowrap",
//               }}
//             >
//               {block.filename || "Untitled file"}
//             </div>
//             <div style={{ fontSize: 12, color: "#8A8878" }}>
//               {block.filetype}
//               {block.filesize ? ` · ${block.filesize}` : ""}
//             </div>
//           </div>
//           <a
//             href={block.url || "#"}
//             target="_blank"
//             rel="noreferrer"
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 12.5,
//               fontWeight: 600,
//               padding: "7px 12px",
//               borderRadius: 7,
//               background: "#1B2340",
//               color: "#fff",
//               textDecoration: "none",
//               flexShrink: 0,
//             }}
//           >
//             <Download size={13} /> Download
//           </a>
//         </div>
//       );
//     }
//     case "lottie":
//       return (
//         <div>
//           <div
//             style={{
//               width: block.width || "100%",
//               height: block.height || "280px",
//               borderRadius: 8,
//               background: "#FBEAF0",
//               border: "1px dashed #ED93B1",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 6,
//               color: "#993556",
//             }}
//           >
//             <Sparkles size={20} />
//             <span
//               style={{ fontSize: 12, padding: "0 12px", textAlign: "center" }}
//             >
//               {block.url
//                 ? "Lottie animation (plays on the live site)"
//                 : "No animation URL set"}
//             </span>
//           </div>
//           {block.caption && (
//             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
//               {block.caption}
//             </div>
//           )}
//         </div>
//       );
//     case "button": {
//       const align = block.align || "left";
//       const justify =
//         align === "center"
//           ? "center"
//           : align === "right"
//             ? "flex-end"
//             : "flex-start";
//       const primary = block.style !== "secondary";
//       return (
//         <div style={{ display: "flex", justifyContent: justify }}>
//           <a
//             href={block.url || "#"}
//             target={block.newTab ? "_blank" : undefined}
//             rel={block.newTab ? "noreferrer" : undefined}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 13.5,
//               fontWeight: 600,
//               padding: "9px 18px",
//               borderRadius: 8,
//               textDecoration: "none",
//               background: primary ? "#1B2340" : "transparent",
//               color: primary ? "#fff" : "#1B2340",
//               border: primary ? "none" : "1px solid #1B2340",
//             }}
//           >
//             {block.label || "Button label"}
//           </a>
//         </div>
//       );
//     }
//     case "badges":
//       return (
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
//           {block.tags.map((tag) => {
//             const c = RAMP[tag.tone] || RAMP.blue;
//             return (
//               <span
//                 key={tag.id}
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   padding: "4px 10px",
//                   borderRadius: 999,
//                   background: c[50],
//                   color: c[800],
//                   border: `1px solid ${c[200]}`,
//                 }}
//               >
//                 {tag.label || "Tag"}
//               </span>
//             );
//           })}
//         </div>
//       );
//     case "stepper":
//       return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           {block.steps.map((step, i) => (
//             <div key={step.id} style={{ display: "flex", gap: 12 }}>
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: 24,
//                     height: 24,
//                     borderRadius: "50%",
//                     background: "#1B2340",
//                     color: "#fff",
//                     fontSize: 11.5,
//                     fontWeight: 700,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   {i + 1}
//                 </div>
//                 {i < block.steps.length - 1 && (
//                   <div
//                     style={{
//                       width: 2,
//                       flex: 1,
//                       background: "#E4E2D8",
//                       minHeight: 18,
//                     }}
//                   />
//                 )}
//               </div>
//               <div style={{ paddingBottom: 16 }}>
//                 <div
//                   style={{ fontSize: 13.5, fontWeight: 600, color: "#1B2340" }}
//                 >
//                   {step.title || (
//                     <span style={{ color: "#C7C4B6" }}>Untitled step</span>
//                   )}
//                 </div>
//                 {step.text && (
//                   <div
//                     style={{
//                       fontSize: 13,
//                       color: "#5F5E5A",
//                       lineHeight: 1.6,
//                       marginTop: 3,
//                     }}
//                   >
//                     {step.text}
//                   </div>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       );
//     case "feedback":
//       return (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             border: "1px solid #E4E2D8",
//             borderRadius: 10,
//             padding: "12px 14px",
//             background: "#FBFAF6",
//           }}
//         >
//           <span style={{ fontSize: 13.5, color: "#3A3A34" }}>
//             {block.prompt || "Was this helpful?"}
//           </span>
//           <div style={{ display: "flex", gap: 8 }}>
//             <div
//               style={{
//                 width: 30,
//                 height: 30,
//                 borderRadius: 7,
//                 border: "1px solid #E4E2D8",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#5F5E5A",
//               }}
//             >
//               <ThumbsUp size={14} />
//             </div>
//             <div
//               style={{
//                 width: 30,
//                 height: 30,
//                 borderRadius: 7,
//                 border: "1px solid #E4E2D8",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#5F5E5A",
//               }}
//             >
//               <ThumbsDown size={14} />
//             </div>
//           </div>
//         </div>
//       );
//     case "table":
//       return (
//         <div
//           style={{
//             overflow: "auto",
//             border: "1px solid #E4E2D8",
//             borderRadius: 8,
//           }}
//         >
//           <table
//             style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}
//           >
//             <thead>
//               <tr>
//                 {block.columns.map((col, i) => (
//                   <th
//                     key={i}
//                     style={{
//                       textAlign: "left",
//                       padding: "8px 12px",
//                       background: "#F1EFE8",
//                       color: "#1B2340",
//                       fontWeight: 600,
//                       borderBottom: "1px solid #E4E2D8",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {col || `Column ${i + 1}`}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {block.rows.map((row, ri) => (
//                 <tr key={ri}>
//                   {row.map((cell, ci) => (
//                     <td
//                       key={ci}
//                       style={{
//                         padding: "8px 12px",
//                         borderBottom: "1px solid #EDEBE0",
//                         color: "#3A3A34",
//                       }}
//                     >
//                       {cell}
//                     </td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       );
//     case "divider":
//       return block.style === "space" ? (
//         <div style={{ height: block.spacing ?? 24 }} />
//       ) : (
//         <hr
//           style={{
//             border: "none",
//             borderTop: `1px ${block.style === "dashed" ? "dashed" : "solid"} #E4E2D8`,
//             margin: `${block.spacing ?? 24}px 0`,
//           }}
//         />
//       );

//     case "richtext":
//       return (
//         <div
//           className="rendered-richtext"
//           style={{
//             fontSize: 14,
//             lineHeight: 1.7,
//             color: "#3A3A34",
//             textAlign: block.align || "left",
//           }}
//           dangerouslySetInnerHTML={{
//             __html:
//               block.html || '<p style="color:#C7C4B6">Empty rich text</p>',
//           }}
//         />
//       );

//     default:
//       return null;
//   }
// }

// function DocumentPreview({ values }) {
//   return (
//     <div
//       style={{
//         background: "#fff",
//         borderRadius: 12,
//         border: "1px solid #E4E2D8",
//         padding: "20px 22px",
//       }}
//     >
//       <div
//         style={{
//           fontSize: 11,
//           fontWeight: 600,
//           color: "#8A8878",
//           textTransform: "uppercase",
//           letterSpacing: "0.04em",
//           marginBottom: 6,
//         }}
//       >
//         {values.category} · {values.doc_type}
//       </div>
//       <div
//         style={{
//           fontSize: 22,
//           fontWeight: 700,
//           color: "#1B2340",
//           fontFamily: "'Space Grotesk', sans-serif",
//           marginBottom: 8,
//         }}
//       >
//         {values.title || "Untitled workflow doc"}
//       </div>
//       <p
//         style={{
//           fontSize: 14,
//           color: "#5F5E5A",
//           lineHeight: 1.7,
//           marginBottom: 18,
//         }}
//       >
//         {values.overview}
//       </p>
//       <div
//         style={{
//           display: "flex",
//           gap: 8,
//           alignItems: "center",
//           marginBottom: 20,
//           fontFamily: "'IBM Plex Mono', monospace",
//           fontSize: 12.5,
//         }}
//       >
//         {values.api_method && (
//           <span
//             style={{
//               background: "#1B2340",
//               color: "#fff",
//               borderRadius: 5,
//               padding: "3px 8px",
//               fontWeight: 600,
//             }}
//           >
//             {values.api_method}
//           </span>
//         )}
//         <span style={{ color: "#5F5E5A", wordBreak: "break-all" }}>
//           {values.api_endpoint}
//         </span>
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//         {values.content_blocks.map((b) => (
//           <RenderedBlock key={b.id} block={b} />
//         ))}
//       </div>
//     </div>
//   );
// }

// function toExportBlock(b) {
//   const { id, ...rest } = b;
//   if (b.type === "request_payload" || b.type === "success_response") {
//     let parsed;
//     try {
//       parsed = JSON.parse(b.data);
//     } catch {
//       parsed = b.data;
//     }
//     return { type: b.type, data: parsed };
//   }
//   if (b.type === "columns") {
//     return {
//       ...rest,
//       columns: (b.columns || []).map((col) => ({
//         blocks: (col.blocks || []).map(toExportBlock),
//       })),
//     };
//   }
//   return rest;
// }

// export default function HrmsBlockEditor() {
//   const { values, setField, setValues } = useFormikLike(initialValues);
//   const [copied, setCopied] = useState(false);
//   const [showPreview, setShowPreview] = useState(true);
//   const [previewTab, setPreviewTab] = useState("rendered");
//   const [addType, setAddType] = useState("paragraph");
//   const { state } = useLocation();
//   const { type } = useParams(); //add || update || copy
//   const [page_data, setPageData] = useState([]);

//   const navigate = useNavigate();

//   const client = useQueryClient();

//   const { mutate: AddDocuments, isLoading } = useMutation(postDocument, {
//     onSuccess: (res) => {
//       if (res?.data?.response_code === 200) {
//         client.refetchQueries(["get-document"]);
//         toast.success(res?.data?.message);
//         navigate(-1);
//       } else {
//         toast.warn(res?.data?.message);
//       }
//     },
//   });

//   const {
//     data: documentResponse,

//     isError,
//     refetch,
//   } = useQuery(["get-document", state], () => getDocument({ doc_id: state }), {
//     refetchOnWindowFocus: false,
//     refetchOnMount: false,
//     enabled: Boolean(state),
//   });

//   function fromImportBlock(b) {
//     const id = nextId();
//     if (b.type === "request_payload" || b.type === "success_response") {
//       const data =
//         typeof b.data === "string"
//           ? b.data
//           : JSON.stringify(b.data ?? {}, null, 2);
//       return { ...b, id, data };
//     }
//     if (b.type === "columns") {
//       return {
//         ...b,
//         id,
//         columns: (b.columns || []).map((col) => ({
//           id: genKey("column"),
//           blocks: (col.blocks || []).map(fromImportBlock),
//         })),
//       };
//     }
//     return { ...b, id };
//   }

//   useEffect(() => {
//     const doc = documentResponse?.data?.data; // aapke sample response ke hisaab se
//     if (!doc) return;
//     setValues({
//       page_title: doc.page_title || "",
//       category: doc.category || "",
//       title: doc.title || "",
//       doc_type: doc.doc_type || "",
//       overview: doc.overview || "",
//       api_method: doc.api_method || "",
//       api_endpoint: doc.api_endpoint || "",
//       content_blocks: (doc.content_blocks || []).map(fromImportBlock),
//     });
//   }, [documentResponse]);

//   const blocks = values.content_blocks;

//   const updateBlock = (idx, updated) => {
//     const next = [...blocks];
//     next[idx] = updated;
//     setField("content_blocks", next);
//   };
//   const removeBlock = (idx) =>
//     setField(
//       "content_blocks",
//       blocks.filter((_, i) => i !== idx),
//     );
//   const moveBlock = (from, to) => {
//     const next = [...blocks];
//     const [item] = next.splice(from, 1);
//     next.splice(to, 0, item);
//     setField("content_blocks", next);
//   };
//   const addBlock = () =>
//     setField("content_blocks", [...blocks, emptyBlockFor(addType)]);

//   const exportJson = {
//     page_title: values?.page_title,
//     category: values.category,
//     title: values.title,
//     doc_type: values.doc_type,
//     overview: values.overview,
//     api_method: values.api_method,
//     api_endpoint: values.api_endpoint,
//     content_blocks: blocks.map(toExportBlock),
//   };

//   const jsonString = JSON.stringify(exportJson, null, 2);

//   const copyJson = async () => {
//     try {
//       await navigator.clipboard.writeText(jsonString);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 1500);
//     } catch {
//       setCopied(false);
//     }
//   };

//   const isEditMode = Boolean(state) && type !== "copy";

//   const { mutate: EditDocument, isLoading: IsUpdateLoading } = useMutation(
//     (payload) => patchDocument({ ...payload, doc_id: state }),
//     {
//       onSuccess: (res) => {
//         if (res?.data?.response_code === 200) {
//           navigate(-1);
//           toast.success(res?.data?.message);
//           client.refetchQueries(["get-document"]);
//         } else {
//           toast.warn(res?.data?.message);
//         }
//       },
//     },
//   );
//   const saveDocument = async () => {
//     if (isEditMode) EditDocument(exportJson);
//     else AddDocuments(exportJson);
//   };

//   const getCreer = () => {
//     axios
//       .get(`${baseUrl}/blog/frontend-page-id-api/`, {
//         headers: {
//           Authorization: `Token ${localStorage.getItem("token")}`,
//           "Access-Control-Allow-Origin": "*",
//         },
//       })
//       .then((res) => {
//         setPageData(res.data?.data);
//       })
//       .catch((err) => {
//         toast.error("Error deleting blog", err?.response?.data?.message);
//       });
//   };

//   useEffect(() => {
//     getCreer();
//   }, []);

//   return (
//     <div
//       style={{
//         fontFamily: "'IBM Plex Sans', sans-serif",
//         background: "#F3F2EC",
//         padding: 24,
//         minHeight: "100vh",

//         boxSizing: "border-box",
//       }}
//     >
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&family=Space+Grotesk:wght@600;700&display=swap');
//         input:focus, textarea:focus, select:focus { border-color: #185FA5 !important; box-shadow: 0 0 0 3px rgba(24,95,165,0.12); }
//         @keyframes spSpin { to { transform: rotate(360deg); } }
//         @keyframes spFade { from { opacity: 0.4; } to { opacity: 1; } }
//       `}</style>

//       <div style={{ maxWidth: "100%", margin: "0 auto" }}>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "baseline",
//             justifyContent: "space-between",
//             marginBottom: 20,
//             flexWrap: "wrap",
//             gap: 10,
//           }}
//         >
//           <div>
//             <div
//               style={{
//                 fontSize: 12,
//                 fontFamily: "'IBM Plex Mono', monospace",
//                 color: "#8A8878",
//                 letterSpacing: "0.06em",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               HRMS content block editor
//             </div>
//             <h1
//               style={{
//                 fontFamily: "'Space Grotesk', sans-serif",
//                 fontSize: 26,
//                 fontWeight: 700,
//                 color: "#1B2340",
//                 margin: 0,
//               }}
//             >
//               {values.title || "Untitled workflow doc"}
//             </h1>
//           </div>
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={() => setShowPreview((s) => !s)}
//               style={{
//                 fontSize: 13,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "1px solid #DEDCD1",
//                 background: "#fff",
//                 color: "#20201C",
//                 cursor: "pointer",
//               }}
//             >
//               {showPreview ? "Hide JSON" : "Show JSON"}
//             </button>
//             <button
//               onClick={copyJson}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "none",
//                 background: "#1B2340",
//                 color: "#fff",
//                 cursor: "pointer",
//               }}
//             >
//               {copied ? <Check size={14} /> : <Copy size={14} />}{" "}
//               {copied ? "Copied" : "Copy JSON"}
//             </button>
//             <button
//               disabled={isLoading || IsUpdateLoading}
//               onClick={saveDocument}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "none",
//                 background: "#1B2340",
//                 color: "#fff",
//                 cursor: "pointer",
//               }}
//             >
//               {isLoading || IsUpdateLoading
//                 ? "Saving..."
//                 : isEditMode
//                   ? "Update Document"
//                   : "Save Document"}
//             </button>
//           </div>
//         </div>

//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: showPreview ? "1fr 1fr" : "1fr",
//             gap: 20,
//             alignItems: "start",
//             minWidth: 0,
//           }}
//         >
//           <div style={{ minWidth: 0 }}>
//             {/* Document meta card */}
//             <div
//               style={{
//                 background: "#fff",
//                 border: "1px solid #E4E2D8",
//                 borderRadius: 12,
//                 padding: 18,
//                 marginBottom: 20,
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: 13,
//                   fontWeight: 600,
//                   color: "#1B2340",
//                   marginBottom: 12,
//                 }}
//               >
//                 Document details
//               </div>

//               <Field label="Select the page you want to view">
//                 <select
//                   style={selectStyle}
//                   value={values.page_title}
//                   onChange={(e) => setField("page_title", e.target.value)}
//                 >
//                   <option className="font-bold ">Select A Page</option>
//                   {page_data?.map((i) => (
//                     <option value={i?.id}>{i?.name}</option>
//                   ))}
//                 </select>
//               </Field>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: 12,
//                 }}
//               >
//                 <Field label="Category">
//                   <input
//                     style={inputStyle}
//                     value={values.category}
//                     onChange={(e) => setField("category", e.target.value)}
//                   />
//                 </Field>
//                 <Field label="Doc type">
//                   <input
//                     style={inputStyle}
//                     value={values.doc_type}
//                     onChange={(e) => setField("doc_type", e.target.value)}
//                   />
//                 </Field>
//               </div>
//               <Field label="Title">
//                 <input
//                   style={inputStyle}
//                   value={values.title}
//                   onChange={(e) => setField("title", e.target.value)}
//                 />
//               </Field>
//               <Field label="Overview">
//                 <textarea
//                   style={textareaStyle}
//                   value={values.overview}
//                   onChange={(e) => setField("overview", e.target.value)}
//                 />
//               </Field>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "120px 1fr",
//                   gap: 12,
//                 }}
//               >
//                 <Field label="API method">
//                   <select
//                     style={selectStyle}
//                     value={values.api_method}
//                     onChange={(e) => setField("api_method", e.target.value)}
//                   >
//                     <option value={""}>None</option>
//                     {["GET", "POST", "PUT", "PATCH", "DELETE"].map((m) => (
//                       <option key={m} value={m}>
//                         {m}
//                       </option>
//                     ))}
//                   </select>
//                 </Field>
//                 <Field label="API endpoint">
//                   <input
//                     style={monoStyle}
//                     value={values.api_endpoint}
//                     onChange={(e) => setField("api_endpoint", e.target.value)}
//                   />
//                 </Field>
//               </div>
//             </div>

//             {/* Blocks */}
//             <div
//               style={{
//                 fontSize: 13,
//                 fontWeight: 600,
//                 color: "#1B2340",
//                 marginBottom: 10,
//               }}
//             >
//               Content blocks ({blocks.length})
//             </div>
//             {blocks.map((b, i) => (
//               <BlockCard
//                 key={b.id}
//                 block={b}
//                 index={i}
//                 total={blocks.length}
//                 onChange={(updated) => updateBlock(i, updated)}
//                 onRemove={removeBlock}
//                 onMove={moveBlock}
//               />
//             ))}

//             <div
//               style={{
//                 display: "flex",
//                 gap: 8,
//                 marginTop: 14,
//                 background: "#fff",
//                 border: "1px dashed #C7C4B6",
//                 borderRadius: 12,
//                 padding: 14,
//                 alignItems: "center",
//               }}
//             >
//               <select
//                 style={{ ...selectStyle, width: "auto", flex: 1 }}
//                 value={addType}
//                 onChange={(e) => setAddType(e.target.value)}
//               >
//                 {Object.entries(BLOCK_TYPES).map(([k, v]) => (
//                   <option key={k} value={k}>
//                     {v.label}
//                   </option>
//                 ))}
//               </select>
//               <button
//                 onClick={addBlock}
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 6,
//                   fontSize: 13,
//                   fontWeight: 600,
//                   padding: "9px 16px",
//                   borderRadius: 8,
//                   border: "none",
//                   background: "#1B2340",
//                   color: "#fff",
//                   cursor: "pointer",
//                 }}
//               >
//                 <Plus size={14} /> Add block
//               </button>
//             </div>
//           </div>

//           {showPreview && (
//             <div style={{ position: "sticky", top: 20, minWidth: 0 }}>
//               <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
//                 {[
//                   ["rendered", "Preview"],
//                   ["json", "JSON"],
//                 ].map(([key, label]) => (
//                   <button
//                     key={key}
//                     onClick={() => setPreviewTab(key)}
//                     style={{
//                       fontSize: 12.5,
//                       fontWeight: 600,
//                       padding: "6px 12px",
//                       borderRadius: 7,
//                       cursor: "pointer",
//                       border:
//                         previewTab === key
//                           ? "1px solid #1B2340"
//                           : "1px solid #DEDCD1",
//                       background: previewTab === key ? "#1B2340" : "#fff",
//                       color: previewTab === key ? "#fff" : "#5F5E5A",
//                     }}
//                   >
//                     {label}
//                   </button>
//                 ))}
//                 <span
//                   style={{
//                     fontSize: 11.5,
//                     color: "#9A988E",
//                     alignSelf: "center",
//                     marginLeft: 4,
//                   }}
//                 >
//                   {previewTab === "rendered"
//                     ? "How this data will display"
//                     : "Data admin will submit"}
//                 </span>
//               </div>

//               {previewTab === "rendered" ? (
//                 <div style={{ maxHeight: "80vh", overflow: "auto" }}>
//                   <DocumentPreview values={values} />
//                 </div>
//               ) : (
//                 <div
//                   style={{
//                     background: "#1B2340",
//                     borderRadius: 12,
//                     overflow: "hidden",
//                     border: "1px solid #1B2340",
//                   }}
//                 >
//                   <div
//                     style={{
//                       padding: "10px 14px",
//                       fontSize: 12,
//                       color: "#9BA6C7",
//                       fontFamily: "'IBM Plex Mono', monospace",
//                       borderBottom: "1px solid #2A335C",
//                     }}
//                   >
//                     output.json
//                   </div>
//                   <pre
//                     style={{
//                       margin: 0,
//                       padding: 16,
//                       fontSize: 12.5,
//                       lineHeight: 1.6,
//                       color: "#E6EAF5",
//                       fontFamily: "'IBM Plex Mono', monospace",
//                       overflow: "auto",
//                       maxHeight: "80vh",
//                     }}
//                   >
//                     {jsonString}
//                   </pre>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// import { useEffect, useState, useRef } from "react";
// import {
//   Heading1,
//   AlignLeft,
//   AlertTriangle,
//   List as ListIcon,
//   Images,
//   Image as ImageIcon,
//   Code2,
//   Terminal,
//   CheckCircle2,
//   Plus,
//   Trash2,
//   ChevronUp,
//   ChevronDown,
//   ChevronDown as Caret,
//   Copy,
//   Check,
//   GripVertical,
//   KeyRound,
//   RefreshCw,
//   Info,
//   XCircle,
//   ImageOff,
//   ChevronLeft,
//   ChevronRight,
//   Columns2,
//   AlignCenter,
//   AlignRight,
//   AlignJustify,
//   Video,
//   Music2,
//   Paperclip,
//   Sparkles,
//   MousePointerClick,
//   Tags,
//   ListOrdered,
//   ThumbsUp,
//   ThumbsDown,
//   Table2,
//   SeparatorHorizontal,
//   FileText,
//   FileArchive,
//   FileSpreadsheet,
//   File as FileGeneric,
//   Download,
//   PenSquare,
//   Smartphone,
//   Tablet,
//   Laptop,
//   Maximize2,
//   X,
//   FileJson,
//   Upload,
// } from "lucide-react";
// import { useMutation, useQuery, useQueryClient } from "react-query";
// import {
//   getDocument,
//   patchDocument,
//   postDocument,
// } from "../../../Services/Document";
// import { toast } from "react-toastify";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { baseUrl } from "../../../Config/baseUrl";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// const RICHTEXT_MODULES = {
//   toolbar: [
//     [{ header: [1, 2, 3, false] }],
//     ["bold", "italic", "underline", "strike"],
//     [{ color: [] }, { background: [] }],
//     [{ list: "ordered" }, { list: "bullet" }],
//     ["blockquote", "code-block", "link"],
//     ["clean"],
//   ],
// };

// const CALLOUT_STYLE = {
//   info: { bg: "#E6F1FB", border: "#185FA5", text: "#0C447C", icon: Info },
//   warning: {
//     bg: "#FAEEDA",
//     border: "#BA7517",
//     text: "#633806",
//     icon: AlertTriangle,
//   },
//   success: {
//     bg: "#EAF3DE",
//     border: "#3B6D11",
//     text: "#27500A",
//     icon: CheckCircle2,
//   },
//   error: { bg: "#FCEBEB", border: "#A32D2D", text: "#501313", icon: XCircle },
// };

// const BLOCK_TYPES = {
//   heading: { label: "Heading", ramp: "blue", icon: Heading1 },
//   paragraph: { label: "Paragraph", ramp: "gray", icon: AlignLeft },
//   callout: { label: "Callout", ramp: "amber", icon: AlertTriangle },
//   list: { label: "List", ramp: "green", icon: ListIcon },
//   slider: { label: "Image slider", ramp: "purple", icon: Images },
//   image: { label: "Image", ramp: "pink", icon: ImageIcon },
//   columns: { label: "Multi-column", ramp: "blue", icon: Columns2 },
//   request_payload: { label: "Request payload", ramp: "teal", icon: Code2 },
//   code: { label: "Code sample", ramp: "gray", icon: Terminal },
//   success_response: {
//     label: "Success response",
//     ramp: "green",
//     icon: CheckCircle2,
//   },
//   video: { label: "Video embed", ramp: "blue", icon: Video },
//   audio: { label: "Audio player / voice note", ramp: "purple", icon: Music2 },
//   file: { label: "File attachment", ramp: "teal", icon: Paperclip },
//   lottie: {
//     label: "Lottie / interactive animation",
//     ramp: "pink",
//     icon: Sparkles,
//   },
//   button: {
//     label: "Button / action link",
//     ramp: "green",
//     icon: MousePointerClick,
//   },
//   badges: { label: "Badge / tag cloud", ramp: "amber", icon: Tags },
//   stepper: { label: "Step-by-step guide", ramp: "blue", icon: ListOrdered },
//   feedback: { label: "Feedback widget", ramp: "green", icon: ThumbsUp },
//   table: { label: "Table", ramp: "gray", icon: Table2 },
//   divider: {
//     label: "Divider / spacer",
//     ramp: "gray",
//     icon: SeparatorHorizontal,
//   },
//   richtext: { label: "Rich text editor", ramp: "purple", icon: PenSquare },
// };

// const RAMP = {
//   blue: { 50: "#E6F1FB", 200: "#85B7EB", 600: "#185FA5", 800: "#0C447C" },
//   gray: { 50: "#F1EFE8", 200: "#B4B2A9", 600: "#5F5E5A", 800: "#444441" },
//   amber: { 50: "#FAEEDA", 200: "#EF9F27", 600: "#854F0B", 800: "#633806" },
//   green: { 50: "#EAF3DE", 200: "#97C459", 600: "#3B6D11", 800: "#27500A" },
//   purple: { 50: "#EEEDFE", 200: "#AFA9EC", 600: "#534AB7", 800: "#3C3489" },
//   pink: { 50: "#FBEAF0", 200: "#ED93B1", 600: "#993556", 800: "#72243E" },
//   teal: { 50: "#E1F5EE", 200: "#5DCAA5", 600: "#0F6E56", 800: "#085041" },
// };

// const ALIGN_OPTIONS = [
//   { value: "left", label: "Left", icon: AlignLeft },
//   { value: "center", label: "Center", icon: AlignCenter },
//   { value: "right", label: "Right", icon: AlignRight },
//   { value: "justify", label: "Justify", icon: AlignJustify },
// ];

// const OBJECT_FIT_OPTIONS = ["cover", "contain", "fill", "none", "scale-down"];

// let uid = 1;
// const nextId = () => `blk-${uid++}`;
// const genKey = (prefix) =>
//   `${prefix}_${Math.random().toString(36).slice(2, 8)}`;

// // ---- Media upload helpers ----------------------------------------------

// function guessExtension(mimeType) {
//   const map = {
//     "image/jpeg": "jpg",
//     "image/png": "png",
//     "image/webp": "webp",
//     "image/gif": "gif",
//     "audio/mpeg": "mp3",
//     "audio/wav": "wav",
//     "video/mp4": "mp4",
//     "application/pdf": "pdf",
//   };
//   return map[mimeType] || mimeType?.split("/")[1] || "bin";
// }

// async function urlToFile(url) {
//   const res = await fetch(url);
//   if (!res.ok) throw new Error("Could not fetch that URL");
//   const blob = await res.blob();
//   const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
//   return new File([blob], `media-${timestamp}.${guessExtension(blob.type)}`, {
//     type: blob.type,
//   });
// }

// async function uploadFileToServer(file) {
//   const formData = new FormData();
//   formData.append("title", "file");
//   formData.append("image", file);

//   const res = await axios.post(
//     `${baseUrl}/blog/upload-image-to-s3-api/`, // TODO: point this at your real upload endpoint
//     formData,
//     {
//       headers: {
//         Authorization: `Token ${localStorage.getItem("token")}`,
//       },
//     },
//   );

//   return res.data?.data?.image; // TODO: adjust to match your API's actual response shape
// }

// // -------------------------------------------------------------------------

// const emptyImageValue = (prefix) => ({
//   image_key: genKey(prefix),
//   url: "",
//   caption: "",
//   alt: "",
//   width: "100%",
//   height: "220px",
//   objectFit: "cover",
// });

// const emptyColumn = () => ({
//   id: genKey("column"),
//   blocks: [],
// });

// const emptyBlockFor = (type) => {
//   const id = nextId();
//   switch (type) {
//     case "heading":
//       return { id, type: "heading", level: "h2", text: "", align: "left" };
//     case "paragraph":
//       return { id, type: "paragraph", text: "", align: "left" };
//     case "callout":
//       return { id, type: "callout", style: "info", text: "", align: "left" };
//     case "list":
//       return { id, type: "list", style: "bullet", items: [""], align: "left" };
//     case "slider":
//       return { id, type: "slider", images: [emptyImageValue("slider_step")] };
//     case "image":
//       return {
//         id,
//         type: "image",
//         image_key: genKey("image"),
//         url: "",
//         caption: "",
//         align: "center",
//         width: "100%",
//         height: "auto",
//         objectFit: "cover",
//       };
//     case "columns":
//       return {
//         id,
//         type: "columns",
//         gap: 20,
//         columns: [emptyColumn(), emptyColumn()],
//       };
//     case "request_payload":
//       return { id, type: "request_payload", data: "{\n  \n}" };
//     case "code":
//       return { id, type: "code", language: "python", code: "" };
//     case "success_response":
//       return { id, type: "success_response", data: "{\n  \n}" };
//     case "video":
//       return {
//         id,
//         type: "video",
//         provider: "youtube",
//         url: "",
//         caption: "",
//         aspectRatio: "16:9",
//       };
//     case "audio":
//       return {
//         id,
//         type: "audio",
//         url: "",
//         title: "",
//         subtitle: "",
//         duration: "",
//       };
//     case "file":
//       return {
//         id,
//         type: "file",
//         url: "",
//         filename: "",
//         filetype: "PDF",
//         filesize: "",
//       };
//     case "lottie":
//       return {
//         id,
//         type: "lottie",
//         url: "",
//         caption: "",
//         width: "100%",
//         height: "280px",
//         loop: true,
//         autoplay: true,
//       };
//     case "button":
//       return {
//         id,
//         type: "button",
//         label: "",
//         url: "",
//         style: "primary",
//         align: "left",
//         newTab: true,
//       };
//     case "badges":
//       return {
//         id,
//         type: "badges",
//         tags: [{ id: genKey("tag"), label: "New", tone: "blue" }],
//       };
//     case "stepper":
//       return {
//         id,
//         type: "stepper",
//         steps: [{ id: genKey("step"), title: "", text: "" }],
//       };
//     case "feedback":
//       return { id, type: "feedback", prompt: "Was this helpful?" };
//     case "table":
//       return {
//         id,
//         type: "table",
//         columns: ["Column 1", "Column 2"],
//         rows: [["", ""]],
//       };
//     case "divider":
//       return { id, type: "divider", style: "solid", spacing: 24 };
//     default:
//       return { id, type: "paragraph", text: "", align: "left" };
//     case "richtext":
//       return { id, type: "richtext", html: "", align: "left" };
//   }
// };

// const initialBlocks = [];

// const initialValues = {
//   page_title: "",
//   category: "",
//   title: "",
//   doc_type: "",
//   overview: "",
//   api_method: "",
//   api_endpoint: "",
//   content_blocks: initialBlocks,
// };

// function useFormikLike(initial) {
//   const [values, setValues] = useState(initial);
//   const setField = (path, val) => {
//     setValues((prev) => {
//       const next = structuredClone(prev);
//       const keys = path.split(".");
//       let cur = next;
//       for (let i = 0; i < keys.length - 1; i++) cur = cur[keys[i]];
//       cur[keys[keys.length - 1]] = val;
//       return next;
//     });
//   };
//   return { values, setValues, setField };
// }

// function Field({ label, children, hint }) {
//   return (
//     <label style={{ display: "block", marginBottom: 14 }}>
//       <span
//         style={{
//           display: "block",
//           fontSize: 12,
//           fontWeight: 600,
//           color: "#5F5E5A",
//           letterSpacing: "0.02em",
//           textTransform: "uppercase",
//           marginBottom: 6,
//         }}
//       >
//         {label}
//       </span>
//       {children}
//       {hint && (
//         <span
//           style={{
//             display: "block",
//             fontSize: 12,
//             color: "#9A988E",
//             marginTop: 4,
//           }}
//         >
//           {hint}
//         </span>
//       )}
//     </label>
//   );
// }

// const inputStyle = {
//   width: "100%",
//   boxSizing: "border-box",
//   padding: "9px 11px",
//   borderRadius: 8,
//   border: "1px solid #DEDCD1",
//   fontSize: 14,
//   fontFamily: "'IBM Plex Sans', sans-serif",
//   color: "#20201C",
//   background: "#FFFFFF",
//   outline: "none",
// };
// const monoStyle = {
//   ...inputStyle,
//   fontFamily: "'IBM Plex Mono', monospace",
//   fontSize: 13,
// };
// const selectStyle = { ...inputStyle, cursor: "pointer" };
// const textareaStyle = {
//   ...inputStyle,
//   resize: "vertical",
//   minHeight: 70,
//   lineHeight: 1.5,
// };

// function IconBtn({ onClick, title, children, danger, active }) {
//   return (
//     <button
//       onClick={onClick}
//       title={title}
//       style={{
//         display: "inline-flex",
//         alignItems: "center",
//         justifyContent: "center",
//         width: 28,
//         height: 28,
//         borderRadius: 6,
//         border: active ? "1px solid #1B2340" : "1px solid #E4E2D8",
//         background: active ? "#1B2340" : "#fff",
//         color: active ? "#fff" : danger ? "#993C1D" : "#5F5E5A",
//         cursor: "pointer",
//       }}
//     >
//       {children}
//     </button>
//   );
// }

// function Spinner({ size = 14 }) {
//   return (
//     <span
//       style={{
//         display: "inline-block",
//         width: size,
//         height: size,
//         border: "2px solid #DEDCD1",
//         borderTopColor: "#1B2340",
//         borderRadius: "50%",
//         animation: "spSpin 0.7s linear infinite",
//         flexShrink: 0,
//       }}
//     />
//   );
// }

// function AlignPicker({ value, onChange }) {
//   return (
//     <Field label="Text align">
//       <div style={{ display: "flex", gap: 6 }}>
//         {ALIGN_OPTIONS.map((opt) => {
//           const Icon = opt.icon;
//           return (
//             <IconBtn
//               key={opt.value}
//               title={opt.label}
//               active={value === opt.value}
//               onClick={() => onChange(opt.value)}
//             >
//               <Icon size={14} />
//             </IconBtn>
//           );
//         })}
//       </div>
//     </Field>
//   );
// }

// function ImageDimensionFields({ width, height, objectFit, onChange }) {
//   return (
//     <div
//       style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}
//     >
//       <Field label="Width" hint="px, % or auto">
//         <input
//           style={inputStyle}
//           value={width}
//           onChange={(e) => onChange({ width: e.target.value })}
//           placeholder="100%"
//         />
//       </Field>
//       <Field label="Height" hint="px or auto">
//         <input
//           style={inputStyle}
//           value={height}
//           onChange={(e) => onChange({ height: e.target.value })}
//           placeholder="220px"
//         />
//       </Field>
//       <Field label="Fit">
//         <select
//           style={selectStyle}
//           value={objectFit}
//           onChange={(e) => onChange({ objectFit: e.target.value })}
//         >
//           {OBJECT_FIT_OPTIONS.map((f) => (
//             <option key={f} value={f}>
//               {f}
//             </option>
//           ))}
//         </select>
//       </Field>
//     </div>
//   );
// }

// function JsonField({ label, value, onChange }) {
//   const [error, setError] = useState(null);
//   return (
//     <Field label={label} hint={error ? null : "Valid JSON object"}>
//       <textarea
//         style={{ ...monoStyle, minHeight: 120 }}
//         value={value}
//         onChange={(e) => {
//           onChange(e.target.value);
//           try {
//             JSON.parse(e.target.value);
//             setError(null);
//           } catch {
//             setError("Not valid JSON yet");
//           }
//         }}
//       />
//       {error && (
//         <span
//           style={{
//             display: "block",
//             fontSize: 12,
//             color: "#993C1D",
//             marginTop: 4,
//           }}
//         >
//           {error}
//         </span>
//       )}
//     </Field>
//   );
// }

// // ---- Media upload field (URL fetch OR direct file upload) --------------

// function MediaUploadField({ label, value, onChange, accept = "*/*", hint }) {
//   const [mode, setMode] = useState("url");
//   const [pastedUrl, setPastedUrl] = useState("");
//   const [status, setStatus] = useState("idle"); // idle | working | error
//   const fileInputRef = useRef(null);

//   const runUpload = async (file) => {
//     setStatus("working");
//     try {
//       const uploadedUrl = await uploadFileToServer(file);
//       if (!uploadedUrl) throw new Error("No URL returned");
//       onChange(uploadedUrl);
//       setStatus("idle");
//     } catch (err) {
//       toast.error("Upload failed. Please try again.");
//       setStatus("error");
//     }
//   };

//   const handleUrlConvert = async () => {
//     if (!pastedUrl) return;
//     setStatus("working");
//     try {
//       const file = await urlToFile(pastedUrl);
//       await runUpload(file);
//     } catch {
//       toast.error("Couldn't read that URL");
//       setStatus("error");
//     }
//   };

//   const handleFilePick = (e) => {
//     const file = e.target.files?.[0];
//     if (file) runUpload(file);
//     e.target.value = ""; // allow re-picking the same file later
//   };

//   const tabBtn = (key, text) => (
//     <button
//       type="button"
//       onClick={() => setMode(key)}
//       style={{
//         fontSize: 12,
//         fontWeight: 600,
//         padding: "5px 10px",
//         borderRadius: 6,
//         cursor: "pointer",
//         border: mode === key ? "1px solid #1B2340" : "1px solid #DEDCD1",
//         background: mode === key ? "#1B2340" : "#fff",
//         color: mode === key ? "#fff" : "#5F5E5A",
//       }}
//     >
//       {text}
//     </button>
//   );

//   return (
//     <Field label={label} hint={hint}>
//       <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
//         {tabBtn("url", "Paste URL")}
//         {tabBtn("upload", "Upload file")}
//       </div>

//       {mode === "url" ? (
//         <div style={{ display: "flex", gap: 6 }}>
//           <input
//             style={inputStyle}
//             value={pastedUrl}
//             onChange={(e) => setPastedUrl(e.target.value)}
//             placeholder="https://..."
//             disabled={status === "working"}
//           />
//           <button
//             type="button"
//             onClick={handleUrlConvert}
//             disabled={status === "working" || !pastedUrl}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 12.5,
//               fontWeight: 600,
//               padding: "0 16px",
//               borderRadius: 8,
//               border: "none",
//               background: "#1B2340",
//               color: "#fff",
//               cursor: status === "working" ? "default" : "pointer",
//               opacity: status === "working" || !pastedUrl ? 0.6 : 1,
//               flexShrink: 0,
//             }}
//           >
//             {status === "working" ? <Spinner /> : "Use"}
//           </button>
//         </div>
//       ) : (
//         <div>
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept={accept}
//             onChange={handleFilePick}
//             style={{ display: "none" }}
//           />
//           <button
//             type="button"
//             onClick={() => fileInputRef.current?.click()}
//             disabled={status === "working"}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 8,
//               fontSize: 13,
//               padding: "8px 14px",
//               borderRadius: 8,
//               border: "1px dashed #C7C4B6",
//               background: "transparent",
//               color: "#5F5E5A",
//               cursor: status === "working" ? "default" : "pointer",
//               opacity: status === "working" ? 0.7 : 1,
//             }}
//           >
//             {status === "working" ? (
//               <>
//                 <Spinner /> Uploading…
//               </>
//             ) : (
//               <>
//                 <Paperclip size={14} /> Choose file
//               </>
//             )}
//           </button>
//         </div>
//       )}

//       <div
//         style={{
//           marginTop: 8,
//           display: "flex",
//           alignItems: "center",
//           gap: 6,
//         }}
//       >
//         <span style={{ fontSize: 11, color: "#9A988E", flexShrink: 0 }}>
//           Generated URL:
//         </span>
//         <input
//           disabled
//           style={{
//             ...inputStyle,
//             fontSize: 12,
//             color: "#5F5E5A",
//             background: "#F7F6F1",
//           }}
//           value={value || ""}
//           placeholder="Not uploaded yet"
//         />
//       </div>
//     </Field>
//   );
// }

// // -------------------------------------------------------------------------

// function BlockCard({
//   block,
//   index,
//   total,
//   onChange,
//   onRemove,
//   onMove,
//   compact,
// }) {
//   const [open, setOpen] = useState(true);
//   const meta = BLOCK_TYPES[block.type];
//   const Icon = meta?.icon;
//   const c = RAMP[meta?.ramp];
//   const patch = (field, val) => onChange({ ...block, [field]: val });

//   return (
//     <div
//       style={{
//         border: "1px solid #E4E2D8",
//         borderRadius: 12,
//         background: "#FFFFFF",
//         marginBottom: 12,
//         overflow: "hidden",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 10,
//           padding: "10px 12px",
//           background: c[50],
//           cursor: "pointer",
//           userSelect: "none",
//         }}
//         onClick={() => setOpen((o) => !o)}
//       >
//         <GripVertical size={15} color={c[600]} style={{ flexShrink: 0 }} />
//         <span
//           style={{
//             fontSize: 12,
//             fontFamily: "'IBM Plex Mono', monospace",
//             color: c[600],
//             fontWeight: 600,
//           }}
//         >
//           {String(index + 1).padStart(2, "0")}
//         </span>
//         <Icon size={15} color={c[800]} style={{ flexShrink: 0 }} />
//         <span style={{ fontSize: 13, fontWeight: 600, color: c[800] }}>
//           {meta.label}
//         </span>
//         <span
//           style={{
//             fontSize: 12,
//             color: c[600],
//             marginLeft: 2,
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             whiteSpace: "nowrap",
//             flex: 1,
//             minWidth: 0,
//           }}
//         >
//           {blockPreview(block)}
//         </span>
//         <div
//           style={{ display: "flex", gap: 4 }}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <IconBtn
//             title="Move up"
//             onClick={() => index > 0 && onMove(index, index - 1)}
//           >
//             <ChevronUp size={14} />
//           </IconBtn>
//           <IconBtn
//             title="Move down"
//             onClick={() => index < total - 1 && onMove(index, index + 1)}
//           >
//             <ChevronDown size={14} />
//           </IconBtn>
//           <IconBtn title="Delete block" danger onClick={() => onRemove(index)}>
//             <Trash2 size={14} />
//           </IconBtn>
//           <Caret
//             size={16}
//             color={c[600]}
//             style={{
//               transform: open ? "rotate(180deg)" : "none",
//               transition: "transform 0.15s",
//               marginLeft: 2,
//             }}
//           />
//         </div>
//       </div>

//       {open && (
//         <div style={{ padding: 16 }}>
//           <BlockFields block={block} patch={patch} onChange={onChange} />
//         </div>
//       )}
//     </div>
//   );
// }

// function blockPreview(b) {
//   if (b.type === "heading" || b.type === "paragraph" || b.type === "callout")
//     return b.text || "Empty";
//   if (b.type === "list")
//     return `${b.items.length} item${b.items.length === 1 ? "" : "s"}`;
//   if (b.type === "slider")
//     return `${b.images.length} image${b.images.length === 1 ? "" : "s"}`;
//   if (b.type === "image") return b.image_key || "unkeyed";
//   if (b.type === "columns") {
//     const total = (b.columns || []).reduce(
//       (s, c) => s + (c.blocks?.length || 0),
//       0,
//     );
//     return `${b.columns?.length || 0} columns, ${total} block${total === 1 ? "" : "s"}`;
//   }
//   if (b.type === "code") return b.language;
//   if (b.type === "request_payload" || b.type === "success_response")
//     return "JSON data";
//   if (b.type === "video") return b.url || "No URL set";
//   if (b.type === "audio") return b.title || b.url || "No audio set";
//   if (b.type === "file") return b.filename || "No file set";
//   if (b.type === "lottie") return b.caption || b.url || "No animation set";
//   if (b.type === "button") return b.label || "No label set";
//   if (b.type === "badges")
//     return `${b.tags.length} tag${b.tags.length === 1 ? "" : "s"}`;
//   if (b.type === "stepper")
//     return `${b.steps.length} step${b.steps.length === 1 ? "" : "s"}`;
//   if (b.type === "feedback") return b.prompt || "Feedback widget";
//   if (b.type === "table")
//     return `${b.rows.length} row${b.rows.length === 1 ? "" : "s"} \u00d7 ${b.columns.length} col${b.columns.length === 1 ? "" : "s"}`;
//   if (b.type === "divider") return b.style;
//   if (b.type === "richtext") {
//     const plain = (b.html || "").replace(/<[^>]+>/g, "").trim();
//     return plain || "Empty";
//   }
//   return "";
// }

// function ColumnBlockList({ blocks, onChange }) {
//   const [addType, setAddType] = useState("paragraph");
//   const nestedTypes = Object.entries(BLOCK_TYPES).filter(
//     ([k]) => k !== "columns",
//   );

//   const updateBlock = (idx, updated) => {
//     const next = [...blocks];
//     next[idx] = updated;
//     onChange(next);
//   };
//   const removeBlock = (idx) => onChange(blocks.filter((_, i) => i !== idx));
//   const moveBlock = (from, to) => {
//     const next = [...blocks];
//     const [item] = next.splice(from, 1);
//     next.splice(to, 0, item);
//     onChange(next);
//   };
//   const addBlock = () => onChange([...blocks, emptyBlockFor(addType)]);

//   return (
//     <div>
//       {blocks.map((b, i) => (
//         <BlockCard
//           key={b.id}
//           block={b}
//           index={i}
//           total={blocks.length}
//           onChange={(updated) => updateBlock(i, updated)}
//           onRemove={removeBlock}
//           onMove={moveBlock}
//         />
//       ))}
//       <div
//         style={{
//           display: "flex",
//           gap: 8,
//           background: "#FAF9F4",
//           border: "1px dashed #C7C4B6",
//           borderRadius: 9,
//           padding: 10,
//           alignItems: "center",
//         }}
//       >
//         <select
//           style={{
//             ...selectStyle,
//             width: "auto",
//             flex: 1,
//             fontSize: 12.5,
//             padding: "6px 9px",
//           }}
//           value={addType}
//           onChange={(e) => setAddType(e.target.value)}
//         >
//           {nestedTypes.map(([k, v]) => (
//             <option key={k} value={k}>
//               {v.label}
//             </option>
//           ))}
//         </select>
//         <button
//           onClick={addBlock}
//           style={{
//             display: "inline-flex",
//             alignItems: "center",
//             gap: 5,
//             fontSize: 12,
//             fontWeight: 600,
//             padding: "6px 11px",
//             borderRadius: 7,
//             border: "none",
//             background: "#1B2340",
//             color: "#fff",
//             cursor: "pointer",
//             whiteSpace: "nowrap",
//           }}
//         >
//           <Plus size={12} /> Add block
//         </button>
//       </div>
//     </div>
//   );
// }

// function BlockFields({ block, patch, onChange }) {
//   switch (block.type) {
//     case "heading":
//       return (
//         <>
//           <Field label="Level">
//             <select
//               style={selectStyle}
//               value={block.level}
//               onChange={(e) => patch("level", e.target.value)}
//             >
//               {["h1", "h2", "h3", "h4"].map((l) => (
//                 <option key={l} value={l}>
//                   {l.toUpperCase()}
//                 </option>
//               ))}
//             </select>
//           </Field>
//           <Field label="Heading text">
//             <input
//               style={inputStyle}
//               value={block.text}
//               onChange={(e) => patch("text", e.target.value)}
//               placeholder="Section heading"
//             />
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );
//     case "paragraph":
//       return (
//         <>
//           <Field label="Paragraph text">
//             <textarea
//               style={textareaStyle}
//               value={block.text}
//               onChange={(e) => patch("text", e.target.value)}
//               placeholder="Write the paragraph copy..."
//             />
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );
//     case "callout":
//       return (
//         <>
//           <Field label="Style">
//             <select
//               style={selectStyle}
//               value={block.style}
//               onChange={(e) => patch("style", e.target.value)}
//             >
//               {["info", "warning", "success", "error"].map((s) => (
//                 <option key={s} value={s}>
//                   {s}
//                 </option>
//               ))}
//             </select>
//           </Field>
//           <Field label="Callout text">
//             <textarea
//               style={textareaStyle}
//               value={block.text}
//               onChange={(e) => patch("text", e.target.value)}
//               placeholder="Warning or note copy..."
//             />
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );
//     case "list":
//       return (
//         <>
//           <Field label="Style">
//             <select
//               style={selectStyle}
//               value={block.style}
//               onChange={(e) => patch("style", e.target.value)}
//             >
//               <option value="bullet">Bullet</option>
//               <option value="number">Numbered</option>
//             </select>
//           </Field>
//           <Field label="Items">
//             {block.items.map((item, i) => (
//               <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
//                 <input
//                   style={inputStyle}
//                   value={item}
//                   onChange={(e) => {
//                     const items = [...block.items];
//                     items[i] = e.target.value;
//                     patch("items", items);
//                   }}
//                   placeholder={`Item ${i + 1}`}
//                 />
//                 <IconBtn
//                   title="Remove item"
//                   danger
//                   onClick={() =>
//                     patch(
//                       "items",
//                       block.items.filter((_, idx) => idx !== i),
//                     )
//                   }
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//             ))}
//             <button
//               onClick={() => patch("items", [...block.items, ""])}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 marginTop: 2,
//                 fontSize: 13,
//                 padding: "6px 10px",
//                 borderRadius: 7,
//                 border: "1px dashed #C7C4B6",
//                 background: "transparent",
//                 color: "#5F5E5A",
//                 cursor: "pointer",
//               }}
//             >
//               <Plus size={13} /> Add item
//             </button>
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );
//     case "slider":
//       return (
//         <>
//           {block.images.map((img, i) => (
//             <div
//               key={i}
//               style={{
//                 border: "1px solid #EDEBE0",
//                 borderRadius: 9,
//                 padding: 12,
//                 marginBottom: 10,
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   marginBottom: 8,
//                 }}
//               >
//                 <span
//                   style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
//                 >
//                   Slide {i + 1}
//                 </span>
//                 <IconBtn
//                   title="Remove slide"
//                   danger
//                   onClick={() =>
//                     patch(
//                       "images",
//                       block.images.filter((_, idx) => idx !== i),
//                     )
//                   }
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//               <ImageKeyField
//                 value={img.image_key}
//                 onChange={(v) => {
//                   const images = [...block.images];
//                   images[i] = { ...images[i], image_key: v };
//                   patch("images", images);
//                 }}
//                 prefix="slide"
//               />
//               <MediaUploadField
//                 label="Image"
//                 value={img.url}
//                 onChange={(url) => {
//                   const images = [...block.images];
//                   images[i] = { ...images[i], url };
//                   patch("images", images);
//                 }}
//                 accept="image/*"
//               />
//               <Field label="Caption">
//                 <input
//                   style={inputStyle}
//                   value={img.caption}
//                   onChange={(e) => {
//                     const images = [...block.images];
//                     images[i] = { ...images[i], caption: e.target.value };
//                     patch("images", images);
//                   }}
//                   placeholder="What this slide shows"
//                 />
//               </Field>
//               <Field label="Alt text">
//                 <input
//                   style={inputStyle}
//                   value={img.alt}
//                   onChange={(e) => {
//                     const images = [...block.images];
//                     images[i] = { ...images[i], alt: e.target.value };
//                     patch("images", images);
//                   }}
//                   placeholder="Accessible description"
//                 />
//               </Field>
//               <ImageDimensionFields
//                 width={img.width || "100%"}
//                 height={img.height || "220px"}
//                 objectFit={img.objectFit || "cover"}
//                 onChange={(fields) => {
//                   const images = [...block.images];
//                   images[i] = { ...images[i], ...fields };
//                   patch("images", images);
//                 }}
//               />
//             </div>
//           ))}
//           <button
//             onClick={() =>
//               patch("images", [...block.images, emptyImageValue("slider_step")])
//             }
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 13,
//               padding: "6px 10px",
//               borderRadius: 7,
//               border: "1px dashed #C7C4B6",
//               background: "transparent",
//               color: "#5F5E5A",
//               cursor: "pointer",
//             }}
//           >
//             <Plus size={13} /> Add slide
//           </button>
//         </>
//       );
//     case "image":
//       return (
//         <>
//           <ImageKeyField
//             value={block.image_key}
//             onChange={(v) => patch("image_key", v)}
//             prefix="image"
//           />
//           <MediaUploadField
//             label="Image"
//             value={block.url}
//             onChange={(url) => patch("url", url)}
//             accept="image/*"
//           />
//           <Field label="Caption">
//             <input
//               style={inputStyle}
//               value={block.caption}
//               onChange={(e) => patch("caption", e.target.value)}
//               placeholder="Figure caption"
//             />
//           </Field>
//           <Field
//             label="Container align"
//             hint="Position of the image within the document width"
//           >
//             <div style={{ display: "flex", gap: 6 }}>
//               {[
//                 { value: "left", label: "Left", icon: AlignLeft },
//                 { value: "center", label: "Center", icon: AlignCenter },
//                 { value: "right", label: "Right", icon: AlignRight },
//               ].map((opt) => {
//                 const Ic = opt.icon;
//                 return (
//                   <IconBtn
//                     key={opt.value}
//                     title={opt.label}
//                     active={block.align === opt.value}
//                     onClick={() => patch("align", opt.value)}
//                   >
//                     <Ic size={14} />
//                   </IconBtn>
//                 );
//               })}
//             </div>
//           </Field>
//           <ImageDimensionFields
//             width={block.width || "100%"}
//             height={block.height || "auto"}
//             objectFit={block.objectFit || "cover"}
//             onChange={(fields) =>
//               Object.entries(fields).forEach(([k, v]) => patch(k, v))
//             }
//           />
//         </>
//       );
//     case "columns": {
//       const columns = block.columns || [];
//       const setColumns = (next) => patch("columns", next);
//       const addColumn = () => setColumns([...columns, emptyColumn()]);
//       const removeColumn = (ci) =>
//         setColumns(columns.filter((_, i) => i !== ci));
//       const updateColumnBlocks = (ci, newBlocks) => {
//         setColumns(
//           columns.map((c, i) => (i === ci ? { ...c, blocks: newBlocks } : c)),
//         );
//       };
//       return (
//         <>
//           <div
//             style={{
//               display: "flex",
//               gap: 10,
//               marginBottom: 4,
//               flexWrap: "wrap",
//             }}
//           >
//             <Field label="Gap between columns" hint="in pixels">
//               <input
//                 type="number"
//                 style={{ ...inputStyle, width: 120 }}
//                 value={block.gap}
//                 onChange={(e) => patch("gap", Number(e.target.value) || 0)}
//               />
//             </Field>
//             <Field
//               label="Columns"
//               hint={`${columns.length} column${columns.length === 1 ? "" : "s"}`}
//             >
//               <button
//                 onClick={addColumn}
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 6,
//                   fontSize: 13,
//                   fontWeight: 600,
//                   padding: "9px 14px",
//                   borderRadius: 8,
//                   border: "1px dashed #C7C4B6",
//                   background: "transparent",
//                   color: "#5F5E5A",
//                   cursor: "pointer",
//                 }}
//               >
//                 <Plus size={13} /> Add column
//               </button>
//             </Field>
//           </div>
//           <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
//             {columns.map((col, ci) => (
//               <div
//                 key={col.id}
//                 style={{
//                   border: "1px solid #EDEBE0",
//                   borderRadius: 9,
//                   padding: 12,
//                   flex: "1 1 240px",
//                   minWidth: 240,
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 10,
//                   }}
//                 >
//                   <span
//                     style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
//                   >
//                     Column {ci + 1} · {col.blocks.length} block
//                     {col.blocks.length === 1 ? "" : "s"}
//                   </span>
//                   {columns.length > 1 && (
//                     <IconBtn
//                       title="Remove column"
//                       danger
//                       onClick={() => removeColumn(ci)}
//                     >
//                       <Trash2 size={13} />
//                     </IconBtn>
//                   )}
//                 </div>
//                 <ColumnBlockList
//                   blocks={col.blocks}
//                   onChange={(nb) => updateColumnBlocks(ci, nb)}
//                 />
//               </div>
//             ))}
//           </div>
//         </>
//       );
//     }
//     case "code":
//       return (
//         <>
//           <Field label="Language">
//             <input
//               style={inputStyle}
//               value={block.language}
//               onChange={(e) => patch("language", e.target.value)}
//               placeholder="python"
//             />
//           </Field>
//           <Field label="Code">
//             <textarea
//               style={{ ...monoStyle, minHeight: 140 }}
//               value={block.code}
//               onChange={(e) => patch("code", e.target.value)}
//               placeholder="Paste the code sample..."
//             />
//           </Field>
//         </>
//       );
//     case "request_payload":
//     case "success_response":
//       return (
//         <JsonField
//           label="JSON data"
//           value={block.data}
//           onChange={(v) => patch("data", v)}
//         />
//       );
//     case "video":
//       return (
//         <>
//           <Field label="Provider">
//             <select
//               style={selectStyle}
//               value={block.provider}
//               onChange={(e) => patch("provider", e.target.value)}
//             >
//               {["youtube", "vimeo", "loom", "mp4"].map((p) => (
//                 <option key={p} value={p}>
//                   {p === "mp4" ? "Direct MP4" : p[0].toUpperCase() + p.slice(1)}
//                 </option>
//               ))}
//             </select>
//           </Field>
//           {block.provider === "mp4" ? (
//             <MediaUploadField
//               label="Video file"
//               value={block.url}
//               onChange={(url) => patch("url", url)}
//               accept="video/*"
//             />
//           ) : (
//             <Field label="Video URL" hint="Paste the share/watch link">
//               <input
//                 style={inputStyle}
//                 value={block.url}
//                 onChange={(e) => patch("url", e.target.value)}
//                 placeholder="https://..."
//               />
//             </Field>
//           )}
//           <Field label="Caption">
//             <input
//               style={inputStyle}
//               value={block.caption}
//               onChange={(e) => patch("caption", e.target.value)}
//               placeholder="Optional caption"
//             />
//           </Field>
//           <Field label="Aspect ratio">
//             <select
//               style={selectStyle}
//               value={block.aspectRatio}
//               onChange={(e) => patch("aspectRatio", e.target.value)}
//             >
//               {["16:9", "4:3", "1:1", "9:16"].map((r) => (
//                 <option key={r} value={r}>
//                   {r}
//                 </option>
//               ))}
//             </select>
//           </Field>
//         </>
//       );
//     case "audio":
//       return (
//         <>
//           <MediaUploadField
//             label="Audio file"
//             value={block.url}
//             onChange={(url) => patch("url", url)}
//             accept="audio/*"
//           />
//           <Field label="Title">
//             <input
//               style={inputStyle}
//               value={block.title}
//               onChange={(e) => patch("title", e.target.value)}
//               placeholder="Episode or clip title"
//             />
//           </Field>
//           <Field label="Subtitle">
//             <input
//               style={inputStyle}
//               value={block.subtitle}
//               onChange={(e) => patch("subtitle", e.target.value)}
//               placeholder="e.g. Podcast · Voice note"
//             />
//           </Field>
//           <Field label="Duration" hint="Display only, e.g. 3:45">
//             <input
//               style={{ ...inputStyle, width: 120 }}
//               value={block.duration}
//               onChange={(e) => patch("duration", e.target.value)}
//               placeholder="3:45"
//             />
//           </Field>
//         </>
//       );
//     case "file":
//       return (
//         <>
//           <MediaUploadField
//             label="File"
//             value={block.url}
//             onChange={(url) => patch("url", url)}
//             accept="*/*"
//           />
//           <Field label="Filename">
//             <input
//               style={inputStyle}
//               value={block.filename}
//               onChange={(e) => patch("filename", e.target.value)}
//               placeholder="onboarding-guide.pdf"
//             />
//           </Field>
//           <div
//             style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}
//           >
//             <Field label="File type">
//               <select
//                 style={selectStyle}
//                 value={block.filetype}
//                 onChange={(e) => patch("filetype", e.target.value)}
//               >
//                 {["PDF", "ZIP", "CSV", "DOCX", "XLSX", "Other"].map((t) => (
//                   <option key={t} value={t}>
//                     {t}
//                   </option>
//                 ))}
//               </select>
//             </Field>
//             <Field label="File size" hint="Display only">
//               <input
//                 style={inputStyle}
//                 value={block.filesize}
//                 onChange={(e) => patch("filesize", e.target.value)}
//                 placeholder="2.4 MB"
//               />
//             </Field>
//           </div>
//         </>
//       );
//     case "lottie":
//       return (
//         <>
//           <Field label="Animation URL" hint="Link to a .json or .lottie file">
//             <input
//               style={inputStyle}
//               value={block.url}
//               onChange={(e) => patch("url", e.target.value)}
//               placeholder="https://.../animation.json"
//             />
//           </Field>
//           <Field label="Caption">
//             <input
//               style={inputStyle}
//               value={block.caption}
//               onChange={(e) => patch("caption", e.target.value)}
//               placeholder="Optional caption"
//             />
//           </Field>
//           <div
//             style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}
//           >
//             <Field label="Width" hint="px or %">
//               <input
//                 style={inputStyle}
//                 value={block.width}
//                 onChange={(e) => patch("width", e.target.value)}
//                 placeholder="100%"
//               />
//             </Field>
//             <Field label="Height" hint="px">
//               <input
//                 style={inputStyle}
//                 value={block.height}
//                 onChange={(e) => patch("height", e.target.value)}
//                 placeholder="280px"
//               />
//             </Field>
//           </div>
//           <div style={{ display: "flex", gap: 16, marginTop: 4 }}>
//             <label
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 color: "#5F5E5A",
//               }}
//             >
//               <input
//                 type="checkbox"
//                 checked={block.loop}
//                 onChange={(e) => patch("loop", e.target.checked)}
//               />
//               Loop
//             </label>
//             <label
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 color: "#5F5E5A",
//               }}
//             >
//               <input
//                 type="checkbox"
//                 checked={block.autoplay}
//                 onChange={(e) => patch("autoplay", e.target.checked)}
//               />
//               Autoplay
//             </label>
//           </div>
//         </>
//       );
//     case "button":
//       return (
//         <>
//           <Field label="Label">
//             <input
//               style={inputStyle}
//               value={block.label}
//               onChange={(e) => patch("label", e.target.value)}
//               placeholder="Get API Key"
//             />
//           </Field>
//           <Field label="Link URL">
//             <input
//               style={inputStyle}
//               value={block.url}
//               onChange={(e) => patch("url", e.target.value)}
//               placeholder="https://..."
//             />
//           </Field>
//           <Field label="Style">
//             <select
//               style={selectStyle}
//               value={block.style}
//               onChange={(e) => patch("style", e.target.value)}
//             >
//               <option value="primary">Primary</option>
//               <option value="secondary">Secondary</option>
//             </select>
//           </Field>
//           <Field label="Align">
//             <div style={{ display: "flex", gap: 6 }}>
//               {[
//                 { value: "left", label: "Left", icon: AlignLeft },
//                 { value: "center", label: "Center", icon: AlignCenter },
//                 { value: "right", label: "Right", icon: AlignRight },
//               ].map((opt) => {
//                 const Ic = opt.icon;
//                 return (
//                   <IconBtn
//                     key={opt.value}
//                     title={opt.label}
//                     active={(block.align || "left") === opt.value}
//                     onClick={() => patch("align", opt.value)}
//                   >
//                     <Ic size={14} />
//                   </IconBtn>
//                 );
//               })}
//             </div>
//           </Field>
//           <label
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 13,
//               color: "#5F5E5A",
//               marginTop: 4,
//             }}
//           >
//             <input
//               type="checkbox"
//               checked={block.newTab}
//               onChange={(e) => patch("newTab", e.target.checked)}
//             />
//             Open in new tab
//           </label>
//         </>
//       );
//     case "badges":
//       return (
//         <Field label="Tags">
//           {block.tags.map((tag, i) => (
//             <div
//               key={tag.id}
//               style={{
//                 display: "flex",
//                 gap: 6,
//                 marginBottom: 6,
//                 alignItems: "center",
//               }}
//             >
//               <input
//                 style={inputStyle}
//                 value={tag.label}
//                 onChange={(e) => {
//                   const tags = [...block.tags];
//                   tags[i] = { ...tags[i], label: e.target.value };
//                   patch("tags", tags);
//                 }}
//                 placeholder="Beta"
//               />
//               <select
//                 style={{ ...selectStyle, width: 110, flexShrink: 0 }}
//                 value={tag.tone}
//                 onChange={(e) => {
//                   const tags = [...block.tags];
//                   tags[i] = { ...tags[i], tone: e.target.value };
//                   patch("tags", tags);
//                 }}
//               >
//                 {Object.keys(RAMP).map((tone) => (
//                   <option key={tone} value={tone}>
//                     {tone}
//                   </option>
//                 ))}
//               </select>
//               <IconBtn
//                 title="Remove tag"
//                 danger
//                 onClick={() =>
//                   patch(
//                     "tags",
//                     block.tags.filter((_, idx) => idx !== i),
//                   )
//                 }
//               >
//                 <Trash2 size={13} />
//               </IconBtn>
//             </div>
//           ))}
//           <button
//             onClick={() =>
//               patch("tags", [
//                 ...block.tags,
//                 { id: genKey("tag"), label: "", tone: "blue" },
//               ])
//             }
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               marginTop: 2,
//               fontSize: 13,
//               padding: "6px 10px",
//               borderRadius: 7,
//               border: "1px dashed #C7C4B6",
//               background: "transparent",
//               color: "#5F5E5A",
//               cursor: "pointer",
//             }}
//           >
//             <Plus size={13} /> Add tag
//           </button>
//         </Field>
//       );
//     case "stepper":
//       return (
//         <>
//           {block.steps.map((step, i) => (
//             <div
//               key={step.id}
//               style={{
//                 border: "1px solid #EDEBE0",
//                 borderRadius: 9,
//                 padding: 12,
//                 marginBottom: 10,
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   marginBottom: 8,
//                 }}
//               >
//                 <span
//                   style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
//                 >
//                   Step {i + 1}
//                 </span>
//                 <IconBtn
//                   title="Remove step"
//                   danger
//                   onClick={() =>
//                     patch(
//                       "steps",
//                       block.steps.filter((_, idx) => idx !== i),
//                     )
//                   }
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//               <Field label="Step title">
//                 <input
//                   style={inputStyle}
//                   value={step.title}
//                   onChange={(e) => {
//                     const steps = [...block.steps];
//                     steps[i] = { ...steps[i], title: e.target.value };
//                     patch("steps", steps);
//                   }}
//                   placeholder="Install the SDK"
//                 />
//               </Field>
//               <Field label="Step details">
//                 <textarea
//                   style={textareaStyle}
//                   value={step.text}
//                   onChange={(e) => {
//                     const steps = [...block.steps];
//                     steps[i] = { ...steps[i], text: e.target.value };
//                     patch("steps", steps);
//                   }}
//                   placeholder="What the reader should do..."
//                 />
//               </Field>
//             </div>
//           ))}
//           <button
//             onClick={() =>
//               patch("steps", [
//                 ...block.steps,
//                 { id: genKey("step"), title: "", text: "" },
//               ])
//             }
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 13,
//               padding: "6px 10px",
//               borderRadius: 7,
//               border: "1px dashed #C7C4B6",
//               background: "transparent",
//               color: "#5F5E5A",
//               cursor: "pointer",
//             }}
//           >
//             <Plus size={13} /> Add step
//           </button>
//         </>
//       );
//     case "feedback":
//       return (
//         <Field label="Prompt text">
//           <input
//             style={inputStyle}
//             value={block.prompt}
//             onChange={(e) => patch("prompt", e.target.value)}
//             placeholder="Was this helpful?"
//           />
//         </Field>
//       );
//     case "table":
//       return (
//         <>
//           <Field label="Columns">
//             {block.columns.map((col, i) => (
//               <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
//                 <input
//                   style={inputStyle}
//                   value={col}
//                   onChange={(e) => {
//                     const columns = [...block.columns];
//                     columns[i] = e.target.value;
//                     onChange({ ...block, columns });
//                   }}
//                   placeholder={`Column ${i + 1}`}
//                 />
//                 <IconBtn
//                   title="Remove column"
//                   danger
//                   onClick={() => {
//                     const columns = block.columns.filter((_, idx) => idx !== i);
//                     const rows = block.rows.map((row) =>
//                       row.filter((_, idx) => idx !== i),
//                     );
//                     onChange({ ...block, columns, rows });
//                   }}
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//             ))}
//             <button
//               onClick={() => {
//                 const columns = [
//                   ...block.columns,
//                   `Column ${block.columns.length + 1}`,
//                 ];
//                 const rows = block.rows.map((row) => [...row, ""]);
//                 onChange({ ...block, columns, rows });
//               }}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "6px 10px",
//                 borderRadius: 7,
//                 border: "1px dashed #C7C4B6",
//                 background: "transparent",
//                 color: "#5F5E5A",
//                 cursor: "pointer",
//               }}
//             >
//               <Plus size={13} /> Add column
//             </button>
//           </Field>
//           <Field label="Rows">
//             {block.rows.map((row, ri) => (
//               <div
//                 key={ri}
//                 style={{
//                   display: "flex",
//                   gap: 6,
//                   marginBottom: 6,
//                   alignItems: "center",
//                 }}
//               >
//                 {row.map((cell, ci) => (
//                   <input
//                     key={ci}
//                     style={inputStyle}
//                     value={cell}
//                     onChange={(e) => {
//                       const rows = block.rows.map((r) => [...r]);
//                       rows[ri][ci] = e.target.value;
//                       patch("rows", rows);
//                     }}
//                     placeholder={block.columns[ci] || `Col ${ci + 1}`}
//                   />
//                 ))}
//                 <IconBtn
//                   title="Remove row"
//                   danger
//                   onClick={() =>
//                     patch(
//                       "rows",
//                       block.rows.filter((_, idx) => idx !== ri),
//                     )
//                   }
//                 >
//                   <Trash2 size={13} />
//                 </IconBtn>
//               </div>
//             ))}
//             <button
//               onClick={() =>
//                 patch("rows", [...block.rows, block.columns.map(() => "")])
//               }
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "6px 10px",
//                 borderRadius: 7,
//                 border: "1px dashed #C7C4B6",
//                 background: "transparent",
//                 color: "#5F5E5A",
//                 cursor: "pointer",
//               }}
//             >
//               <Plus size={13} /> Add row
//             </button>
//           </Field>
//         </>
//       );
//     case "divider":
//       return (
//         <>
//           <Field label="Style">
//             <select
//               style={selectStyle}
//               value={block.style}
//               onChange={(e) => patch("style", e.target.value)}
//             >
//               <option value="solid">Solid line</option>
//               <option value="dashed">Dashed line</option>
//               <option value="space">Blank space only</option>
//             </select>
//           </Field>
//           <Field label="Spacing" hint="Vertical space in pixels">
//             <input
//               type="number"
//               style={{ ...inputStyle, width: 120 }}
//               value={block.spacing}
//               onChange={(e) => patch("spacing", Number(e.target.value) || 0)}
//             />
//           </Field>
//         </>
//       );

//     case "richtext":
//       return (
//         <>
//           <Field label="Content">
//             <div
//               style={{
//                 border: "1px solid #DEDCD1",
//                 borderRadius: 8,
//                 // overflow: "hidden",
//                 background: "#fff",
//                 overflow: "visible",
//               }}
//             >
//               <ReactQuill
//                 theme="snow"
//                 value={block.html}
//                 onChange={(html) => patch("html", html)}
//                 placeholder="Write rich content..."
//                 modules={{
//                   toolbar: [
//                     [{ header: [1, 2, 3, false] }],
//                     ["bold", "italic", "underline", "strike"],

//                     // [{ color: [] }, { background: [] }],
//                     [{ list: "ordered" }, { list: "bullet" }],
//                     ["blockquote", "code-block", "link"],
//                     ["clean"],
//                   ],
//                 }}
//               />
//             </div>
//           </Field>
//           <AlignPicker
//             value={block.align || "left"}
//             onChange={(v) => patch("align", v)}
//           />
//         </>
//       );

//     default:
//       return null;
//   }
// }

// function ImageKeyField({ value, onChange, prefix }) {
//   return (
//     <Field
//       label="Image key"
//       hint="Used to reference this image elsewhere in the document"
//     >
//       <div style={{ display: "flex", gap: 6 }}>
//         <div style={{ position: "relative", flex: 1 }}>
//           <KeyRound
//             size={13}
//             color="#9A988E"
//             style={{ position: "absolute", left: 10, top: 12 }}
//           />
//           <input
//             style={{ ...monoStyle, paddingLeft: 30 }}
//             value={value}
//             onChange={(e) => onChange(e.target.value)}
//             placeholder="unique_image_key"
//           />
//         </div>
//         <IconBtn
//           title="Generate a new key"
//           onClick={() => onChange(genKey(prefix))}
//         >
//           <RefreshCw size={13} />
//         </IconBtn>
//       </div>
//     </Field>
//   );
// }

// function PreviewImg({ src, alt, style }) {
//   const [broken, setBroken] = useState(false);
//   if (!src || broken) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           gap: 6,
//           background: "#F1EFE8",
//           border: "1px dashed #C7C4B6",
//           borderRadius: 8,
//           color: "#8A8878",
//           fontSize: 12,
//           minHeight: 110,
//           ...style,
//         }}
//       >
//         <ImageOff size={18} />
//         <span>{alt || "Image"}</span>
//       </div>
//     );
//   }
//   return (
//     <img
//       src={src}
//       alt={alt}
//       onError={() => setBroken(true)}
//       style={{ display: "block", borderRadius: 8, ...style }}
//     />
//   );
// }

// function toResponsiveSize(v) {
//   return v;
// }

// function NavButton({ side, onClick, visible }) {
//   return (
//     <button
//       onClick={onClick}
//       aria-label={side === "left" ? "Previous slide" : "Next slide"}
//       style={{
//         position: "absolute",
//         top: "50%",
//         [side]: 8,
//         transform: "translateY(-50%)",
//         border: "none",
//         background: "rgba(255,255,255,0.9)",
//         borderRadius: "50%",
//         width: 30,
//         height: 30,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         cursor: "pointer",
//         boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
//         opacity: visible ? 1 : 0,
//         transition: "opacity 150ms ease, transform 150ms ease",
//       }}
//       onMouseEnter={(e) =>
//         (e.currentTarget.style.transform = "translateY(-50%) scale(1.08)")
//       }
//       onMouseLeave={(e) =>
//         (e.currentTarget.style.transform = "translateY(-50%)")
//       }
//     >
//       {side === "left" ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
//     </button>
//   );
// }

// function SliderPreview({ images }) {
//   const [i, setI] = useState(0);
//   const [isHovering, setIsHovering] = useState(false);

//   if (!images?.length) return null;
//   const img = images[Math.min(i, images.length - 1)];
//   const hasMultiple = images.length > 1;

//   const go = (delta) =>
//     setI((v) => (v + delta + images.length) % images.length);

//   return (
//     <div
//       style={{
//         border: "1px solid #E4E2D8",
//         borderRadius: 12,
//         overflow: "hidden",
//         background: "#FAF9F4",
//         width: "100%",
//         boxSizing: "border-box",
//         boxShadow: "0 1px 2px rgba(32,32,28,0.04)",
//       }}
//     >
//       <div
//         style={{ position: "relative" }}
//         onMouseEnter={() => setIsHovering(true)}
//         onMouseLeave={() => setIsHovering(false)}
//       >
//         <PreviewImg
//           key={img.url}
//           src={img.url}
//           alt={img.alt}
//           style={{
//             width: img.width || "100%",
//             height: toResponsiveSize(img.height || "220px"),
//             objectFit: img.objectFit || "cover",
//             borderRadius: 0,
//             display: "block",
//             animation: "spFade 200ms ease",
//           }}
//         />

//         {hasMultiple && (
//           <div
//             style={{
//               position: "absolute",
//               top: 10,
//               right: 10,
//               padding: "3px 8px",
//               borderRadius: 999,
//               background: "rgba(32,32,28,0.55)",
//               backdropFilter: "blur(2px)",
//               color: "#fff",
//               fontSize: 11,
//               fontWeight: 500,
//               letterSpacing: 0.2,
//             }}
//           >
//             {i + 1} / {images.length}
//           </div>
//         )}

//         {hasMultiple && (
//           <>
//             <NavButton
//               side="left"
//               onClick={() => go(-1)}
//               visible={isHovering}
//             />
//             <NavButton
//               side="right"
//               onClick={() => go(1)}
//               visible={isHovering}
//             />
//           </>
//         )}
//       </div>

//       <div
//         style={{
//           padding: "10px 14px",
//           display: "flex",
//           alignItems: "center",
//           gap: 10,
//         }}
//       >
//         <div style={{ flex: 1, minWidth: 0 }}>
//           <div
//             style={{
//               fontSize: "clamp(12.5px, 3.2vw, 13px)",
//               color: "#20201C",
//               lineHeight: 1.5,
//               wordBreak: "break-word",
//             }}
//           >
//             {img.caption || "No caption"}
//           </div>
//         </div>

//         {hasMultiple && (
//           <div style={{ display: "flex", gap: 5, flexShrink: 0 }}>
//             {images.map((_, idx) => (
//               <button
//                 key={idx}
//                 onClick={() => setI(idx)}
//                 aria-label={`Go to slide ${idx + 1}`}
//                 style={{
//                   width: idx === i ? 16 : 6,
//                   height: 6,
//                   borderRadius: 999,
//                   border: "none",
//                   padding: 0,
//                   cursor: "pointer",
//                   background: idx === i ? "#20201C" : "#DAD8CC",
//                   transition: "all 150ms ease",
//                 }}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function toEmbedUrl(provider, url) {
//   if (!url) return "";
//   if (provider === "mp4") return url;
//   if (provider === "youtube") {
//     const idMatch = url.match(/(?:youtu\.be\/|v=|embed\/)([a-zA-Z0-9_-]{6,})/);
//     return idMatch ? `https://www.youtube.com/embed/${idMatch[1]}` : url;
//   }
//   if (provider === "vimeo") {
//     const idMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
//     return idMatch ? `https://player.vimeo.com/video/${idMatch[1]}` : url;
//   }
//   if (provider === "loom") {
//     const idMatch = url.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
//     return idMatch ? `https://www.loom.com/embed/${idMatch[1]}` : url;
//   }
//   return url;
// }

// const FILE_TYPE_ICONS = {
//   PDF: FileText,
//   ZIP: FileArchive,
//   CSV: FileSpreadsheet,
//   DOCX: FileText,
//   XLSX: FileSpreadsheet,
//   Other: FileGeneric,
// };

// function RenderedBlock({ block }) {
//   switch (block.type) {
//     case "heading": {
//       const sizes = { h1: 24, h2: 20, h3: 17, h4: 15 };
//       return (
//         <div
//           style={{
//             fontSize: sizes[block.level] || 18,
//             fontWeight: 600,
//             color: "#1B2340",
//             margin: "4px 0",
//             textAlign: block.align || "left",
//           }}
//         >
//           {block.text || (
//             <span style={{ color: "#C7C4B6" }}>Empty heading</span>
//           )}
//         </div>
//       );
//     }
//     case "paragraph":
//       return (
//         <p
//           style={{
//             fontSize: 14,
//             lineHeight: 1.7,
//             color: "#3A3A34",
//             margin: "4px 0",
//             textAlign: block.align || "left",
//           }}
//         >
//           {block.text || (
//             <span style={{ color: "#C7C4B6" }}>Empty paragraph</span>
//           )}
//         </p>
//       );
//     case "callout": {
//       const s = CALLOUT_STYLE[block.style] || CALLOUT_STYLE.info;
//       const Icon = s.icon;
//       return (
//         <div
//           style={{
//             display: "flex",
//             gap: 10,
//             background: s.bg,
//             borderLeft: `3px solid ${s.border}`,
//             borderRadius: 6,
//             padding: "10px 12px",
//             textAlign: block.align || "left",
//           }}
//         >
//           <Icon
//             size={16}
//             color={s.text}
//             style={{ flexShrink: 0, marginTop: 1 }}
//           />
//           <span
//             style={{ fontSize: 13.5, color: s.text, lineHeight: 1.6, flex: 1 }}
//           >
//             {block.text || "Empty callout"}
//           </span>
//         </div>
//       );
//     }
//     case "list": {
//       const Tag = block.style === "number" ? "ol" : "ul";
//       return (
//         <Tag
//           style={{
//             margin: "4px 0",
//             paddingLeft: 20,
//             textAlign: block.align || "left",
//           }}
//         >
//           {block.items.map((it, i) => (
//             <li
//               key={i}
//               style={{ fontSize: 14, color: "#3A3A34", lineHeight: 1.7 }}
//             >
//               {it || <span style={{ color: "#C7C4B6" }}>Empty item</span>}
//             </li>
//           ))}
//         </Tag>
//       );
//     }
//     case "slider":
//       return <SliderPreview images={block.images} />;
//     case "image": {
//       const align = block.align || "center";
//       const marginLeft = align === "left" ? 0 : "auto";
//       const marginRight = align === "right" ? 0 : "auto";
//       return (
//         <div style={{ textAlign: align }}>
//           <PreviewImg
//             src={block.url}
//             alt={block.alt}
//             style={{
//               width: block.width || "100%",
//               height: block.height || "auto",
//               objectFit: block.objectFit || "cover",
//               maxWidth: "100%",
//               marginLeft,
//               marginRight,
//             }}
//           />
//           {block.caption && (
//             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
//               {block.caption}
//             </div>
//           )}
//         </div>
//       );
//     }
//     case "columns":
//       return (
//         <div
//           style={{ display: "flex", gap: block.gap ?? 20, flexWrap: "wrap" }}
//         >
//           {(block.columns || []).map((col) => (
//             <div
//               key={col.id}
//               style={{
//                 flex: "1 1 200px",
//                 minWidth: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 14,
//               }}
//             >
//               {col.blocks.map((b) => (
//                 <RenderedBlock key={b.id} block={b} />
//               ))}
//             </div>
//           ))}
//         </div>
//       );
//     case "code":
//       return (
//         <div
//           style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
//         >
//           <div
//             style={{
//               padding: "6px 12px",
//               fontSize: 11,
//               color: "#9BA6C7",
//               fontFamily: "'IBM Plex Mono', monospace",
//               borderBottom: "1px solid #2A335C",
//             }}
//           >
//             {block.language || "code"}
//           </div>
//           <pre
//             style={{
//               margin: 0,
//               padding: 12,
//               fontSize: 12.5,
//               color: "#E6EAF5",
//               fontFamily: "'IBM Plex Mono', monospace",
//               overflow: "auto",
//             }}
//           >
//             {block.code || "// empty"}
//           </pre>
//         </div>
//       );
//     case "request_payload":
//     case "success_response": {
//       const isSuccess = block.type === "success_response";
//       let pretty = block.data;
//       try {
//         pretty = JSON.stringify(JSON.parse(block.data), null, 2);
//       } catch {
//         /* keep raw */
//       }
//       return (
//         <div
//           style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               padding: "6px 12px",
//               borderBottom: "1px solid #2A335C",
//             }}
//           >
//             <span
//               style={{
//                 fontSize: 11,
//                 color: "#9BA6C7",
//                 fontFamily: "'IBM Plex Mono', monospace",
//               }}
//             >
//               {isSuccess ? "response" : "request payload"}
//             </span>
//             {isSuccess && (
//               <span
//                 style={{
//                   fontSize: 10,
//                   fontWeight: 600,
//                   color: "#27500A",
//                   background: "#C0DD97",
//                   borderRadius: 4,
//                   padding: "2px 6px",
//                 }}
//               >
//                 201 success
//               </span>
//             )}
//           </div>
//           <pre
//             style={{
//               margin: 0,
//               padding: 12,
//               fontSize: 12.5,
//               color: "#E6EAF5",
//               fontFamily: "'IBM Plex Mono', monospace",
//               overflow: "auto",
//             }}
//           >
//             {pretty}
//           </pre>
//         </div>
//       );
//     }
//     case "video": {
//       const ratios = {
//         "16:9": "56.25%",
//         "4:3": "75%",
//         "1:1": "100%",
//         "9:16": "177.78%",
//       };
//       const embedUrl = toEmbedUrl(block.provider, block.url);
//       return (
//         <div>
//           <div
//             style={{
//               position: "relative",
//               width: "100%",
//               paddingTop: ratios[block.aspectRatio] || "56.25%",
//               background: "#1B2340",
//               borderRadius: 8,
//               overflow: "hidden",
//             }}
//           >
//             {embedUrl ? (
//               block.provider === "mp4" ? (
//                 <video
//                   src={embedUrl}
//                   controls
//                   style={{
//                     position: "absolute",
//                     inset: 0,
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "cover",
//                   }}
//                 />
//               ) : (
//                 <iframe
//                   src={embedUrl}
//                   title={block.caption || "Video"}
//                   allow="autoplay; fullscreen; picture-in-picture"
//                   style={{
//                     position: "absolute",
//                     inset: 0,
//                     width: "100%",
//                     height: "100%",
//                     border: 0,
//                   }}
//                 />
//               )
//             ) : (
//               <div
//                 style={{
//                   position: "absolute",
//                   inset: 0,
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: 6,
//                   color: "#9BA6C7",
//                   fontSize: 12,
//                 }}
//               >
//                 <Video size={20} />
//                 <span>No video URL set</span>
//               </div>
//             )}
//           </div>
//           {block.caption && (
//             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
//               {block.caption}
//             </div>
//           )}
//         </div>
//       );
//     }
//     case "audio":
//       return (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "flex-start",
//             gap: 12,
//             border: "1px solid #E4E2D8",
//             borderRadius: 10,
//             padding: "12px 14px",
//             background: "#FBFAF6",
//           }}
//         >
//           <div
//             style={{
//               width: 36,
//               height: 36,
//               borderRadius: "50%",
//               background: "#EEEDFE",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             <Music2 size={16} color="#534AB7" />
//           </div>
//           <div style={{ flex: 1, minWidth: 0 }}>
//             <div style={{ fontSize: 13.5, fontWeight: 600, color: "#1B2340" }}>
//               {block.title || "Untitled audio"}
//             </div>
//             <div style={{ fontSize: 12, color: "#8A8878" }}>
//               {block.subtitle}
//               {block.subtitle && block.duration ? " · " : ""}
//               {block.duration}
//             </div>
//             {block.url ? (
//               <audio
//                 src={block.url}
//                 controls
//                 style={{ width: "100%", height: 32, marginTop: 6 }}
//               />
//             ) : (
//               <div style={{ fontSize: 12, color: "#C7C4B6", marginTop: 4 }}>
//                 No audio URL set
//               </div>
//             )}
//           </div>
//         </div>
//       );
//     case "file": {
//       const Icon = FILE_TYPE_ICONS[block.filetype] || FileGeneric;
//       return (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 12,
//             border: "1px solid #E4E2D8",
//             borderRadius: 10,
//             padding: "12px 14px",
//             background: "#FBFAF6",
//           }}
//         >
//           <div
//             style={{
//               width: 36,
//               height: 36,
//               borderRadius: 8,
//               background: "#E1F5EE",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             <Icon size={17} color="#0F6E56" />
//           </div>
//           <div style={{ flex: 1, minWidth: 0 }}>
//             <div
//               style={{
//                 fontSize: 13.5,
//                 fontWeight: 600,
//                 color: "#1B2340",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 whiteSpace: "nowrap",
//               }}
//             >
//               {block.filename || "Untitled file"}
//             </div>
//             <div style={{ fontSize: 12, color: "#8A8878" }}>
//               {block.filetype}
//               {block.filesize ? ` · ${block.filesize}` : ""}
//             </div>
//           </div>
//           <a
//             href={block.url || "#"}
//             target="_blank"
//             rel="noreferrer"
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 12.5,
//               fontWeight: 600,
//               padding: "7px 12px",
//               borderRadius: 7,
//               background: "#1B2340",
//               color: "#fff",
//               textDecoration: "none",
//               flexShrink: 0,
//             }}
//           >
//             <Download size={13} /> Download
//           </a>
//         </div>
//       );
//     }
//     case "lottie":
//       return (
//         <div>
//           <div
//             style={{
//               width: block.width || "100%",
//               height: block.height || "280px",
//               borderRadius: 8,
//               background: "#FBEAF0",
//               border: "1px dashed #ED93B1",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 6,
//               color: "#993556",
//             }}
//           >
//             <Sparkles size={20} />
//             <span
//               style={{ fontSize: 12, padding: "0 12px", textAlign: "center" }}
//             >
//               {block.url
//                 ? "Lottie animation (plays on the live site)"
//                 : "No animation URL set"}
//             </span>
//           </div>
//           {block.caption && (
//             <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
//               {block.caption}
//             </div>
//           )}
//         </div>
//       );
//     case "button": {
//       const align = block.align || "left";
//       const justify =
//         align === "center"
//           ? "center"
//           : align === "right"
//             ? "flex-end"
//             : "flex-start";
//       const primary = block.style !== "secondary";
//       return (
//         <div style={{ display: "flex", justifyContent: justify }}>
//           <a
//             href={block.url || "#"}
//             target={block.newTab ? "_blank" : undefined}
//             rel={block.newTab ? "noreferrer" : undefined}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 6,
//               fontSize: 13.5,
//               fontWeight: 600,
//               padding: "9px 18px",
//               borderRadius: 8,
//               textDecoration: "none",
//               background: primary ? "#1B2340" : "transparent",
//               color: primary ? "#fff" : "#1B2340",
//               border: primary ? "none" : "1px solid #1B2340",
//             }}
//           >
//             {block.label || "Button label"}
//           </a>
//         </div>
//       );
//     }
//     case "badges":
//       return (
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
//           {block.tags.map((tag) => {
//             const c = RAMP[tag.tone] || RAMP.blue;
//             return (
//               <span
//                 key={tag.id}
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   padding: "4px 10px",
//                   borderRadius: 999,
//                   background: c[50],
//                   color: c[800],
//                   border: `1px solid ${c[200]}`,
//                 }}
//               >
//                 {tag.label || "Tag"}
//               </span>
//             );
//           })}
//         </div>
//       );
//     case "stepper":
//       return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           {block.steps.map((step, i) => (
//             <div key={step.id} style={{ display: "flex", gap: 12 }}>
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: 24,
//                     height: 24,
//                     borderRadius: "50%",
//                     background: "#1B2340",
//                     color: "#fff",
//                     fontSize: 11.5,
//                     fontWeight: 700,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   {i + 1}
//                 </div>
//                 {i < block.steps.length - 1 && (
//                   <div
//                     style={{
//                       width: 2,
//                       flex: 1,
//                       background: "#E4E2D8",
//                       minHeight: 18,
//                     }}
//                   />
//                 )}
//               </div>
//               <div style={{ paddingBottom: 16 }}>
//                 <div
//                   style={{ fontSize: 13.5, fontWeight: 600, color: "#1B2340" }}
//                 >
//                   {step.title || (
//                     <span style={{ color: "#C7C4B6" }}>Untitled step</span>
//                   )}
//                 </div>
//                 {step.text && (
//                   <div
//                     style={{
//                       fontSize: 13,
//                       color: "#5F5E5A",
//                       lineHeight: 1.6,
//                       marginTop: 3,
//                     }}
//                   >
//                     {step.text}
//                   </div>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       );
//     case "feedback":
//       return (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             border: "1px solid #E4E2D8",
//             borderRadius: 10,
//             padding: "12px 14px",
//             background: "#FBFAF6",
//           }}
//         >
//           <span style={{ fontSize: 13.5, color: "#3A3A34" }}>
//             {block.prompt || "Was this helpful?"}
//           </span>
//           <div style={{ display: "flex", gap: 8 }}>
//             <div
//               style={{
//                 width: 30,
//                 height: 30,
//                 borderRadius: 7,
//                 border: "1px solid #E4E2D8",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#5F5E5A",
//               }}
//             >
//               <ThumbsUp size={14} />
//             </div>
//             <div
//               style={{
//                 width: 30,
//                 height: 30,
//                 borderRadius: 7,
//                 border: "1px solid #E4E2D8",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#5F5E5A",
//               }}
//             >
//               <ThumbsDown size={14} />
//             </div>
//           </div>
//         </div>
//       );
//     case "table":
//       return (
//         <div
//           style={{
//             overflow: "auto",
//             border: "1px solid #E4E2D8",
//             borderRadius: 8,
//           }}
//         >
//           <table
//             style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}
//           >
//             <thead>
//               <tr>
//                 {block.columns.map((col, i) => (
//                   <th
//                     key={i}
//                     style={{
//                       textAlign: "left",
//                       padding: "8px 12px",
//                       background: "#F1EFE8",
//                       color: "#1B2340",
//                       fontWeight: 600,
//                       borderBottom: "1px solid #E4E2D8",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {col || `Column ${i + 1}`}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {block.rows.map((row, ri) => (
//                 <tr key={ri}>
//                   {row.map((cell, ci) => (
//                     <td
//                       key={ci}
//                       style={{
//                         padding: "8px 12px",
//                         borderBottom: "1px solid #EDEBE0",
//                         color: "#3A3A34",
//                       }}
//                     >
//                       {cell}
//                     </td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       );
//     case "divider":
//       return block.style === "space" ? (
//         <div style={{ height: block.spacing ?? 24 }} />
//       ) : (
//         <hr
//           style={{
//             border: "none",
//             borderTop: `1px ${block.style === "dashed" ? "dashed" : "solid"} #E4E2D8`,
//             margin: `${block.spacing ?? 24}px 0`,
//           }}
//         />
//       );

//     case "richtext":
//       return (
//         <div
//           className="rendered-richtext"
//           style={{
//             fontSize: 14,
//             lineHeight: 1.7,
//             color: "#3A3A34",
//             textAlign: block.align || "left",
//           }}
//           dangerouslySetInnerHTML={{
//             __html:
//               block.html || '<p style="color:#C7C4B6">Empty rich text</p>',
//           }}
//         />
//       );

//     default:
//       return null;
//   }
// }

// function DocumentPreview({ values }) {
//   return (
//     <div
//       style={{
//         background: "#fff",
//         borderRadius: 12,
//         border: "1px solid #E4E2D8",
//         padding: "20px 22px",
//       }}
//     >
//       <div
//         style={{
//           fontSize: 11,
//           fontWeight: 600,
//           color: "#8A8878",
//           textTransform: "uppercase",
//           letterSpacing: "0.04em",
//           marginBottom: 6,
//         }}
//       >
//         {values.category} · {values.doc_type}
//       </div>
//       <div
//         style={{
//           fontSize: 22,
//           fontWeight: 700,
//           color: "#1B2340",
//           fontFamily: "'Space Grotesk', sans-serif",
//           marginBottom: 8,
//         }}
//       >
//         {values.title || "Untitled workflow doc"}
//       </div>
//       <p
//         style={{
//           fontSize: 14,
//           color: "#5F5E5A",
//           lineHeight: 1.7,
//           marginBottom: 18,
//         }}
//       >
//         {values.overview}
//       </p>
//       <div
//         style={{
//           display: "flex",
//           gap: 8,
//           alignItems: "center",
//           marginBottom: 20,
//           fontFamily: "'IBM Plex Mono', monospace",
//           fontSize: 12.5,
//         }}
//       >
//         {values.api_method && (
//           <span
//             style={{
//               background: "#1B2340",
//               color: "#fff",
//               borderRadius: 5,
//               padding: "3px 8px",
//               fontWeight: 600,
//             }}
//           >
//             {values.api_method}
//           </span>
//         )}
//         <span style={{ color: "#5F5E5A", wordBreak: "break-all" }}>
//           {values.api_endpoint}
//         </span>
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
//         {values.content_blocks.map((b) => (
//           <RenderedBlock key={b.id} block={b} />
//         ))}
//       </div>
//     </div>
//   );
// }

// function toExportBlock(b) {
//   const { id, ...rest } = b;
//   if (b.type === "request_payload" || b.type === "success_response") {
//     let parsed;
//     try {
//       parsed = JSON.parse(b.data);
//     } catch {
//       parsed = b.data;
//     }
//     return { type: b.type, data: parsed };
//   }
//   if (b.type === "columns") {
//     return {
//       ...rest,
//       columns: (b.columns || []).map((col) => ({
//         blocks: (col.blocks || []).map(toExportBlock),
//       })),
//     };
//   }
//   return rest;
// }

// export default function HrmsBlockEditor() {
//   const { values, setField, setValues } = useFormikLike(initialValues);
//   const [copied, setCopied] = useState(false);
//   const [showPreview, setShowPreview] = useState(true);
//   const [previewTab, setPreviewTab] = useState("rendered");
//   const [addType, setAddType] = useState("paragraph");
//   const [showLoadPayload, setShowLoadPayload] = useState(false);
//   const [payloadText, setPayloadText] = useState("");
//   const [payloadError, setPayloadError] = useState(null);
//   const [fullscreenPreview, setFullscreenPreview] = useState(false);
//   const [deviceView, setDeviceView] = useState("laptop"); // mobile | tablet | laptop
//   const { state } = useLocation();
//   const { type } = useParams(); //add || update || copy
//   const [page_data, setPageData] = useState([]);

//   const navigate = useNavigate();

//   const client = useQueryClient();

//   const { mutate: AddDocuments, isLoading } = useMutation(postDocument, {
//     onSuccess: (res) => {
//       if (res?.data?.response_code === 200) {
//         client.refetchQueries(["get-document"]);
//         toast.success(res?.data?.message);
//         navigate(-1);
//       } else {
//         toast.warn(res?.data?.message);
//       }
//     },
//   });

//   const {
//     data: documentResponse,

//     isError,
//     refetch,
//   } = useQuery(["get-document", state], () => getDocument({ doc_id: state }), {
//     refetchOnWindowFocus: false,
//     refetchOnMount: false,
//     enabled: Boolean(state),
//   });

//   function fromImportBlock(b) {
//     const id = nextId();
//     if (b.type === "request_payload" || b.type === "success_response") {
//       const data =
//         typeof b.data === "string"
//           ? b.data
//           : JSON.stringify(b.data ?? {}, null, 2);
//       return { ...b, id, data };
//     }
//     if (b.type === "columns") {
//       return {
//         ...b,
//         id,
//         columns: (b.columns || []).map((col) => ({
//           id: genKey("column"),
//           blocks: (col.blocks || []).map(fromImportBlock),
//         })),
//       };
//     }
//     return { ...b, id };
//   }

//   useEffect(() => {
//     const doc = documentResponse?.data?.data; // aapke sample response ke hisaab se
//     if (!doc) return;
//     setValues({
//       page_title: doc.page_title || "",
//       category: doc.category || "",
//       title: doc.title || "",
//       doc_type: doc.doc_type || "",
//       overview: doc.overview || "",
//       api_method: doc.api_method || "",
//       api_endpoint: doc.api_endpoint || "",
//       content_blocks: (doc.content_blocks || []).map(fromImportBlock),
//     });
//   }, [documentResponse]);

//   const blocks = values.content_blocks;

//   const updateBlock = (idx, updated) => {
//     const next = [...blocks];
//     next[idx] = updated;
//     setField("content_blocks", next);
//   };
//   const removeBlock = (idx) =>
//     setField(
//       "content_blocks",
//       blocks.filter((_, i) => i !== idx),
//     );
//   const moveBlock = (from, to) => {
//     const next = [...blocks];
//     const [item] = next.splice(from, 1);
//     next.splice(to, 0, item);
//     setField("content_blocks", next);
//   };
//   const addBlock = () =>
//     setField("content_blocks", [...blocks, emptyBlockFor(addType)]);

//   const loadPayload = () => {
//     try {
//       const parsed = JSON.parse(payloadText);
//       setValues({
//         page_title: parsed.page_title || "",
//         category: parsed.category || "",
//         title: parsed.title || "",
//         doc_type: parsed.doc_type || "",
//         overview: parsed.overview || "",
//         api_method: parsed.api_method || "",
//         api_endpoint: parsed.api_endpoint || "",
//         content_blocks: (parsed.content_blocks || []).map(fromImportBlock),
//       });
//       setPayloadError(null);
//       setShowLoadPayload(false);
//       setPayloadText("");
//       toast.success("Payload loaded into the editor");
//     } catch (e) {
//       setPayloadError(
//         "That doesn't look like valid JSON. Please check the format and try again.",
//       );
//     }
//   };

//   const exportJson = {
//     page_title: values?.page_title,
//     category: values.category,
//     title: values.title,
//     doc_type: values.doc_type,
//     overview: values.overview,
//     api_method: values.api_method,
//     api_endpoint: values.api_endpoint,
//     content_blocks: blocks.map(toExportBlock),
//   };

//   const jsonString = JSON.stringify(exportJson, null, 2);

//   const copyJson = async () => {
//     try {
//       await navigator.clipboard.writeText(jsonString);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 1500);
//     } catch {
//       setCopied(false);
//     }
//   };

//   const isEditMode = Boolean(state) && type !== "copy";

//   const { mutate: EditDocument, isLoading: IsUpdateLoading } = useMutation(
//     (payload) => patchDocument({ ...payload, doc_id: state }),
//     {
//       onSuccess: (res) => {
//         if (res?.data?.response_code === 200) {
//           navigate(-1);
//           toast.success(res?.data?.message);
//           client.refetchQueries(["get-document"]);
//         } else {
//           toast.warn(res?.data?.message);
//         }
//       },
//     },
//   );
//   const saveDocument = async () => {
//     if (isEditMode) EditDocument(exportJson);
//     else AddDocuments(exportJson);
//   };

//   const getCreer = () => {
//     axios
//       .get(`${baseUrl}/blog/frontend-page-id-api/`, {
//         headers: {
//           Authorization: `Token ${localStorage.getItem("token")}`,
//           "Access-Control-Allow-Origin": "*",
//         },
//       })
//       .then((res) => {
//         setPageData(res.data?.data);
//       })
//       .catch((err) => {
//         toast.error("Error deleting blog", err?.response?.data?.message);
//       });
//   };

//   useEffect(() => {
//     getCreer();
//   }, []);

//   function sanitizeBlock(b) {
//     if (!b || !BLOCK_TYPES[b.type]) return null; // unknown/missing type -> drop silently, never render
//     const base = emptyBlockFor(b.type);
//     const merged = { ...base, ...b };

//     // any array field the type expects must actually be an array, else fall back to the safe default
//     ["items", "images", "tags", "steps", "columns", "rows"].forEach((k) => {
//       if (k in base && !Array.isArray(merged[k])) merged[k] = base[k];
//     });

//     if (merged.type === "columns") {
//       merged.columns = merged.columns.map((col) => ({
//         ...col,
//         blocks: (Array.isArray(col.blocks) ? col.blocks : [])
//           .map(sanitizeBlock)
//           .filter(Boolean),
//       }));
//     }
//     if (merged.type === "table") {
//       if (!Array.isArray(merged.columns)) merged.columns = base.columns;
//       if (!Array.isArray(merged.rows)) merged.rows = base.rows;
//     }
//     return merged;
//   }

//   const sanitizeBlocks = (blocks) =>
//     (Array.isArray(blocks) ? blocks : []).map(sanitizeBlock).filter(Boolean);

//   const SARVAM_API_KEY = "sk_a65z3hrt_WeR4kZdg4xlUT6ecKL7PDbW6";

//   const DOC_SCHEMA_SYSTEM_PROMPT = `You generate structured documentation-page content as strict JSON for a content block editor. Output ONLY a raw JSON object — no markdown fences, no preamble, no explanation.

// Shape:
// {
//   "category": string,
//   "title": string,
//   "doc_type": string,
//   "overview": string,
//   "api_method": "GET"|"POST"|"PUT"|"PATCH"|"DELETE"|"",
//   "api_endpoint": string,
//   "content_blocks": [ ...block objects... ]
// }

// Do NOT include "page_title" — the user picks that from a dropdown themselves.

// Every content block has a "type" field plus type-specific fields below. Leave any media URL field ("url", "header_image") as an empty string "" — the user uploads real media separately; never invent a fake URL.

// - heading: { type: "heading", level: "h1"|"h2"|"h3"|"h4", text, align: "left"|"center"|"right"|"justify" }
// - paragraph: { type: "paragraph", text, align }
// - callout: { type: "callout", style: "info"|"warning"|"success"|"error", text, align }
// - list: { type: "list", style: "bullet"|"number", items: string[], align }
// - slider: { type: "slider", images: [{ image_key, url: "", caption, alt, width, height, objectFit }] }
// - image: { type: "image", image_key, url: "", caption, align: "left"|"center"|"right", width, height, objectFit }
// - columns: { type: "columns", gap: number, columns: [{ blocks: [...nested block objects...] }] }
// - request_payload: { type: "request_payload", data: <JSON object or JSON string> }
// - code: { type: "code", language, code }
// - success_response: { type: "success_response", data: <JSON object or JSON string> }
// - video: { type: "video", provider: "youtube"|"vimeo"|"loom"|"mp4", url: "", caption, aspectRatio: "16:9"|"4:3"|"1:1"|"9:16" }
// - audio: { type: "audio", url: "", title, subtitle, duration }
// - file: { type: "file", url: "", filename, filetype: "PDF"|"ZIP"|"CSV"|"DOCX"|"XLSX"|"Other", filesize }
// - lottie: { type: "lottie", url: "", caption, width, height, loop: boolean, autoplay: boolean }
// - button: { type: "button", label, url, style: "primary"|"secondary", align, newTab: boolean }
// - badges: { type: "badges", tags: [{ label, tone: "blue"|"gray"|"amber"|"green"|"purple"|"pink"|"teal" }] }
// - stepper: { type: "stepper", steps: [{ title, text }] }
// - feedback: { type: "feedback", prompt }
// - table: { type: "table", columns: string[], rows: string[][] }
// - divider: { type: "divider", style: "solid"|"dashed"|"space", spacing: number }
// - richtext: { type: "richtext", html, align }

// Build a well-structured documentation page using a sensible mix of block types — headings for structure, paragraphs for prose, code/request_payload/success_response for API docs, stepper for how-tos, table for reference data. 6-14 blocks unless the user asks for more or less.`;

//   const [showAiGenerate, setShowAiGenerate] = useState(false);
//   const [aiPrompt, setAiPrompt] = useState("");

//   const { mutate: generateDocWithAi, isLoading: aiGenerating } = useMutation(
//     async (userPrompt) => {
//       const res = await fetch("https://api.sarvam.ai/v1/chat/completions", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "api-subscription-key": SARVAM_API_KEY,
//         },
//         body: JSON.stringify({
//           model: "sarvam-105b",
//           messages: [
//             { role: "system", content: DOC_SCHEMA_SYSTEM_PROMPT },
//             { role: "user", content: userPrompt },
//           ],
//           temperature: 0.3,
//           reasoning_effort: null, // raw JSON chahiye, chain-of-thought nahi — warna content null aa sakta hai (finish_reason: "length")
//           max_tokens: 4096,
//         }),
//       });

//       if (!res.ok) {
//         const errText = await res.text().catch(() => "");
//         throw new Error(
//           `Sarvam API error ${res.status}: ${errText.slice(0, 200)}`,
//         );
//       }

//       const data = await res.json();
//       const choice = data?.choices?.[0];
//       const raw = choice?.message?.content;

//       if (!raw) {
//         if (choice?.finish_reason === "length") {
//           throw new Error(
//             "Response got cut off before finishing — try a shorter or simpler prompt",
//           );
//         }
//         throw new Error("Empty response from AI");
//       }

//       const cleaned = raw.replace(/```json|```/g, "").trim();
//       return JSON.parse(cleaned); // malformed JSON throws here — caught by onError below
//     },
//     {
//       onSuccess: (parsed) => {
//         try {
//           if (
//             !parsed ||
//             typeof parsed !== "object" ||
//             !Array.isArray(parsed.content_blocks)
//           ) {
//             throw new Error("Unexpected response shape");
//           }
//           setValues((prev) => ({
//             ...prev,
//             category: parsed.category || prev.category,
//             title: parsed.title || prev.title,
//             doc_type: parsed.doc_type || prev.doc_type,
//             overview: parsed.overview || prev.overview,
//             api_method: parsed.api_method || prev.api_method,
//             api_endpoint: parsed.api_endpoint || prev.api_endpoint,
//             content_blocks: sanitizeBlocks(parsed.content_blocks).map(
//               fromImportBlock,
//             ),
//           }));
//           toast.success("Document generated successfully");
//           setShowAiGenerate(false);
//           setAiPrompt("");
//         } catch (err) {
//           toast.error("AI response could not be applied: " + err.message);
//         }
//       },
//       onError: (err) =>
//         toast.error(
//           err?.message || "Could not generate document, please try again",
//         ),
//     },
//   );

//   // const GEMINI_API_KEY =
//   //   "AQ.Ab8RN6JoSqA6UGkjwLrsRqbro8M9b98VIbjmbrvSZix6KaRIzw"; // apne bundler ke hisaab se prefix confirm karo
//   // const GEMINI_MODEL = "gemini-3.6-flash"; // agar tumhare account me koi aur model enabled hai to yeh badal dena

//   // const { mutate: generateDocWithAi, isLoading: aiGenerating } = useMutation(
//   //   async (userPrompt) => {
//   //     const res = await fetch(
//   //       `https://generativelanguage.googleapis.com/v1beta/models/${GEMINI_MODEL}:generateContent`,
//   //       {
//   //         method: "POST",
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //           "x-goog-api-key": GEMINI_API_KEY,
//   //         },
//   //         body: JSON.stringify({
//   //           contents: [{ role: "user", parts: [{ text: userPrompt }] }],
//   //           systemInstruction: {
//   //             parts: [{ text: DOC_SCHEMA_SYSTEM_PROMPT }],
//   //           },
//   //           generationConfig: {
//   //             temperature: 0.3,
//   //             maxOutputTokens: 8192,
//   //             responseMimeType: "application/json", // Gemini ko force karta hai strict JSON dene ke liye, koi ```json fence nahi
//   //           },
//   //         }),
//   //       },
//   //     );

//   //     if (!res.ok) {
//   //       const errText = await res.text().catch(() => "");
//   //       throw new Error(
//   //         `Gemini API error ${res.status}: ${errText.slice(0, 200)}`,
//   //       );
//   //     }

//   //     const data = await res.json();
//   //     const candidate = data?.candidates?.[0];
//   //     const raw = candidate?.content?.parts?.[0]?.text;

//   //     if (!raw) {
//   //       if (candidate?.finishReason === "MAX_TOKENS") {
//   //         throw new Error(
//   //           "Response got cut off before finishing — try a shorter or simpler prompt",
//   //         );
//   //       }
//   //       if (
//   //         candidate?.finishReason === "SAFETY" ||
//   //         data?.promptFeedback?.blockReason
//   //       ) {
//   //         throw new Error("Gemini blocked this prompt — try rephrasing it");
//   //       }
//   //       throw new Error("Empty response from AI");
//   //     }

//   //     const cleaned = raw.replace(/```json|```/g, "").trim(); // safety net, mostly unnecessary with responseMimeType set
//   //     return JSON.parse(cleaned); // malformed JSON throws here — caught by onError below
//   //   },
//   //   {
//   //     onSuccess: (parsed) => {
//   //       try {
//   //         if (
//   //           !parsed ||
//   //           typeof parsed !== "object" ||
//   //           !Array.isArray(parsed.content_blocks)
//   //         ) {
//   //           throw new Error("Unexpected response shape");
//   //         }
//   //         setValues((prev) => ({
//   //           ...prev,
//   //           category: parsed.category || prev.category,
//   //           title: parsed.title || prev.title,
//   //           doc_type: parsed.doc_type || prev.doc_type,
//   //           overview: parsed.overview || prev.overview,
//   //           api_method: parsed.api_method || prev.api_method,
//   //           api_endpoint: parsed.api_endpoint || prev.api_endpoint,
//   //           content_blocks: sanitizeBlocks(parsed.content_blocks).map(
//   //             fromImportBlock,
//   //           ),
//   //         }));
//   //         toast.success("Document generated successfully");
//   //         setShowAiGenerate(false);
//   //         setAiPrompt("");
//   //       } catch (err) {
//   //         toast.error("AI response could not be applied: " + err.message);
//   //       }
//   //     },
//   //     onError: (err) =>
//   //       toast.error(
//   //         err?.message || "Could not generate document, please try again",
//   //       ),
//   //   },
//   // );

//   const handleGenerateDocWithAi = () => {
//     const prompt = aiPrompt.trim();
//     if (!prompt || aiGenerating) return;
//     generateDocWithAi(prompt);
//   };

//   return (
//     <div
//       style={{
//         fontFamily: "'IBM Plex Sans', sans-serif",
//         background: "#F3F2EC",
//         padding: 24,
//         minHeight: "100vh",

//         boxSizing: "border-box",
//       }}
//     >
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&family=Space+Grotesk:wght@600;700&display=swap');
//         input:focus, textarea:focus, select:focus { border-color: #185FA5 !important; box-shadow: 0 0 0 3px rgba(24,95,165,0.12); }
//         @keyframes spSpin { to { transform: rotate(360deg); } }
//         @keyframes spFade { from { opacity: 0.4; } to { opacity: 1; } }
//       `}</style>

//       <div style={{ maxWidth: "100%", margin: "0 auto" }}>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "baseline",
//             justifyContent: "space-between",
//             marginBottom: 20,
//             flexWrap: "wrap",
//             gap: 10,
//           }}
//         >
//           <div>
//             <div
//               style={{
//                 fontSize: 12,
//                 fontFamily: "'IBM Plex Mono', monospace",
//                 color: "#8A8878",
//                 letterSpacing: "0.06em",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               HRMS content block editor
//             </div>
//             <h1
//               style={{
//                 fontFamily: "'Space Grotesk', sans-serif",
//                 fontSize: 26,
//                 fontWeight: 700,
//                 color: "#1B2340",
//                 margin: 0,
//               }}
//             >
//               {values.title || "Untitled workflow doc"}
//             </h1>
//           </div>
//           <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
//             <button
//               onClick={() => setShowPreview((s) => !s)}
//               style={{
//                 fontSize: 13,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "1px solid #DEDCD1",
//                 background: "#fff",
//                 color: "#20201C",
//                 cursor: "pointer",
//               }}
//             >
//               {showPreview ? "Hide JSON" : "Show JSON"}
//             </button>
//             <button
//               onClick={() => setShowLoadPayload(true)}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "1px solid #DEDCD1",
//                 background: "#fff",
//                 color: "#20201C",
//                 cursor: "pointer",
//               }}
//             >
//               <FileJson size={14} /> Load Payload
//             </button>
//             <button
//               onClick={() => setShowAiGenerate(true)}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "1px solid #AFA9EC",
//                 background: "#EEEDFE",
//                 color: "#3C3489",
//                 cursor: "pointer",
//               }}
//             >
//               <Sparkles size={14} /> Generate with AI
//             </button>
//             <button
//               onClick={() => setFullscreenPreview(true)}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "1px solid #DEDCD1",
//                 background: "#fff",
//                 color: "#20201C",
//                 cursor: "pointer",
//               }}
//             >
//               <Maximize2 size={14} /> Full Screen Preview
//             </button>
//             <button
//               onClick={copyJson}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "none",
//                 background: "#1B2340",
//                 color: "#fff",
//                 cursor: "pointer",
//               }}
//             >
//               {copied ? <Check size={14} /> : <Copy size={14} />}{" "}
//               {copied ? "Copied" : "Copy JSON"}
//             </button>
//             <button
//               disabled={isLoading || IsUpdateLoading}
//               onClick={saveDocument}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "none",
//                 background: "#1B2340",
//                 color: "#fff",
//                 cursor: "pointer",
//               }}
//             >
//               {isLoading || IsUpdateLoading
//                 ? "Saving..."
//                 : isEditMode
//                   ? "Update Document"
//                   : "Save Document"}
//             </button>
//           </div>
//         </div>

//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: showPreview ? "1fr 1fr" : "1fr",
//             gap: 20,
//             alignItems: "start",
//             minWidth: 0,
//           }}
//         >
//           <div style={{ minWidth: 0 }}>
//             {/* Document meta card */}
//             <div
//               style={{
//                 background: "#fff",
//                 border: "1px solid #E4E2D8",
//                 borderRadius: 12,
//                 padding: 18,
//                 marginBottom: 20,
//               }}
//             >
//               <div
//                 style={{
//                   fontSize: 13,
//                   fontWeight: 600,
//                   color: "#1B2340",
//                   marginBottom: 12,
//                 }}
//               >
//                 Document details
//               </div>

//               <Field label="Select the page you want to view">
//                 <select
//                   style={selectStyle}
//                   value={values.page_title}
//                   onChange={(e) => setField("page_title", e.target.value)}
//                 >
//                   <option className="font-bold ">Select A Page</option>
//                   {page_data?.map((i) => (
//                     <option value={i?.id}>{i?.name}</option>
//                   ))}
//                 </select>
//               </Field>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: 12,
//                 }}
//               >
//                 <Field label="Category">
//                   <input
//                     style={inputStyle}
//                     value={values.category}
//                     onChange={(e) => setField("category", e.target.value)}
//                   />
//                 </Field>
//                 <Field label="Doc type">
//                   <input
//                     style={inputStyle}
//                     value={values.doc_type}
//                     onChange={(e) => setField("doc_type", e.target.value)}
//                   />
//                 </Field>
//               </div>
//               <Field label="Title">
//                 <input
//                   style={inputStyle}
//                   value={values.title}
//                   onChange={(e) => setField("title", e.target.value)}
//                 />
//               </Field>
//               <Field label="Overview">
//                 <textarea
//                   style={textareaStyle}
//                   value={values.overview}
//                   onChange={(e) => setField("overview", e.target.value)}
//                 />
//               </Field>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "120px 1fr",
//                   gap: 12,
//                 }}
//               >
//                 <Field label="API method">
//                   <select
//                     style={selectStyle}
//                     value={values.api_method}
//                     onChange={(e) => setField("api_method", e.target.value)}
//                   >
//                     <option value={""}>None</option>
//                     {["GET", "POST", "PUT", "PATCH", "DELETE"].map((m) => (
//                       <option key={m} value={m}>
//                         {m}
//                       </option>
//                     ))}
//                   </select>
//                 </Field>
//                 <Field label="API endpoint">
//                   <input
//                     style={monoStyle}
//                     value={values.api_endpoint}
//                     onChange={(e) => setField("api_endpoint", e.target.value)}
//                   />
//                 </Field>
//               </div>
//             </div>

//             {/* Blocks */}
//             <div
//               style={{
//                 fontSize: 13,
//                 fontWeight: 600,
//                 color: "#1B2340",
//                 marginBottom: 10,
//               }}
//             >
//               Content blocks ({blocks.length})
//             </div>
//             {blocks.map((b, i) => (
//               <BlockCard
//                 key={b.id}
//                 block={b}
//                 index={i}
//                 total={blocks.length}
//                 onChange={(updated) => updateBlock(i, updated)}
//                 onRemove={removeBlock}
//                 onMove={moveBlock}
//               />
//             ))}

//             <div
//               style={{
//                 display: "flex",
//                 gap: 8,
//                 marginTop: 14,
//                 background: "#fff",
//                 border: "1px dashed #C7C4B6",
//                 borderRadius: 12,
//                 padding: 14,
//                 alignItems: "center",
//               }}
//             >
//               <select
//                 style={{ ...selectStyle, width: "auto", flex: 1 }}
//                 value={addType}
//                 onChange={(e) => setAddType(e.target.value)}
//               >
//                 {Object.entries(BLOCK_TYPES).map(([k, v]) => (
//                   <option key={k} value={k}>
//                     {v.label}
//                   </option>
//                 ))}
//               </select>
//               <button
//                 onClick={addBlock}
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 6,
//                   fontSize: 13,
//                   fontWeight: 600,
//                   padding: "9px 16px",
//                   borderRadius: 8,
//                   border: "none",
//                   background: "#1B2340",
//                   color: "#fff",
//                   cursor: "pointer",
//                 }}
//               >
//                 <Plus size={14} /> Add block
//               </button>
//             </div>
//           </div>

//           {showPreview && (
//             <div style={{ position: "sticky", top: 20, minWidth: 0 }}>
//               <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
//                 {[
//                   ["rendered", "Preview"],
//                   ["json", "JSON"],
//                 ].map(([key, label]) => (
//                   <button
//                     key={key}
//                     onClick={() => setPreviewTab(key)}
//                     style={{
//                       fontSize: 12.5,
//                       fontWeight: 600,
//                       padding: "6px 12px",
//                       borderRadius: 7,
//                       cursor: "pointer",
//                       border:
//                         previewTab === key
//                           ? "1px solid #1B2340"
//                           : "1px solid #DEDCD1",
//                       background: previewTab === key ? "#1B2340" : "#fff",
//                       color: previewTab === key ? "#fff" : "#5F5E5A",
//                     }}
//                   >
//                     {label}
//                   </button>
//                 ))}
//                 <span
//                   style={{
//                     fontSize: 11.5,
//                     color: "#9A988E",
//                     alignSelf: "center",
//                     marginLeft: 4,
//                   }}
//                 >
//                   {previewTab === "rendered"
//                     ? "How this data will display"
//                     : "Data admin will submit"}
//                 </span>
//               </div>

//               {previewTab === "rendered" ? (
//                 <div style={{ maxHeight: "80vh", overflow: "auto" }}>
//                   <DocumentPreview values={values} />
//                 </div>
//               ) : (
//                 <div
//                   style={{
//                     background: "#1B2340",
//                     borderRadius: 12,
//                     overflow: "hidden",
//                     border: "1px solid #1B2340",
//                   }}
//                 >
//                   <div
//                     style={{
//                       padding: "10px 14px",
//                       fontSize: 12,
//                       color: "#9BA6C7",
//                       fontFamily: "'IBM Plex Mono', monospace",
//                       borderBottom: "1px solid #2A335C",
//                     }}
//                   >
//                     output.json
//                   </div>
//                   <pre
//                     style={{
//                       margin: 0,
//                       padding: 16,
//                       fontSize: 12.5,
//                       lineHeight: 1.6,
//                       color: "#E6EAF5",
//                       fontFamily: "'IBM Plex Mono', monospace",
//                       overflow: "auto",
//                       maxHeight: "80vh",
//                     }}
//                   >
//                     {jsonString}
//                   </pre>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {showLoadPayload && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(27,35,64,0.55)",
//             zIndex: 1200,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             padding: 20,
//           }}
//           onClick={() => setShowLoadPayload(false)}
//         >
//           <div
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               background: "#fff",
//               borderRadius: 12,
//               width: "100%",
//               maxWidth: 640,
//               maxHeight: "85vh",
//               display: "flex",
//               flexDirection: "column",
//               boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 padding: "14px 18px",
//                 borderBottom: "1px solid #E4E2D8",
//                 flexShrink: 0,
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 8,
//                   fontSize: 14,
//                   fontWeight: 600,
//                   color: "#1B2340",
//                 }}
//               >
//                 <FileJson size={16} /> Load JSON payload
//               </div>
//               <IconBtn
//                 title="Close"
//                 onClick={() => {
//                   setShowLoadPayload(false);
//                   setPayloadError(null);
//                 }}
//               >
//                 <X size={14} />
//               </IconBtn>
//             </div>
//             <div style={{ padding: 18, overflow: "auto" }}>
//               <Field
//                 label="Paste document JSON"
//                 hint="Uses the same shape as Copy JSON — loading this will replace the current title, overview, API info and all content blocks with what you paste here."
//               >
//                 <textarea
//                   style={{ ...monoStyle, minHeight: 260 }}
//                   value={payloadText}
//                   onChange={(e) => {
//                     setPayloadText(e.target.value);
//                     if (payloadError) setPayloadError(null);
//                   }}
//                   placeholder='{"title": "...", "content_blocks": [...]}'
//                 />
//               </Field>
//               {payloadError && (
//                 <div
//                   style={{
//                     fontSize: 12.5,
//                     color: "#993C1D",
//                     marginTop: -6,
//                     marginBottom: 10,
//                   }}
//                 >
//                   {payloadError}
//                 </div>
//               )}
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 gap: 8,
//                 padding: "12px 18px",
//                 borderTop: "1px solid #E4E2D8",
//                 flexShrink: 0,
//               }}
//             >
//               <button
//                 onClick={() => {
//                   setShowLoadPayload(false);
//                   setPayloadError(null);
//                 }}
//                 style={{
//                   fontSize: 13,
//                   padding: "8px 14px",
//                   borderRadius: 8,
//                   border: "1px solid #DEDCD1",
//                   background: "#fff",
//                   color: "#20201C",
//                   cursor: "pointer",
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={loadPayload}
//                 disabled={!payloadText.trim()}
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 6,
//                   fontSize: 13,
//                   fontWeight: 600,
//                   padding: "8px 16px",
//                   borderRadius: 8,
//                   border: "none",
//                   background: "#1B2340",
//                   color: "#fff",
//                   cursor: payloadText.trim() ? "pointer" : "default",
//                   opacity: payloadText.trim() ? 1 : 0.6,
//                 }}
//               >
//                 <Upload size={14} /> Load
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showAiGenerate && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(27,35,64,0.55)",
//             zIndex: 1200,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             padding: 20,
//           }}
//           onClick={() => !aiGenerating && setShowAiGenerate(false)}
//         >
//           <div
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               background: "#fff",
//               borderRadius: 12,
//               width: "100%",
//               maxWidth: 560,
//               display: "flex",
//               flexDirection: "column",
//               boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 padding: "14px 18px",
//                 borderBottom: "1px solid #E4E2D8",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 8,
//                   fontSize: 14,
//                   fontWeight: 600,
//                   color: "#1B2340",
//                 }}
//               >
//                 <Sparkles size={16} color="#534AB7" /> Generate document with AI
//               </div>
//               <IconBtn
//                 title="Close"
//                 onClick={() => !aiGenerating && setShowAiGenerate(false)}
//               >
//                 <X size={14} />
//               </IconBtn>
//             </div>
//             <div style={{ padding: 18 }}>
//               <Field
//                 label="Describe the document"
//                 hint="e.g. an API reference doc for a 'create employee' endpoint, with a request payload, success response, and a step-by-step guide."
//               >
//                 <textarea
//                   autoFocus
//                   style={{ ...textareaStyle, minHeight: 130 }}
//                   value={aiPrompt}
//                   onChange={(e) => setAiPrompt(e.target.value)}
//                   disabled={aiGenerating}
//                   placeholder="Describe what the document should cover..."
//                 />
//               </Field>
//               <div
//                 style={{
//                   fontSize: 12,
//                   color: "#9A988E",
//                 }}
//               >
//                 This replaces the title, overview, API info and content blocks
//                 below — page selection stays untouched, and media stays empty
//                 for you to upload.
//               </div>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 gap: 8,
//                 padding: "12px 18px",
//                 borderTop: "1px solid #E4E2D8",
//               }}
//             >
//               <button
//                 onClick={() => setShowAiGenerate(false)}
//                 disabled={aiGenerating}
//                 style={{
//                   fontSize: 13,
//                   padding: "8px 14px",
//                   borderRadius: 8,
//                   border: "1px solid #DEDCD1",
//                   background: "#fff",
//                   color: "#20201C",
//                   cursor: aiGenerating ? "default" : "pointer",
//                   opacity: aiGenerating ? 0.6 : 1,
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleGenerateDocWithAi}
//                 disabled={aiGenerating || !aiPrompt.trim()}
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 6,
//                   fontSize: 13,
//                   fontWeight: 600,
//                   padding: "8px 16px",
//                   borderRadius: 8,
//                   border: "none",
//                   background: "#1B2340",
//                   color: "#fff",
//                   cursor:
//                     aiGenerating || !aiPrompt.trim() ? "default" : "pointer",
//                   opacity: aiGenerating || !aiPrompt.trim() ? 0.6 : 1,
//                 }}
//               >
//                 {aiGenerating && <Spinner size={13} />}
//                 {aiGenerating ? "Generating..." : "Generate"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {fullscreenPreview && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "#EDEBDF",
//             zIndex: 1100,
//             display: "flex",
//             flexDirection: "column",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               padding: "10px 18px",
//               background: "#1B2340",
//               flexShrink: 0,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
//               {[
//                 { key: "mobile", label: "Mobile", icon: Smartphone },
//                 { key: "tablet", label: "Tablet", icon: Tablet },
//                 { key: "laptop", label: "Laptop", icon: Laptop },
//               ].map((d) => {
//                 const Icon = d.icon;
//                 const active = deviceView === d.key;
//                 return (
//                   <button
//                     key={d.key}
//                     onClick={() => setDeviceView(d.key)}
//                     style={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       gap: 6,
//                       fontSize: 12.5,
//                       fontWeight: 600,
//                       padding: "7px 12px",
//                       borderRadius: 7,
//                       border: active ? "1px solid #fff" : "1px solid #3C4570",
//                       background: active ? "#fff" : "transparent",
//                       color: active ? "#1B2340" : "#C9CEDD",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <Icon size={14} /> {d.label}
//                   </button>
//                 );
//               })}
//             </div>
//             <button
//               onClick={() => setFullscreenPreview(false)}
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//                 fontSize: 13,
//                 fontWeight: 600,
//                 padding: "8px 14px",
//                 borderRadius: 8,
//                 border: "1px solid #3C4570",
//                 background: "transparent",
//                 color: "#fff",
//                 cursor: "pointer",
//               }}
//             >
//               <X size={14} /> Close
//             </button>
//           </div>
//           <div
//             style={{
//               flex: 1,
//               overflow: "auto",
//               display: "flex",
//               justifyContent: "center",
//               padding: "28px 16px",
//             }}
//           >
//             <div
//               style={{
//                 width:
//                   deviceView === "mobile"
//                     ? 390
//                     : deviceView === "tablet"
//                       ? 834
//                       : 1280,
//                 maxWidth: "100%",
//                 transition: "width 200ms ease",
//               }}
//             >
//               <DocumentPreview values={values} />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import { useEffect, useState, useRef } from "react";
import {
  Heading1,
  AlignLeft,
  AlertTriangle,
  List as ListIcon,
  Images,
  Image as ImageIcon,
  Code2,
  Terminal,
  CheckCircle2,
  Plus,
  Trash2,
  ChevronUp,
  ChevronDown,
  ChevronDown as Caret,
  Copy,
  Check,
  GripVertical,
  KeyRound,
  RefreshCw,
  Info,
  XCircle,
  ImageOff,
  ChevronLeft,
  ChevronRight,
  Columns2,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Video,
  Music2,
  Paperclip,
  Sparkles,
  MousePointerClick,
  Tags,
  ListOrdered,
  ThumbsUp,
  ThumbsDown,
  Table2,
  SeparatorHorizontal,
  FileText,
  FileArchive,
  FileSpreadsheet,
  File as FileGeneric,
  Download,
  PenSquare,
  Smartphone,
  Tablet,
  Laptop,
  Maximize2,
  X,
  FileJson,
  Upload,
  Globe,
} from "lucide-react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  getDocument,
  patchDocument,
  postDocument,
} from "../../../Services/Document";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../../Config/baseUrl";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RICHTEXT_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote", "code-block", "link"],
    ["clean"],
  ],
};

const CALLOUT_STYLE = {
  info: { bg: "#E6F1FB", border: "#185FA5", text: "#0C447C", icon: Info },
  warning: {
    bg: "#FAEEDA",
    border: "#BA7517",
    text: "#633806",
    icon: AlertTriangle,
  },
  success: {
    bg: "#EAF3DE",
    border: "#3B6D11",
    text: "#27500A",
    icon: CheckCircle2,
  },
  error: { bg: "#FCEBEB", border: "#A32D2D", text: "#501313", icon: XCircle },
};

const BLOCK_TYPES = {
  heading: { label: "Heading", ramp: "blue", icon: Heading1 },
  paragraph: { label: "Paragraph", ramp: "gray", icon: AlignLeft },
  callout: { label: "Callout", ramp: "amber", icon: AlertTriangle },
  list: { label: "List", ramp: "green", icon: ListIcon },
  slider: { label: "Image slider", ramp: "purple", icon: Images },
  image: { label: "Image", ramp: "pink", icon: ImageIcon },
  columns: { label: "Multi-column", ramp: "blue", icon: Columns2 },
  api: { label: "API endpoint", ramp: "teal", icon: Globe },
  request_payload: { label: "Request payload", ramp: "teal", icon: Code2 },
  code: { label: "Code sample", ramp: "gray", icon: Terminal },
  success_response: {
    label: "Success response",
    ramp: "green",
    icon: CheckCircle2,
  },
  video: { label: "Video embed", ramp: "blue", icon: Video },
  audio: { label: "Audio player / voice note", ramp: "purple", icon: Music2 },
  file: { label: "File attachment", ramp: "teal", icon: Paperclip },
  lottie: {
    label: "Lottie / interactive animation",
    ramp: "pink",
    icon: Sparkles,
  },
  button: {
    label: "Button / action link",
    ramp: "green",
    icon: MousePointerClick,
  },
  badges: { label: "Badge / tag cloud", ramp: "amber", icon: Tags },
  stepper: { label: "Step-by-step guide", ramp: "blue", icon: ListOrdered },
  feedback: { label: "Feedback widget", ramp: "green", icon: ThumbsUp },
  table: { label: "Table", ramp: "gray", icon: Table2 },
  divider: {
    label: "Divider / spacer",
    ramp: "gray",
    icon: SeparatorHorizontal,
  },
  richtext: { label: "Rich text editor", ramp: "purple", icon: PenSquare },
};

const RAMP = {
  blue: { 50: "#E6F1FB", 200: "#85B7EB", 600: "#185FA5", 800: "#0C447C" },
  gray: { 50: "#F1EFE8", 200: "#B4B2A9", 600: "#5F5E5A", 800: "#444441" },
  amber: { 50: "#FAEEDA", 200: "#EF9F27", 600: "#854F0B", 800: "#633806" },
  green: { 50: "#EAF3DE", 200: "#97C459", 600: "#3B6D11", 800: "#27500A" },
  purple: { 50: "#EEEDFE", 200: "#AFA9EC", 600: "#534AB7", 800: "#3C3489" },
  pink: { 50: "#FBEAF0", 200: "#ED93B1", 600: "#993556", 800: "#72243E" },
  teal: { 50: "#E1F5EE", 200: "#5DCAA5", 600: "#0F6E56", 800: "#085041" },
};

const API_METHODS = ["GET", "POST", "PUT", "PATCH", "DELETE"];

const METHOD_COLOR = {
  GET: { bg: "#E1F5EE", text: "#0F6E56" },
  POST: { bg: "#E6F1FB", text: "#0C447C" },
  PUT: { bg: "#FAEEDA", text: "#633806" },
  PATCH: { bg: "#EEEDFE", text: "#3C3489" },
  DELETE: { bg: "#FCEBEB", text: "#501313" },
};

const ALIGN_OPTIONS = [
  { value: "left", label: "Left", icon: AlignLeft },
  { value: "center", label: "Center", icon: AlignCenter },
  { value: "right", label: "Right", icon: AlignRight },
  { value: "justify", label: "Justify", icon: AlignJustify },
];

const OBJECT_FIT_OPTIONS = ["cover", "contain", "fill", "none", "scale-down"];

let uid = 1;
const nextId = () => `blk-${uid++}`;
const genKey = (prefix) =>
  `${prefix}_${Math.random().toString(36).slice(2, 8)}`;

// ---- Media upload helpers ----------------------------------------------

function guessExtension(mimeType) {
  const map = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/webp": "webp",
    "image/gif": "gif",
    "audio/mpeg": "mp3",
    "audio/wav": "wav",
    "video/mp4": "mp4",
    "application/pdf": "pdf",
  };
  return map[mimeType] || mimeType?.split("/")[1] || "bin";
}

async function urlToFile(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error("Could not fetch that URL");
  const blob = await res.blob();
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  return new File([blob], `media-${timestamp}.${guessExtension(blob.type)}`, {
    type: blob.type,
  });
}

async function uploadFileToServer(file) {
  const formData = new FormData();
  formData.append("title", "file");
  formData.append("image", file);

  const res = await axios.post(
    `${baseUrl}/blog/upload-image-to-s3-api/`, // TODO: point this at your real upload endpoint
    formData,
    {
      headers: {
        Authorization: `Token ${localStorage.getItem("token")}`,
      },
    },
  );

  return res.data?.data?.image; // TODO: adjust to match your API's actual response shape
}

// -------------------------------------------------------------------------

const emptyImageValue = (prefix) => ({
  image_key: genKey(prefix),
  url: "",
  caption: "",
  alt: "",
  width: "100%",
  height: "220px",
  objectFit: "cover",
});

const emptyColumn = () => ({
  id: genKey("column"),
  blocks: [],
});

const emptyBlockFor = (type) => {
  const id = nextId();
  switch (type) {
    case "heading":
      return { id, type: "heading", level: "h2", text: "", align: "left" };
    case "paragraph":
      return { id, type: "paragraph", text: "", align: "left" };
    case "callout":
      return { id, type: "callout", style: "info", text: "", align: "left" };
    case "list":
      return { id, type: "list", style: "bullet", items: [""], align: "left" };
    case "slider":
      return { id, type: "slider", images: [emptyImageValue("slider_step")] };
    case "image":
      return {
        id,
        type: "image",
        image_key: genKey("image"),
        url: "",
        caption: "",
        align: "center",
        width: "100%",
        height: "auto",
        objectFit: "cover",
      };
    case "columns":
      return {
        id,
        type: "columns",
        gap: 20,
        columns: [emptyColumn(), emptyColumn()],
      };
    case "api":
      return {
        id,
        type: "api",
        method: "GET",
        url: "",
        description: "",
      };
    case "request_payload":
      return { id, type: "request_payload", data: "{\n  \n}" };
    case "code":
      return { id, type: "code", language: "python", code: "" };
    case "success_response":
      return { id, type: "success_response", data: "{\n  \n}" };
    case "video":
      return {
        id,
        type: "video",
        provider: "youtube",
        url: "",
        caption: "",
        aspectRatio: "16:9",
      };
    case "audio":
      return {
        id,
        type: "audio",
        url: "",
        title: "",
        subtitle: "",
        duration: "",
      };
    case "file":
      return {
        id,
        type: "file",
        url: "",
        filename: "",
        filetype: "PDF",
        filesize: "",
      };
    case "lottie":
      return {
        id,
        type: "lottie",
        url: "",
        caption: "",
        width: "100%",
        height: "280px",
        loop: true,
        autoplay: true,
      };
    case "button":
      return {
        id,
        type: "button",
        label: "",
        url: "",
        style: "primary",
        align: "left",
        newTab: true,
      };
    case "badges":
      return {
        id,
        type: "badges",
        tags: [{ id: genKey("tag"), label: "New", tone: "blue" }],
      };
    case "stepper":
      return {
        id,
        type: "stepper",
        steps: [{ id: genKey("step"), title: "", text: "" }],
      };
    case "feedback":
      return { id, type: "feedback", prompt: "Was this helpful?" };
    case "table":
      return {
        id,
        type: "table",
        columns: ["Column 1", "Column 2"],
        rows: [["", ""]],
      };
    case "divider":
      return { id, type: "divider", style: "solid", spacing: 24 };
    case "richtext":
      return { id, type: "richtext", html: "", align: "left" };
    default:
      return { id, type: "paragraph", text: "", align: "left" };
  }
};

const initialBlocks = [];

const initialValues = {
  page_title: "",
  category: "",
  title: "",
  doc_type: "",
  overview: "",
  api_method: "",
  api_endpoint: "",
  content_blocks: initialBlocks,
};

function useFormikLike(initial) {
  const [values, setValues] = useState(initial);
  const setField = (path, val) => {
    setValues((prev) => {
      const next = structuredClone(prev);
      const keys = path.split(".");
      let cur = next;
      for (let i = 0; i < keys.length - 1; i++) cur = cur[keys[i]];
      cur[keys[keys.length - 1]] = val;
      return next;
    });
  };
  return { values, setValues, setField };
}

function Field({ label, children, hint }) {
  return (
    <label style={{ display: "block", marginBottom: 14 }}>
      <span
        style={{
          display: "block",
          fontSize: 12,
          fontWeight: 600,
          color: "#5F5E5A",
          letterSpacing: "0.02em",
          textTransform: "uppercase",
          marginBottom: 6,
        }}
      >
        {label}
      </span>
      {children}
      {hint && (
        <span
          style={{
            display: "block",
            fontSize: 12,
            color: "#9A988E",
            marginTop: 4,
          }}
        >
          {hint}
        </span>
      )}
    </label>
  );
}

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "9px 11px",
  borderRadius: 8,
  border: "1px solid #DEDCD1",
  fontSize: 14,
  fontFamily: "'IBM Plex Sans', sans-serif",
  color: "#20201C",
  background: "#FFFFFF",
  outline: "none",
};
const monoStyle = {
  ...inputStyle,
  fontFamily: "'IBM Plex Mono', monospace",
  fontSize: 13,
};
const selectStyle = { ...inputStyle, cursor: "pointer" };
const textareaStyle = {
  ...inputStyle,
  resize: "vertical",
  minHeight: 70,
  lineHeight: 1.5,
};

function IconBtn({ onClick, title, children, danger, active }) {
  return (
    <button
      onClick={onClick}
      title={title}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        borderRadius: 6,
        border: active ? "1px solid #1B2340" : "1px solid #E4E2D8",
        background: active ? "#1B2340" : "#fff",
        color: active ? "#fff" : danger ? "#993C1D" : "#5F5E5A",
        cursor: "pointer",
      }}
    >
      {children}
    </button>
  );
}

function Spinner({ size = 14 }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        border: "2px solid #DEDCD1",
        borderTopColor: "#1B2340",
        borderRadius: "50%",
        animation: "spSpin 0.7s linear infinite",
        flexShrink: 0,
      }}
    />
  );
}

function AlignPicker({ value, onChange }) {
  return (
    <Field label="Text align">
      <div style={{ display: "flex", gap: 6 }}>
        {ALIGN_OPTIONS.map((opt) => {
          const Icon = opt.icon;
          return (
            <IconBtn
              key={opt.value}
              title={opt.label}
              active={value === opt.value}
              onClick={() => onChange(opt.value)}
            >
              <Icon size={14} />
            </IconBtn>
          );
        })}
      </div>
    </Field>
  );
}

function ImageDimensionFields({ width, height, objectFit, onChange }) {
  return (
    <div
      style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}
    >
      <Field label="Width" hint="px, % or auto">
        <input
          style={inputStyle}
          value={width}
          onChange={(e) => onChange({ width: e.target.value })}
          placeholder="100%"
        />
      </Field>
      <Field label="Height" hint="px or auto">
        <input
          style={inputStyle}
          value={height}
          onChange={(e) => onChange({ height: e.target.value })}
          placeholder="220px"
        />
      </Field>
      <Field label="Fit">
        <select
          style={selectStyle}
          value={objectFit}
          onChange={(e) => onChange({ objectFit: e.target.value })}
        >
          {OBJECT_FIT_OPTIONS.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </select>
      </Field>
    </div>
  );
}

function JsonField({ label, value, onChange }) {
  const [error, setError] = useState(null);
  return (
    <Field label={label} hint={error ? null : "Valid JSON object"}>
      <textarea
        style={{ ...monoStyle, minHeight: 120 }}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          try {
            JSON.parse(e.target.value);
            setError(null);
          } catch {
            setError("Not valid JSON yet");
          }
        }}
      />
      {error && (
        <span
          style={{
            display: "block",
            fontSize: 12,
            color: "#993C1D",
            marginTop: 4,
          }}
        >
          {error}
        </span>
      )}
    </Field>
  );
}

// ---- Media upload field (URL fetch OR direct file upload) --------------

function MediaUploadField({ label, value, onChange, accept = "*/*", hint }) {
  const [mode, setMode] = useState("url");
  const [pastedUrl, setPastedUrl] = useState("");
  const [status, setStatus] = useState("idle"); // idle | working | error
  const fileInputRef = useRef(null);

  const runUpload = async (file) => {
    setStatus("working");
    try {
      const uploadedUrl = await uploadFileToServer(file);
      if (!uploadedUrl) throw new Error("No URL returned");
      onChange(uploadedUrl);
      setStatus("idle");
    } catch (err) {
      toast.error("Upload failed. Please try again.");
      setStatus("error");
    }
  };

  const handleUrlConvert = async () => {
    if (!pastedUrl) return;
    setStatus("working");
    try {
      const file = await urlToFile(pastedUrl);
      await runUpload(file);
    } catch {
      toast.error("Couldn't read that URL");
      setStatus("error");
    }
  };

  const handleFilePick = (e) => {
    const file = e.target.files?.[0];
    if (file) runUpload(file);
    e.target.value = ""; // allow re-picking the same file later
  };

  const tabBtn = (key, text) => (
    <button
      type="button"
      onClick={() => setMode(key)}
      style={{
        fontSize: 12,
        fontWeight: 600,
        padding: "5px 10px",
        borderRadius: 6,
        cursor: "pointer",
        border: mode === key ? "1px solid #1B2340" : "1px solid #DEDCD1",
        background: mode === key ? "#1B2340" : "#fff",
        color: mode === key ? "#fff" : "#5F5E5A",
      }}
    >
      {text}
    </button>
  );

  return (
    <Field label={label} hint={hint}>
      <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
        {tabBtn("url", "Paste URL")}
        {tabBtn("upload", "Upload file")}
      </div>

      {mode === "url" ? (
        <div style={{ display: "flex", gap: 6 }}>
          <input
            style={inputStyle}
            value={pastedUrl}
            onChange={(e) => setPastedUrl(e.target.value)}
            placeholder="https://..."
            disabled={status === "working"}
          />
          <button
            type="button"
            onClick={handleUrlConvert}
            disabled={status === "working" || !pastedUrl}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontSize: 12.5,
              fontWeight: 600,
              padding: "0 16px",
              borderRadius: 8,
              border: "none",
              background: "#1B2340",
              color: "#fff",
              cursor: status === "working" ? "default" : "pointer",
              opacity: status === "working" || !pastedUrl ? 0.6 : 1,
              flexShrink: 0,
            }}
          >
            {status === "working" ? <Spinner /> : "Use"}
          </button>
        </div>
      ) : (
        <div>
          <input
            ref={fileInputRef}
            type="file"
            accept={accept}
            onChange={handleFilePick}
            style={{ display: "none" }}
          />
          <button
            type="button"
            onClick={() => fileInputRef.current?.click()}
            disabled={status === "working"}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              fontSize: 13,
              padding: "8px 14px",
              borderRadius: 8,
              border: "1px dashed #C7C4B6",
              background: "transparent",
              color: "#5F5E5A",
              cursor: status === "working" ? "default" : "pointer",
              opacity: status === "working" ? 0.7 : 1,
            }}
          >
            {status === "working" ? (
              <>
                <Spinner /> Uploading…
              </>
            ) : (
              <>
                <Paperclip size={14} /> Choose file
              </>
            )}
          </button>
        </div>
      )}

      <div
        style={{
          marginTop: 8,
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <span style={{ fontSize: 11, color: "#9A988E", flexShrink: 0 }}>
          Generated URL:
        </span>
        <input
          disabled
          style={{
            ...inputStyle,
            fontSize: 12,
            color: "#5F5E5A",
            background: "#F7F6F1",
          }}
          value={value || ""}
          placeholder="Not uploaded yet"
        />
      </div>
    </Field>
  );
}

// -------------------------------------------------------------------------

function BlockCard({
  block,
  index,
  total,
  onChange,
  onRemove,
  onMove,
  compact,
}) {
  const [open, setOpen] = useState(true);
  const meta = BLOCK_TYPES[block.type];
  const Icon = meta?.icon;
  const c = RAMP[meta?.ramp];
  const patch = (field, val) => onChange({ ...block, [field]: val });

  return (
    <div
      style={{
        border: "1px solid #E4E2D8",
        borderRadius: 12,
        background: "#FFFFFF",
        marginBottom: 12,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "10px 12px",
          background: c[50],
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={() => setOpen((o) => !o)}
      >
        <GripVertical size={15} color={c[600]} style={{ flexShrink: 0 }} />
        <span
          style={{
            fontSize: 12,
            fontFamily: "'IBM Plex Mono', monospace",
            color: c[600],
            fontWeight: 600,
          }}
        >
          {String(index + 1).padStart(2, "0")}
        </span>
        <Icon size={15} color={c[800]} style={{ flexShrink: 0 }} />
        <span style={{ fontSize: 13, fontWeight: 600, color: c[800] }}>
          {meta.label}
        </span>
        <span
          style={{
            fontSize: 12,
            color: c[600],
            marginLeft: 2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1,
            minWidth: 0,
          }}
        >
          {blockPreview(block)}
        </span>
        <div
          style={{ display: "flex", gap: 4 }}
          onClick={(e) => e.stopPropagation()}
        >
          <IconBtn
            title="Move up"
            onClick={() => index > 0 && onMove(index, index - 1)}
          >
            <ChevronUp size={14} />
          </IconBtn>
          <IconBtn
            title="Move down"
            onClick={() => index < total - 1 && onMove(index, index + 1)}
          >
            <ChevronDown size={14} />
          </IconBtn>
          <IconBtn title="Delete block" danger onClick={() => onRemove(index)}>
            <Trash2 size={14} />
          </IconBtn>
          <Caret
            size={16}
            color={c[600]}
            style={{
              transform: open ? "rotate(180deg)" : "none",
              transition: "transform 0.15s",
              marginLeft: 2,
            }}
          />
        </div>
      </div>

      {open && (
        <div style={{ padding: 16 }}>
          <BlockFields block={block} patch={patch} onChange={onChange} />
        </div>
      )}
    </div>
  );
}

function blockPreview(b) {
  if (b.type === "heading" || b.type === "paragraph" || b.type === "callout")
    return b.text || "Empty";
  if (b.type === "list")
    return `${b.items.length} item${b.items.length === 1 ? "" : "s"}`;
  if (b.type === "slider")
    return `${b.images.length} image${b.images.length === 1 ? "" : "s"}`;
  if (b.type === "image") return b.image_key || "unkeyed";
  if (b.type === "columns") {
    const total = (b.columns || []).reduce(
      (s, c) => s + (c.blocks?.length || 0),
      0,
    );
    return `${b.columns?.length || 0} columns, ${total} block${total === 1 ? "" : "s"}`;
  }
  if (b.type === "api") return `${b.method || "GET"} ${b.url || "No URL set"}`;
  if (b.type === "code") return b.language;
  if (b.type === "request_payload" || b.type === "success_response")
    return "JSON data";
  if (b.type === "video") return b.url || "No URL set";
  if (b.type === "audio") return b.title || b.url || "No audio set";
  if (b.type === "file") return b.filename || "No file set";
  if (b.type === "lottie") return b.caption || b.url || "No animation set";
  if (b.type === "button") return b.label || "No label set";
  if (b.type === "badges")
    return `${b.tags.length} tag${b.tags.length === 1 ? "" : "s"}`;
  if (b.type === "stepper")
    return `${b.steps.length} step${b.steps.length === 1 ? "" : "s"}`;
  if (b.type === "feedback") return b.prompt || "Feedback widget";
  if (b.type === "table")
    return `${b.rows.length} row${b.rows.length === 1 ? "" : "s"} \u00d7 ${b.columns.length} col${b.columns.length === 1 ? "" : "s"}`;
  if (b.type === "divider") return b.style;
  if (b.type === "richtext") {
    const plain = (b.html || "").replace(/<[^>]+>/g, "").trim();
    return plain || "Empty";
  }
  return "";
}

function ColumnBlockList({ blocks, onChange }) {
  const [addType, setAddType] = useState("paragraph");
  const nestedTypes = Object.entries(BLOCK_TYPES).filter(
    ([k]) => k !== "columns",
  );

  const updateBlock = (idx, updated) => {
    const next = [...blocks];
    next[idx] = updated;
    onChange(next);
  };
  const removeBlock = (idx) => onChange(blocks.filter((_, i) => i !== idx));
  const moveBlock = (from, to) => {
    const next = [...blocks];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    onChange(next);
  };
  const addBlock = () => onChange([...blocks, emptyBlockFor(addType)]);

  return (
    <div>
      {blocks.map((b, i) => (
        <BlockCard
          key={b.id}
          block={b}
          index={i}
          total={blocks.length}
          onChange={(updated) => updateBlock(i, updated)}
          onRemove={removeBlock}
          onMove={moveBlock}
        />
      ))}
      <div
        style={{
          display: "flex",
          gap: 8,
          background: "#FAF9F4",
          border: "1px dashed #C7C4B6",
          borderRadius: 9,
          padding: 10,
          alignItems: "center",
        }}
      >
        <select
          style={{
            ...selectStyle,
            width: "auto",
            flex: 1,
            fontSize: 12.5,
            padding: "6px 9px",
          }}
          value={addType}
          onChange={(e) => setAddType(e.target.value)}
        >
          {nestedTypes.map(([k, v]) => (
            <option key={k} value={k}>
              {v.label}
            </option>
          ))}
        </select>
        <button
          onClick={addBlock}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 5,
            fontSize: 12,
            fontWeight: 600,
            padding: "6px 11px",
            borderRadius: 7,
            border: "none",
            background: "#1B2340",
            color: "#fff",
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          <Plus size={12} /> Add block
        </button>
      </div>
    </div>
  );
}

function BlockFields({ block, patch, onChange }) {
  switch (block.type) {
    case "heading":
      return (
        <>
          <Field label="Level">
            <select
              style={selectStyle}
              value={block.level}
              onChange={(e) => patch("level", e.target.value)}
            >
              {["h1", "h2", "h3", "h4"].map((l) => (
                <option key={l} value={l}>
                  {l.toUpperCase()}
                </option>
              ))}
            </select>
          </Field>
          <Field label="Heading text">
            <input
              style={inputStyle}
              value={block.text}
              onChange={(e) => patch("text", e.target.value)}
              placeholder="Section heading"
            />
          </Field>
          <AlignPicker
            value={block.align || "left"}
            onChange={(v) => patch("align", v)}
          />
        </>
      );
    case "paragraph":
      return (
        <>
          <Field label="Paragraph text">
            <textarea
              style={textareaStyle}
              value={block.text}
              onChange={(e) => patch("text", e.target.value)}
              placeholder="Write the paragraph copy..."
            />
          </Field>
          <AlignPicker
            value={block.align || "left"}
            onChange={(v) => patch("align", v)}
          />
        </>
      );
    case "callout":
      return (
        <>
          <Field label="Style">
            <select
              style={selectStyle}
              value={block.style}
              onChange={(e) => patch("style", e.target.value)}
            >
              {["info", "warning", "success", "error"].map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </Field>
          <Field label="Callout text">
            <textarea
              style={textareaStyle}
              value={block.text}
              onChange={(e) => patch("text", e.target.value)}
              placeholder="Warning or note copy..."
            />
          </Field>
          <AlignPicker
            value={block.align || "left"}
            onChange={(v) => patch("align", v)}
          />
        </>
      );
    case "list":
      return (
        <>
          <Field label="Style">
            <select
              style={selectStyle}
              value={block.style}
              onChange={(e) => patch("style", e.target.value)}
            >
              <option value="bullet">Bullet</option>
              <option value="number">Numbered</option>
            </select>
          </Field>
          <Field label="Items">
            {block.items.map((item, i) => (
              <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
                <input
                  style={inputStyle}
                  value={item}
                  onChange={(e) => {
                    const items = [...block.items];
                    items[i] = e.target.value;
                    patch("items", items);
                  }}
                  placeholder={`Item ${i + 1}`}
                />
                <IconBtn
                  title="Remove item"
                  danger
                  onClick={() =>
                    patch(
                      "items",
                      block.items.filter((_, idx) => idx !== i),
                    )
                  }
                >
                  <Trash2 size={13} />
                </IconBtn>
              </div>
            ))}
            <button
              onClick={() => patch("items", [...block.items, ""])}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                marginTop: 2,
                fontSize: 13,
                padding: "6px 10px",
                borderRadius: 7,
                border: "1px dashed #C7C4B6",
                background: "transparent",
                color: "#5F5E5A",
                cursor: "pointer",
              }}
            >
              <Plus size={13} /> Add item
            </button>
          </Field>
          <AlignPicker
            value={block.align || "left"}
            onChange={(v) => patch("align", v)}
          />
        </>
      );
    case "slider":
      return (
        <>
          {block.images.map((img, i) => (
            <div
              key={i}
              style={{
                border: "1px solid #EDEBE0",
                borderRadius: 9,
                padding: 12,
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                <span
                  style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
                >
                  Slide {i + 1}
                </span>
                <IconBtn
                  title="Remove slide"
                  danger
                  onClick={() =>
                    patch(
                      "images",
                      block.images.filter((_, idx) => idx !== i),
                    )
                  }
                >
                  <Trash2 size={13} />
                </IconBtn>
              </div>
              <ImageKeyField
                value={img.image_key}
                onChange={(v) => {
                  const images = [...block.images];
                  images[i] = { ...images[i], image_key: v };
                  patch("images", images);
                }}
                prefix="slide"
              />
              <MediaUploadField
                label="Image"
                value={img.url}
                onChange={(url) => {
                  const images = [...block.images];
                  images[i] = { ...images[i], url };
                  patch("images", images);
                }}
                accept="image/*"
              />
              <Field label="Caption">
                <input
                  style={inputStyle}
                  value={img.caption}
                  onChange={(e) => {
                    const images = [...block.images];
                    images[i] = { ...images[i], caption: e.target.value };
                    patch("images", images);
                  }}
                  placeholder="What this slide shows"
                />
              </Field>
              <Field label="Alt text">
                <input
                  style={inputStyle}
                  value={img.alt}
                  onChange={(e) => {
                    const images = [...block.images];
                    images[i] = { ...images[i], alt: e.target.value };
                    patch("images", images);
                  }}
                  placeholder="Accessible description"
                />
              </Field>
              <ImageDimensionFields
                width={img.width || "100%"}
                height={img.height || "220px"}
                objectFit={img.objectFit || "cover"}
                onChange={(fields) => {
                  const images = [...block.images];
                  images[i] = { ...images[i], ...fields };
                  patch("images", images);
                }}
              />
            </div>
          ))}
          <button
            onClick={() =>
              patch("images", [...block.images, emptyImageValue("slider_step")])
            }
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontSize: 13,
              padding: "6px 10px",
              borderRadius: 7,
              border: "1px dashed #C7C4B6",
              background: "transparent",
              color: "#5F5E5A",
              cursor: "pointer",
            }}
          >
            <Plus size={13} /> Add slide
          </button>
        </>
      );
    case "image":
      return (
        <>
          <ImageKeyField
            value={block.image_key}
            onChange={(v) => patch("image_key", v)}
            prefix="image"
          />
          <MediaUploadField
            label="Image"
            value={block.url}
            onChange={(url) => patch("url", url)}
            accept="image/*"
          />
          <Field label="Caption">
            <input
              style={inputStyle}
              value={block.caption}
              onChange={(e) => patch("caption", e.target.value)}
              placeholder="Figure caption"
            />
          </Field>
          <Field
            label="Container align"
            hint="Position of the image within the document width"
          >
            <div style={{ display: "flex", gap: 6 }}>
              {[
                { value: "left", label: "Left", icon: AlignLeft },
                { value: "center", label: "Center", icon: AlignCenter },
                { value: "right", label: "Right", icon: AlignRight },
              ].map((opt) => {
                const Ic = opt.icon;
                return (
                  <IconBtn
                    key={opt.value}
                    title={opt.label}
                    active={block.align === opt.value}
                    onClick={() => patch("align", opt.value)}
                  >
                    <Ic size={14} />
                  </IconBtn>
                );
              })}
            </div>
          </Field>
          <ImageDimensionFields
            width={block.width || "100%"}
            height={block.height || "auto"}
            objectFit={block.objectFit || "cover"}
            onChange={(fields) =>
              Object.entries(fields).forEach(([k, v]) => patch(k, v))
            }
          />
        </>
      );
    case "columns": {
      const columns = block.columns || [];
      const setColumns = (next) => patch("columns", next);
      const addColumn = () => setColumns([...columns, emptyColumn()]);
      const removeColumn = (ci) =>
        setColumns(columns.filter((_, i) => i !== ci));
      const updateColumnBlocks = (ci, newBlocks) => {
        setColumns(
          columns.map((c, i) => (i === ci ? { ...c, blocks: newBlocks } : c)),
        );
      };
      return (
        <>
          <div
            style={{
              display: "flex",
              gap: 10,
              marginBottom: 4,
              flexWrap: "wrap",
            }}
          >
            <Field label="Gap between columns" hint="in pixels">
              <input
                type="number"
                style={{ ...inputStyle, width: 120 }}
                value={block.gap}
                onChange={(e) => patch("gap", Number(e.target.value) || 0)}
              />
            </Field>
            <Field
              label="Columns"
              hint={`${columns.length} column${columns.length === 1 ? "" : "s"}`}
            >
              <button
                onClick={addColumn}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 13,
                  fontWeight: 600,
                  padding: "9px 14px",
                  borderRadius: 8,
                  border: "1px dashed #C7C4B6",
                  background: "transparent",
                  color: "#5F5E5A",
                  cursor: "pointer",
                }}
              >
                <Plus size={13} /> Add column
              </button>
            </Field>
          </div>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            {columns.map((col, ci) => (
              <div
                key={col.id}
                style={{
                  border: "1px solid #EDEBE0",
                  borderRadius: 9,
                  padding: 12,
                  flex: "1 1 240px",
                  minWidth: 240,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <span
                    style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
                  >
                    Column {ci + 1} · {col.blocks.length} block
                    {col.blocks.length === 1 ? "" : "s"}
                  </span>
                  {columns.length > 1 && (
                    <IconBtn
                      title="Remove column"
                      danger
                      onClick={() => removeColumn(ci)}
                    >
                      <Trash2 size={13} />
                    </IconBtn>
                  )}
                </div>
                <ColumnBlockList
                  blocks={col.blocks}
                  onChange={(nb) => updateColumnBlocks(ci, nb)}
                />
              </div>
            ))}
          </div>
        </>
      );
    }
    case "api":
      return (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "130px 1fr",
              gap: 10,
            }}
          >
            <Field label="Method">
              <select
                style={selectStyle}
                value={block.method || "GET"}
                onChange={(e) => patch("method", e.target.value)}
              >
                {API_METHODS.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Endpoint URL">
              <input
                style={monoStyle}
                value={block.url}
                onChange={(e) => patch("url", e.target.value)}
                placeholder="/api/v1/employees/"
              />
            </Field>
          </div>
          <Field label="Description" hint="Optional — what this endpoint does">
            <textarea
              style={textareaStyle}
              value={block.description}
              onChange={(e) => patch("description", e.target.value)}
              placeholder="Creates a new employee record..."
            />
          </Field>
        </>
      );
    case "code":
      return (
        <>
          <Field label="Language">
            <input
              style={inputStyle}
              value={block.language}
              onChange={(e) => patch("language", e.target.value)}
              placeholder="python"
            />
          </Field>
          <Field label="Code">
            <textarea
              style={{ ...monoStyle, minHeight: 140 }}
              value={block.code}
              onChange={(e) => patch("code", e.target.value)}
              placeholder="Paste the code sample..."
            />
          </Field>
        </>
      );
    case "request_payload":
    case "success_response":
      return (
        <JsonField
          label="JSON data"
          value={block.data}
          onChange={(v) => patch("data", v)}
        />
      );
    case "video":
      return (
        <>
          <Field label="Provider">
            <select
              style={selectStyle}
              value={block.provider}
              onChange={(e) => patch("provider", e.target.value)}
            >
              {["youtube", "vimeo", "loom", "mp4"].map((p) => (
                <option key={p} value={p}>
                  {p === "mp4" ? "Direct MP4" : p[0].toUpperCase() + p.slice(1)}
                </option>
              ))}
            </select>
          </Field>
          {block.provider === "mp4" ? (
            <MediaUploadField
              label="Video file"
              value={block.url}
              onChange={(url) => patch("url", url)}
              accept="video/*"
            />
          ) : (
            <Field label="Video URL" hint="Paste the share/watch link">
              <input
                style={inputStyle}
                value={block.url}
                onChange={(e) => patch("url", e.target.value)}
                placeholder="https://..."
              />
            </Field>
          )}
          <Field label="Caption">
            <input
              style={inputStyle}
              value={block.caption}
              onChange={(e) => patch("caption", e.target.value)}
              placeholder="Optional caption"
            />
          </Field>
          <Field label="Aspect ratio">
            <select
              style={selectStyle}
              value={block.aspectRatio}
              onChange={(e) => patch("aspectRatio", e.target.value)}
            >
              {["16:9", "4:3", "1:1", "9:16"].map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </Field>
        </>
      );
    case "audio":
      return (
        <>
          <MediaUploadField
            label="Audio file"
            value={block.url}
            onChange={(url) => patch("url", url)}
            accept="audio/*"
          />
          <Field label="Title">
            <input
              style={inputStyle}
              value={block.title}
              onChange={(e) => patch("title", e.target.value)}
              placeholder="Episode or clip title"
            />
          </Field>
          <Field label="Subtitle">
            <input
              style={inputStyle}
              value={block.subtitle}
              onChange={(e) => patch("subtitle", e.target.value)}
              placeholder="e.g. Podcast · Voice note"
            />
          </Field>
          <Field label="Duration" hint="Display only, e.g. 3:45">
            <input
              style={{ ...inputStyle, width: 120 }}
              value={block.duration}
              onChange={(e) => patch("duration", e.target.value)}
              placeholder="3:45"
            />
          </Field>
        </>
      );
    case "file":
      return (
        <>
          <MediaUploadField
            label="File"
            value={block.url}
            onChange={(url) => patch("url", url)}
            accept="*/*"
          />
          <Field label="Filename">
            <input
              style={inputStyle}
              value={block.filename}
              onChange={(e) => patch("filename", e.target.value)}
              placeholder="onboarding-guide.pdf"
            />
          </Field>
          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}
          >
            <Field label="File type">
              <select
                style={selectStyle}
                value={block.filetype}
                onChange={(e) => patch("filetype", e.target.value)}
              >
                {["PDF", "ZIP", "CSV", "DOCX", "XLSX", "Other"].map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="File size" hint="Display only">
              <input
                style={inputStyle}
                value={block.filesize}
                onChange={(e) => patch("filesize", e.target.value)}
                placeholder="2.4 MB"
              />
            </Field>
          </div>
        </>
      );
    case "lottie":
      return (
        <>
          <Field label="Animation URL" hint="Link to a .json or .lottie file">
            <input
              style={inputStyle}
              value={block.url}
              onChange={(e) => patch("url", e.target.value)}
              placeholder="https://.../animation.json"
            />
          </Field>
          <Field label="Caption">
            <input
              style={inputStyle}
              value={block.caption}
              onChange={(e) => patch("caption", e.target.value)}
              placeholder="Optional caption"
            />
          </Field>
          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}
          >
            <Field label="Width" hint="px or %">
              <input
                style={inputStyle}
                value={block.width}
                onChange={(e) => patch("width", e.target.value)}
                placeholder="100%"
              />
            </Field>
            <Field label="Height" hint="px">
              <input
                style={inputStyle}
                value={block.height}
                onChange={(e) => patch("height", e.target.value)}
                placeholder="280px"
              />
            </Field>
          </div>
          <div style={{ display: "flex", gap: 16, marginTop: 4 }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                color: "#5F5E5A",
              }}
            >
              <input
                type="checkbox"
                checked={block.loop}
                onChange={(e) => patch("loop", e.target.checked)}
              />
              Loop
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                color: "#5F5E5A",
              }}
            >
              <input
                type="checkbox"
                checked={block.autoplay}
                onChange={(e) => patch("autoplay", e.target.checked)}
              />
              Autoplay
            </label>
          </div>
        </>
      );
    case "button":
      return (
        <>
          <Field label="Label">
            <input
              style={inputStyle}
              value={block.label}
              onChange={(e) => patch("label", e.target.value)}
              placeholder="Get API Key"
            />
          </Field>
          <Field label="Link URL">
            <input
              style={inputStyle}
              value={block.url}
              onChange={(e) => patch("url", e.target.value)}
              placeholder="https://..."
            />
          </Field>
          <Field label="Style">
            <select
              style={selectStyle}
              value={block.style}
              onChange={(e) => patch("style", e.target.value)}
            >
              <option value="primary">Primary</option>
              <option value="secondary">Secondary</option>
            </select>
          </Field>
          <Field label="Align">
            <div style={{ display: "flex", gap: 6 }}>
              {[
                { value: "left", label: "Left", icon: AlignLeft },
                { value: "center", label: "Center", icon: AlignCenter },
                { value: "right", label: "Right", icon: AlignRight },
              ].map((opt) => {
                const Ic = opt.icon;
                return (
                  <IconBtn
                    key={opt.value}
                    title={opt.label}
                    active={(block.align || "left") === opt.value}
                    onClick={() => patch("align", opt.value)}
                  >
                    <Ic size={14} />
                  </IconBtn>
                );
              })}
            </div>
          </Field>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 13,
              color: "#5F5E5A",
              marginTop: 4,
            }}
          >
            <input
              type="checkbox"
              checked={block.newTab}
              onChange={(e) => patch("newTab", e.target.checked)}
            />
            Open in new tab
          </label>
        </>
      );
    case "badges":
      return (
        <Field label="Tags">
          {block.tags.map((tag, i) => (
            <div
              key={tag.id}
              style={{
                display: "flex",
                gap: 6,
                marginBottom: 6,
                alignItems: "center",
              }}
            >
              <input
                style={inputStyle}
                value={tag.label}
                onChange={(e) => {
                  const tags = [...block.tags];
                  tags[i] = { ...tags[i], label: e.target.value };
                  patch("tags", tags);
                }}
                placeholder="Beta"
              />
              <select
                style={{ ...selectStyle, width: 110, flexShrink: 0 }}
                value={tag.tone}
                onChange={(e) => {
                  const tags = [...block.tags];
                  tags[i] = { ...tags[i], tone: e.target.value };
                  patch("tags", tags);
                }}
              >
                {Object.keys(RAMP).map((tone) => (
                  <option key={tone} value={tone}>
                    {tone}
                  </option>
                ))}
              </select>
              <IconBtn
                title="Remove tag"
                danger
                onClick={() =>
                  patch(
                    "tags",
                    block.tags.filter((_, idx) => idx !== i),
                  )
                }
              >
                <Trash2 size={13} />
              </IconBtn>
            </div>
          ))}
          <button
            onClick={() =>
              patch("tags", [
                ...block.tags,
                { id: genKey("tag"), label: "", tone: "blue" },
              ])
            }
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              marginTop: 2,
              fontSize: 13,
              padding: "6px 10px",
              borderRadius: 7,
              border: "1px dashed #C7C4B6",
              background: "transparent",
              color: "#5F5E5A",
              cursor: "pointer",
            }}
          >
            <Plus size={13} /> Add tag
          </button>
        </Field>
      );
    case "stepper":
      return (
        <>
          {block.steps.map((step, i) => (
            <div
              key={step.id}
              style={{
                border: "1px solid #EDEBE0",
                borderRadius: 9,
                padding: 12,
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                <span
                  style={{ fontSize: 12, fontWeight: 600, color: "#8A8878" }}
                >
                  Step {i + 1}
                </span>
                <IconBtn
                  title="Remove step"
                  danger
                  onClick={() =>
                    patch(
                      "steps",
                      block.steps.filter((_, idx) => idx !== i),
                    )
                  }
                >
                  <Trash2 size={13} />
                </IconBtn>
              </div>
              <Field label="Step title">
                <input
                  style={inputStyle}
                  value={step.title}
                  onChange={(e) => {
                    const steps = [...block.steps];
                    steps[i] = { ...steps[i], title: e.target.value };
                    patch("steps", steps);
                  }}
                  placeholder="Install the SDK"
                />
              </Field>
              <Field label="Step details">
                <textarea
                  style={textareaStyle}
                  value={step.text}
                  onChange={(e) => {
                    const steps = [...block.steps];
                    steps[i] = { ...steps[i], text: e.target.value };
                    patch("steps", steps);
                  }}
                  placeholder="What the reader should do..."
                />
              </Field>
            </div>
          ))}
          <button
            onClick={() =>
              patch("steps", [
                ...block.steps,
                { id: genKey("step"), title: "", text: "" },
              ])
            }
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontSize: 13,
              padding: "6px 10px",
              borderRadius: 7,
              border: "1px dashed #C7C4B6",
              background: "transparent",
              color: "#5F5E5A",
              cursor: "pointer",
            }}
          >
            <Plus size={13} /> Add step
          </button>
        </>
      );
    case "feedback":
      return (
        <Field label="Prompt text">
          <input
            style={inputStyle}
            value={block.prompt}
            onChange={(e) => patch("prompt", e.target.value)}
            placeholder="Was this helpful?"
          />
        </Field>
      );
    case "table":
      return (
        <>
          <Field label="Columns">
            {block.columns.map((col, i) => (
              <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
                <input
                  style={inputStyle}
                  value={col}
                  onChange={(e) => {
                    const columns = [...block.columns];
                    columns[i] = e.target.value;
                    onChange({ ...block, columns });
                  }}
                  placeholder={`Column ${i + 1}`}
                />
                <IconBtn
                  title="Remove column"
                  danger
                  onClick={() => {
                    const columns = block.columns.filter((_, idx) => idx !== i);
                    const rows = block.rows.map((row) =>
                      row.filter((_, idx) => idx !== i),
                    );
                    onChange({ ...block, columns, rows });
                  }}
                >
                  <Trash2 size={13} />
                </IconBtn>
              </div>
            ))}
            <button
              onClick={() => {
                const columns = [
                  ...block.columns,
                  `Column ${block.columns.length + 1}`,
                ];
                const rows = block.rows.map((row) => [...row, ""]);
                onChange({ ...block, columns, rows });
              }}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                padding: "6px 10px",
                borderRadius: 7,
                border: "1px dashed #C7C4B6",
                background: "transparent",
                color: "#5F5E5A",
                cursor: "pointer",
              }}
            >
              <Plus size={13} /> Add column
            </button>
          </Field>
          <Field label="Rows">
            {block.rows.map((row, ri) => (
              <div
                key={ri}
                style={{
                  display: "flex",
                  gap: 6,
                  marginBottom: 6,
                  alignItems: "center",
                }}
              >
                {row.map((cell, ci) => (
                  <input
                    key={ci}
                    style={inputStyle}
                    value={cell}
                    onChange={(e) => {
                      const rows = block.rows.map((r) => [...r]);
                      rows[ri][ci] = e.target.value;
                      patch("rows", rows);
                    }}
                    placeholder={block.columns[ci] || `Col ${ci + 1}`}
                  />
                ))}
                <IconBtn
                  title="Remove row"
                  danger
                  onClick={() =>
                    patch(
                      "rows",
                      block.rows.filter((_, idx) => idx !== ri),
                    )
                  }
                >
                  <Trash2 size={13} />
                </IconBtn>
              </div>
            ))}
            <button
              onClick={() =>
                patch("rows", [...block.rows, block.columns.map(() => "")])
              }
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                padding: "6px 10px",
                borderRadius: 7,
                border: "1px dashed #C7C4B6",
                background: "transparent",
                color: "#5F5E5A",
                cursor: "pointer",
              }}
            >
              <Plus size={13} /> Add row
            </button>
          </Field>
        </>
      );
    case "divider":
      return (
        <>
          <Field label="Style">
            <select
              style={selectStyle}
              value={block.style}
              onChange={(e) => patch("style", e.target.value)}
            >
              <option value="solid">Solid line</option>
              <option value="dashed">Dashed line</option>
              <option value="space">Blank space only</option>
            </select>
          </Field>
          <Field label="Spacing" hint="Vertical space in pixels">
            <input
              type="number"
              style={{ ...inputStyle, width: 120 }}
              value={block.spacing}
              onChange={(e) => patch("spacing", Number(e.target.value) || 0)}
            />
          </Field>
        </>
      );

    case "richtext":
      return (
        <>
          <Field label="Content">
            <div
              style={{
                border: "1px solid #DEDCD1",
                borderRadius: 8,
                background: "#fff",
                overflow: "visible",
              }}
            >
              <ReactQuill
                theme="snow"
                value={block.html}
                onChange={(html) => patch("html", html)}
                placeholder="Write rich content..."
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ["bold", "italic", "underline", "strike"],

                    // [{ color: [] }, { background: [] }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["blockquote", "code-block", "link"],
                    ["clean"],
                  ],
                }}
              />
            </div>
          </Field>
          <AlignPicker
            value={block.align || "left"}
            onChange={(v) => patch("align", v)}
          />
        </>
      );

    default:
      return null;
  }
}

function ImageKeyField({ value, onChange, prefix }) {
  return (
    <Field
      label="Image key"
      hint="Used to reference this image elsewhere in the document"
    >
      <div style={{ display: "flex", gap: 6 }}>
        <div style={{ position: "relative", flex: 1 }}>
          <KeyRound
            size={13}
            color="#9A988E"
            style={{ position: "absolute", left: 10, top: 12 }}
          />
          <input
            style={{ ...monoStyle, paddingLeft: 30 }}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="unique_image_key"
          />
        </div>
        <IconBtn
          title="Generate a new key"
          onClick={() => onChange(genKey(prefix))}
        >
          <RefreshCw size={13} />
        </IconBtn>
      </div>
    </Field>
  );
}

function PreviewImg({ src, alt, style }) {
  const [broken, setBroken] = useState(false);
  if (!src || broken) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          background: "#F1EFE8",
          border: "1px dashed #C7C4B6",
          borderRadius: 8,
          color: "#8A8878",
          fontSize: 12,
          minHeight: 110,
          ...style,
        }}
      >
        <ImageOff size={18} />
        <span>{alt || "Image"}</span>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      onError={() => setBroken(true)}
      style={{ display: "block", borderRadius: 8, ...style }}
    />
  );
}

function toResponsiveSize(v) {
  return v;
}

function NavButton({ side, onClick, visible }) {
  return (
    <button
      onClick={onClick}
      aria-label={side === "left" ? "Previous slide" : "Next slide"}
      style={{
        position: "absolute",
        top: "50%",
        [side]: 8,
        transform: "translateY(-50%)",
        border: "none",
        background: "rgba(255,255,255,0.9)",
        borderRadius: "50%",
        width: 30,
        height: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
        opacity: visible ? 1 : 0,
        transition: "opacity 150ms ease, transform 150ms ease",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.transform = "translateY(-50%) scale(1.08)")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.transform = "translateY(-50%)")
      }
    >
      {side === "left" ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
    </button>
  );
}

function SliderPreview({ images }) {
  const [i, setI] = useState(0);
  const [isHovering, setIsHovering] = useState(false);

  if (!images?.length) return null;
  const img = images[Math.min(i, images.length - 1)];
  const hasMultiple = images.length > 1;

  const go = (delta) =>
    setI((v) => (v + delta + images.length) % images.length);

  return (
    <div
      style={{
        border: "1px solid #E4E2D8",
        borderRadius: 12,
        overflow: "hidden",
        background: "#FAF9F4",
        width: "100%",
        boxSizing: "border-box",
        boxShadow: "0 1px 2px rgba(32,32,28,0.04)",
      }}
    >
      <div
        style={{ position: "relative" }}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <PreviewImg
          key={img.url}
          src={img.url}
          alt={img.alt}
          style={{
            width: img.width || "100%",
            height: toResponsiveSize(img.height || "220px"),
            objectFit: img.objectFit || "cover",
            borderRadius: 0,
            display: "block",
            animation: "spFade 200ms ease",
          }}
        />

        {hasMultiple && (
          <div
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              padding: "3px 8px",
              borderRadius: 999,
              background: "rgba(32,32,28,0.55)",
              backdropFilter: "blur(2px)",
              color: "#fff",
              fontSize: 11,
              fontWeight: 500,
              letterSpacing: 0.2,
            }}
          >
            {i + 1} / {images.length}
          </div>
        )}

        {hasMultiple && (
          <>
            <NavButton
              side="left"
              onClick={() => go(-1)}
              visible={isHovering}
            />
            <NavButton
              side="right"
              onClick={() => go(1)}
              visible={isHovering}
            />
          </>
        )}
      </div>

      <div
        style={{
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: "clamp(12.5px, 3.2vw, 13px)",
              color: "#20201C",
              lineHeight: 1.5,
              wordBreak: "break-word",
            }}
          >
            {img.caption || "No caption"}
          </div>
        </div>

        {hasMultiple && (
          <div style={{ display: "flex", gap: 5, flexShrink: 0 }}>
            {images.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                aria-label={`Go to slide ${idx + 1}`}
                style={{
                  width: idx === i ? 16 : 6,
                  height: 6,
                  borderRadius: 999,
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  background: idx === i ? "#20201C" : "#DAD8CC",
                  transition: "all 150ms ease",
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function toEmbedUrl(provider, url) {
  if (!url) return "";
  if (provider === "mp4") return url;
  if (provider === "youtube") {
    const idMatch = url.match(/(?:youtu\.be\/|v=|embed\/)([a-zA-Z0-9_-]{6,})/);
    return idMatch ? `https://www.youtube.com/embed/${idMatch[1]}` : url;
  }
  if (provider === "vimeo") {
    const idMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return idMatch ? `https://player.vimeo.com/video/${idMatch[1]}` : url;
  }
  if (provider === "loom") {
    const idMatch = url.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
    return idMatch ? `https://www.loom.com/embed/${idMatch[1]}` : url;
  }
  return url;
}

const FILE_TYPE_ICONS = {
  PDF: FileText,
  ZIP: FileArchive,
  CSV: FileSpreadsheet,
  DOCX: FileText,
  XLSX: FileSpreadsheet,
  Other: FileGeneric,
};

function RenderedBlock({ block }) {
  switch (block.type) {
    case "heading": {
      const sizes = { h1: 24, h2: 20, h3: 17, h4: 15 };
      return (
        <div
          style={{
            fontSize: sizes[block.level] || 18,
            fontWeight: 600,
            color: "#1B2340",
            margin: "4px 0",
            textAlign: block.align || "left",
          }}
        >
          {block.text || (
            <span style={{ color: "#C7C4B6" }}>Empty heading</span>
          )}
        </div>
      );
    }
    case "paragraph":
      return (
        <p
          style={{
            fontSize: 14,
            lineHeight: 1.7,
            color: "#3A3A34",
            margin: "4px 0",
            textAlign: block.align || "left",
          }}
        >
          {block.text || (
            <span style={{ color: "#C7C4B6" }}>Empty paragraph</span>
          )}
        </p>
      );
    case "callout": {
      const s = CALLOUT_STYLE[block.style] || CALLOUT_STYLE.info;
      const Icon = s.icon;
      return (
        <div
          style={{
            display: "flex",
            gap: 10,
            background: s.bg,
            borderLeft: `3px solid ${s.border}`,
            borderRadius: 6,
            padding: "10px 12px",
            textAlign: block.align || "left",
          }}
        >
          <Icon
            size={16}
            color={s.text}
            style={{ flexShrink: 0, marginTop: 1 }}
          />
          <span
            style={{ fontSize: 13.5, color: s.text, lineHeight: 1.6, flex: 1 }}
          >
            {block.text || "Empty callout"}
          </span>
        </div>
      );
    }
    case "list": {
      const Tag = block.style === "number" ? "ol" : "ul";
      return (
        <Tag
          style={{
            margin: "4px 0",
            paddingLeft: 20,
            textAlign: block.align || "left",
          }}
        >
          {block.items.map((it, i) => (
            <li
              key={i}
              style={{ fontSize: 14, color: "#3A3A34", lineHeight: 1.7 }}
            >
              {it || <span style={{ color: "#C7C4B6" }}>Empty item</span>}
            </li>
          ))}
        </Tag>
      );
    }
    case "slider":
      return <SliderPreview images={block.images} />;
    case "image": {
      const align = block.align || "center";
      const marginLeft = align === "left" ? 0 : "auto";
      const marginRight = align === "right" ? 0 : "auto";
      return (
        <div style={{ textAlign: align }}>
          <PreviewImg
            src={block.url}
            alt={block.alt}
            style={{
              width: block.width || "100%",
              height: block.height || "auto",
              objectFit: block.objectFit || "cover",
              maxWidth: "100%",
              marginLeft,
              marginRight,
            }}
          />
          {block.caption && (
            <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
              {block.caption}
            </div>
          )}
        </div>
      );
    }
    case "columns":
      return (
        <div
          style={{ display: "flex", gap: block.gap ?? 20, flexWrap: "wrap" }}
        >
          {(block.columns || []).map((col) => (
            <div
              key={col.id}
              style={{
                flex: "1 1 200px",
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: 14,
              }}
            >
              {col.blocks.map((b) => (
                <RenderedBlock key={b.id} block={b} />
              ))}
            </div>
          ))}
        </div>
      );
    case "api": {
      const m = METHOD_COLOR[block.method] || METHOD_COLOR.GET;
      return (
        <div
          style={{
            border: "1px solid #E4E2D8",
            borderRadius: 10,
            padding: "12px 14px",
            background: "#FBFAF6",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span
              style={{
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 11.5,
                fontWeight: 700,
                letterSpacing: "0.03em",
                padding: "3px 8px",
                borderRadius: 5,
                background: m.bg,
                color: m.text,
                flexShrink: 0,
              }}
            >
              {block.method || "GET"}
            </span>
            <span
              style={{
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 13,
                color: "#1B2340",
                wordBreak: "break-all",
              }}
            >
              {block.url || (
                <span style={{ color: "#C7C4B6" }}>No URL set</span>
              )}
            </span>
          </div>
          {block.description && (
            <div
              style={{
                fontSize: 13,
                color: "#5F5E5A",
                lineHeight: 1.6,
                marginTop: 8,
              }}
            >
              {block.description}
            </div>
          )}
        </div>
      );
    }
    case "code":
      return (
        <div
          style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
        >
          <div
            style={{
              padding: "6px 12px",
              fontSize: 11,
              color: "#9BA6C7",
              fontFamily: "'IBM Plex Mono', monospace",
              borderBottom: "1px solid #2A335C",
            }}
          >
            {block.language || "code"}
          </div>
          <pre
            style={{
              margin: 0,
              padding: 12,
              fontSize: 12.5,
              color: "#E6EAF5",
              fontFamily: "'IBM Plex Mono', monospace",
              overflow: "auto",
            }}
          >
            {block.code || "// empty"}
          </pre>
        </div>
      );
    case "request_payload":
    case "success_response": {
      const isSuccess = block.type === "success_response";
      let pretty = block.data;
      try {
        pretty = JSON.stringify(JSON.parse(block.data), null, 2);
      } catch {
        /* keep raw */
      }
      return (
        <div
          style={{ background: "#1B2340", borderRadius: 8, overflow: "hidden" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "6px 12px",
              borderBottom: "1px solid #2A335C",
            }}
          >
            <span
              style={{
                fontSize: 11,
                color: "#9BA6C7",
                fontFamily: "'IBM Plex Mono', monospace",
              }}
            >
              {isSuccess ? "response" : "request payload"}
            </span>
            {isSuccess && (
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 600,
                  color: "#27500A",
                  background: "#C0DD97",
                  borderRadius: 4,
                  padding: "2px 6px",
                }}
              >
                201 success
              </span>
            )}
          </div>
          <pre
            style={{
              margin: 0,
              padding: 12,
              fontSize: 12.5,
              color: "#E6EAF5",
              fontFamily: "'IBM Plex Mono', monospace",
              overflow: "auto",
            }}
          >
            {pretty}
          </pre>
        </div>
      );
    }
    case "video": {
      const ratios = {
        "16:9": "56.25%",
        "4:3": "75%",
        "1:1": "100%",
        "9:16": "177.78%",
      };
      const embedUrl = toEmbedUrl(block.provider, block.url);
      return (
        <div>
          <div
            style={{
              position: "relative",
              width: "100%",
              paddingTop: ratios[block.aspectRatio] || "56.25%",
              background: "#1B2340",
              borderRadius: 8,
              overflow: "hidden",
            }}
          >
            {embedUrl ? (
              block.provider === "mp4" ? (
                <video
                  src={embedUrl}
                  controls
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <iframe
                  src={embedUrl}
                  title={block.caption || "Video"}
                  allow="autoplay; fullscreen; picture-in-picture"
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    border: 0,
                  }}
                />
              )
            ) : (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  color: "#9BA6C7",
                  fontSize: 12,
                }}
              >
                <Video size={20} />
                <span>No video URL set</span>
              </div>
            )}
          </div>
          {block.caption && (
            <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
              {block.caption}
            </div>
          )}
        </div>
      );
    }
    case "audio":
      return (
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 12,
            border: "1px solid #E4E2D8",
            borderRadius: 10,
            padding: "12px 14px",
            background: "#FBFAF6",
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              background: "#EEEDFE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Music2 size={16} color="#534AB7" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13.5, fontWeight: 600, color: "#1B2340" }}>
              {block.title || "Untitled audio"}
            </div>
            <div style={{ fontSize: 12, color: "#8A8878" }}>
              {block.subtitle}
              {block.subtitle && block.duration ? " · " : ""}
              {block.duration}
            </div>
            {block.url ? (
              <audio
                src={block.url}
                controls
                style={{ width: "100%", height: 32, marginTop: 6 }}
              />
            ) : (
              <div style={{ fontSize: 12, color: "#C7C4B6", marginTop: 4 }}>
                No audio URL set
              </div>
            )}
          </div>
        </div>
      );
    case "file": {
      const Icon = FILE_TYPE_ICONS[block.filetype] || FileGeneric;
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            border: "1px solid #E4E2D8",
            borderRadius: 10,
            padding: "12px 14px",
            background: "#FBFAF6",
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              background: "#E1F5EE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Icon size={17} color="#0F6E56" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                fontSize: 13.5,
                fontWeight: 600,
                color: "#1B2340",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {block.filename || "Untitled file"}
            </div>
            <div style={{ fontSize: 12, color: "#8A8878" }}>
              {block.filetype}
              {block.filesize ? ` · ${block.filesize}` : ""}
            </div>
          </div>
          <a
            href={block.url || "#"}
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontSize: 12.5,
              fontWeight: 600,
              padding: "7px 12px",
              borderRadius: 7,
              background: "#1B2340",
              color: "#fff",
              textDecoration: "none",
              flexShrink: 0,
            }}
          >
            <Download size={13} /> Download
          </a>
        </div>
      );
    }
    case "lottie":
      return (
        <div>
          <div
            style={{
              width: block.width || "100%",
              height: block.height || "280px",
              borderRadius: 8,
              background: "#FBEAF0",
              border: "1px dashed #ED93B1",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              color: "#993556",
            }}
          >
            <Sparkles size={20} />
            <span
              style={{ fontSize: 12, padding: "0 12px", textAlign: "center" }}
            >
              {block.url
                ? "Lottie animation (plays on the live site)"
                : "No animation URL set"}
            </span>
          </div>
          {block.caption && (
            <div style={{ fontSize: 12, color: "#8A8878", marginTop: 6 }}>
              {block.caption}
            </div>
          )}
        </div>
      );
    case "button": {
      const align = block.align || "left";
      const justify =
        align === "center"
          ? "center"
          : align === "right"
            ? "flex-end"
            : "flex-start";
      const primary = block.style !== "secondary";
      return (
        <div style={{ display: "flex", justifyContent: justify }}>
          <a
            href={block.url || "#"}
            target={block.newTab ? "_blank" : undefined}
            rel={block.newTab ? "noreferrer" : undefined}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              fontSize: 13.5,
              fontWeight: 600,
              padding: "9px 18px",
              borderRadius: 8,
              textDecoration: "none",
              background: primary ? "#1B2340" : "transparent",
              color: primary ? "#fff" : "#1B2340",
              border: primary ? "none" : "1px solid #1B2340",
            }}
          >
            {block.label || "Button label"}
          </a>
        </div>
      );
    }
    case "badges":
      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {block.tags.map((tag) => {
            const c = RAMP[tag.tone] || RAMP.blue;
            return (
              <span
                key={tag.id}
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  padding: "4px 10px",
                  borderRadius: 999,
                  background: c[50],
                  color: c[800],
                  border: `1px solid ${c[200]}`,
                }}
              >
                {tag.label || "Tag"}
              </span>
            );
          })}
        </div>
      );
    case "stepper":
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {block.steps.map((step, i) => (
            <div key={step.id} style={{ display: "flex", gap: 12 }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    background: "#1B2340",
                    color: "#fff",
                    fontSize: 11.5,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {i + 1}
                </div>
                {i < block.steps.length - 1 && (
                  <div
                    style={{
                      width: 2,
                      flex: 1,
                      background: "#E4E2D8",
                      minHeight: 18,
                    }}
                  />
                )}
              </div>
              <div style={{ paddingBottom: 16 }}>
                <div
                  style={{ fontSize: 13.5, fontWeight: 600, color: "#1B2340" }}
                >
                  {step.title || (
                    <span style={{ color: "#C7C4B6" }}>Untitled step</span>
                  )}
                </div>
                {step.text && (
                  <div
                    style={{
                      fontSize: 13,
                      color: "#5F5E5A",
                      lineHeight: 1.6,
                      marginTop: 3,
                    }}
                  >
                    {step.text}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      );
    case "feedback":
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #E4E2D8",
            borderRadius: 10,
            padding: "12px 14px",
            background: "#FBFAF6",
          }}
        >
          <span style={{ fontSize: 13.5, color: "#3A3A34" }}>
            {block.prompt || "Was this helpful?"}
          </span>
          <div style={{ display: "flex", gap: 8 }}>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: 7,
                border: "1px solid #E4E2D8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#5F5E5A",
              }}
            >
              <ThumbsUp size={14} />
            </div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: 7,
                border: "1px solid #E4E2D8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#5F5E5A",
              }}
            >
              <ThumbsDown size={14} />
            </div>
          </div>
        </div>
      );
    case "table":
      return (
        <div
          style={{
            overflow: "auto",
            border: "1px solid #E4E2D8",
            borderRadius: 8,
          }}
        >
          <table
            style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}
          >
            <thead>
              <tr>
                {block.columns.map((col, i) => (
                  <th
                    key={i}
                    style={{
                      textAlign: "left",
                      padding: "8px 12px",
                      background: "#F1EFE8",
                      color: "#1B2340",
                      fontWeight: 600,
                      borderBottom: "1px solid #E4E2D8",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {col || `Column ${i + 1}`}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row, ri) => (
                <tr key={ri}>
                  {row.map((cell, ci) => (
                    <td
                      key={ci}
                      style={{
                        padding: "8px 12px",
                        borderBottom: "1px solid #EDEBE0",
                        color: "#3A3A34",
                      }}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    case "divider":
      return block.style === "space" ? (
        <div style={{ height: block.spacing ?? 24 }} />
      ) : (
        <hr
          style={{
            border: "none",
            borderTop: `1px ${block.style === "dashed" ? "dashed" : "solid"} #E4E2D8`,
            margin: `${block.spacing ?? 24}px 0`,
          }}
        />
      );

    case "richtext":
      return (
        <div
          className="rendered-richtext"
          style={{
            fontSize: 14,
            lineHeight: 1.7,
            color: "#3A3A34",
            textAlign: block.align || "left",
          }}
          dangerouslySetInnerHTML={{
            __html:
              block.html || '<p style="color:#C7C4B6">Empty rich text</p>',
          }}
        />
      );

    default:
      return null;
  }
}

function DocumentPreview({ values }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        border: "1px solid #E4E2D8",
        padding: "20px 22px",
      }}
    >
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          color: "#8A8878",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          marginBottom: 6,
        }}
      >
        {values.category} · {values.doc_type}
      </div>
      <div
        style={{
          fontSize: 22,
          fontWeight: 700,
          color: "#1B2340",
          fontFamily: "'Space Grotesk', sans-serif",
          marginBottom: 8,
        }}
      >
        {values.title || "Untitled workflow doc"}
      </div>
      <p
        style={{
          fontSize: 14,
          color: "#5F5E5A",
          lineHeight: 1.7,
          marginBottom: 18,
        }}
      >
        {values.overview}
      </p>
      <div
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          marginBottom: 20,
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 12.5,
        }}
      >
        {values.api_method && (
          <span
            style={{
              background: "#1B2340",
              color: "#fff",
              borderRadius: 5,
              padding: "3px 8px",
              fontWeight: 600,
            }}
          >
            {values.api_method}
          </span>
        )}
        <span style={{ color: "#5F5E5A", wordBreak: "break-all" }}>
          {values.api_endpoint}
        </span>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {values.content_blocks.map((b) => (
          <RenderedBlock key={b.id} block={b} />
        ))}
      </div>
    </div>
  );
}

function toExportBlock(b) {
  const { id, ...rest } = b;
  if (b.type === "request_payload" || b.type === "success_response") {
    let parsed;
    try {
      parsed = JSON.parse(b.data);
    } catch {
      parsed = b.data;
    }
    return { type: b.type, data: parsed };
  }
  if (b.type === "columns") {
    return {
      ...rest,
      columns: (b.columns || []).map((col) => ({
        blocks: (col.blocks || []).map(toExportBlock),
      })),
    };
  }
  return rest;
}

export default function HrmsBlockEditor() {
  const { values, setField, setValues } = useFormikLike(initialValues);
  const [copied, setCopied] = useState(false);
  const [showPreview, setShowPreview] = useState(true);
  const [previewTab, setPreviewTab] = useState("rendered");
  const [addType, setAddType] = useState("paragraph");
  const [showLoadPayload, setShowLoadPayload] = useState(false);
  const [payloadText, setPayloadText] = useState("");
  const [payloadError, setPayloadError] = useState(null);
  const [fullscreenPreview, setFullscreenPreview] = useState(false);
  const [deviceView, setDeviceView] = useState("laptop"); // mobile | tablet | laptop
  const { state } = useLocation();
  const { type } = useParams(); //add || update || copy
  const [page_data, setPageData] = useState([]);

  const navigate = useNavigate();

  const client = useQueryClient();

  const { mutate: AddDocuments, isLoading } = useMutation(postDocument, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        client.refetchQueries(["get-document"]);
        toast.success(res?.data?.message);
        navigate(-1);
      } else {
        toast.warn(res?.data?.message);
      }
    },
  });

  const {
    data: documentResponse,

    isError,
    refetch,
  } = useQuery(["get-document", state], () => getDocument({ doc_id: state }), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: Boolean(state),
  });

  function fromImportBlock(b) {
    const id = nextId();
    if (b.type === "request_payload" || b.type === "success_response") {
      const data =
        typeof b.data === "string"
          ? b.data
          : JSON.stringify(b.data ?? {}, null, 2);
      return { ...b, id, data };
    }
    if (b.type === "columns") {
      return {
        ...b,
        id,
        columns: (b.columns || []).map((col) => ({
          id: genKey("column"),
          blocks: (col.blocks || []).map(fromImportBlock),
        })),
      };
    }
    return { ...b, id };
  }

  useEffect(() => {
    const doc = documentResponse?.data?.data; // aapke sample response ke hisaab se
    if (!doc) return;
    setValues({
      page_title: doc.page_title || "",
      category: doc.category || "",
      title: doc.title || "",
      doc_type: doc.doc_type || "",
      overview: doc.overview || "",
      api_method: doc.api_method || "",
      api_endpoint: doc.api_endpoint || "",
      content_blocks: (doc.content_blocks || []).map(fromImportBlock),
    });
  }, [documentResponse]);

  const blocks = values.content_blocks;

  const updateBlock = (idx, updated) => {
    const next = [...blocks];
    next[idx] = updated;
    setField("content_blocks", next);
  };
  const removeBlock = (idx) =>
    setField(
      "content_blocks",
      blocks.filter((_, i) => i !== idx),
    );
  const moveBlock = (from, to) => {
    const next = [...blocks];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    setField("content_blocks", next);
  };
  const addBlock = () =>
    setField("content_blocks", [...blocks, emptyBlockFor(addType)]);

  const loadPayload = () => {
    try {
      const parsed = JSON.parse(payloadText);
      setValues({
        page_title: parsed.page_title || "",
        category: parsed.category || "",
        title: parsed.title || "",
        doc_type: parsed.doc_type || "",
        overview: parsed.overview || "",
        api_method: parsed.api_method || "",
        api_endpoint: parsed.api_endpoint || "",
        content_blocks: (parsed.content_blocks || []).map(fromImportBlock),
      });
      setPayloadError(null);
      setShowLoadPayload(false);
      setPayloadText("");
      toast.success("Payload loaded into the editor");
    } catch (e) {
      setPayloadError(
        "That doesn't look like valid JSON. Please check the format and try again.",
      );
    }
  };

  const exportJson = {
    page_title: values?.page_title,
    category: values.category,
    title: values.title,
    doc_type: values.doc_type,
    overview: values.overview,
    api_method: values.api_method,
    api_endpoint: values.api_endpoint,
    content_blocks: blocks.map(toExportBlock),
  };

  const jsonString = JSON.stringify(exportJson, null, 2);

  const copyJson = async () => {
    try {
      await navigator.clipboard.writeText(jsonString);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };

  const isEditMode = Boolean(state) && type !== "copy";

  const { mutate: EditDocument, isLoading: IsUpdateLoading } = useMutation(
    (payload) => patchDocument({ ...payload, doc_id: state }),
    {
      onSuccess: (res) => {
        if (res?.data?.response_code === 200) {
          navigate(-1);
          toast.success(res?.data?.message);
          client.refetchQueries(["get-document"]);
        } else {
          toast.warn(res?.data?.message);
        }
      },
    },
  );
  const saveDocument = async () => {
    if (isEditMode) EditDocument(exportJson);
    else AddDocuments(exportJson);
  };

  const getCreer = () => {
    axios
      .get(`${baseUrl}/blog/frontend-page-id-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        setPageData(res.data?.data);
      })
      .catch((err) => {
        toast.error("Error deleting blog", err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getCreer();
  }, []);

  function sanitizeBlock(b) {
    if (!b || !BLOCK_TYPES[b.type]) return null; // unknown/missing type -> drop silently, never render
    const base = emptyBlockFor(b.type);
    const merged = { ...base, ...b };

    // any array field the type expects must actually be an array, else fall back to the safe default
    ["items", "images", "tags", "steps", "columns", "rows"].forEach((k) => {
      if (k in base && !Array.isArray(merged[k])) merged[k] = base[k];
    });

    if (merged.type === "columns") {
      merged.columns = merged.columns.map((col) => ({
        ...col,
        blocks: (Array.isArray(col.blocks) ? col.blocks : [])
          .map(sanitizeBlock)
          .filter(Boolean),
      }));
    }
    if (merged.type === "table") {
      if (!Array.isArray(merged.columns)) merged.columns = base.columns;
      if (!Array.isArray(merged.rows)) merged.rows = base.rows;
    }
    if (merged.type === "api") {
      if (!API_METHODS.includes(merged.method)) merged.method = "GET";
    }
    return merged;
  }

  const sanitizeBlocks = (blocks) =>
    (Array.isArray(blocks) ? blocks : []).map(sanitizeBlock).filter(Boolean);

  const SARVAM_API_KEY = "sk_a65z3hrt_WeR4kZdg4xlUT6ecKL7PDbW6";

  const DOC_SCHEMA_SYSTEM_PROMPT = `You generate structured documentation-page content as strict JSON for a content block editor. Output ONLY a raw JSON object — no markdown fences, no preamble, no explanation.

Shape:
{
  "category": string,
  "title": string,
  "doc_type": string,
  "overview": string,
  "api_method": "GET"|"POST"|"PUT"|"PATCH"|"DELETE"|"",
  "api_endpoint": string,
  "content_blocks": [ ...block objects... ]
}

Do NOT include "page_title" — the user picks that from a dropdown themselves.

Every content block has a "type" field plus type-specific fields below. Leave any media URL field ("url", "header_image") as an empty string "" — the user uploads real media separately; never invent a fake URL.

- heading: { type: "heading", level: "h1"|"h2"|"h3"|"h4", text, align: "left"|"center"|"right"|"justify" }
- paragraph: { type: "paragraph", text, align }
- callout: { type: "callout", style: "info"|"warning"|"success"|"error", text, align }
- list: { type: "list", style: "bullet"|"number", items: string[], align }
- slider: { type: "slider", images: [{ image_key, url: "", caption, alt, width, height, objectFit }] }
- image: { type: "image", image_key, url: "", caption, align: "left"|"center"|"right", width, height, objectFit }
- columns: { type: "columns", gap: number, columns: [{ blocks: [...nested block objects...] }] }
- api: { type: "api", method: "GET"|"POST"|"PUT"|"PATCH"|"DELETE", url, description }  // an endpoint row shown inline in the page — here "url" IS the endpoint path, so always fill it (e.g. "/api/v1/employees/"), never leave it empty
- request_payload: { type: "request_payload", data: <JSON object or JSON string> }
- code: { type: "code", language, code }
- success_response: { type: "success_response", data: <JSON object or JSON string> }
- video: { type: "video", provider: "youtube"|"vimeo"|"loom"|"mp4", url: "", caption, aspectRatio: "16:9"|"4:3"|"1:1"|"9:16" }
- audio: { type: "audio", url: "", title, subtitle, duration }
- file: { type: "file", url: "", filename, filetype: "PDF"|"ZIP"|"CSV"|"DOCX"|"XLSX"|"Other", filesize }
- lottie: { type: "lottie", url: "", caption, width, height, loop: boolean, autoplay: boolean }
- button: { type: "button", label, url, style: "primary"|"secondary", align, newTab: boolean }
- badges: { type: "badges", tags: [{ label, tone: "blue"|"gray"|"amber"|"green"|"purple"|"pink"|"teal" }] }
- stepper: { type: "stepper", steps: [{ title, text }] }
- feedback: { type: "feedback", prompt }
- table: { type: "table", columns: string[], rows: string[][] }
- divider: { type: "divider", style: "solid"|"dashed"|"space", spacing: number }
- richtext: { type: "richtext", html, align }

Build a well-structured documentation page using a sensible mix of block types — headings for structure, paragraphs for prose, api + code/request_payload/success_response for API docs, stepper for how-tos, table for reference data. 6-14 blocks unless the user asks for more or less.`;

  //   const [showAiGenerate, setShowAiGenerate] = useState(false);
  //   const [aiPrompt, setAiPrompt] = useState("");

  //   const { mutate: generateDocWithAi, isLoading: aiGenerating } = useMutation(
  //     async (userPrompt) => {
  //       const res = await fetch("https://api.sarvam.ai/v1/chat/completions", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "api-subscription-key": SARVAM_API_KEY,
  //         },
  //         body: JSON.stringify({
  //           model: "sarvam-105b",
  //           messages: [
  //             { role: "system", content: DOC_SCHEMA_SYSTEM_PROMPT },
  //             { role: "user", content: userPrompt },
  //           ],
  //           temperature: 0.3,
  //           reasoning_effort: null, // raw JSON chahiye, chain-of-thought nahi — warna content null aa sakta hai (finish_reason: "length")
  //           max_tokens: 4096,
  //         }),
  //       });

  //       if (!res.ok) {
  //         const errText = await res.text().catch(() => "");
  //         throw new Error(
  //           `Sarvam API error ${res.status}: ${errText.slice(0, 200)}`,
  //         );
  //       }

  //       const data = await res.json();
  //       const choice = data?.choices?.[0];
  //       const raw = choice?.message?.content;

  //       if (!raw) {
  //         if (choice?.finish_reason === "length") {
  //           throw new Error(
  //             "Response got cut off before finishing — try a shorter or simpler prompt",
  //           );
  //         }
  //         throw new Error("Empty response from AI");
  //       }

  //       const cleaned = raw.replace(/```json|```/g, "").trim();
  //       return JSON.parse(cleaned); // malformed JSON throws here — caught by onError below
  //     },
  //     {
  //       onSuccess: (parsed) => {
  //         try {
  //           if (
  //             !parsed ||
  //             typeof parsed !== "object" ||
  //             !Array.isArray(parsed.content_blocks)
  //           ) {
  //             throw new Error("Unexpected response shape");
  //           }
  //           setValues((prev) => ({
  //             ...prev,
  //             category: parsed.category || prev.category,
  //             title: parsed.title || prev.title,
  //             doc_type: parsed.doc_type || prev.doc_type,
  //             overview: parsed.overview || prev.overview,
  //             api_method: parsed.api_method || prev.api_method,
  //             api_endpoint: parsed.api_endpoint || prev.api_endpoint,
  //             content_blocks: sanitizeBlocks(parsed.content_blocks).map(
  //               fromImportBlock,
  //             ),
  //           }));
  //           toast.success("Document generated successfully");
  //           setShowAiGenerate(false);
  //           setAiPrompt("");
  //         } catch (err) {
  //           toast.error("AI response could not be applied: " + err.message);
  //         }
  //       },
  //       onError: (err) =>
  //         toast.error(
  //           err?.message || "Could not generate document, please try again",
  //         ),
  //     },
  //   );

  //   const handleGenerateDocWithAi = () => {
  //     const prompt = aiPrompt.trim();
  //     if (!prompt || aiGenerating) return;
  //     generateDocWithAi(prompt);
  //   };

  // Vite ho to: import.meta.env.VITE_GEMINI_API_KEY
  const GEMINI_API_KEY =
    "AQ.Ab8RN6IICBaYLcsZKqrlPjyqK_S96K8AoodjeW9UJTrDsgUTyg";
  const GEMINI_MODEL = "gemini-3-flash-preview";

  const [showAiGenerate, setShowAiGenerate] = useState(false);
  const [aiPrompt, setAiPrompt] = useState("");

  const { mutate: generateDocWithAi, isLoading: aiGenerating } = useMutation(
    async (userPrompt) => {
      if (!GEMINI_API_KEY) {
        throw new Error(
          "Gemini API key is missing. Add REACT_APP_GEMINI_API_KEY to .env and restart the dev server.",
        );
      }

      const res = await fetch(
        `https://generativelanguage.googleapis.com/v1beta/models/${GEMINI_MODEL}:generateContent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-goog-api-key": GEMINI_API_KEY,
          },
          body: JSON.stringify({
            systemInstruction: {
              parts: [{ text: DOC_SCHEMA_SYSTEM_PROMPT }],
            },
            contents: [{ role: "user", parts: [{ text: userPrompt }] }],
            generationConfig: {
              temperature: 0.3,
              maxOutputTokens: 8192,
              responseMimeType: "application/json", // raw JSON hi aayega
            },
          }),
        },
      );

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(
          err?.error?.message || `Gemini API error ${res.status}`,
        );
      }

      const data = await res.json();
      const candidate = data?.candidates?.[0];

      // thinking parts (agar aaye) skip karo, sirf actual output jodo
      const raw = (candidate?.content?.parts || [])
        .filter((p) => !p.thought && typeof p.text === "string")
        .map((p) => p.text)
        .join("")
        .trim();

      if (!raw) {
        if (candidate?.finishReason === "MAX_TOKENS") {
          throw new Error(
            "Response got cut off before finishing — try a shorter or simpler prompt",
          );
        }
        if (data?.promptFeedback?.blockReason) {
          throw new Error(
            `Request blocked by AI: ${data.promptFeedback.blockReason}`,
          );
        }
        throw new Error("Empty response from AI");
      }

      if (candidate?.finishReason === "MAX_TOKENS") {
        throw new Error(
          "Response got cut off before finishing — try a shorter or simpler prompt",
        );
      }

      const cleaned = raw.replace(/```json|```/g, "").trim();
      return JSON.parse(cleaned); // malformed JSON yahin throw hoga — onError me catch hota hai
    },
    {
      onSuccess: (parsed) => {
        try {
          if (
            !parsed ||
            typeof parsed !== "object" ||
            !Array.isArray(parsed.content_blocks)
          ) {
            throw new Error("Unexpected response shape");
          }
          setValues((prev) => ({
            ...prev,
            category: parsed.category || prev.category,
            title: parsed.title || prev.title,
            doc_type: parsed.doc_type || prev.doc_type,
            overview: parsed.overview || prev.overview,
            api_method: parsed.api_method || prev.api_method,
            api_endpoint: parsed.api_endpoint || prev.api_endpoint,
            content_blocks: sanitizeBlocks(parsed.content_blocks).map(
              fromImportBlock,
            ),
          }));
          toast.success("Document generated successfully");
          setShowAiGenerate(false);
          setAiPrompt("");
        } catch (err) {
          toast.error("AI response could not be applied: " + err.message);
        }
      },
      onError: (err) =>
        toast.error(
          err?.message || "Could not generate document, please try again",
        ),
    },
  );

  const handleGenerateDocWithAi = () => {
    const prompt = aiPrompt.trim();
    if (!prompt || aiGenerating) return;
    generateDocWithAi(prompt);
  };

  return (
    <div
      style={{
        fontFamily: "'IBM Plex Sans', sans-serif",
        background: "#F3F2EC",
        padding: 24,
        minHeight: "100vh",

        boxSizing: "border-box",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&family=Space+Grotesk:wght@600;700&display=swap');
        input:focus, textarea:focus, select:focus { border-color: #185FA5 !important; box-shadow: 0 0 0 3px rgba(24,95,165,0.12); }
        @keyframes spSpin { to { transform: rotate(360deg); } }
        @keyframes spFade { from { opacity: 0.4; } to { opacity: 1; } }
      `}</style>

      <div style={{ maxWidth: "100%", margin: "0 auto" }}>
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <div>
            <div
              style={{
                fontSize: 12,
                fontFamily: "'IBM Plex Mono', monospace",
                color: "#8A8878",
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                marginBottom: 4,
              }}
            >
              HRMS content block editor
            </div>
            <h1
              style={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: 26,
                fontWeight: 700,
                color: "#1B2340",
                margin: 0,
              }}
            >
              {values.title || "Untitled workflow doc"}
            </h1>
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <button
              onClick={() => setShowPreview((s) => !s)}
              style={{
                fontSize: 13,
                padding: "8px 14px",
                borderRadius: 8,
                border: "1px solid #DEDCD1",
                background: "#fff",
                color: "#20201C",
                cursor: "pointer",
              }}
            >
              {showPreview ? "Hide JSON" : "Show JSON"}
            </button>
            <button
              onClick={() => setShowLoadPayload(true)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                padding: "8px 14px",
                borderRadius: 8,
                border: "1px solid #DEDCD1",
                background: "#fff",
                color: "#20201C",
                cursor: "pointer",
              }}
            >
              <FileJson size={14} /> Load Payload
            </button>
            <button
              onClick={() => setShowAiGenerate(true)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                padding: "8px 14px",
                borderRadius: 8,
                border: "1px solid #AFA9EC",
                background: "#EEEDFE",
                color: "#3C3489",
                cursor: "pointer",
              }}
            >
              <Sparkles size={14} /> Generate with AI
            </button>
            <button
              onClick={() => setFullscreenPreview(true)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                padding: "8px 14px",
                borderRadius: 8,
                border: "1px solid #DEDCD1",
                background: "#fff",
                color: "#20201C",
                cursor: "pointer",
              }}
            >
              <Maximize2 size={14} /> Full Screen Preview
            </button>
            <button
              onClick={copyJson}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                padding: "8px 14px",
                borderRadius: 8,
                border: "none",
                background: "#1B2340",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              {copied ? <Check size={14} /> : <Copy size={14} />}{" "}
              {copied ? "Copied" : "Copy JSON"}
            </button>
            <button
              disabled={isLoading || IsUpdateLoading}
              onClick={saveDocument}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                padding: "8px 14px",
                borderRadius: 8,
                border: "none",
                background: "#1B2340",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              {isLoading || IsUpdateLoading
                ? "Saving..."
                : isEditMode
                  ? "Update Document"
                  : "Save Document"}
            </button>
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: showPreview ? "1fr 1fr" : "1fr",
            gap: 20,
            alignItems: "start",
            minWidth: 0,
          }}
        >
          <div style={{ minWidth: 0 }}>
            {/* Document meta card */}
            <div
              style={{
                background: "#fff",
                border: "1px solid #E4E2D8",
                borderRadius: 12,
                padding: 18,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#1B2340",
                  marginBottom: 12,
                }}
              >
                Document details
              </div>

              <Field label="Select the page you want to view">
                <select
                  style={selectStyle}
                  value={values.page_title}
                  onChange={(e) => setField("page_title", e.target.value)}
                >
                  <option className="font-bold ">Select A Page</option>
                  {page_data?.map((i) => (
                    <option value={i?.id}>{i?.name}</option>
                  ))}
                </select>
              </Field>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 12,
                }}
              >
                <Field label="Category">
                  <input
                    style={inputStyle}
                    value={values.category}
                    onChange={(e) => setField("category", e.target.value)}
                  />
                </Field>
                <Field label="Doc type">
                  <input
                    style={inputStyle}
                    value={values.doc_type}
                    onChange={(e) => setField("doc_type", e.target.value)}
                  />
                </Field>
              </div>
              <Field label="Title">
                <input
                  style={inputStyle}
                  value={values.title}
                  onChange={(e) => setField("title", e.target.value)}
                />
              </Field>
              <Field label="Overview">
                <textarea
                  style={textareaStyle}
                  value={values.overview}
                  onChange={(e) => setField("overview", e.target.value)}
                />
              </Field>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "120px 1fr",
                  gap: 12,
                }}
              >
                <Field label="API method">
                  <select
                    style={selectStyle}
                    value={values.api_method}
                    onChange={(e) => setField("api_method", e.target.value)}
                  >
                    <option value={""}>None</option>
                    {API_METHODS.map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                </Field>
                <Field label="API endpoint">
                  <input
                    style={monoStyle}
                    value={values.api_endpoint}
                    onChange={(e) => setField("api_endpoint", e.target.value)}
                  />
                </Field>
              </div>
            </div>

            {/* Blocks */}
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: "#1B2340",
                marginBottom: 10,
              }}
            >
              Content blocks ({blocks.length})
            </div>
            {blocks.map((b, i) => (
              <BlockCard
                key={b.id}
                block={b}
                index={i}
                total={blocks.length}
                onChange={(updated) => updateBlock(i, updated)}
                onRemove={removeBlock}
                onMove={moveBlock}
              />
            ))}

            <div
              style={{
                display: "flex",
                gap: 8,
                marginTop: 14,
                background: "#fff",
                border: "1px dashed #C7C4B6",
                borderRadius: 12,
                padding: 14,
                alignItems: "center",
              }}
            >
              <select
                style={{ ...selectStyle, width: "auto", flex: 1 }}
                value={addType}
                onChange={(e) => setAddType(e.target.value)}
              >
                {Object.entries(BLOCK_TYPES).map(([k, v]) => (
                  <option key={k} value={k}>
                    {v.label}
                  </option>
                ))}
              </select>
              <button
                onClick={addBlock}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 13,
                  fontWeight: 600,
                  padding: "9px 16px",
                  borderRadius: 8,
                  border: "none",
                  background: "#1B2340",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                <Plus size={14} /> Add block
              </button>
            </div>
          </div>

          {showPreview && (
            <div style={{ position: "sticky", top: 20, minWidth: 0 }}>
              <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                {[
                  ["rendered", "Preview"],
                  ["json", "JSON"],
                ].map(([key, label]) => (
                  <button
                    key={key}
                    onClick={() => setPreviewTab(key)}
                    style={{
                      fontSize: 12.5,
                      fontWeight: 600,
                      padding: "6px 12px",
                      borderRadius: 7,
                      cursor: "pointer",
                      border:
                        previewTab === key
                          ? "1px solid #1B2340"
                          : "1px solid #DEDCD1",
                      background: previewTab === key ? "#1B2340" : "#fff",
                      color: previewTab === key ? "#fff" : "#5F5E5A",
                    }}
                  >
                    {label}
                  </button>
                ))}
                <span
                  style={{
                    fontSize: 11.5,
                    color: "#9A988E",
                    alignSelf: "center",
                    marginLeft: 4,
                  }}
                >
                  {previewTab === "rendered"
                    ? "How this data will display"
                    : "Data admin will submit"}
                </span>
              </div>

              {previewTab === "rendered" ? (
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <DocumentPreview values={values} />
                </div>
              ) : (
                <div
                  style={{
                    background: "#1B2340",
                    borderRadius: 12,
                    overflow: "hidden",
                    border: "1px solid #1B2340",
                  }}
                >
                  <div
                    style={{
                      padding: "10px 14px",
                      fontSize: 12,
                      color: "#9BA6C7",
                      fontFamily: "'IBM Plex Mono', monospace",
                      borderBottom: "1px solid #2A335C",
                    }}
                  >
                    output.json
                  </div>
                  <pre
                    style={{
                      margin: 0,
                      padding: 16,
                      fontSize: 12.5,
                      lineHeight: 1.6,
                      color: "#E6EAF5",
                      fontFamily: "'IBM Plex Mono', monospace",
                      overflow: "auto",
                      maxHeight: "80vh",
                    }}
                  >
                    {jsonString}
                  </pre>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {showLoadPayload && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(27,35,64,0.55)",
            zIndex: 1200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
          onClick={() => setShowLoadPayload(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "100%",
              maxWidth: 640,
              maxHeight: "85vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "14px 18px",
                borderBottom: "1px solid #E4E2D8",
                flexShrink: 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#1B2340",
                }}
              >
                <FileJson size={16} /> Load JSON payload
              </div>
              <IconBtn
                title="Close"
                onClick={() => {
                  setShowLoadPayload(false);
                  setPayloadError(null);
                }}
              >
                <X size={14} />
              </IconBtn>
            </div>
            <div style={{ padding: 18, overflow: "auto" }}>
              <Field
                label="Paste document JSON"
                hint="Uses the same shape as Copy JSON — loading this will replace the current title, overview, API info and all content blocks with what you paste here."
              >
                <textarea
                  style={{ ...monoStyle, minHeight: 260 }}
                  value={payloadText}
                  onChange={(e) => {
                    setPayloadText(e.target.value);
                    if (payloadError) setPayloadError(null);
                  }}
                  placeholder='{"title": "...", "content_blocks": [...]}'
                />
              </Field>
              {payloadError && (
                <div
                  style={{
                    fontSize: 12.5,
                    color: "#993C1D",
                    marginTop: -6,
                    marginBottom: 10,
                  }}
                >
                  {payloadError}
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                padding: "12px 18px",
                borderTop: "1px solid #E4E2D8",
                flexShrink: 0,
              }}
            >
              <button
                onClick={() => {
                  setShowLoadPayload(false);
                  setPayloadError(null);
                }}
                style={{
                  fontSize: 13,
                  padding: "8px 14px",
                  borderRadius: 8,
                  border: "1px solid #DEDCD1",
                  background: "#fff",
                  color: "#20201C",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={loadPayload}
                disabled={!payloadText.trim()}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 13,
                  fontWeight: 600,
                  padding: "8px 16px",
                  borderRadius: 8,
                  border: "none",
                  background: "#1B2340",
                  color: "#fff",
                  cursor: payloadText.trim() ? "pointer" : "default",
                  opacity: payloadText.trim() ? 1 : 0.6,
                }}
              >
                <Upload size={14} /> Load
              </button>
            </div>
          </div>
        </div>
      )}

      {showAiGenerate && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(27,35,64,0.55)",
            zIndex: 1200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
          onClick={() => !aiGenerating && setShowAiGenerate(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "100%",
              maxWidth: 560,
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "14px 18px",
                borderBottom: "1px solid #E4E2D8",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#1B2340",
                }}
              >
                <Sparkles size={16} color="#534AB7" /> Generate document with AI
              </div>
              <IconBtn
                title="Close"
                onClick={() => !aiGenerating && setShowAiGenerate(false)}
              >
                <X size={14} />
              </IconBtn>
            </div>
            <div style={{ padding: 18 }}>
              <Field
                label="Describe the document"
                hint="e.g. an API reference doc for a 'create employee' endpoint, with a request payload, success response, and a step-by-step guide."
              >
                <textarea
                  autoFocus
                  style={{ ...textareaStyle, minHeight: 130 }}
                  value={aiPrompt}
                  onChange={(e) => setAiPrompt(e.target.value)}
                  disabled={aiGenerating}
                  placeholder="Describe what the document should cover..."
                />
              </Field>
              <div
                style={{
                  fontSize: 12,
                  color: "#9A988E",
                }}
              >
                This replaces the title, overview, API info and content blocks
                below — page selection stays untouched, and media stays empty
                for you to upload.
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                padding: "12px 18px",
                borderTop: "1px solid #E4E2D8",
              }}
            >
              <button
                onClick={() => setShowAiGenerate(false)}
                disabled={aiGenerating}
                style={{
                  fontSize: 13,
                  padding: "8px 14px",
                  borderRadius: 8,
                  border: "1px solid #DEDCD1",
                  background: "#fff",
                  color: "#20201C",
                  cursor: aiGenerating ? "default" : "pointer",
                  opacity: aiGenerating ? 0.6 : 1,
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleGenerateDocWithAi}
                disabled={aiGenerating || !aiPrompt.trim()}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 13,
                  fontWeight: 600,
                  padding: "8px 16px",
                  borderRadius: 8,
                  border: "none",
                  background: "#1B2340",
                  color: "#fff",
                  cursor:
                    aiGenerating || !aiPrompt.trim() ? "default" : "pointer",
                  opacity: aiGenerating || !aiPrompt.trim() ? 0.6 : 1,
                }}
              >
                {aiGenerating && <Spinner size={13} />}
                {aiGenerating ? "Generating..." : "Generate"}
              </button>
            </div>
          </div>
        </div>
      )}

      {fullscreenPreview && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "#EDEBDF",
            zIndex: 1100,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 18px",
              background: "#1B2340",
              flexShrink: 0,
              flexWrap: "wrap",
              gap: 10,
            }}
          >
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {[
                { key: "mobile", label: "Mobile", icon: Smartphone },
                { key: "tablet", label: "Tablet", icon: Tablet },
                { key: "laptop", label: "Laptop", icon: Laptop },
              ].map((d) => {
                const Icon = d.icon;
                const active = deviceView === d.key;
                return (
                  <button
                    key={d.key}
                    onClick={() => setDeviceView(d.key)}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      fontSize: 12.5,
                      fontWeight: 600,
                      padding: "7px 12px",
                      borderRadius: 7,
                      border: active ? "1px solid #fff" : "1px solid #3C4570",
                      background: active ? "#fff" : "transparent",
                      color: active ? "#1B2340" : "#C9CEDD",
                      cursor: "pointer",
                    }}
                  >
                    <Icon size={14} /> {d.label}
                  </button>
                );
              })}
            </div>
            <button
              onClick={() => setFullscreenPreview(false)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                fontWeight: 600,
                padding: "8px 14px",
                borderRadius: 8,
                border: "1px solid #3C4570",
                background: "transparent",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              <X size={14} /> Close
            </button>
          </div>
          <div
            style={{
              flex: 1,
              overflow: "auto",
              display: "flex",
              justifyContent: "center",
              padding: "28px 16px",
            }}
          >
            <div
              style={{
                width:
                  deviceView === "mobile"
                    ? 390
                    : deviceView === "tablet"
                      ? 834
                      : 1280,
                maxWidth: "100%",
                transition: "width 200ms ease",
              }}
            >
              <DocumentPreview values={values} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
